import type { Characteristic } from '@/typings/setting'
import i18n from '@/i18n'
import { I18nKeys } from '@/constants/i18n'

// @ts-ignore
// const t = i18n.global.t

export const ACCEPT_TYPES = 'image/png,image/jpeg,image/webp'

export const ACCEPT_TYPES_PLUS = 'image/png,image/jpeg,image/webp,image/svg+xml'

export const LOADING_ICON = new URL('@/assets/gif/loading.gif', import.meta.url).href

export const WAITING_ICON = new URL('@/assets/icons/waiting.png', import.meta.url).href

export const DEFAULT_IMAGE = new URL('@/assets/images/default.png', import.meta.url).href

export const FAILED_ICON = new URL('@/assets/images/failed-image.svg', import.meta.url).href

export const GIFT_IMAGE = new URL('@/assets/images/gift.png', import.meta.url).href

export const GIFT_IMAGE_SMALL = new URL('@/assets/images/gift-small.png', import.meta.url).href

export const SEGMENT_IMAGE_SIZE = 1024

/**
 * 线稿或样衣裁剪系数
 */
export enum SizeType {
  '1:1' = 0,
  '3:2' = 2,
  '2:3' = 1,
  '4:3' = 3,
  '3:4' = 4,
  '16:9' = 5,
  '9:16' = 6,
  'free' = 7,
  '3:1' = 8,
  '1:3' = 9
}
/**
 * 图案提取裁剪系数
 */
export enum PatternExtractionSizeType {
  '1:1' = 1,
  '3:4' = 2,
  '4:3' = 3,  
}
/**
 * 服装提取裁剪系数
 */
export enum ClothingExtractionSizeType {
  '1:1' = 1,
  '2:3' = 2,
  '3:2' = 3,
  '3:4' = 4,
  '4:3' = 5,
  '16:9' = 6,
  '9:16' = 7,
}

export const SizeTypeMapBuilder = () => {
  // @ts-ignore
  const t = i18n.global.t

  return {
    [SizeType['1:1']]: '1:1',
    [SizeType['3:2']]: '3:2',
    [SizeType['2:3']]: '2:3',
    [SizeType['4:3']]: '4:3',
    [SizeType['3:4']]: '3:4',
    [SizeType['3:1']]: '3:1',
    [SizeType['1:3']]: '1:3',
    [SizeType['16:9']]: '16:9',
    [SizeType['9:16']]: '9:16',
    [SizeType['free']]: t(I18nKeys.text2Image.freeProportionText)
  }
}

export const PatternExtractionSizeTypeMapBuilder = () => {
  return {
    [PatternExtractionSizeType['1:1']]: '1:1',
    [PatternExtractionSizeType['3:4']]: '3:4',
    [PatternExtractionSizeType['4:3']]: '4:3'
  }
}

export const ClothingExtractionSizeTypeMapBuilder = () => {
  return {
    [ClothingExtractionSizeType['1:1']]: '1:1',
    [ClothingExtractionSizeType['2:3']]: '2:3',
    [ClothingExtractionSizeType['3:2']]: '3:2',
    [ClothingExtractionSizeType['3:4']]: '3:4',
    [ClothingExtractionSizeType['4:3']]: '4:3',
    [ClothingExtractionSizeType['16:9']]: '16:9',
    [ClothingExtractionSizeType['9:16']]: '9:16'
  }
}

export const SizeTypeValueMap = {
  [SizeType['1:1']]: { width: 10, height: 10 },
  [SizeType['3:2']]: { width: 15, height: 10 },
  [SizeType['2:3']]: { width: 10, height: 15 },
  [SizeType['4:3']]: { width: 16, height: 12 },
  [SizeType['3:4']]: { width: 12, height: 16 },
  [SizeType['3:1']]: { width: 15, height: 5 },
  [SizeType['1:3']]: { width: 5, height: 15 },
  [SizeType['16:9']]: { width: 16, height: 9 },
  [SizeType['9:16']]: { width: 9, height: 16 },
  [SizeType['free']]: { width: 9, height: 16 }
}

export const PatternExtractionSizeTypeValueMap = {
  [PatternExtractionSizeType['1:1']]: { width: 10, height: 10 },
  [PatternExtractionSizeType['3:4']]: { width: 12, height: 16 },
  [PatternExtractionSizeType['4:3']]: { width: 16, height: 12 }
}

export const ClothingExtractionSizeTypeValueMap = {
  [ClothingExtractionSizeType['1:1']]: { width: 10, height: 10 },
  [ClothingExtractionSizeType['2:3']]: { width: 10, height: 15 },
  [ClothingExtractionSizeType['3:2']]: { width: 15, height: 10 },
  [ClothingExtractionSizeType['3:4']]: { width: 12, height: 16 },
  [ClothingExtractionSizeType['4:3']]: { width: 16, height: 12 },
  [ClothingExtractionSizeType['16:9']]: { width: 16, height: 9 },
  [ClothingExtractionSizeType['9:16']]: { width: 9, height: 16 }
}

/**
 * 图片上传类型
 */
export enum ImageType {
  /**
   * 线稿
   */
  LINE_DRAFT = 0,
  /**
   * 样衣
   */
  TEMPLATE = 1
}

/**
 * 上传图片操作入口
 */
export enum ImageOperateType {
  /**
   * 款式
   */
  SHAPE = 'shape',
  /**
   * 参考图
   */
  REF = 'ref',
  /**
   * 普通上传图片操作
   */
  UPLOAD = 'upload',
  /**
   * 参考背景
   */
  BACKGROUND = 'background',
  /**
   * 图案提取
   */
  PATTERN = 'pattern'
}

export const enum ImageOrigin {
  USER_UPLOAD = 0,
  TASK_GENERATE = 1
}

/**
 * 画布操作类型
 */
export const enum CanvasOperateType {
  /**
   * 画笔
   */
  BRUSH = 'brush',
  /**
   * 橡皮刷
   */
  ERASING = 'erasing',
  /**
   * 选择
   */
  SELECT = 'select',
  /**
   * 局部选择
   */
  PART = 'part'
}

/**
 * 抠图对话框操作模式
 */
export const enum PhotoMode {
  /**
   * 生成蒙版
   */
  MASK = 'mask',
  /**
   * 抠图
   */
  MATTE = 'matte',
  /**
   * 局部
   */
  PART = 'part',
  /**
   * 智能抠图页面
   */
  CUTOUT = 'cutout',
  /**
   * 去前景，删除图片上蒙版区域内的内容并通过AI重绘补全
   */
  OBJECT_REMOVAL = 'object_removal'
}

/**
 * 生成图片的类型
 */
export const enum GenerateType {
  /**
   * 文生图
   */
  TEXT_2_IMAGE = 'text2image',
  /**
   * 款式延伸
   */
  STYLE_EXTENSION = 'styleextension',
  /**
   * 风格融合
   */
  STYLE_FUSION = 'styleblending',
  /**
   * 创意
   */
  ORIGINALITY = 'sketch2image',
  /**
   * 微调
   */
  TUNE = 'inpaint',
  /**
   * 换色
   */
  RECOLOR = 'recolor',
  /**
   * 智能场景-高级模式
   */
  PHOTO = 'photo',
  /**
   * 智能场景-简单模式
   */
  PHOTO_EASY = 'changebg',
  /**
   * 魔术擦除
   */
  CLEANER = 'removerfg',
  /**
   * 一键抠图
   */
  MATTE = 'removebg',
  /**
   * 一键抠图-智能
   */
  MAGIC = 'removebg_smart',
  /**
   * 高清生成
   */
  HD = 'upscale',
  /**
   * 花型扩图
   */
  FLOWER_PATTERN_EXPANSION = 'flower_pattern_expansion',
  /**
   * AI扩图
   */
  AI_EXPANSION = 'ai_expansion',
  /**
   * 花型
   */
  PATTERN = 'pattern',
  /**
   * 模特试穿
   */
  MODEL_TRY_ON = 'model_try_on',
  /**
   * 模特换脸
   */
  MODEL_FACE = 'model_face',
  /**
   * 花型提取
   */
  PATTERN_EXTRACTION = 'pattern_extraction',
  /**
   * 服装提取
   */
  CLOTHING_EXTRACTION = 'clothing_extraction',
  /**
   * 材质转换
   */
  MATERIAL_CONVERSION = 'material_conversion',
  /**
   * 款式图上印花
   */
  STYLE_IMAGE_PRINTING = 'style_image_printing',
  /**
   * 款式图
   */
  STYLE_PICTURE = 'style_picture',
  /**
   * 款式图 x 面料
   */
  FLAT_SKETCH_FABRIC = 'flat_sketch_fabric',
}

/**
 * 任务类型
 */
export enum TaskType {
  //CPU任务

  /**
   * 语义分割
   */
  SEGMENT = 'segment',  
  /**
   * 精细化处理
   */
  MATTE = 'matte',  
  /**
   * 检测（线稿生图的时候显示出线稿图）
   */
  DETECT = 'detect',  
  /**
   * 一键抠图
   */
  REMBG = 'rembg', 
  /**
   * 图案提取 openai
   */
  PATTERN_EXTRACTION_BY_OPENAI = 'patternExtractionByOpenai',  
  /**
   * 图案提取 flux
   */
  PATTERN_EXTRACTION_BY_FLUX = 'patternExtractionByFlux',  
  /**
   * 服装提取
   */
  CLOTHES_EXTRACTION = 'clothesExtraction',  
  /**
   * 材质转换 openai
   */
  MATERIAL_CONVERSION_BY_OPENAI = 'materialConversionByOpenai',  
  /**
   * 材质转换 flux
   */
  MATERIAL_CONVERSION_BY_FLUX = 'materialConversionByFlux',
  /**
   * 智能换色开放平台 API
   */
  RECOLOR_BY_API = 'recolorByAPI',
  /**
   * 智能换色
   */
  RECOLOR = 'recolor',
  /**
   * 款式图上印花
   */
  STYLE_IMAGE_PRINTING = 'flatSketchPrint',
  /**
   * 款式图
   */
  STYLE_PICTURE = 'flatSketch',
  /**
   * 款式图 x 面料
   */
  FLAT_SKETCH_FABRIC = 'flatSketchFabric',

  //GPU任务

  /**
   * 高清放大
   */
  UPSCALE = 'upscale', 
  /**
   * 魔术擦除
   */
  OBJECT_REMOVAL = 'objectRemoval', 
  /**
   * 背景重绘
   */
  BACKGROUND_INPAINT = 'backgroundInpaint', 
  /**
   * AI换背景
   */
  BACKGROUND_GENERATE = 'backgroundGenerate', 
  /**
   * 四方连续
   */
  SEAMLESSTILE = 'seamlessTile', 
  /**
   * 局部修改
   */
  INPAINT = 'inpaint', 
  /**
   * 旧文生图任务已弃用
   */
  TEXT_2_IMAGE = 'text2image', 
  /**
   * 文生图
   */
  CLOTHES_TEXT_2_IMAGE = 'clothesText2Image', 
  /**
   * 风格融合
   */
  CLOTHES_STYLE_MIX = 'clothesStyleMix', 
  /**
   * 款式衍生
   */
  CLOTHES_DERIVATION = 'clothesDerivation', 
  /**
   * 线稿生图
   */
  CLOTHES_LINE_2_IMAGE = 'clothesLine2Image', 
  /**
   * 智能换装
   */
  TRY_ON = 'tryOn',
  /**
   * 换脸
   */
  SWAP_FACE = 'swapFace',
  /**
   * AI扩图
   */
  IMAGE_EXTEND = 'imageExtend',
  /**
   * 花型贴图
   */
  PATTERN_INPAINT = 'patternInpaint'
}

/**
 * 图片隐藏状态
 */
export enum ImageHideStatus {
  HIDDEN = 1,
  SHOW = 0
}

/**
 * 图片清晰度
 */
export enum ImageClarity {
  SD = 1,
  HD = 2,
  UHD = 4
}

/**
 * 图片清晰度名称对照
 */
export const ImageClarityMapBuilder = () => {
  // @ts-ignore
  const t = i18n.global.t

  return {
    [ImageClarity.SD]: t(I18nKeys.hd.imageClaritySD),
    [ImageClarity.HD]: t(I18nKeys.hd.imageClarityHD),
    [ImageClarity.UHD]: t(I18nKeys.hd.imageClarityUHD)
  }
}

/**
 * 图片清晰度名称对照
 */
export const ImageClarityTextMapBuilder = () => {
  // @ts-ignore
  const t = i18n.global.t

  return {
    [ImageClarity.SD]: t(I18nKeys.hd.imageClarityTextSD),
    [ImageClarity.HD]: t(I18nKeys.hd.imageClarityTextHD),
    [ImageClarity.UHD]: t(I18nKeys.hd.imageClarityTextUHD)
  }
}

/**
 * 图片清晰度对应的背景色
 */
export const ImageClarityBackground = {
  [ImageClarity.SD]: '#f2f2f2',
  [ImageClarity.HD]: '#AEF224',
  [ImageClarity.UHD]: 'var(--background-3)'
}

/**
 * 任务类型
 */
export enum ImageTaskType {
  /**
   * 需要保存预览图片的任务
   */
  IMAGE = 'image',
  /**
   * 只是临时任务，无需保存预览图片
   */
  TASK = 'task'
}

/**
 * 设计风格数据
 */
export const KeywordsData: Characteristic[] = [
  {
    'order': 1,
    'name': { 'zh-cn': '款式', en: 'Style', 'zh-hant': '款式', ja: 'スタイル', de: 'Stil', fr: 'Style', it: 'Stile', ko: '스타일' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '外套', en: 'Jacket', 'zh-hant': '外套', ja: 'アウター', de: 'Mantel', fr: 'Manteau', it: 'Cappotto', ko: '자켓' },
        'list': [
          {
            'order': 1,
            'zh-cn': '夹克',
            'en': 'jacket',
            'zh-hant': '夹克',
            'ja': 'ジャケット',
            'de': 'Jacke',
            'fr': 'Blouson',
            'it': 'Giacca',
            'ko': '재킷'
          },
          {
            'order': 1,
            'zh-cn': '羽绒外套',
            'en': 'down jacket',
            'zh-hant': '羽絨外套',
            'ja': 'ダウンコート',
            'de': 'Daunenjacke',
            'fr': 'Doudoune',
            'it': 'Piumino',
            'ko': '패딩'
          },
          {
            'order': 1,
            'zh-cn': '户外服',
            'en': 'outdoor jacket',
            'zh-hant': '戶外服',
            'ja': 'アウトドアウェア',
            'de': 'Outdoor-Bekleidung',
            'fr': 'Vêtements d\'extérieur',
            'it': 'Abbigliamento da esterno',
            'ko': '아웃도어 자켓'
          },
          {
            'order': 1,
            'zh-cn': '尼克服',
            'en': 'nike jacket',
            'zh-hant': '尼克服',
            'ja': 'N-3B',
            'de': 'N-3B Parka',
            'fr': 'Parka N3B',
            'it': 'Parka N3B',
            'ko': '나이키 재킷'
          },
          {
            'order': 1,
            'zh-cn': '披肩斗篷',
            'en': 'shawl cape',
            'zh-hant': '披肩斗篷',
            'ja': 'ポンチョ',
            'de': 'Poncho',
            'fr': 'Poncho',
            'it': 'Poncho',
            'ko': '숄 케이프'
          },
          {
            'order': 1,
            'zh-cn': '防风衣',
            'en': 'windbreaker',
            'zh-hant': '防風衣',
            'ja': 'ウインドブレーカー',
            'de': 'Windjacke',
            'fr': 'Coupe-vent',
            'it': 'Giacca a vento',
            'ko': '윈드브레이커'
          },
          {
            'order': 1,
            'zh-cn': '斗篷',
            'en': 'cape',
            'zh-hant': '斗篷',
            'ja': 'ケープ',
            'de': 'Umhang',
            'fr': 'Cape',
            'it': 'Mantella',
            'ko': '케이프'
          },
          {
            'order': 1,
            'zh-cn': '派克服',
            'en': 'parka',
            'zh-hant': '派克服',
            'ja': 'パーカー',
            'de': 'Parka',
            'fr': 'Parka',
            'it': 'Parka',
            'ko': '파커'
          },
          {
            'order': 1,
            'zh-cn': '冲锋衣',
            'en': 'fleece jacket',
            'zh-hant': '沖鋒衣',
            'ja': 'ハードシェル',
            'de': 'Hardshell-Jacke',
            'fr': 'Veste de montagne',
            'it': 'Giacca da alpinismo',
            'ko': '플리스 자켓'
          },
          {
            'order': 1,
            'zh-cn': '披肩',
            'en': 'poncho',
            'zh-hant': '披肩',
            'ja': 'ショール',
            'de': 'Schal',
            'fr': 'Châle',
            'it': 'Scialle',
            'ko': '판초'
          },
          {
            'order': 1,
            'zh-cn': '大衣',
            'en': 'coat',
            'zh-hant': '大衣',
            'ja': 'コート',
            'de': 'Mantel',
            'fr': 'Manteau',
            'it': 'Cappotto',
            'ko': '코트'
          },
          {
            'order': 1,
            'zh-cn': '牛仔夹克',
            'en': 'denim jacket',
            'zh-hant': '牛仔夾克',
            'ja': 'デニムジャケット',
            'de': 'Jeansjacke',
            'fr': 'Veste en jean',
            'it': 'Giacca di jeans',
            'ko': '데님 자켓'
          },
          {
            'order': 1,
            'zh-cn': '棒球夹克',
            'en': 'varsity jacket',
            'zh-hant': '棒球夾克',
            'ja': 'ベースボールジャケット',
            'de': 'Baseballjacke',
            'fr': 'Blouson de baseball',
            'it': 'Giacca da baseball',
            'ko': '스타디움 자켓'
          },
          {
            'order': 1,
            'zh-cn': '风衣',
            'en': 'trench coat',
            'zh-hant': '風衣',
            'ja': 'トレンチコート',
            'de': 'Trenchcoat',
            'fr': 'Trench',
            'it': 'Trench',
            'ko': '트렌치 코트'
          },
          {
            'order': 1,
            'zh-cn': '防晒服',
            'en': 'sun protection clothing',
            'zh-hant': '防曬服',
            'ja': 'サンプロテクティブウェア',
            'de': 'Sonnenschutzbekleidung',
            'fr': 'Vêtement anti-UV',
            'it': 'Abbigliamento anti-UV',
            'ko': '자외선 차단 의류'
          },
          {
            'order': 1,
            'zh-cn': '棉衣',
            'en': 'cotton padded jacket',
            'zh-hant': '棉衣',
            'ja': '綿のコート',
            'de': 'Baumwollmantel',
            'fr': 'Manteau en coton',
            'it': 'Cappotto di cotone',
            'ko': '코튼 패딩 자켓'
          },
          {
            'order': 1,
            'zh-cn': '西装外套',
            'en': 'blazer',
            'zh-hant': '西裝外套',
            'ja': 'ブレザー',
            'de': 'Blazer',
            'fr': 'Blazer',
            'it': 'Blazer',
            'ko': '블레이저'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '上装', en: 'Top', 'zh-hant': '上裝', ja: 'トップス', de: 'Oberteil', fr: 'Haut', it: 'Top', ko: '상의' },
        'list': [
          {
            'order': 1,
            'zh-cn': '上衣',
            'en': 'top',
            'zh-hant': '上衣',
            'ja': 'トップス',
            'de': 'Oberteil',
            'fr': 'Haut',
            'it': 'Top',
            'ko': '상의'
          },
          {
            'order': 1,
            'zh-cn': '卫衣',
            'en': 'hoodie',
            'zh-hant': '衛衣',
            'ja': 'スウェットシャツ',
            'de': 'Sweatshirt',
            'fr': 'Sweatshirt',
            'it': 'Felpa',
            'ko': '후드티'
          },
          {
            'order': 1,
            'zh-cn': '马夹',
            'en': 'vest',
            'zh-hant': '馬甲',
            'ja': 'ベスト',
            'de': 'Weste',
            'fr': 'Gilet',
            'it': 'Gilet',
            'ko': '조끼'
          },
          {
            'order': 1,
            'zh-cn': '衬衫',
            'en': 'shirt',
            'zh-hant': '襯衫',
            'ja': 'シャツ',
            'de': 'Hemd',
            'fr': 'Chemise',
            'it': 'Camicia',
            'ko': '셔츠'
          },
          {
            'order': 1,
            'zh-cn': '背心',
            'en': 'tank top',
            'zh-hant': '背心',
            'ja': 'タンクトップ',
            'de': 'Tanktop',
            'fr': 'Débardeur',
            'it': 'Canottiera',
            'ko': '탱크탑'
          },
          {
            'order': 1,
            'zh-cn': 'polo衫',
            'en': 'polo shirt',
            'zh-hant': 'Polo衫',
            'ja': 'ポロシャツ',
            'de': 'Poloshirt',
            'fr': 'Polo',
            'it': 'Polo',
            'ko': '폴로 셔츠'
          },
          {
            'order': 1,
            'zh-cn': '中长款上装',
            'en': 'tunic',
            'zh-hant': '中長款上裝',
            'ja': 'ミドル丈トップス',
            'de': 'Mittellanges Oberteil',
            'fr': 'Top mi-long',
            'it': 'Top di media lunghezza',
            'ko': '튜닉'
          },
          {
            'order': 1,
            'zh-cn': '小上衣',
            'en': 'crop top',
            'zh-hant': '小上衣',
            'ja': 'ブラウス',
            'de': 'Bluse',
            'fr': 'Blouse',
            'it': 'Blusa',
            'ko': '크롭탑'
          },
          {
            'order': 1,
            'zh-cn': '牛仔上衣',
            'en': 'denim top',
            'zh-hant': '牛仔上衣',
            'ja': 'デニムトップス',
            'de': 'Jeans-Oberteil',
            'fr': 'Haut en jean',
            'it': 'Top in jeans',
            'ko': '데님 상의'
          },
          {
            'order': 1,
            'zh-cn': '牛仔村衫',
            'en': 'denim shirt',
            'zh-hant': '牛仔襯衫',
            'ja': 'デニムシャツ',
            'de': 'Jeanshemd',
            'fr': 'Chemise en jean',
            'it': 'Camicia di jeans',
            'ko': '데님 셔츠'
          },
          {
            'order': 1,
            'zh-cn': 't恤',
            'en': 't-shirt',
            'zh-hant': 'T恤',
            'ja': 'Tシャツ',
            'de': 'T-Shirt',
            'fr': 'T-shirt',
            'it': 'Maglietta',
            'ko': '티셔츠'
          },
          {
            'order': 1,
            'zh-cn': '七分袖t恤',
            'en': 'three quarter sleeve t-shirt',
            'zh-hant': '七分袖T恤',
            'ja': '七分袖Tシャツ',
            'de': 'Dreiviertelarm-T-Shirt',
            'fr': 'T-shirt manches trois-quarts',
            'it': 'Maglietta a maniche tre quarti',
            'ko': '7부 소매 티셔츠'
          },
          {
            'order': 1,
            'zh-cn': '短袖t恤',
            'en': 'short sleeve t-shirt',
            'zh-hant': '短袖T恤',
            'ja': '半袖Tシャツ',
            'de': 'Kurzarm-T-Shirt',
            'fr': 'T-shirt manches courtes',
            'it': 'Maglietta a maniche corte',
            'ko': '반소매'
          },
          {
            'order': 1,
            'zh-cn': '长袖t恤',
            'en': 'long sleeve t-shirt',
            'zh-hant': '長袖T恤',
            'ja': '長袖Tシャツ',
            'de': 'Langarm-T-Shirt',
            'fr': 'T-shirt manches longues',
            'it': 'Maglietta a maniche lunghe',
            'ko': '긴소매'
          },
          {
            'order': 1,
            'zh-cn': '中长款t恤',
            'en': 'mid length t-shirt',
            'zh-hant': '中長款T恤',
            'ja': 'ミドル丈Tシャツ',
            'de': 'Mittellanges T-Shirt',
            'fr': 'T-shirt mi-long',
            'it': 'Maglietta di media lunghezza',
            'ko': '5부 티셔츠'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '裤装', en: 'Bottom', 'zh-hant': '褲裝', ja: 'ボトムス', de: 'Hose', fr: 'Pantalon', it: 'Pantaloni', ko: '하의' },
        'list': [
          {
            'order': 1,
            'zh-cn': '长裤',
            'en': 'long pants',
            'zh-hant': '長褲',
            'ja': 'ロングパンツ',
            'de': 'Lange Hose',
            'fr': 'Pantalon long',
            'it': 'Pantaloni lunghi',
            'ko': '바지'
          },
          {
            'order': 1,
            'zh-cn': '工装裤',
            'en': 'cargo pants',
            'zh-hant': '工裝褲',
            'ja': 'カーゴパンツ',
            'de': 'Cargohose',
            'fr': 'Pantalon cargo',
            'it': 'Pantaloni cargo',
            'ko': '카고 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '紧身/弹力裤',
            'en': 'leggings/tights',
            'zh-hant': '緊身/彈力褲',
            'ja': 'スキニーパンツ/ストレッチパンツ',
            'de': 'Enge/Stretchhose',
            'fr': 'Pantalon moulant/élastique',
            'it': 'Pantaloni aderenti/elastici',
            'ko': '레깅스 / 타이즈'
          },
          {
            'order': 1,
            'zh-cn': '西裤',
            'en': 'dress pants',
            'zh-hant': '西褲',
            'ja': 'スラックス',
            'de': 'Anzughose',
            'fr': 'Pantalon de costume',
            'it': 'Pantaloni da abito',
            'ko': '정장 바지'
          },
          {
            'order': 1,
            'zh-cn': '裙裤/裤裙',
            'en': 'skort',
            'zh-hant': '裙褲/褲裙',
            'ja': 'スカートパンツ/パンツスカート',
            'de': 'Hosenrock',
            'fr': 'Jupe-culotte/pantalon jupe',
            'it': 'Gonna-pantalone/pantaloni gonna',
            'ko': '스커트 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '保暖裤',
            'en': 'thermal pants',
            'zh-hant': '保暖褲',
            'ja': '保温パンツ',
            'de': 'Thermohose',
            'fr': 'Pantalon thermique',
            'it': 'Pantaloni termici',
            'ko': '기모 바지'
          },
          {
            'order': 1,
            'zh-cn': '中裤/五分裤',
            'en': 'capri pants',
            'zh-hant': '中褲/五分褲',
            'ja': 'ショートパンツ',
            'de': 'Kurze Hose',
            'fr': 'Pantalon court',
            'it': 'Pantaloni corti',
            'ko': '칠부 바지'
          },
          {
            'order': 1,
            'zh-cn': '打底裤',
            'en': 'leggings',
            'zh-hant': '打底褲',
            'ja': 'レギンス',
            'de': 'Leggings',
            'fr': 'Leggings',
            'it': 'Leggings',
            'ko': '레깅스'
          },
          {
            'order': 1,
            'zh-cn': '迷你裤/迷你裙裤',
            'en': 'miniskirt pants',
            'zh-hant': '迷你褲/迷你裙褲',
            'ja': 'ミニパンツ/ミニスカートパンツ',
            'de': 'Minihose/Miniröckchenhose',
            'fr': 'Mini-pantalon/mini-jupe-pantalon',
            'it': 'Mini-pantaloni/mini gonna-pantaloni',
            'ko': '미니스커트 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '商务裤',
            'en': 'slacks',
            'zh-hant': '商務褲',
            'ja': 'ビジネスパンツ',
            'de': 'Businesshose',
            'fr': 'Pantalon de business',
            'it': 'Pantaloni da lavoro',
            'ko': '슬랙스'
          },
          {
            'order': 1,
            'zh-cn': '灯笼裤',
            'en': 'harem pants',
            'zh-hant': '燈籠褲',
            'ja': 'バルーンパンツ',
            'de': 'Ballonhose',
            'fr': 'Pantalon ballon',
            'it': 'Pantaloni a palloncino',
            'ko': '배기 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '踩脚裤',
            'en': 'cropped pants',
            'zh-hant': '踩腳褲',
            'ja': 'ストラップパンツ',
            'de': 'Steghose',
            'fr': 'Pantalon à pied-de-poule',
            'it': 'Pantaloni con staffa',
            'ko': '크롭 바지'
          },
          {
            'order': 1,
            'zh-cn': '短裤',
            'en': 'shorts',
            'zh-hant': '短褲',
            'ja': 'ショートパンツ',
            'de': 'Shorts',
            'fr': 'Short',
            'it': 'Shorts',
            'ko': '반바지'
          },
          {
            'order': 1,
            'zh-cn': '五分-九分裤',
            'en': 'crop pants',
            'zh-hant': '五分-九分褲',
            'ja': 'クロップドパンツ',
            'de': '5/8-Hose',
            'fr': 'Pantalon court 5-9',
            'it': 'Pantaloni 5/8',
            'ko': '크롭 바지'
          },
          {
            'order': 1,
            'zh-cn': '阔腿裤',
            'en': 'wide leg pants',
            'zh-hant': '闊腿褲',
            'ja': 'ワイドパンツ',
            'de': 'Weite Hose',
            'fr': 'Pantalon large',
            'it': 'Pantaloni a gamba larga',
            'ko': '와이드 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '妇女裤',
            'en': 'women\'s trousers',
            'zh-hant': '婦女褲',
            'ja': 'ウィメンズパンツ',
            'de': 'Frauenhose',
            'fr': 'Pantalon pour femmes',
            'it': 'Pantaloni da donna',
            'ko': '여성용 슬랙스'
          },
          {
            'order': 1,
            'zh-cn': '慢跑裤',
            'en': 'jogging pants',
            'zh-hant': '慢跑褲',
            'ja': 'ジョギングパンツ',
            'de': 'Jogginghose',
            'fr': 'Pantalon de jogging',
            'it': 'Pantaloni da jogging',
            'ko': '조거 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '拳击短裤',
            'en': 'boxing shorts',
            'zh-hant': '拳擊短褲',
            'ja': 'ボクサーショーツ',
            'de': 'Boxershorts',
            'fr': 'Short de boxe',
            'it': 'Pantaloncini da boxe',
            'ko': '복싱 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '连体裤',
            'en': 'jumpsuit',
            'zh-hant': '連體褲',
            'ja': 'ジャンプスーツ',
            'de': 'Overall',
            'fr': 'Combinaison',
            'it': 'Tuta intera',
            'ko': '점프수트'
          },
          {
            'order': 1,
            'zh-cn': '小脚裤',
            'en': 'skinny pants',
            'zh-hant': '小腳褲',
            'ja': 'テーパードパンツ',
            'de': 'Schmale Hose',
            'fr': 'Pantalon étroit',
            'it': 'Pantaloni stretti',
            'ko': '스키니 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '喇叭裤',
            'en': 'flare pants',
            'zh-hant': '喇叭褲',
            'ja': 'ベルボトムパンツ',
            'de': 'Schlaghose',
            'fr': 'Pantalon évasé',
            'it': 'Pantaloni a zampa',
            'ko': '플레어 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '九分裤',
            'en': 'crop pants',
            'zh-hant': '五分-九分褲',
            'ja': 'クロップドパンツ',
            'de': '5/8-Hose',
            'fr': 'Pantalon court 5-9',
            'it': 'Pantaloni 5/8',
            'ko': '크롭 바지'
          },
          {
            'order': 1,
            'zh-cn': '牛仔裤',
            'en': 'jeans',
            'zh-hant': '牛仔褲',
            'ja': 'デニムパンツ',
            'de': 'Jeans',
            'fr': 'Jean',
            'it': 'Jeans',
            'ko': '청바지'
          },
          {
            'order': 1,
            'zh-cn': '针织裤',
            'en': 'knit pants',
            'zh-hant': '針織褲',
            'ja': 'ニットパンツ',
            'de': 'Strickhose',
            'fr': 'Pantalon en tricot',
            'it': 'Pantaloni in maglia',
            'ko': '스웨터 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '背带裤',
            'en': 'overalls',
            'zh-hant': '背帶褲',
            'ja': 'オーバーオール',
            'de': 'Latzhose',
            'fr': 'Salopette',
            'it': 'Salopette',
            'ko': '오버올'
          },
          {
            'order': 1,
            'zh-cn': '哈伦裤',
            'en': 'harem pants',
            'zh-hant': '燈籠褲',
            'ja': 'バルーンパンツ',
            'de': 'Ballonhose',
            'fr': 'Pantalon ballon',
            'it': 'Pantaloni a palloncino',
            'ko': '배기 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '直筒裤',
            'en': 'straight leg pants',
            'zh-hant': '直筒褲',
            'ja': 'ストレートパンツ',
            'de': 'Gerade Hose',
            'fr': 'Pantalon droit',
            'it': 'Pantaloni dritti',
            'ko': '스트레이트 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '运动裤',
            'en': 'sweatpants',
            'zh-hant': '運動褲',
            'ja': 'スポーツパンツ',
            'de': 'Sporthose',
            'fr': 'Pantalon de sport',
            'it': 'Pantaloni sportivi',
            'ko': '트레이닝'
          },
          {
            'order': 1,
            'zh-cn': '卫裤',
            'en': 'track pants',
            'zh-hant': '衛褲',
            'ja': 'スウェットパンツ',
            'de': 'Jogginghose',
            'fr': 'Pantalon de jogging',
            'it': 'Pantaloni felpati',
            'ko': '트랙 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '降落伞裤',
            'en': 'parachute pants',
            'zh-hant': '降落傘褲',
            'ja': 'パラシュートパンツ',
            'de': 'Fallschirmhose',
            'fr': 'Pantalon parachute',
            'it': 'Pantaloni paracadute',
            'ko': '패러슈트 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '吊档裤',
            'en': 'bib overalls',
            'zh-hant': '吊檔褲',
            'ja': 'ドロップクロッチパンツ',
            'de': 'Tiefhängende Hose',
            'fr': 'Pantalon à entrejambe tombante',
            'it': 'Pantaloni con cavallo basso',
            'ko': 'BIB 멜빵'
          },
          {
            'order': 1,
            'zh-cn': '多袋裤',
            'en': 'cargo pants',
            'zh-hant': '工裝褲',
            'ja': 'カーゴパンツ',
            'de': 'Cargohose',
            'fr': 'Pantalon cargo',
            'it': 'Pantaloni cargo',
            'ko': '카고 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '锥形裤',
            'en': 'culottes',
            'zh-hant': '錐形褲',
            'ja': 'テーパードパンツ',
            'de': 'Kegelhose',
            'fr': 'Pantalon fuselé',
            'it': 'Pantaloni affusolati',
            'ko': '퀼로트'
          },
          {
            'order': 1,
            'zh-cn': '七分裤',
            'en': 'crop pants',
            'zh-hant': '五分-九分褲',
            'ja': 'クロップドパンツ',
            'de': '5/8-Hose',
            'fr': 'Pantalon court 5-9',
            'it': 'Pantaloni 5/8',
            'ko': '크롭 바지'
          },
          {
            'order': 1,
            'zh-cn': '萝卜裤',
            'en': 'carrot pants',
            'zh-hant': '蘿蔔褲',
            'ja': 'キャロットパンツ',
            'de': 'Karottenhose',
            'fr': 'Pantalon carotte',
            'it': 'Pantaloni carota',
            'ko': '캐롯 팬츠'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '裙子', en: 'Dress', 'zh-hant': '裙子', ja: 'スカート', de: 'Rock', fr: 'Jupe', it: 'Gonna', ko: '치마' },
        'list': [
          {
            'order': 1,
            'zh-cn': '连衣裙',
            'en': 'maxi dress',
            'zh-hant': 'Maxi 連衣裙',
            'ja': 'マキシドレス',
            'de': 'Maxikleid',
            'fr': 'Robe maxi',
            'it': 'Vestito maxi',
            'ko': '맥시 드레스'
          },
          {
            'order': 1,
            'zh-cn': '牛仔裙',
            'en': 'denim skirt',
            'zh-hant': '牛仔裙',
            'ja': 'デニムスカート',
            'de': 'Jeansrock',
            'fr': 'Jupe en jean',
            'it': 'Gonna di jeans',
            'ko': '데님 스커트'
          },
          {
            'order': 1,
            'zh-cn': '针织连衣裙',
            'en': 'knit dress',
            'zh-hant': '針織連衣裙',
            'ja': 'ニットドレス',
            'de': 'Strickkleid',
            'fr': 'Robe en tricot',
            'it': 'Vestito in maglia',
            'ko': '스웨터 드레스'
          },
          {
            'order': 1,
            'zh-cn': '牛仔半裙',
            'en': 'denim mini skirt',
            'zh-hant': '牛仔迷你裙',
            'ja': 'デニムミニスカート',
            'de': 'Jeansminirock',
            'fr': 'Mini-jupe en jean',
            'it': 'Minigonna di jeans',
            'ko': '데님 미니스커트'
          },
          {
            'order': 1,
            'zh-cn': 'a裙',
            'en': 'a-line skirt',
            'zh-hant': 'A字裙',
            'ja': 'Aラインスカート',
            'de': 'A-Linien-Rock',
            'fr': 'Jupe évasée',
            'it': 'Gonna a trapezio',
            'ko': 'A라인 스커트'
          },
          {
            'order': 1,
            'zh-cn': '半裙',
            'en': 'midi skirt',
            'zh-hant': '中長裙',
            'ja': 'ミディスカート',
            'de': 'Midirock',
            'fr': 'Jupe midi',
            'it': 'Gonna midi',
            'ko': '미디 스커트'
          },
          {
            'order': 1,
            'zh-cn': '公主裙',
            'en': 'princess dress',
            'zh-hant': '公主裙',
            'ja': 'プリンセスドレス',
            'de': 'Prinzessinkleid',
            'fr': 'Robe princesse',
            'it': 'Abito da principessa',
            'ko': '프린세스 드레스'
          },
          {
            'order': 1,
            'zh-cn': '衬衫连衣裙',
            'en': 'shirtdress',
            'zh-hant': '襯衫裙',
            'ja': 'シャツドレス',
            'de': 'Hemdblusenkleid',
            'fr': 'Robe chemise',
            'it': 'Chemisier',
            'ko': '셔츠 드레스'
          },
          {
            'order': 1,
            'zh-cn': '牛仔连衣裙',
            'en': 'denim dress',
            'zh-hant': '牛仔連衣裙',
            'ja': 'デニムドレス',
            'de': 'Jeanskleid',
            'fr': 'Robe en jean',
            'it': 'Vestito di jeans',
            'ko': '데님 드레스'
          },
          {
            'order': 1,
            'zh-cn': '百褶裙',
            'en': 'pleated skirt',
            'zh-hant': '百褶裙',
            'ja': 'プリーツスカート',
            'de': 'Faltenrock',
            'fr': 'Jupe plissée',
            'it': 'Gonna plissettata',
            'ko': '플리츠 스커트'
          },
          {
            'order': 1,
            'zh-cn': '背带裙',
            'en': 'pinafore dress',
            'zh-hant': '圍裙裙',
            'ja': 'ジャンパースカート',
            'de': 'Schürzenkleid',
            'fr': 'Robe chasuble',
            'it': 'Vestito a grembiule',
            'ko': '피나포어 드레스'
          },
          {
            'order': 1,
            'zh-cn': '抹胸连衣裙',
            'en': 'strapless dress',
            'zh-hant': '無肩帶連衣裙',
            'ja': 'ストラップレスドレス',
            'de': 'Trägerloses Kleid',
            'fr': 'Robe bustier',
            'it': 'Vestito senza spalline',
            'ko': '스트랩리스 드레스'
          },
          {
            'order': 1,
            'zh-cn': '铅笔裙',
            'en': 'pencil skirt',
            'zh-hant': '鉛筆裙',
            'ja': 'ペンシルスカート',
            'de': 'Bleistiftrock',
            'fr': 'Jupe crayon',
            'it': 'Gonna a matita',
            'ko': '펜슬 스커트'
          },
          {
            'order': 1,
            'zh-cn': '多层裙',
            'en': 'tiered skirt',
            'zh-hant': '層疊裙',
            'ja': 'ティアードスカート',
            'de': 'Stufenrock',
            'fr': 'Jupe à volants',
            'it': 'Gonna a balze',
            'ko': '티어드 스커트'
          },
          {
            'order': 1,
            'zh-cn': '郁金香裙',
            'en': 'tulip skirt',
            'zh-hant': '鬱金香裙',
            'ja': 'チューリップスカート',
            'de': 'Tulpenrock',
            'fr': 'Jupe tulipe',
            'it': 'Gonna a tulipano',
            'ko': '튤립 스커트'
          },
          {
            'order': 1,
            'zh-cn': '吊带裙',
            'en': 'spaghetti strap dress',
            'zh-hant': '細肩帶連衣裙',
            'ja': 'スパゲッティストラップドレス',
            'de': 'Spaghettiträgerkleid',
            'fr': 'Robe à bretelles spaghetti',
            'it': 'Vestito con spalline sottili',
            'ko': '스파게티 스트랩 드레스'
          },
          {
            'order': 1,
            'zh-cn': '卫衣连衣裙',
            'en': 'sweatshirt dress',
            'zh-hant': '衛衣連衣裙',
            'ja': 'スウェットシャツドレス',
            'de': 'Sweatshirtkleid',
            'fr': 'Robe sweat',
            'it': 'Vestito felpa',
            'ko': '스웨트셔츠 드레스'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '毛衫', en: 'Sweater', 'zh-hant': '毛衫', ja: 'セーター', de: 'Pullover', fr: 'Pull', it: 'Maglione', ko: '스웨터' },
        'list': [
          {
            'order': 1,
            'zh-cn': '毛织裙',
            'en': 'knit dress',
            'zh-hant': '針織連衣裙',
            'ja': 'ニットドレス',
            'de': 'Strickkleid',
            'fr': 'Robe en tricot',
            'it': 'Vestito in maglia',
            'ko': '스웨터 드레스'
          },
          {
            'order': 1,
            'zh-cn': '开衫',
            'en': 'cardigan sweater',
            'zh-hant': '開衫',
            'ja': 'カーディガン',
            'de': 'Strickjacke',
            'fr': 'Gilet',
            'it': 'Cardigan',
            'ko': '가디건 스웨터'
          },
          {
            'order': 1,
            'zh-cn': '毛织裤',
            'en': 'knit pants',
            'zh-hant': '針織褲',
            'ja': 'ニットパンツ',
            'de': 'Strickhose',
            'fr': 'Pantalon en tricot',
            'it': 'Pantaloni in maglia',
            'ko': '스웨터 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '毛衫背心',
            'en': 'sweater vest',
            'zh-hant': '毛衣背心',
            'ja': 'ニットベスト',
            'de': 'Strickweste',
            'fr': 'Débardeur en tricot',
            'it': 'Gilet di maglia',
            'ko': '스웨터 조끼'
          },
          {
            'order': 1,
            'zh-cn': '毛衣',
            'en': 'pullover sweater',
            'zh-hant': '毛衣',
            'ja': 'ニットセーター',
            'de': 'Strickpullover',
            'fr': 'Pull',
            'it': 'Maglione',
            'ko': '풀오버 스웨터'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '内衣', en: 'Lingerie', 'zh-hant': '內衣', ja: '下着', de: 'Unterwäsche', fr: 'Sous-vêtements', it: 'Intimo', ko: '란제리' },
        'list': [
          {
            'order': 1,
            'zh-cn': '文胸',
            'en': 'bra',
            'zh-hant': '文胸',
            'ja': 'ブラ',
            'de': 'BH',
            'fr': 'Soutien-gorge',
            'it': 'reggiseno',
            'ko': '브래지어'
          },
          {
            'order': 1,
            'zh-cn': '抹胸',
            'en': 'bandeau',
            'zh-hant': '抹胸',
            'ja': 'バンドゥー',
            'de': 'Bandeau-BH',
            'fr': 'Bandeau',
            'it': 'bandeau',
            'ko': '반도 브라'
          },
          {
            'order': 1,
            'zh-cn': '钢圈文胸',
            'en': 'underwire bra',
            'zh-hant': '鋼圈文胸',
            'ja': 'ワイヤーブラ',
            'de': 'Bügel-BH',
            'fr': 'Soutien-gorge à armatures',
            'it': 'reggiseno con ferretto',
            'ko': '와이어 브라'
          },
          {
            'order': 1,
            'zh-cn': '法式文胸',
            'en': 'balconette bra',
            'zh-hant': '法式文胸',
            'ja': 'バルコネットブラ',
            'de': 'Balconette-BH',
            'fr': 'Soutien-gorge balconnet',
            'it': 'reggiseno balconcino',
            'ko': '발코네트 브라'
          },
          {
            'order': 1,
            'zh-cn': '无钢圈文胸',
            'en': 'wire-free bra',
            'zh-hant': '無鋼圈文胸',
            'ja': 'ワイヤーレスブラ',
            'de': 'Bügelloser BH',
            'fr': 'Soutien-gorge sans armatures',
            'it': 'reggiseno senza ferretto',
            'ko': '와이어 없는 브라'
          },
          {
            'order': 1,
            'zh-cn': '薄杯文胸',
            'en': 'demi-cup bra',
            'zh-hant': '薄杯文胸',
            'ja': 'デミカップブラ',
            'de': 'Demi-Cup-BH',
            'fr': 'Soutien-gorge demi-bonnet',
            'it': 'reggiseno demi-cup',
            'ko': '반컵 브라'
          },
          {
            'order': 1,
            'zh-cn': '光面文胸',
            'en': 'smooth bra',
            'zh-hant': '光面文胸',
            'ja': 'スムースブラ',
            'de': 'Glatter BH',
            'fr': 'Soutien-gorge lisse',
            'it': 'reggiseno liscio',
            'ko': '부드러운 브라'
          },
          {
            'order': 1,
            'zh-cn': '美背文胸',
            'en': 'backless bra',
            'zh-hant': '美背文胸',
            'ja': 'バックレスブラ',
            'de': 'Rückenfreier BH',
            'fr': 'Soutien-gorge dos nu',
            'it': 'reggiseno senza schienale',
            'ko': '백리스 브라'
          },
          {
            'order': 1,
            'zh-cn': '睡眠文胸',
            'en': 'sleep bra',
            'zh-hant': '睡眠文胸',
            'ja': 'スリープブラ',
            'de': 'Schlaf-BH',
            'fr': 'Soutien-gorge de nuit',
            'it': 'reggiseno da notte',
            'ko': '슬립 브라'
          },
          {
            'order': 1,
            'zh-cn': '半杯文胸',
            'en': 'half-cup bra',
            'zh-hant': '半杯文胸',
            'ja': 'ハーフカップブラ',
            'de': 'Halbschalen-BH',
            'fr': 'Soutien-gorge demi-cup',
            'it': 'reggiseno mezza-coppa',
            'ko': '반컵 브라'
          },
          {
            'order': 1,
            'zh-cn': '哺乳文胸',
            'en': 'nursing bra',
            'zh-hant': '哺乳文胸',
            'ja': '授乳用ブラ',
            'de': 'Still-BH',
            'fr': 'Soutien-gorge d\'allaitement',
            'it': 'reggiseno per allattamento',
            'ko': '수유 브라'
          },
          {
            'order': 1,
            'zh-cn': '无痕文胸',
            'en': 'invisible bra',
            'zh-hant': '無痕文胸',
            'ja': 'インビジブルブラ',
            'de': 'Unsichtbarer BH',
            'fr': 'Soutien-gorge invisible',
            'it': 'reggiseno invisibile',
            'ko': '인비저블 브라'
          },
          {
            'order': 1,
            'zh-cn': '调整型文胸',
            'en': 'push-up bra',
            'zh-hant': '調整型文胸',
            'ja': 'プッシュアップブラ',
            'de': 'Push-up-BH',
            'fr': 'Soutien-gorge push-up',
            'it': 'reggiseno push-up',
            'ko': '푸시업 브라'
          },
          {
            'order': 1,
            'zh-cn': '运动文胸',
            'en': 'sports bra',
            'zh-hant': '運動文胸',
            'ja': 'スポーツブラ',
            'de': 'Sport-BH',
            'fr': 'Soutien-gorge de sport',
            'it': 'reggiseno sportivo',
            'ko': '스포츠 브라'
          },
          {
            'order': 1,
            'zh-cn': '情趣文胸',
            'en': 'lingerie bra',
            'zh-hant': '情趣文胸',
            'ja': 'ランジェリーブラ',
            'de': 'Lingerie-BH',
            'fr': 'soutien-gorge en dentelle',
            'it': 'reggiseno in pizzo',
            'ko': '란제리 브라'
          },
          {
            'order': 1,
            'zh-cn': '内裤',
            'en': 'panties',
            'zh-hant': '內褲',
            'ja': 'パンティ',
            'de': 'Slip',
            'fr': 'culotte',
            'it': 'mutandine',
            'ko': '팬티'
          },
          {
            'order': 1,
            'zh-cn': '高腰内裤',
            'en': 'high-waist panties',
            'zh-hant': '高腰內褲',
            'ja': 'ハイウエストパンティ',
            'de': 'Hoher Taillenslip',
            'fr': 'culotte taille haute',
            'it': 'mutandine a vita alta',
            'ko': '하이웨이스트 팬티'
          },
          {
            'order': 1,
            'zh-cn': '丁字裤',
            'en': 'thong',
            'zh-hant': '丁字褲',
            'ja': 'Tバック',
            'de': 'String',
            'fr': 'string',
            'it': 'perizoma',
            'ko': '텅 / 스윔웨어 팬티'
          },
          {
            'order': 1,
            'zh-cn': '松身内裤',
            'en': 'loose-fit panties',
            'zh-hant': '寬鬆內褲',
            'ja': 'ルーズフィットパンティ',
            'de': 'Lockere Slips',
            'fr': 'culotte ample',
            'it': 'mutandine larghe',
            'ko': '루즈핏 팬티'
          },
          {
            'order': 1,
            'zh-cn': '平角内裤',
            'en': 'boxer briefs',
            'zh-hant': '平角內褲',
            'ja': 'ボクサーパンツ',
            'de': 'Boxershorts',
            'fr': 'culotte boxer',
            'it': 'boxer',
            'ko': '복서 팬티'
          },
          {
            'order': 1,
            'zh-cn': '安全裤',
            'en': 'period panties',
            'zh-hant': '安全褲',
            'ja': '生理用パンティ',
            'de': 'Periodenslip',
            'fr': 'culotte périodique',
            'it': 'mutandine per il ciclo',
            'ko': '생리 팬티'
          },
          {
            'order': 1,
            'zh-cn': '三角内裤',
            'en': 'bikini panties',
            'zh-hant': '三角內褲',
            'ja': 'ビキニパンティ',
            'de': 'Bikini-Slip',
            'fr': 'culotte bikini',
            'it': 'mutandine bikini',
            'ko': '비키니 팬티'
          },
          {
            'order': 1,
            'zh-cn': '孕妇内裤',
            'en': 'maternity panties',
            'zh-hant': '孕婦內褲',
            'ja': 'マタニティーパンティ',
            'de': 'Umstandsslip',
            'fr': 'culotte de maternité',
            'it': 'mutandine premaman',
            'ko': '임산부 팬티'
          },
          {
            'order': 1,
            'zh-cn': '情趣内裤',
            'en': 'lingerie panties',
            'zh-hant': '情趣內褲',
            'ja': 'ランジェリーパンティ',
            'de': 'Sexy Unterwäsche',
            'fr': 'culotte sexy',
            'it': 'mutandine sexy',
            'ko': '란제리 팬티'
          },
          {
            'order': 1,
            'zh-cn': '吊袜带内裤',
            'en': 'garter belt',
            'zh-hant': '吊襪帶內褲',
            'ja': 'ガーターベルト',
            'de': 'Strumpfhalter',
            'fr': 'porte-jarretelles culotte',
            'it': 'reggicalze mutandine',
            'ko': '가터벨트'
          },
          {
            'order': 1,
            'zh-cn': '生理内裤',
            'en': 'menstrual underwear',
            'zh-hant': '生理內褲',
            'ja': '生理用下着',
            'de': 'Menstruationsslip',
            'fr': 'culotte menstruelle',
            'it': 'mutandine assorbenti',
            'ko': '생리용 속옷'
          },
          {
            'order': 1,
            'zh-cn': '塑身美体',
            'en': 'shapewear',
            'zh-hant': '塑身美體',
            'ja': 'シェイプウェア',
            'de': 'Shapewear',
            'fr': 'lingerie sculptante',
            'it': 'lingerie modellante',
            'ko': '셰이프웨어'
          },
          {
            'order': 1,
            'zh-cn': '塑身美体腰封',
            'en': 'waist cincher',
            'zh-hant': '塑身美體腰封',
            'ja': 'ウエストシンチャー',
            'de': 'Taillenformer',
            'fr': 'ceinture gainante',
            'it': 'cintura modellante',
            'ko': '웨이스트 신처'
          },
          {
            'order': 1,
            'zh-cn': '塑身裤',
            'en': 'body shaper',
            'zh-hant': '塑身褲',
            'ja': 'ボディシェイパー',
            'de': 'Body Shaper',
            'fr': 'body sculptant',
            'it': 'body modellante',
            'ko': '바디 쉐이퍼'
          },
          {
            'order': 1,
            'zh-cn': '连体塑身衣',
            'en': 'full-body shaper',
            'zh-hant': '連體塑身衣',
            'ja': '全身シェイパー',
            'de': 'Ganzkörper-Shaper',
            'fr': 'body sculptant intégral',
            'it': 'body modellante integrale',
            'ko': '풀 바디 쉐이퍼'
          },
          {
            'order': 1,
            'zh-cn': '塑身背心',
            'en': 'shaping tank top',
            'zh-hant': '塑身背心',
            'ja': 'シェイピングタンクトップ',
            'de': 'Shaping Tanktop',
            'fr': 'débardeur gainant',
            'it': 'canottiera modellante',
            'ko': '쉐이핑 탱크탑'
          },
          {
            'order': 1,
            'zh-cn': '塑身胸衣',
            'en': 'shaping camisole',
            'zh-hant': '塑身胸衣',
            'ja': 'シェイピングキャミソール',
            'de': 'Shaping-Camisole',
            'fr': 'caraco sculptant',
            'it': 'canotta modellante',
            'ko': '쉐이핑 카미솔'
          },
          {
            'order': 1,
            'zh-cn': '孕妇文胸',
            'en': 'maternity support bra',
            'zh-hant': '孕婦文胸',
            'ja': 'マタニティサポートブラ',
            'de': 'Umstands-Stütz-BH',
            'fr': 'soutien-gorge de maternité',
            'it': 'reggiseno per maternità',
            'ko': '임산부 지원 브라'
          },
          {
            'order': 1,
            'zh-cn': '塑身胸托',
            'en': 'breast lifter',
            'zh-hant': '塑身胸托',
            'ja': 'ブレストリフター',
            'de': 'Brustformer',
            'fr': 'soutien-gorge rehausseur',
            'it': 'reggiseno rialzante',
            'ko': '브래스트 리프터'
          },
          {
            'order': 1,
            'zh-cn': '打底衣',
            'en': 'camisole',
            'zh-hant': '打底衣',
            'ja': 'キャミソール',
            'de': 'Camisole',
            'fr': 'caraco',
            'it': 'canotta',
            'ko': '캐미솔'
          },
          {
            'order': 1,
            'zh-cn': '保暖内衣',
            'en': 'thermal underwear',
            'zh-hant': '保暖內衣',
            'ja': '保温下着',
            'de': 'Thermounterwäsche',
            'fr': 'sous-vêtement thermique',
            'it': 'intimo termico',
            'ko': '발열 속옷'
          },
          {
            'order': 1,
            'zh-cn': '连体内衣',
            'en': 'bodysuit',
            'zh-hant': '連體內衣',
            'ja': 'ボディスーツ',
            'de': 'Body',
            'fr': 'body',
            'it': 'body',
            'ko': '바디수트'
          },
          {
            'order': 1,
            'zh-cn': '背心式内衣',
            'en': 'tank top',
            'zh-hant': '背心',
            'ja': 'タンクトップ',
            'de': 'Tanktop',
            'fr': 'Débardeur',
            'it': 'Canottiera',
            'ko': '탱크탑'
          },
          {
            'order': 1,
            'zh-cn': '情趣内衣',
            'en': 'lingerie',
            'zh-hant': '情趣內衣',
            'ja': 'ランジェリー',
            'de': 'Lingerie',
            'fr': 'lingerie',
            'it': 'lingerie',
            'ko': '란제리'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '泳装', en: 'Swimwear', 'zh-hant': '泳裝', ja: '水着', de: 'Badeanzug', fr: 'Maillot de bain', it: 'Costume da bagno', ko: '수영복' },
        'list': [
          {
            'order': 1,
            'zh-cn': '连体泳装',
            'en': 'one-piece swimsuit',
            'zh-hant': '連身泳裝',
            'ja': 'ワンピース水着',
            'de': 'Badeanzug',
            'fr': 'maillot de bain une pièce',
            'it': 'costume intero',
            'ko': '원피스 수영복'
          },
          {
            'order': 1,
            'zh-cn': '比基尼',
            'en': 'bikini',
            'zh-hant': '比基尼',
            'ja': 'ビキニ',
            'de': 'Bikini',
            'fr': 'bikini',
            'it': 'bikini',
            'ko': '비키니'
          },
          {
            'order': 1,
            'zh-cn': '比基尼上衣',
            'en': 'bikini top',
            'zh-hant': '比基尼上衣',
            'ja': 'ビキニトップス',
            'de': 'Bikinioberteil',
            'fr': 'haut de bikini',
            'it': 'top bikini',
            'ko': '비키니 탑'
          },
          {
            'order': 1,
            'zh-cn': '泳裤',
            'en': 'swim bottom',
            'zh-hant': '泳褲',
            'ja': '水泳パンツ',
            'de': 'Badehose',
            'fr': 'bas de maillot de bain',
            'it': 'slip da bagno',
            'ko': '수영복 하의'
          },
          {
            'order': 1,
            'zh-cn': '三角泳裤',
            'en': 'triangle bikini bottom',
            'zh-hant': '三角泳褲',
            'ja': '三角ビキニ',
            'de': 'Bikinihose',
            'fr': 'bikini à taille basse',
            'it': 'bikini a vita bassa',
            'ko': '삼각 비키니 하의'
          },
          {
            'order': 1,
            'zh-cn': '平角泳裤',
            'en': 'bikini briefs',
            'zh-hant': '平角泳褲',
            'ja': 'ボーイショーツ',
            'de': 'Shorts',
            'fr': 'short de bain',
            'it': 'short da bagno',
            'ko': '비키니 브리프'
          },
          {
            'order': 1,
            'zh-cn': '分体泳装',
            'en': 'two-piece swimsuit',
            'zh-hant': '分體泳裝',
            'ja': 'ツーピース水着',
            'de': 'Zweiteiliger Badeanzug',
            'fr': 'maillot de bain deux pièces',
            'it': 'costume da bagno due pezzi',
            'ko': '투피스 수영복'
          },
          {
            'order': 1,
            'zh-cn': '分体泳衣上衣',
            'en': 'swim top',
            'zh-hant': '分體泳衣上衣',
            'ja': 'ツーピース水着トップス',
            'de': 'Zweiteiliges Badeanzugoberteil',
            'fr': 'haut de maillot de bain deux pièces',
            'it': 'top costume da bagno due pezzi',
            'ko': '수영 상의'
          },
          {
            'order': 1,
            'zh-cn': '孕妇泳装',
            'en': 'maternity swimwear',
            'zh-hant': '孕婦泳裝',
            'ja': 'マタニティ水着',
            'de': 'Umstandsbademode',
            'fr': 'maillot de bain de maternité',
            'it': 'costume da bagno premaman',
            'ko': '임산부 수영복'
          },
          {
            'order': 1,
            'zh-cn': '冲浪泳装',
            'en': 'surfing swimsuit',
            'zh-hant': '衝浪泳裝',
            'ja': 'サーフィン水着',
            'de': 'Surfbadeanzug',
            'fr': 'maillot de bain de surf',
            'it': 'costume da bagno da surf',
            'ko': '서핑수트'
          },
          {
            'order': 1,
            'zh-cn': '潜水泳衣',
            'en': 'diving wetsuit',
            'zh-hant': '潛水泳衣',
            'ja': 'ダイビングスーツ',
            'de': 'Taucheranzug',
            'fr': 'combinaison de plongée',
            'it': 'muta da sub',
            'ko': '다이빙수트'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '家居服', en: 'Loungewear', 'zh-hant': '家居服', ja: '水着', de: 'Hausbekleidung', fr: 'Vêtements de maison', it: 'Abbigliamento per la casa', ko: '라운지웨어' },
        'list': [
          {
            'order': 1,
            'zh-cn': '家居服套装',
            'en': 'loungewear set',
            'zh-hant': '居家服套裝',
            'ja': 'ルームウェアセット',
            'de': 'Loungewear-Set',
            'fr': 'Ensemble de vêtements de détente',
            'it': 'Set di abbigliamento da casa',
            'ko': '라운지웨어 세트'
          },
          {
            'order': 1,
            'zh-cn': '孕妈装',
            'en': 'maternity loungewear',
            'zh-hant': '孕婦居家服',
            'ja': 'マタニティルームウェア',
            'de': 'Umstandsloungewear',
            'fr': 'Vêtements de détente de maternité',
            'it': 'Abbigliamento da casa per maternità',
            'ko': '임산부 라운지웨어'
          },
          {
            'order': 1,
            'zh-cn': '睡袍',
            'en': 'robe',
            'zh-hant': '浴袍',
            'ja': 'ローブ',
            'de': 'Morgenmantel',
            'fr': 'Peignoir',
            'it': 'Vestaglia',
            'ko': '로브'
          },
          {
            'order': 1,
            'zh-cn': '吊带上衣',
            'en': 'camisole',
            'zh-hant': '打底衣',
            'ja': 'キャミソール',
            'de': 'Camisole',
            'fr': 'caraco',
            'it': 'canotta',
            'ko': '캐미솔'
          },
          {
            'order': 1,
            'zh-cn': '睡衣',
            'en': 'pajamas',
            'zh-hant': '睡衣',
            'ja': 'パジャマ',
            'de': 'Schlafanzug',
            'fr': 'Pyjama',
            'it': 'Pigiama',
            'ko': '파자마'
          },
          {
            'order': 1,
            'zh-cn': '连体家居服',
            'en': 'onesie',
            'zh-hant': '連體衣',
            'ja': 'オールインワン',
            'de': 'Strampler',
            'fr': 'Grenouillère',
            'it': 'Tutina',
            'ko': '원지'
          },
          {
            'order': 1,
            'zh-cn': '睡裤',
            'en': 'pajama pants',
            'zh-hant': '睡褲',
            'ja': 'パジャマパンツ',
            'de': 'Schlafanzughose',
            'fr': 'Pantalon de pyjama',
            'it': 'Pantaloni del pigiama',
            'ko': '파자마 바지'
          },
          {
            'order': 1,
            'zh-cn': '睡裙',
            'en': 'pajama shorts',
            'zh-hant': '睡短褲',
            'ja': 'パジャマショーツ',
            'de': 'Schlafshorts',
            'fr': 'Short de pyjama',
            'it': 'Pantaloncini del pigiama',
            'ko': '파자마 반바지'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '皮装', en: 'Leatherwear', 'zh-hant': '皮裝', ja: 'レザーウェア', de: 'Lederkleidung', fr: 'Vêtements en cuir', it: 'Abbigliamento in pelle', ko: '가죽 의류' },
        'list': [
          {
            'order': 1,
            'zh-cn': '皮毛一体',
            'en': 'shearling jacket',
            'zh-hant': '羊毛外套',
            'ja': 'シアリングジャケット',
            'de': 'Schaffelljacke',
            'fr': 'Veste en shearling',
            'it': 'Giacca in shearling',
            'ko': '시어링 자켓'
          },
          {
            'order': 1,
            'zh-cn': '皮裙',
            'en': 'leather skirt',
            'zh-hant': '皮裙',
            'ja': 'レザースカート',
            'de': 'Lederrock',
            'fr': 'Jupe en cuir',
            'it': 'Gonna di pelle',
            'ko': '가죽 치마'
          },
          {
            'order': 1,
            'zh-cn': '皮草',
            'en': 'leather fur',
            'zh-hant': '皮毛',
            'ja': 'レザーファー',
            'de': 'Lederfell',
            'fr': 'Fourrure en cuir',
            'it': 'Pelliccia di pelle',
            'ko': '가죽 퍼'
          },
          {
            'order': 1,
            'zh-cn': '皮裤',
            'en': 'leather pants',
            'zh-hant': '皮褲',
            'ja': 'レザーパンツ',
            'de': 'Lederhose',
            'fr': 'Pantalon en cuir',
            'it': 'Pantaloni di pelle',
            'ko': '가죽 바지'
          },
          {
            'order': 1,
            'zh-cn': '皮衣',
            'en': 'leather jacket',
            'zh-hant': '皮夾克',
            'ja': 'レザージャケット',
            'de': 'Lederjacke',
            'fr': 'Veste en cuir',
            'it': 'Giacca di pelle',
            'ko': '가죽 자켓'
          },
          {
            'order': 1,
            'zh-cn': '皮衬衫',
            'en': 'leather shirt',
            'zh-hant': '皮襯衫',
            'ja': 'レザーシャツ',
            'de': 'Lederhemd',
            'fr': 'Chemise en cuir',
            'it': 'Camicia di pelle',
            'ko': '가죽 셔츠'
          },
          {
            'order': 1,
            'zh-cn': '漆皮',
            'en': 'patent leather jacket',
            'zh-hant': '漆皮夾克',
            'ja': 'エナメルレザージャケット',
            'de': 'Lacklederjacke',
            'fr': 'Veste en cuir verni',
            'it': 'Giacca di pelle verniciata',
            'ko': '유광 가죽 자켓'
          },
          {
            'order': 1,
            'zh-cn': '皮风衣',
            'en': 'leather trench coat',
            'zh-hant': '皮風衣',
            'ja': 'レザートレンチコート',
            'de': 'Ledermantel',
            'fr': 'Trench-coat en cuir',
            'it': 'Trench di pelle',
            'ko': '가죽 트렌치코트'
          },
          {
            'order': 1,
            'zh-cn': '皮西服',
            'en': 'leather suit',
            'zh-hant': '皮西裝',
            'ja': 'レザースーツ',
            'de': 'Lederanzug',
            'fr': 'Costume en cuir',
            'it': 'Completo di pelle',
            'ko': '가죽 수트'
          },
          {
            'order': 1,
            'zh-cn': '皮装棉衣',
            'en': 'leather down jacket',
            'zh-hant': '皮羽絨外套',
            'ja': 'レザーダウンジャケット',
            'de': 'Lederdaunenjacke',
            'fr': 'Doudoune en cuir',
            'it': 'Piumino di pelle',
            'ko': '가죽 패딩'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '套装', en: 'Suit', 'zh-hant': '套裝', ja: 'スーツ', de: 'Anzug', fr: 'Ensemble', it: 'Completo', ko: '정장' },
        'list': [
          {
            'order': 1,
            'zh-cn': '大童套装',
            'en': 'big kid\'s suit',
            'zh-hant': '大童西裝',
            'ja': '大きな子供用スーツ',
            'de': 'Anzug für große Kinder',
            'fr': 'Costume pour grand enfant',
            'it': 'Abito per ragazzi grandi',
            'ko': '큰아이 정장'
          },
          {
            'order': 1,
            'zh-cn': '校服',
            'en': 'school uniform',
            'zh-hant': '校服',
            'ja': '学校の制服',
            'de': 'Schuluniform',
            'fr': 'Uniforme scolaire',
            'it': 'Uniforme scolastica',
            'ko': '교복'
          },
          {
            'order': 1,
            'zh-cn': '小童套装',
            'en': 'little kid\'s suit',
            'zh-hant': '小童西裝',
            'ja': '小さな子供用スーツ',
            'de': 'Anzug für kleine Kinder',
            'fr': 'Costume pour petit enfant',
            'it': 'Abito per bambini piccoli',
            'ko': '작은아이 정장'
          },
          {
            'order': 1,
            'zh-cn': '西装套装',
            'en': 'suit',
            'zh-hant': '西裝',
            'ja': 'スーツ',
            'de': 'Anzug',
            'fr': 'Costume',
            'it': 'Abito',
            'ko': '정장'
          },
          {
            'order': 1,
            'zh-cn': '运动套装',
            'en': 'sports suit',
            'zh-hant': '運動服',
            'ja': 'スポーツスーツ',
            'de': 'Sportanzug',
            'fr': 'Costume de sport',
            'it': 'Abito sportivo',
            'ko': '스포츠 정장'
          },
          {
            'order': 1,
            'zh-cn': '时尚套装',
            'en': 'fashion suit',
            'zh-hant': '時尚西裝',
            'ja': 'ファッションスーツ',
            'de': 'Modischer Anzug',
            'fr': 'Costume de mode',
            'it': 'Abito alla moda',
            'ko': '패션 정장'
          },
          {
            'order': 1,
            'zh-cn': '休闲套装',
            'en': 'casual suit',
            'zh-hant': '休閒西裝',
            'ja': 'カジュアルスーツ',
            'de': 'Freizeitanzug',
            'fr': 'Costume décontracté',
            'it': 'Abito casual',
            'ko': '캐주얼 정장'
          },
          {
            'order': 1,
            'zh-cn': '职业套装',
            'en': 'professional suit',
            'zh-hant': '職業西裝',
            'ja': 'プロフェッショナルスーツ',
            'de': 'Professioneller Anzug',
            'fr': 'Costume professionnel',
            'it': 'Abito professionale',
            'ko': '전문 정장'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '骑行服', en: 'Cycling Wear', 'zh-hant': '騎行服', ja: 'サイクリングウェア', de: 'Radbekleidung', fr: 'Vêtements de cyclisme', it: 'Abbigliamento da ciclismo', ko: '사이클링 웨어' },
        'list': [
          {
            'order': 1,
            'zh-cn': '骑行上衣',
            'en': 'cycling jersey',
            'zh-hant': '單車騎行服',
            'ja': 'サイクリングジャージ',
            'de': 'Radtrikot',
            'fr': 'Maillot de cyclisme',
            'it': 'Maglia da ciclismo',
            'ko': '사이클링 저지'
          },
          {
            'order': 1,
            'zh-cn': '短袖骑行上衣',
            'en': 'short-sleeved cycling jersey',
            'zh-hant': '短袖單車騎行服',
            'ja': '半袖サイクリングジャージ',
            'de': 'Kurzärmliges Radtrikot',
            'fr': 'Maillot de cyclisme à manches courtes',
            'it': 'Maglia da ciclismo a maniche corte',
            'ko': '반소매 사이클링 저지'
          },
          {
            'order': 1,
            'zh-cn': '长袖骑行上衣',
            'en': 'long-sleeved cycling jersey',
            'zh-hant': '長袖單車騎行服',
            'ja': '長袖サイクリングジャージ',
            'de': 'Langärmliges Radtrikot',
            'fr': 'Maillot de cyclisme à manches longues',
            'it': 'Maglia da ciclismo a maniche lunghe',
            'ko': '긴소매 사이클링 저지'
          },
          {
            'order': 1,
            'zh-cn': '骑行短裤',
            'en': 'cycling shorts',
            'zh-hant': '單車短褲',
            'ja': 'サイクリングショーツ',
            'de': 'Radshorts',
            'fr': 'Cuissard de cyclisme',
            'it': 'Pantaloncini da ciclismo',
            'ko': '사이클링 쇼츠'
          },
          {
            'order': 1,
            'zh-cn': '无背带骑行短裤',
            'en': 'bib-less cycling shorts',
            'zh-hant': '無吊帶單車短褲',
            'ja': 'ビブなしサイクリングショーツ',
            'de': 'Radhose ohne Träger',
            'fr': 'Cuissard sans bretelles',
            'it': 'Pantaloncini da ciclismo senza bretelle',
            'ko': '빕 리스 사이클링 쇼츠'
          },
          {
            'order': 1,
            'zh-cn': '有背带骑行短裤',
            'en': 'bib cycling shorts',
            'zh-hant': '吊帶單車短褲',
            'ja': 'ビブ付きサイクリングショーツ',
            'de': 'Radhose mit Trägern',
            'fr': 'Cuissard à bretelles',
            'it': 'Pantaloncini da ciclismo con bretelle',
            'ko': '빕 사이클링 쇼츠'
          },
          {
            'order': 1,
            'zh-cn': '骑行裤',
            'en': 'cycling pants',
            'zh-hant': '單車長褲',
            'ja': 'サイクリングパンツ',
            'de': 'Radlerhose',
            'fr': 'Pantalon de cyclisme',
            'it': 'Pantaloni da ciclismo',
            'ko': '사이클링 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '骑行套装',
            'en': 'cycling kit',
            'zh-hant': '單車套裝',
            'ja': 'サイクリングキット',
            'de': 'Radoutfit',
            'fr': 'Ensemble de cyclisme',
            'it': 'Kit da ciclismo',
            'ko': '사이클링 키트'
          },
          {
            'order': 1,
            'zh-cn': '防晒披肩',
            'en': 'sun protection arm sleeve',
            'zh-hant': '防曬袖套',
            'ja': 'サンプロテクションアームスリーブ',
            'de': 'Sonnenschutzarmstulpe',
            'fr': 'Manchette de protection solaire',
            'it': 'Manicotto di protezione solare',
            'ko': '자외선 차단 팔 토시'
          },
          {
            'order': 1,
            'zh-cn': '骑行袜',
            'en': 'cycling socks',
            'zh-hant': '單車襪',
            'ja': 'サイクリングソックス',
            'de': 'Radsocken',
            'fr': 'Chaussettes de cyclisme',
            'it': 'Calze da ciclismo',
            'ko': '사이클링 양말'
          },
          {
            'order': 1,
            'zh-cn': '防晒面罩',
            'en': 'sun protection face mask',
            'zh-hant': '防曬面罩',
            'ja': 'サンプロテクションフェイスマスク',
            'de': 'Sonnenschutzgesichtsmaske',
            'fr': 'Masque de protection solaire',
            'it': 'Maschera facciale di protezione solare',
            'ko': '자외선 차단 페이스 마스크'
          },
          {
            'order': 1,
            'zh-cn': '骑行手套',
            'en': 'cycling gloves',
            'zh-hant': '單車手套',
            'ja': 'サイクリンググローブ',
            'de': 'Radfahrerhandschuhe',
            'fr': 'Gants de cyclisme',
            'it': 'Guanti da ciclismo',
            'ko': '사이클링 장갑'
          },
          {
            'order': 1,
            'zh-cn': '骑行鞋',
            'en': 'cycling shoes',
            'zh-hant': '單車鞋',
            'ja': 'サイクリングシューズ',
            'de': 'Radschuhe',
            'fr': 'Chaussures de cyclisme',
            'it': 'Scarpe da ciclismo',
            'ko': '사이클링 슈즈'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '瑜伽服', en: 'Yoga Wear', 'zh-hant': '瑜伽服', ja: 'ヨガウェア', de: 'Yogabekleidung', fr: 'Vêtements de yoga', it: 'Abbigliamento da yoga', ko: '요가복' },
        'list': [
          {
            'order': 1,
            'zh-cn': '瑜伽上衣',
            'en': 'yoga top',
            'zh-hant': '瑜伽上衣',
            'ja': 'ヨガトップ',
            'de': 'Yoga-Top',
            'fr': 'Haut de yoga',
            'it': 'Top da yoga',
            'ko': '요가 상의'
          },
          {
            'order': 1,
            'zh-cn': '运动背心',
            'en': 'sports tank top',
            'zh-hant': '運動背心',
            'ja': 'スポーツタンクトップ',
            'de': 'Sport-Tanktop',
            'fr': 'Débardeur de sport',
            'it': 'Canotta sportiva',
            'ko': '스포츠 탱크탑'
          },
          {
            'order': 1,
            'zh-cn': '瑜伽t恤',
            'en': 'yoga t-shirt',
            'zh-hant': '瑜伽T恤',
            'ja': 'ヨガTシャツ',
            'de': 'Yoga-T-Shirt',
            'fr': 'T-shirt de yoga',
            'it': 'T-shirt da yoga',
            'ko': '요가 티셔츠'
          },
          {
            'order': 1,
            'zh-cn': '瑜伽裤',
            'en': 'yoga pants',
            'zh-hant': '瑜伽褲',
            'ja': 'ヨガパンツ',
            'de': 'Yogahosen',
            'fr': 'Pantalon de yoga',
            'it': 'Pantaloni da yoga',
            'ko': '요가 바지'
          },
          {
            'order': 1,
            'zh-cn': '瑜伽紧身裤',
            'en': 'yoga leggings',
            'zh-hant': '瑜伽緊身褲',
            'ja': 'ヨガレギンス',
            'de': 'Yoga-Leggings',
            'fr': 'Leggings de yoga',
            'it': 'Leggings da yoga',
            'ko': '요가 레깅스'
          },
          {
            'order': 1,
            'zh-cn': '高腰瑜伽裤',
            'en': 'high-waisted yoga pants',
            'zh-hant': '高腰瑜伽褲',
            'ja': 'ハイウエストヨガパンツ',
            'de': 'Hochtaillierte Yogahosen',
            'fr': 'Pantalon de yoga taille haute',
            'it': 'Pantaloni da yoga a vita alta',
            'ko': '하이웨이스트 요가 바지'
          },
          {
            'order': 1,
            'zh-cn': '连体瑜伽服',
            'en': 'yoga jumpsuit',
            'zh-hant': '瑜伽連體衣',
            'ja': 'ヨガジャンプスーツ',
            'de': 'Yoga-Jumpsuit',
            'fr': 'Combinaison de yoga',
            'it': 'Tuta da yoga',
            'ko': '요가 점프수트'
          },
          {
            'order': 1,
            'zh-cn': '瑜伽套装',
            'en': 'yoga set',
            'zh-hant': '瑜伽套裝',
            'ja': 'ヨガセット',
            'de': 'Yoga-Set',
            'fr': 'Ensemble de yoga',
            'it': 'Set da yoga',
            'ko': '요가 세트'
          },
          {
            'order': 1,
            'zh-cn': '瑜伽短裤',
            'en': 'yoga shorts',
            'zh-hant': '瑜伽短褲',
            'ja': 'ヨガショーツ',
            'de': 'Yoga-Shorts',
            'fr': 'Short de yoga',
            'it': 'Pantaloncini da yoga',
            'ko': '요가 반바지'
          },
          {
            'order': 1,
            'zh-cn': '宽松瑜伽服',
            'en': 'loose-fitting yoga clothes',
            'zh-hant': '寬鬆瑜伽服',
            'ja': 'ゆったりしたヨガウェア',
            'de': 'Locker sitzende Yogakleidung',
            'fr': 'Vêtements de yoga amples',
            'it': 'Abbigliamento da yoga largo',
            'ko': '루즈핏 요가복'
          },
          {
            'order': 1,
            'zh-cn': '瑜伽袜',
            'en': 'yoga socks',
            'zh-hant': '瑜伽襪',
            'ja': 'ヨガソックス',
            'de': 'Yoga-Socken',
            'fr': 'Chaussettes de yoga',
            'it': 'Calzini da yoga',
            'ko': '요가 양말'
          },
          {
            'order': 1,
            'zh-cn': '瑜伽手套',
            'en': 'yoga gloves',
            'zh-hant': '瑜伽手套',
            'ja': 'ヨガグローブ',
            'de': 'Yoga-Handschuhe',
            'fr': 'Gants de yoga',
            'it': 'Guanti da yoga',
            'ko': '요가 장갑'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '婚纱礼服', en: 'Wedding Dress', 'zh-hant': '婚紗禮服', ja: 'ウェディングドレス', de: 'Hochzeitskleid', fr: 'Robe de mariée', it: 'Abito da sposa', ko: '웨딩드레스' },
        'list': [
          {
            'order': 1,
            'zh-cn': '婚纱',
            'en': 'wedding dress',
            'zh-hant': '婚紗',
            'ja': 'ウェディングドレス',
            'de': 'Hochzeitskleid',
            'fr': 'Robe de mariée',
            'it': 'Abito da sposa',
            'ko': '웨딩드레스'
          },
          {
            'order': 1,
            'zh-cn': '白色婚纱',
            'en': 'white wedding dress',
            'zh-hant': '白色婚紗',
            'ja': '白いウェディングドレス',
            'de': 'Weißes Hochzeitskleid',
            'fr': 'Robe de mariée blanche',
            'it': 'Abito da sposa bianco',
            'ko': '화이트 웨딩드레스'
          },
          {
            'order': 1,
            'zh-cn': '色彩婚纱',
            'en': 'colored wedding dress',
            'zh-hant': '彩色婚紗',
            'ja': 'カラードレス',
            'de': 'Farbige Hochzeitskleid',
            'fr': 'Robe de mariée colorée',
            'it': 'Abito da sposa colorato',
            'ko': '컬러 웨딩드레스'
          },
          {
            'order': 1,
            'zh-cn': '婚纱裙',
            'en': 'wedding skirt',
            'zh-hant': '婚紗裙',
            'ja': 'ウェディングスカート',
            'de': 'Hochzeitsrock',
            'fr': 'Jupe de mariée',
            'it': 'Gonna da sposa',
            'ko': '웨딩 스커트'
          },
          {
            'order': 1,
            'zh-cn': '礼服',
            'en': 'evening dress',
            'zh-hant': '晚禮服',
            'ja': 'イブニングドレス',
            'de': 'Abendkleid',
            'fr': 'Robe de soirée',
            'it': 'Abito da sera',
            'ko': '이브닝 드레스'
          },
          {
            'order': 1,
            'zh-cn': '长礼服',
            'en': 'long evening dress',
            'zh-hant': '長款晚禮服',
            'ja': 'ロングイブニングドレス',
            'de': 'Langes Abendkleid',
            'fr': 'Robe de soirée longue',
            'it': 'Abito da sera lungo',
            'ko': '롱 이브닝 드레스'
          },
          {
            'order': 1,
            'zh-cn': '短晚装',
            'en': 'short cocktail dress',
            'zh-hant': '短款雞尾酒裙',
            'ja': 'ショートカクテルドレス',
            'de': 'Kurzes Cocktailkleid',
            'fr': 'Robe cocktail courte',
            'it': 'Abito da cocktail corto',
            'ko': '숏 칵테일 드레스'
          },
          {
            'order': 1,
            'zh-cn': '秀禾服',
            'en': 'chinese traditional wedding dress',
            'zh-hant': '中式傳統婚紗',
            'ja': '中国の伝統的なウェディングドレス',
            'de': 'Traditionelles chinesisches Hochzeitskleid',
            'fr': 'Robe de mariée traditionnelle chinoise',
            'it': 'Abito da sposa tradizionale cinese',
            'ko': '중국 전통 웨딩드레스'
          },
          {
            'order': 1,
            'zh-cn': '龙凤褂',
            'en': 'chinese traditional groom\'s attire',
            'zh-hant': '中式傳統新郎禮服',
            'ja': '中国の伝統的な新郎の服装',
            'de': 'Traditionelle chinesische Bräutigamkleidung',
            'fr': 'Tenue traditionnelle du marié chinois',
            'it': 'Abito tradizionale dello sposo cinese',
            'ko': '중국 전통 신랑 예복'
          },
          {
            'order': 1,
            'zh-cn': '晚装',
            'en': 'formal dress',
            'zh-hant': '正式禮服',
            'ja': 'フォーマルドレス',
            'de': 'Festliches Kleid',
            'fr': 'Robe de cérémonie',
            'it': 'Abito formale',
            'ko': '포멀 드레스'
          },
          {
            'order': 1,
            'zh-cn': '长晚装',
            'en': 'long formal dress',
            'zh-hant': '長款正式禮服',
            'ja': 'ロングフォーマルドレス',
            'de': 'Langes festliches Kleid',
            'fr': 'Robe de cérémonie longue',
            'it': 'Abito formale lungo',
            'ko': '롱 포멀 드레스'
          },
          {
            'order': 1,
            'zh-cn': '短晚装',
            'en': 'short formal dress',
            'zh-hant': '短款正式禮服',
            'ja': 'ショートフォーマルドレス',
            'de': 'Kurzes festliches Kleid',
            'fr': 'Robe de cérémonie courte',
            'it': 'Abito formale corto',
            'ko': '숏 포멀 드레스'
          },
          {
            'order': 1,
            'zh-cn': '伴娘服',
            'en': 'bridesmaid dress',
            'zh-hant': '伴娘禮服',
            'ja': 'ブライドメイドドレス',
            'de': 'Brautjungfernkleid',
            'fr': 'Robe de demoiselle d\'honneur',
            'it': 'Abito da damigella d\'onore',
            'ko': '브라이드메이드 드레스'
          },
          {
            'order': 1,
            'zh-cn': '花童服',
            'en': 'flower girl dress',
            'zh-hant': '花童裙',
            'ja': 'フラワーガールドレス',
            'de': 'Blumenmädchenkleid',
            'fr': 'Robe de fille aux fleurs',
            'it': 'Abito da damigella dei fiori',
            'ko': '플라워 걸 드레스'
          },
          {
            'order': 1,
            'zh-cn': '西装礼服',
            'en': 'tuxedo',
            'zh-hant': '燕尾服',
            'ja': 'タキシード',
            'de': 'Smoking',
            'fr': 'Smoking',
            'it': 'Smoking',
            'ko': '턱시도'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '沙滩装', en: 'Beachwear', 'zh-hant': '沙灘裝', ja: 'ビーチウェア', de: 'Strandkleidung', fr: 'Tenue de plage', it: 'Abbigliamento da spiaggia', ko: '비치웨어' },
        'list': [
          {
            'order': 1,
            'zh-cn': '沙滩裤',
            'en': 'beach pants',
            'zh-hant': '沙灘褲',
            'ja': 'ビーチパンツ',
            'de': 'Strandhose',
            'fr': 'Pantalon de plage',
            'it': 'Pantaloni da spiaggia',
            'ko': '비치 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '阔腿沙滩裤',
            'en': 'wide leg beach pants',
            'zh-hant': '寬腿沙灘褲',
            'ja': 'ワイドレッグビーチパンツ',
            'de': 'Weit geschnittene Strandhose',
            'fr': 'Pantalon de plage à jambes larges',
            'it': 'Pantaloni da spiaggia a gamba larga',
            'ko': '와이드 핏 비치 팬츠'
          },
          {
            'order': 1,
            'zh-cn': '短裤沙滩裤',
            'en': 'shorts beach pants',
            'zh-hant': '短款沙灘褲',
            'ja': 'ショートビーチパンツ',
            'de': 'Kurze Strandhose',
            'fr': 'Short de plage',
            'it': 'Pantaloncini da spiaggia',
            'ko': '비치 반바지'
          },
          {
            'order': 1,
            'zh-cn': '沙滩裙',
            'en': 'beach skirt',
            'zh-hant': '沙灘裙',
            'ja': 'ビーチスカート',
            'de': 'Strandrock',
            'fr': 'Jupe de plage',
            'it': 'Gonna da spiaggia',
            'ko': '비치 스커트'
          },
          {
            'order': 1,
            'zh-cn': '连衣裙沙滩裙',
            'en': 'maxi beach skirt',
            'zh-hant': '長款沙灘裙',
            'ja': 'マキシビーチスカート',
            'de': 'Langer Strandrock',
            'fr': 'Jupe de plage longue',
            'it': 'Gonna lunga da spiaggia',
            'ko': '맥시 비치 스커트'
          },
          {
            'order': 1,
            'zh-cn': '短裙沙滩裙',
            'en': 'short beach skirt',
            'zh-hant': '短款沙灘裙',
            'ja': 'ショートビーチスカート',
            'de': 'Kurzer Strandrock',
            'fr': 'Jupe de plage courte',
            'it': 'Gonna corta da spiaggia',
            'ko': '숏 비치 스커트'
          },
          {
            'order': 1,
            'zh-cn': '连体沙滩装',
            'en': 'beach jumpsuit',
            'zh-hant': '沙灘連身褲',
            'ja': 'ビーチジャンプスーツ',
            'de': 'Strandoverall',
            'fr': 'Combinaison de plage',
            'it': 'Tuta da spiaggia',
            'ko': '비치 점프수트'
          },
          {
            'order': 1,
            'zh-cn': '沙滩衬衫',
            'en': 'beach shirt',
            'zh-hant': '沙灘襯衫',
            'ja': 'ビーチシャツ',
            'de': 'Strandhemd',
            'fr': 'Chemise de plage',
            'it': 'Camicia da spiaggia',
            'ko': '비치 셔츠'
          },
          {
            'order': 1,
            'zh-cn': '短袖沙滩衬衫',
            'en': 'short-sleeved beach shirt',
            'zh-hant': '短袖沙灘襯衫',
            'ja': '半袖ビーチシャツ',
            'de': 'Kurzärmliges Strandhemd',
            'fr': 'Chemise de plage à manches courtes',
            'it': 'Camicia da spiaggia a maniche corte',
            'ko': '반소매 비치 셔츠'
          },
          {
            'order': 1,
            'zh-cn': '长袖沙滩衬衫',
            'en': 'long-sleeved beach shirt',
            'zh-hant': '長袖沙灘襯衫',
            'ja': '長袖ビーチシャツ',
            'de': 'Langärmliges Strandhemd',
            'fr': 'Chemise de plage à manches longues',
            'it': 'Camicia da spiaggia a maniche lunghe',
            'ko': '긴소매 비치 셔츠'
          },
          {
            'order': 1,
            'zh-cn': '沙滩包臀裙',
            'en': 'sarong',
            'zh-hant': '沙龍裙',
            'ja': 'サロン',
            'de': 'Sarong',
            'fr': 'Paréo',
            'it': 'Pareo',
            'ko': '사롱'
          },
          {
            'order': 1,
            'zh-cn': '毛边牛仔短裤',
            'en': 'denim shorts',
            'zh-hant': '牛仔短褲',
            'ja': 'デニムショーツ',
            'de': 'Jeansshorts',
            'fr': 'Short en jean',
            'it': 'Pantaloncini di jeans',
            'ko': '데님 비치 쇼츠'
          },
          {
            'order': 1,
            'zh-cn': '沙滩连衣裙',
            'en': 'cover-up dress',
            'zh-hant': '沙灘罩衫',
            'ja': 'ビーチカバーアップドレス',
            'de': 'Strandkleid',
            'fr': 'Robe de plage',
            'it': 'Copricostume',
            'ko': '커버업 드레스'
          },
          {
            'order': 1,
            'zh-cn': '沙滩背心',
            'en': 'beach tank top',
            'zh-hant': '沙灘背心',
            'ja': 'ビーチタンクトップ',
            'de': 'Strandtanktop',
            'fr': 'Débardeur de plage',
            'it': 'Canotta da spiaggia',
            'ko': '비치 탱크탑'
          },
          {
            'order': 1,
            'zh-cn': '水手服',
            'en': 'nautical clothing',
            'zh-hant': '海洋風服飾',
            'ja': 'マリン服',
            'de': 'Nautische Kleidung',
            'fr': 'Vêtements nautiques',
            'it': 'Abbigliamento nautico',
            'ko': '해상 스타일 의류'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '鞋子', en: 'Shoes', 'zh-hant': '鞋子', ja: 'シューズ', de: 'Schuhe', fr: 'Chaussures', it: 'Scarpe', ko: '신발' },
        'list': [
          {
            'order': 1,
            'zh-cn': '运动鞋',
            'en': 'athletic shoes',
            'zh-hant': '運動鞋',
            'ja': 'スニーカー',
            'de': 'Sportschuhe',
            'fr': 'Chaussures de sport',
            'it': 'Scarpe sportive',
            'ko': '운동화'
          },
          {
            'order': 1,
            'zh-cn': '皮鞋',
            'en': 'leather shoes',
            'zh-hant': '皮鞋',
            'ja': '革靴',
            'de': 'Lederschuhe',
            'fr': 'Chaussures en cuir',
            'it': 'Scarpe di pelle',
            'ko': '가죽 신발'
          },
          {
            'order': 1,
            'zh-cn': '男式皮鞋',
            'en': 'men\'s leather shoes',
            'zh-hant': '男士皮鞋',
            'ja': 'メンズ革靴',
            'de': 'Herrenschuhe aus Leder',
            'fr': 'Chaussures en cuir pour hommes',
            'it': 'Scarpe di pelle da uomo',
            'ko': '남성용 가죽 신발'
          },
          {
            'order': 1,
            'zh-cn': '女式皮鞋',
            'en': 'women\'s leather shoes',
            'zh-hant': '女士皮鞋',
            'ja': 'レディース革靴',
            'de': 'Damenschuhe aus Leder',
            'fr': 'Chaussures en cuir pour femmes',
            'it': 'Scarpe di pelle da donna',
            'ko': '여성용 가죽 신발'
          },
          {
            'order': 1,
            'zh-cn': '靴子',
            'en': 'boots',
            'zh-hant': '靴子',
            'ja': 'ブーツ',
            'de': 'Stiefel',
            'fr': 'Bottes',
            'it': 'Stivali',
            'ko': '부츠'
          },
          {
            'order': 1,
            'zh-cn': '雪地靴',
            'en': 'snow boots',
            'zh-hant': '雪地靴',
            'ja': 'スノーブーツ',
            'de': 'Schneestiefel',
            'fr': 'Bottes de neige',
            'it': 'Stivali da neve',
            'ko': '스노우 부츠'
          },
          {
            'order': 1,
            'zh-cn': '马丁靴',
            'en': 'martin boots',
            'zh-hant': '馬丁靴',
            'ja': 'マーチンブーツ',
            'de': 'Martin-Stiefel',
            'fr': 'Bottes Martin',
            'it': 'Stivali Martin',
            'ko': '마틴 부츠'
          },
          {
            'order': 1,
            'zh-cn': '工装靴',
            'en': 'work boots',
            'zh-hant': '工作靴',
            'ja': 'ワークブーツ',
            'de': 'Arbeitsstiefel',
            'fr': 'Bottes de travail',
            'it': 'Stivali da lavoro',
            'ko': '워크 부츠'
          },
          {
            'order': 1,
            'zh-cn': '长筒靴',
            'en': 'knee-high boots',
            'zh-hant': '及膝靴',
            'ja': '膝丈ブーツ',
            'de': 'Kniehohe Stiefel',
            'fr': 'Bottes hautes',
            'it': 'Stivali al ginocchio',
            'ko': '니하이 부츠'
          },
          {
            'order': 1,
            'zh-cn': '短靴',
            'en': 'ankle boots',
            'zh-hant': '短靴',
            'ja': 'アンクルブーツ',
            'de': 'Knöchelhohe Stiefel',
            'fr': 'Bottines',
            'it': 'Stivaletti',
            'ko': '앵클 부츠'
          },
          {
            'order': 1,
            'zh-cn': '凉鞋',
            'en': 'sandals',
            'zh-hant': '涼鞋',
            'ja': 'サンダル',
            'de': 'Sandalen',
            'fr': 'Sandales',
            'it': 'Sandali',
            'ko': '샌들'
          },
          {
            'order': 1,
            'zh-cn': '平底凉鞋',
            'en': 'flat sandals',
            'zh-hant': '平底涼鞋',
            'ja': 'フラットサンダル',
            'de': 'Flache Sandalen',
            'fr': 'Sandales plates',
            'it': 'Sandali bassi',
            'ko': '플랫 샌들'
          },
          {
            'order': 1,
            'zh-cn': '带跟凉鞋',
            'en': 'heeled sandals',
            'zh-hant': '高跟涼鞋',
            'ja': 'ヒールサンダル',
            'de': 'Sandalen mit Absatz',
            'fr': 'Sandales à talons',
            'it': 'Sandali con tacco',
            'ko': '힐 샌들'
          },
          {
            'order': 1,
            'zh-cn': '拖鞋',
            'en': 'slippers',
            'zh-hant': '拖鞋',
            'ja': 'スリッパ',
            'de': 'Hausschuhe',
            'fr': 'Chaussons',
            'it': 'Pantofole',
            'ko': '슬리퍼'
          },
          {
            'order': 1,
            'zh-cn': '船鞋',
            'en': 'boat shoes',
            'zh-hant': '船鞋',
            'ja': 'ボートシューズ',
            'de': 'Bootsschuhe',
            'fr': 'Chaussures bateau',
            'it': 'Scarpe da barca',
            'ko': '보트 슈즈'
          },
          {
            'order': 1,
            'zh-cn': '帆布鞋',
            'en': 'canvas shoes',
            'zh-hant': '帆布鞋',
            'ja': 'キャンバスシューズ',
            'de': 'Leinenschuhe',
            'fr': 'Chaussures en toile',
            'it': 'Scarpe di tela',
            'ko': '캔버스 슈즈'
          },
          {
            'order': 1,
            'zh-cn': '复古鞋',
            'en': 'vintage shoes',
            'zh-hant': '復古鞋',
            'ja': 'ヴィンテージシューズ',
            'de': 'Vintage-Schuhe',
            'fr': 'Chaussures vintage',
            'it': 'Scarpe vintage',
            'ko': '빈티지 신발'
          },
          {
            'order': 1,
            'zh-cn': '高跟鞋',
            'en': 'high-heeled shoes',
            'zh-hant': '高跟鞋',
            'ja': 'ハイヒール',
            'de': 'Schuhe mit hohen Absätzen',
            'fr': 'Chaussures à talons hauts',
            'it': 'Scarpe con tacco alto',
            'ko': '하이힐'
          }
        ]
      }
    ]
  },
  {
    'order': 1,
    'name': { 'zh-cn': '色彩', en: 'Color', 'zh-hant': '色彩', ja: 'カラー', de: 'Farbe', fr: 'Couleur', it: 'Colore', ko: '색상' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '单一色彩', en: 'Single Color', 'zh-hant': '單一色彩', ja: '単色', de: 'Einzelfarbe', fr: 'Couleur unique', it: 'Colore singolo', ko: '단일 색상' },
        'list': [
          {
            'order': 1,
            'zh-cn': '白色',
            'en': 'white Color',
            'zh-hant': '白色',
            'ja': '白色',
            'de': 'Weiße Farbe',
            'fr': 'Couleur blanche',
            'it': 'Colore bianco',
            'ko': '흰색'
          },
          {
            'order': 1,
            'zh-cn': '草地绿',
            'en': 'meadow green Color',
            'zh-hant': '草地綠色',
            'ja': '草地の緑色',
            'de': 'Wiesengrüne Farbe',
            'fr': 'Couleur vert prairie',
            'it': 'Colore verde prato',
            'ko': '초원 녹색'
          },
          {
            'order': 1,
            'zh-cn': '草绿色',
            'en': 'grass green Color',
            'zh-hant': '草綠色',
            'ja': '草の緑色',
            'de': 'Grasgrüne Farbe',
            'fr': 'Couleur vert gazon',
            'it': 'Colore verde erba',
            'ko': '풀빛 녹색'
          },
          {
            'order': 1,
            'zh-cn': '橙色',
            'en': 'orange Color',
            'zh-hant': '橙色',
            'ja': 'オレンジ色',
            'de': 'Orange Farbe',
            'fr': 'Couleur orange',
            'it': 'Colore arancione',
            'ko': '주황색'
          },
          {
            'order': 1,
            'zh-cn': '春绿色',
            'en': 'spring green Color',
            'zh-hant': '春綠色',
            'ja': '春の緑色',
            'de': 'Frühlingsgrüne Farbe',
            'fr': 'Couleur vert printemps',
            'it': 'Colore verde primavera',
            'ko': '봄 녹색'
          },
          {
            'order': 1,
            'zh-cn': '靛蓝色',
            'en': 'indigo Color',
            'zh-hant': '靛藍色',
            'ja': 'インディゴ色',
            'de': 'Indigo Farbe',
            'fr': 'Couleur indigo',
            'it': 'Colore indaco',
            'ko': '남색'
          },
          {
            'order': 1,
            'zh-cn': '粉红色',
            'en': 'pink Color',
            'zh-hant': '粉紅色',
            'ja': 'ピンク色',
            'de': 'Rosa Farbe',
            'fr': 'Couleur rose',
            'it': 'Colore rosa',
            'ko': '분홍색'
          },
          {
            'order': 1,
            'zh-cn': '橄榄色',
            'en': 'olive Color',
            'zh-hant': '橄欖色',
            'ja': 'オリーブ色',
            'de': 'Oliv Farbe',
            'fr': 'Couleur olive',
            'it': 'Colore oliva',
            'ko': '올리브색'
          },
          {
            'order': 1,
            'zh-cn': '钢蓝色',
            'en': 'steel blue Color',
            'zh-hant': '鋼藍色',
            'ja': 'スチールブルー色',
            'de': 'Stahlblaue Farbe',
            'fr': 'Couleur bleu acier',
            'it': 'Colore blu acciaio',
            'ko': '스틸 블루'
          },
          {
            'order': 1,
            'zh-cn': '高山蓝',
            'en': 'alpine blue Color',
            'zh-hant': '阿爾卑斯藍色',
            'ja': 'アルパインブルー色',
            'de': 'Alpenblaue Farbe',
            'fr': 'Couleur bleu alpin',
            'it': 'Colore blu alpino',
            'ko': '알파인 블루'
          },
          {
            'order': 1,
            'zh-cn': '鲑鱼粉',
            'en': 'salmon pink Color',
            'zh-hant': '鮭魚粉色',
            'ja': 'サーモンピンク色',
            'de': 'Lachsrosa Farbe',
            'fr': 'Couleur rose saumon',
            'it': 'Colore rosa salmone',
            'ko': '연어 핑크'
          },
          {
            'order': 1,
            'zh-cn': '海蓝色',
            'en': 'aquamarine Color',
            'zh-hant': '海藍寶石色',
            'ja': 'アクアマリン色',
            'de': 'Aquamarin Farbe',
            'fr': 'Couleur aigue-marine',
            'it': 'Colore acquamarina',
            'ko': '아쿠아마린'
          },
          {
            'order': 1,
            'zh-cn': '海洋蓝',
            'en': 'ocean blue Color',
            'zh-hant': '海洋藍色',
            'ja': 'オーシャンブルー色',
            'de': 'Ozeanblaue Farbe',
            'fr': 'Couleur bleu océan',
            'it': 'Colore blu oceano',
            'ko': '오션 블루'
          },
          {
            'order': 1,
            'zh-cn': '褐红色',
            'en': 'maroon brown Color',
            'zh-hant': '栗棕色',
            'ja': 'マルーンブラウン色',
            'de': 'Kastanienbraune Farbe',
            'fr': 'Couleur marron bordeaux',
            'it': 'Colore marrone bordeaux',
            'ko': '밤색'
          },
          {
            'order': 1,
            'zh-cn': '黑色',
            'en': 'black Color',
            'zh-hant': '黑色',
            'ja': '黒色',
            'de': 'Schwarze Farbe',
            'fr': 'Couleur noire',
            'it': 'Colore nero',
            'ko': '검정색'
          },
          {
            'order': 1,
            'zh-cn': '红色',
            'en': 'red Color',
            'zh-hant': '紅色',
            'ja': '赤色',
            'de': 'Rote Farbe',
            'fr': 'Couleur rouge',
            'it': 'Colore rosso',
            'ko': '빨간색'
          },
          {
            'order': 1,
            'zh-cn': '黄色',
            'en': 'yellow Color',
            'zh-hant': '黃色',
            'ja': '黄色',
            'de': 'Gelbe Farbe',
            'fr': 'Couleur jaune',
            'it': 'Colore giallo',
            'ko': '노란색'
          },
          {
            'order': 1,
            'zh-cn': '灰蓝色',
            'en': 'slate blue Color',
            'zh-hant': '石板藍色',
            'ja': 'スレートブルー色',
            'de': 'Schieferblaue Farbe',
            'fr': 'Couleur bleu ardoise',
            'it': 'Colore blu ardesia',
            'ko': '슬레이트 블루'
          },
          {
            'order': 1,
            'zh-cn': '灰色',
            'en': 'gray Color',
            'zh-hant': '灰色',
            'ja': '灰色',
            'de': 'Graue Farbe',
            'fr': 'Couleur grise',
            'it': 'Colore grigio',
            'ko': '회색'
          },
          {
            'order': 1,
            'zh-cn': '极光紫',
            'en': 'aurora purple Color',
            'zh-hant': '極光紫色',
            'ja': 'オーロラパープル色',
            'de': 'Aurora Lila Farbe',
            'fr': 'Couleur violet aurora',
            'it': 'Colore viola aurora',
            'ko': '오로라 퍼플'
          },
          {
            'order': 1,
            'zh-cn': '浆果紫',
            'en': 'berry purple Color',
            'zh-hant': '漿果紫色',
            'ja': 'ベリーパープル色',
            'de': 'Beeren Lila Farbe',
            'fr': 'Couleur violet baie',
            'it': 'Colore viola bacca',
            'ko': '베리 퍼플'
          },
          {
            'order': 1,
            'zh-cn': '金色',
            'en': 'gold Color',
            'zh-hant': '金色',
            'ja': '金色',
            'de': 'Goldene Farbe',
            'fr': 'Couleur or',
            'it': 'Colore oro',
            'ko': '금색'
          },
          {
            'order': 1,
            'zh-cn': '酒红色',
            'en': 'burgundy Color',
            'zh-hant': '酒紅色',
            'ja': 'バーガンディ色',
            'de': 'Burgunder Farbe',
            'fr': 'Couleur bourgogne',
            'it': 'Colore borgogna',
            'ko': '버건디색'
          },
          {
            'order': 1,
            'zh-cn': '橘红色',
            'en': 'tangerine Color',
            'zh-hant': '橘橙色',
            'ja': 'タンジェリン色',
            'de': 'Mandarinenorange Farbe',
            'fr': 'Couleur mandarine',
            'it': 'Colore mandarino',
            'ko': '탠저린색'
          },
          {
            'order': 1,
            'zh-cn': '咖啡色',
            'en': 'coffee Color',
            'zh-hant': '咖啡色',
            'ja': 'コーヒー色',
            'de': 'Kaffeefarbe',
            'fr': 'Couleur café',
            'it': 'Colore caffè',
            'ko': '커피색'
          },
          {
            'order': 1,
            'zh-cn': '孔雀蓝',
            'en': 'peacock blue Color',
            'zh-hant': '孔雀藍色',
            'ja': 'ピーコックブルー色',
            'de': 'Pfauenblaue Farbe',
            'fr': 'Couleur bleu paon',
            'it': 'Colore blu pavone',
            'ko': '피코크 블루'
          },
          {
            'order': 1,
            'zh-cn': '蓝色',
            'en': 'blue Color',
            'zh-hant': '藍色',
            'ja': '青色',
            'de': 'Blaue Farbe',
            'fr': 'Couleur bleue',
            'it': 'Colore blu',
            'ko': '파란색'
          },
          {
            'order': 1,
            'zh-cn': '栗色',
            'en': 'chestnut Color',
            'zh-hant': '栗色',
            'ja': '栗色',
            'de': 'Kastanienbraune Farbe',
            'fr': 'Couleur marron',
            'it': 'Colore castagna',
            'ko': '밤색'
          },
          {
            'order': 1,
            'zh-cn': '亮橙色',
            'en': 'bright orange Color',
            'zh-hant': '鮮橙色',
            'ja': '鮮やかなオレンジ色',
            'de': 'Helles Orange',
            'fr': 'Couleur orange vif',
            'it': 'Colore arancione brillante',
            'ko': '밝은 주황색'
          },
          {
            'order': 1,
            'zh-cn': '绿色',
            'en': 'green Color',
            'zh-hant': '綠色',
            'ja': '緑色',
            'de': 'Grüne Farbe',
            'fr': 'Couleur verte',
            'it': 'Colore verde',
            'ko': '초록색'
          },
          {
            'order': 1,
            'zh-cn': '玫瑰红',
            'en': 'rose red Color',
            'zh-hant': '玫紅色',
            'ja': 'ローズレッド色',
            'de': 'Rosenrote Farbe',
            'fr': 'Couleur rouge rosé',
            'it': 'Colore rosso rosa',
            'ko': '장미빛 붉은색'
          },
          {
            'order': 1,
            'zh-cn': '玫瑰金',
            'en': 'rose gold Color',
            'zh-hant': '玫瑰金色',
            'ja': 'ローズゴールド色',
            'de': 'Roségoldene Farbe',
            'fr': 'Couleur or rose',
            'it': 'Colore oro rosa',
            'ko': '로즈골드'
          },
          {
            'order': 1,
            'zh-cn': '米黄色',
            'en': 'ivory Color',
            'zh-hant': '象牙色',
            'ja': 'アイボリー色',
            'de': 'Elfenbeinfarbe',
            'fr': 'Couleur ivoire',
            'it': 'Colore avorio',
            'ko': '아이보리색'
          },
          {
            'order': 1,
            'zh-cn': '米色',
            'en': 'beige Color',
            'zh-hant': '米色',
            'ja': 'ベージュ色',
            'de': 'Beigefarbe',
            'fr': 'Couleur beige',
            'it': 'Colore beige',
            'ko': '베이지색'
          },
          {
            'order': 1,
            'zh-cn': '霓虹蓝',
            'en': 'neon blue Color',
            'zh-hant': '霓藍色',
            'ja': 'ネオンブルー色',
            'de': 'Neongelbe Farbe',
            'fr': 'Couleur bleu néon',
            'it': 'Colore blu neon',
            'ko': '네온 블루'
          },
          {
            'order': 1,
            'zh-cn': '柠檬黄',
            'en': 'lemon yellow Color',
            'zh-hant': '檸檬黃色',
            'ja': 'レモンイエロー色',
            'de': 'Zitronengelbe Farbe',
            'fr': 'Couleur jaune citron',
            'it': 'Colore giallo limone',
            'ko': '레몬 옐로우'
          },
          {
            'order': 1,
            'zh-cn': '青草绿',
            'en': 'lime green Color',
            'zh-hant': '萊姆綠色',
            'ja': 'ライムグリーン色',
            'de': 'Limettengrüne Farbe',
            'fr': 'Couleur vert citron',
            'it': 'Colore verde lime',
            'ko': '라임 그린'
          },
          {
            'order': 1,
            'zh-cn': '青色',
            'en': 'cyan Color',
            'zh-hant': '青色',
            'ja': 'シアン色',
            'de': 'Cyanfarbe',
            'fr': 'Couleur cyan',
            'it': 'Colore ciano',
            'ko': '시안색'
          },
          {
            'order': 1,
            'zh-cn': '珊瑚橙',
            'en': 'coral orange Color',
            'zh-hant': '珊瑚橙色',
            'ja': 'コーラルオレンジ色',
            'de': 'Korallenorange Farbe',
            'fr': 'Couleur corail orange',
            'it': 'Colore arancione corallo',
            'ko': '코랄 오렌지'
          },
          {
            'order': 1,
            'zh-cn': '珊瑚粉',
            'en': 'coral pink Color',
            'zh-hant': '珊瑚粉色',
            'ja': 'コーラルピンク色',
            'de': 'Korallenrosa Farbe',
            'fr': 'Couleur corail rose',
            'it': 'Colore rosa corallo',
            'ko': '코랄 핑크'
          },
          {
            'order': 1,
            'zh-cn': '珊瑚色',
            'en': 'coral Color',
            'zh-hant': '珊瑚色',
            'ja': 'コーラル色',
            'de': 'Korallenfarbe',
            'fr': 'Couleur corail',
            'it': 'Colore corallo',
            'ko': '코랄색'
          },
          {
            'order': 1,
            'zh-cn': '深棕色',
            'en': 'dark brown Color',
            'zh-hant': '深棕色',
            'ja': 'ダークブラウン色',
            'de': 'Dunkelbraune Farbe',
            'fr': 'Couleur marron foncé',
            'it': 'Colore marrone scuro',
            'ko': '짙은 갈색'
          },
          {
            'order': 1,
            'zh-cn': '石板灰',
            'en': 'slate gray Color',
            'zh-hant': '石板灰色',
            'ja': 'スレートグレー色',
            'de': 'Schiefergraue Farbe',
            'fr': 'Couleur gris ardoise',
            'it': 'Colore grigio ardesia',
            'ko': '슬레이트 그레이'
          },
          {
            'order': 1,
            'zh-cn': '石榴红',
            'en': 'pomegranate red Color',
            'zh-hant': '石榴紅色',
            'ja': 'ザクロレッド色',
            'de': 'Granatapfelrote Farbe',
            'fr': 'Couleur rouge grenade',
            'it': 'Colore rosso melograno',
            'ko': '석류 레드'
          },
          {
            'order': 1,
            'zh-cn': '松绿色',
            'en': 'pine green Color',
            'zh-hant': '松綠色',
            'ja': 'パイングリーン色',
            'de': 'Kieferngrüne Farbe',
            'fr': 'Couleur vert pin',
            'it': 'Colore verde pino',
            'ko': '소나무 녹색'
          },
          {
            'order': 1,
            'zh-cn': '天蓝色',
            'en': 'sky blue Color',
            'zh-hant': '天藍色',
            'ja': 'スカイブルー色',
            'de': 'Himmelblaue Farbe',
            'fr': 'Couleur bleu ciel',
            'it': 'Colore azzurro',
            'ko': '하늘색'
          },
          {
            'order': 1,
            'zh-cn': '鲜黄色',
            'en': 'lime yellow Color',
            'zh-hant': '萊姆黃色',
            'ja': 'ライムイエロー色',
            'de': 'Limettengelbe Farbe',
            'fr': 'Couleur jaune citron vert',
            'it': 'Colore giallo lime',
            'ko': '라임 옐로우'
          },
          {
            'order': 1,
            'zh-cn': '杏黄色',
            'en': 'apricot Color',
            'zh-hant': '杏色',
            'ja': 'アプリコット色',
            'de': 'Aprikosenfarbe',
            'fr': 'Couleur abricot',
            'it': 'Colore albicocca',
            'ko': '살구색'
          },
          {
            'order': 1,
            'zh-cn': '雪白色',
            'en': 'snow white Color',
            'zh-hant': '雪白色',
            'ja': '雪の白色',
            'de': 'Schneeweiße Farbe',
            'fr': 'Couleur blanc neige',
            'it': 'Colore bianco neve',
            'ko': '설백색'
          },
          {
            'order': 1,
            'zh-cn': '雪青色',
            'en': 'frosty blue Color',
            'zh-hant': '霜藍色',
            'ja': '霜の青色',
            'de': 'Frostblaue Farbe',
            'fr': 'Couleur bleu givré',
            'it': 'Colore blu ghiaccio',
            'ko': '서리 블루'
          },
          {
            'order': 1,
            'zh-cn': '薰衣草紫',
            'en': 'lavender Color',
            'zh-hant': '薰衣草色',
            'ja': 'ラベンダー色',
            'de': 'Lavendelfarbe',
            'fr': 'Couleur lavande',
            'it': 'Colore lavanda',
            'ko': '라벤더색'
          },
          {
            'order': 1,
            'zh-cn': '雅致黑',
            'en': 'jet black Color',
            'zh-hant': '烏黑色',
            'ja': '漆黒色',
            'de': 'Pechschwarze Farbe',
            'fr': 'Couleur noir de jais',
            'it': 'Colore nero corvino',
            'ko': '제트 블랙'
          },
          {
            'order': 1,
            'zh-cn': '银灰色',
            'en': 'silver gray Color',
            'zh-hant': '銀灰色',
            'ja': 'シルバーグレー色',
            'de': 'Silbergraue Farbe',
            'fr': 'Couleur gris argenté',
            'it': 'Colore grigio argento',
            'ko': '은회색'
          },
          {
            'order': 1,
            'zh-cn': '银色',
            'en': 'silver Color',
            'zh-hant': '銀色',
            'ja': 'シルバー色',
            'de': 'Silberne Farbe',
            'fr': 'Couleur argent',
            'it': 'Colore argento',
            'ko': '은색'
          },
          {
            'order': 1,
            'zh-cn': '荧光绿',
            'en': 'neon green Color',
            'zh-hant': '霓虹綠色',
            'ja': 'ネオングリーン色',
            'de': 'Neongrüne Farbe',
            'fr': 'Couleur vert néon',
            'it': 'Colore verde neon',
            'ko': '네온 그린'
          },
          {
            'order': 1,
            'zh-cn': '原野黄',
            'en': 'meadow yellow Color',
            'zh-hant': '草地黃色',
            'ja': '草原の黄色',
            'de': 'Wiesengelbe Farbe',
            'fr': 'Couleur jaune prairie',
            'it': 'Colore giallo prato',
            'ko': '초원 옐로우'
          },
          {
            'order': 1,
            'zh-cn': '枣红色',
            'en': 'maroon Color',
            'zh-hant': '栗紅色',
            'ja': 'マルーン色',
            'de': 'Kastanienbraune Farbe',
            'fr': 'Couleur marron',
            'it': 'Colore marrone scuro',
            'ko': '대추색'
          },
          {
            'order': 1,
            'zh-cn': '紫红色',
            'en': 'magenta Color',
            'zh-hant': '洋紅色',
            'ja': 'マゼンタ色',
            'de': 'Magentafarbene Farbe',
            'fr': 'Couleur magenta',
            'it': 'Colore magenta',
            'ko': '자홍색'
          },
          {
            'order': 1,
            'zh-cn': '紫色',
            'en': 'purple Color',
            'zh-hant': '紫色',
            'ja': '紫色',
            'de': 'Violette Farbe',
            'fr': 'Couleur violet',
            'it': 'Colore viola',
            'ko': '보라색'
          },
          {
            'order': 1,
            'zh-cn': '棕色',
            'en': 'brown Color',
            'zh-hant': '棕色',
            'ja': '茶色',
            'de': 'Braune Farbe',
            'fr': 'Couleur marron',
            'it': 'Colore marrone',
            'ko': '갈색'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '配色方案', en: 'Color Scheme', 'zh-hant': '配色方案', ja: 'カラースキーム', de: 'Farbschema', fr: 'Schéma de couleurs', it: 'Schema di colori', ko: '배색 방안' },
        'list': [
          {
            'order': 1,
            'zh-cn': '白粉橙',
            'en': 'white-pink-orange Color',
            'zh-hant': '白粉橙色',
            'ja': '白ピンクオレンジ色',
            'de': 'Weiß-Pink-Orange Farbe',
            'fr': 'Couleur blanc-rose-orange',
            'it': 'Colore bianco-rosa-arancione',
            'ko': '흰색-분홍-주황색'
          },
          {
            'order': 1,
            'zh-cn': '草绿橙',
            'en': 'lime green-orange Color',
            'zh-hant': '萊姆綠橙色',
            'ja': 'ライムグリーンオレンジ色',
            'de': 'Limettengrün-Orange Farbe',
            'fr': 'Couleur vert citron-orange',
            'it': 'Colore verde lime-arancione',
            'ko': '라임 그린-주황색'
          },
          {
            'order': 1,
            'zh-cn': '橙黄白',
            'en': 'orange-yellow-white Color',
            'zh-hant': '橙黃白色',
            'ja': 'オレンジ黄色白色',
            'de': 'Orange-Gelb-Weiß Farbe',
            'fr': 'Couleur orange-jaune-blanc',
            'it': 'Colore arancione-giallo-bianco',
            'ko': '주황-노랑-흰색'
          },
          {
            'order': 1,
            'zh-cn': '橙黄蓝',
            'en': 'orange-yellow-blue Color',
            'zh-hant': '橙黃藍色',
            'ja': 'オレンジ黄色青色',
            'de': 'Orange-Gelb-Blau Farbe',
            'fr': 'Couleur orange-jaune-bleu',
            'it': 'Colore arancione-giallo-blu',
            'ko': '주황-노랑-파랑색'
          },
          {
            'order': 1,
            'zh-cn': '橙蓝白',
            'en': 'orange-blue-white Color',
            'zh-hant': '橙藍白色',
            'ja': 'オレンジ青色白色',
            'de': 'Orange-Blau-Weiß Farbe',
            'fr': 'Couleur orange-bleu-blanc',
            'it': 'Colore arancione-blu-bianco',
            'ko': '주황-파랑-흰색'
          },
          {
            'order': 1,
            'zh-cn': '橙紫绿',
            'en': 'orange-purple-green Color',
            'zh-hant': '橙紫綠色',
            'ja': 'オレンジ紫色緑色',
            'de': 'Orange-Lila-Grün Farbe',
            'fr': 'Couleur orange-violet-vert',
            'it': 'Colore arancione-viola-verde',
            'ko': '주황-보라-초록색'
          },
          {
            'order': 1,
            'zh-cn': '粉橙绿',
            'en': 'pink-orange-green Color',
            'zh-hant': '粉橙綠色',
            'ja': 'ピンクオレンジ緑色',
            'de': 'Pink-Orange-Grün Farbe',
            'fr': 'Couleur rose-orange-vert',
            'it': 'Colore rosa-arancione-verde',
            'ko': '분홍-주황-초록색'
          },
          {
            'order': 1,
            'zh-cn': '粉橙紫',
            'en': 'pink-orange-purple Color',
            'zh-hant': '粉橙紫色',
            'ja': 'ピンクオレンジ紫色',
            'de': 'Pink-Orange-Lila Farbe',
            'fr': 'Couleur rose-orange-violet',
            'it': 'Colore rosa-arancione-viola',
            'ko': '분홍-주황-보라색'
          },
          {
            'order': 1,
            'zh-cn': '粉黄绿',
            'en': 'pink-yellow-green Color',
            'zh-hant': '粉黃綠色',
            'ja': 'ピンク黄色緑色',
            'de': 'Pink-Gelb-Grün Farbe',
            'fr': 'Couleur rose-jaune-vert',
            'it': 'Colore rosa-giallo-verde',
            'ko': '분홍-노랑-초록색'
          },
          {
            'order': 1,
            'zh-cn': '粉蓝色',
            'en': 'pink-blue Color',
            'zh-hant': '粉藍色',
            'ja': 'ピンク青色',
            'de': 'Pink-Blau Farbe',
            'fr': 'Couleur rose-bleu',
            'it': 'Colore rosa-blu',
            'ko': '분홍-파랑색'
          },
          {
            'order': 1,
            'zh-cn': '粉绿紫',
            'en': 'pink-green-purple Color',
            'zh-hant': '粉綠紫色',
            'ja': 'ピンク緑色紫色',
            'de': 'Pink-Grün-Lila Farbe',
            'fr': 'Couleur rose-vert-violet',
            'it': 'Colore rosa-verde-viola',
            'ko': '분홍-초록-보라색'
          },
          {
            'order': 1,
            'zh-cn': '粉紫白',
            'en': 'pink-purple-white Color',
            'zh-hant': '粉紫白色',
            'ja': 'ピンク紫色白色',
            'de': 'Pink-Lila-Weiß Farbe',
            'fr': 'Couleur rose-violet-blanc',
            'it': 'Colore rosa-viola-bianco',
            'ko': '분홍-보라-흰색'
          },
          {
            'order': 1,
            'zh-cn': '海洋蓝白',
            'en': 'ocean blue-white Color',
            'zh-hant': '海洋藍白色',
            'ja': 'オーシャンブルー白色',
            'de': 'Ozeanblau-Weiß Farbe',
            'fr': 'Couleur bleu océan-blanc',
            'it': 'Colore blu oceano-bianco',
            'ko': '바다 파랑-흰색'
          },
          {
            'order': 1,
            'zh-cn': '褐红绿',
            'en': 'maroon-green Color',
            'zh-hant': '栗紅綠色',
            'ja': '栗色緑色',
            'de': 'Kastanienbraun-Grün Farbe',
            'fr': 'Couleur marron-vert',
            'it': 'Colore marrone-verde',
            'ko': '밤색-초록색'
          },
          {
            'order': 1,
            'zh-cn': '褐绿黄',
            'en': 'olive green-yellow Color',
            'zh-hant': '橄欖綠黃色',
            'ja': 'オリーブグリーン黄色',
            'de': 'Olivgrün-Gelb Farbe',
            'fr': 'Couleur vert olive-jaune',
            'it': 'Colore verde oliva-giallo',
            'ko': '올리브 초록-노랑색'
          },
          {
            'order': 1,
            'zh-cn': '黑白红',
            'en': 'black-white-red Color',
            'zh-hant': '黑白紅色',
            'ja': '黒白赤色',
            'de': 'Schwarz-Weiß-Rot Farbe',
            'fr': 'Couleur noir-blanc-rouge',
            'it': 'Colore nero-bianco-rosso',
            'ko': '검정-흰색-빨강색'
          },
          {
            'order': 1,
            'zh-cn': '黑白灰',
            'en': 'black-white-gray Color',
            'zh-hant': '黑白灰色',
            'ja': '黒白灰色',
            'de': 'Schwarz-Weiß-Grau Farbe',
            'fr': 'Couleur noir-blanc-gris',
            'it': 'Colore nero-bianco-grigio',
            'ko': '검정-흰색-회색'
          },
          {
            'order': 1,
            'zh-cn': '黑红白',
            'en': 'black-red-white Color',
            'zh-hant': '黑紅白色',
            'ja': '黒赤白色',
            'de': 'Schwarz-Rot-Weiß Farbe',
            'fr': 'Couleur noir-rouge-blanc',
            'it': 'Colore nero-rosso-bianco',
            'ko': '검정-빨강-흰색'
          },
          {
            'order': 1,
            'zh-cn': '黑红金',
            'en': 'black-red-gold Color',
            'zh-hant': '黑紅金色',
            'ja': '黒赤金色',
            'de': 'Schwarz-Rot-Gold Farbe',
            'fr': 'Couleur noir-rouge-or',
            'it': 'Colore nero-rosso-oro',
            'ko': '검정-빨강-금색'
          },
          {
            'order': 1,
            'zh-cn': '黑灰白',
            'en': 'black-gray-white Color',
            'zh-hant': '黑灰白色',
            'ja': '黒灰白色',
            'de': 'Schwarz-Grau-Weiß Farbe',
            'fr': 'Couleur noir-gris-blanc',
            'it': 'Colore nero-grigio-bianco',
            'ko': '검정-회색-흰색'
          },
          {
            'order': 1,
            'zh-cn': '黑灰红',
            'en': 'black-gray-red Color',
            'zh-hant': '黑灰紅色',
            'ja': '黒灰赤色',
            'de': 'Schwarz-Grau-Rot Farbe',
            'fr': 'Couleur noir-gris-rouge',
            'it': 'Colore nero-grigio-rosso',
            'ko': '검정-회색-빨강색'
          },
          {
            'order': 1,
            'zh-cn': '黑金白',
            'en': 'black-gold-white Color',
            'zh-hant': '黑金白色',
            'ja': '黒金白色',
            'de': 'Schwarz-Gold-Weiß Farbe',
            'fr': 'Couleur noir-or-blanc',
            'it': 'Colore nero-oro-bianco',
            'ko': '검정-금색-흰색'
          },
          {
            'order': 1,
            'zh-cn': '黑金银',
            'en': 'black-gold-silver Color',
            'zh-hant': '黑金銀色',
            'ja': '黒金銀色',
            'de': 'Schwarz-Gold-Silber Farbe',
            'fr': 'Couleur noir-or-argent',
            'it': 'Colore nero-oro-argento',
            'ko': '검정-금색-은색'
          },
          {
            'order': 1,
            'zh-cn': '红白绿',
            'en': 'red-white-green Color',
            'zh-hant': '紅白綠色',
            'ja': '赤白緑色',
            'de': 'Rot-Weiß-Grün Farbe',
            'fr': 'Couleur rouge-blanc-vert',
            'it': 'Colore rosso-bianco-verde',
            'ko': '빨강-흰색-초록색'
          },
          {
            'order': 1,
            'zh-cn': '红黑白',
            'en': 'red-black-white Color',
            'zh-hant': '紅黑白色',
            'ja': '赤黒白色',
            'de': 'Rot-Schwarz-Weiß Farbe',
            'fr': 'Couleur rouge-noir-blanc',
            'it': 'Colore rosso-nero-bianco',
            'ko': '빨강-검정-흰색'
          },
          {
            'order': 1,
            'zh-cn': '红黄蓝',
            'en': 'red-yellow-blue Color',
            'zh-hant': '紅黃藍色',
            'ja': '赤黄色青色',
            'de': 'Rot-Gelb-Blau Farbe',
            'fr': 'Couleur rouge-jaune-bleu',
            'it': 'Colore rosso-giallo-blu',
            'ko': '빨강-노랑-파랑색'
          },
          {
            'order': 1,
            'zh-cn': '红黄绿',
            'en': 'red-yellow-green Color',
            'zh-hant': '紅黃綠色',
            'ja': '赤黄色緑色',
            'de': 'Rot-Gelb-Grün Farbe',
            'fr': 'Couleur rouge-jaune-vert',
            'it': 'Colore rosso-giallo-verde',
            'ko': '빨강-노랑-초록색'
          },
          {
            'order': 1,
            'zh-cn': '红灰黑',
            'en': 'red-gray-black Color',
            'zh-hant': '紅灰黑色',
            'ja': '赤灰黒色',
            'de': 'Rot-Grau-Schwarz Farbe',
            'fr': 'Couleur rouge-gris-noir',
            'it': 'Colore rosso-grigio-nero',
            'ko': '빨강-회색-검정색'
          },
          {
            'order': 1,
            'zh-cn': '红灰金',
            'en': 'red-gray-gold Color',
            'zh-hant': '紅灰金色',
            'ja': '赤灰金色',
            'de': 'Rot-Grau-Gold Farbe',
            'fr': 'Couleur rouge-gris-or',
            'it': 'Colore rosso-grigio-oro',
            'ko': '빨강-회색-금색'
          },
          {
            'order': 1,
            'zh-cn': '红蓝白',
            'en': 'red-blue-white Color',
            'zh-hant': '紅藍白色',
            'ja': '赤青白色',
            'de': 'Rot-Blau-Weiß Farbe',
            'fr': 'Couleur rouge-bleu-blanc',
            'it': 'Colore rosso-blu-bianco',
            'ko': '빨강-파랑-흰색'
          },
          {
            'order': 1,
            'zh-cn': '红紫金',
            'en': 'red-purple-gold Color',
            'zh-hant': '紅紫金色',
            'ja': '赤紫金色',
            'de': 'Rot-Lila-Gold Farbe',
            'fr': 'Couleur rouge-violet-or',
            'it': 'Colore rosso-viola-oro',
            'ko': '빨강-보라-금색'
          },
          {
            'order': 1,
            'zh-cn': '黄紫配',
            'en': 'yellow-purple Color',
            'zh-hant': '黃紫色',
            'ja': '黄色紫色',
            'de': 'Gelb-Lila Farbe',
            'fr': 'Couleur jaune-violet',
            'it': 'Colore giallo-viola',
            'ko': '노랑-보라색'
          },
          {
            'order': 1,
            'zh-cn': '灰粉蓝',
            'en': 'gray-pink-blue Color',
            'zh-hant': '灰粉藍色',
            'ja': '灰色ピンク青色',
            'de': 'Grau-Rosa-Blau Farbe',
            'fr': 'Couleur gris-rose-bleu',
            'it': 'Colore grigio-rosa-blu',
            'ko': '회색-분홍-파랑색'
          },
          {
            'order': 1,
            'zh-cn': '灰粉绿',
            'en': 'gray-pink-green Color',
            'zh-hant': '灰粉綠色',
            'ja': '灰色ピンク緑色',
            'de': 'Grau-Rosa-Grün Farbe',
            'fr': 'Couleur gris-rose-vert',
            'it': 'Colore grigio-rosa-verde',
            'ko': '회색-분홍-초록색'
          },
          {
            'order': 1,
            'zh-cn': '灰粉紫',
            'en': 'gray-pink-purple Color',
            'zh-hant': '灰粉紫色',
            'ja': '灰色ピンク紫色',
            'de': 'Grau-Rosa-Lila Farbe',
            'fr': 'Couleur gris-rose-violet',
            'it': 'Colore grigio-rosa-viola',
            'ko': '회색-분홍-보라색'
          },
          {
            'order': 1,
            'zh-cn': '灰褐白',
            'en': 'gray-brown-white Color',
            'zh-hant': '灰棕白色',
            'ja': '灰色茶色白色',
            'de': 'Grau-Braun-Weiß Farbe',
            'fr': 'Couleur gris-marron-blanc',
            'it': 'Colore grigio-marrone-bianco',
            'ko': '회색-갈색-흰색'
          },
          {
            'order': 1,
            'zh-cn': '灰蓝白',
            'en': 'slate blue-white Color',
            'zh-hant': '石板藍白色',
            'ja': 'スレートブルー白色',
            'de': 'Schieferblau-Weiß Farbe',
            'fr': 'Couleur bleu ardoise-blanc',
            'it': 'Colore blu ardesia-bianco',
            'ko': '슬레이트 파랑-흰색'
          },
          {
            'order': 1,
            'zh-cn': '灰蓝绿',
            'en': 'gray-blue-green Color',
            'zh-hant': '灰藍綠色',
            'ja': '灰色青緑色',
            'de': 'Grau-Blau-Grün Farbe',
            'fr': 'Couleur gris-bleu-vert',
            'it': 'Colore grigio-blu-verde',
            'ko': '회색-파랑-초록색'
          },
          {
            'order': 1,
            'zh-cn': '酒红金',
            'en': 'burgundy-gold Color',
            'zh-hant': '酒紅金色',
            'ja': 'バーガンディ金色',
            'de': 'Burgunder-Gold Farbe',
            'fr': 'Couleur bordeaux-or',
            'it': 'Colore bordeaux-oro',
            'ko': '버건디-금색'
          },
          {
            'order': 1,
            'zh-cn': '酒红绿',
            'en': 'burgundy-green Color',
            'zh-hant': '酒紅綠色',
            'ja': 'バーガンディ緑色',
            'de': 'Burgunder-Grün Farbe',
            'fr': 'Couleur bordeaux-vert',
            'it': 'Colore bordeaux-verde',
            'ko': '버건디-초록색'
          },
          {
            'order': 1,
            'zh-cn': '酒红银',
            'en': 'burgundy-silver Color',
            'zh-hant': '酒紅銀色',
            'ja': 'バーガンディ銀色',
            'de': 'Burgunder-Silber Farbe',
            'fr': 'Couleur bordeaux-argent',
            'it': 'Colore bordeaux-argento',
            'ko': '버건디-은색'
          },
          {
            'order': 1,
            'zh-cn': '橘绿紫',
            'en': 'orange-green-purple Color',
            'zh-hant': '橙綠紫色',
            'ja': 'オレンジ緑紫色',
            'de': 'Orange-Grün-Lila Farbe',
            'fr': 'Couleur orange-vert-violet',
            'it': 'Colore arancione-verde-viola',
            'ko': '주황-초록-보라색'
          },
          {
            'order': 1,
            'zh-cn': '蓝白粉',
            'en': 'blue-white-pink Color',
            'zh-hant': '藍白粉色',
            'ja': '青白ピンク色',
            'de': 'Blau-Weiß-Rosa Farbe',
            'fr': 'Couleur bleu-blanc-rose',
            'it': 'Colore blu-bianco-rosa',
            'ko': '파랑-흰색-분홍색'
          },
          {
            'order': 1,
            'zh-cn': '蓝白红',
            'en': 'blue-white-red Color',
            'zh-hant': '藍白紅色',
            'ja': '青白赤色',
            'de': 'Blau-Weiß-Rot Farbe',
            'fr': 'Couleur bleu-blanc-rouge',
            'it': 'Colore blu-bianco-rosso',
            'ko': '파랑-흰색-빨강색'
          },
          {
            'order': 1,
            'zh-cn': '蓝白黄',
            'en': 'blue-white-yellow Color',
            'zh-hant': '藍白黃色',
            'ja': '青白黄色',
            'de': 'Blau-Weiß-Gelb Farbe',
            'fr': 'Couleur bleu-blanc-jaune',
            'it': 'Colore blu-bianco-giallo',
            'ko': '파랑-흰색-노랑색'
          },
          {
            'order': 1,
            'zh-cn': '蓝白绿',
            'en': 'blue-white-green Color',
            'zh-hant': '藍白綠色',
            'ja': '青白緑色',
            'de': 'Blau-Weiß-Grün Farbe',
            'fr': 'Couleur bleu-blanc-vert',
            'it': 'Colore blu-bianco-verde',
            'ko': '파랑-흰색-초록색'
          },
          {
            'order': 1,
            'zh-cn': '蓝粉白',
            'en': 'blue-pink-white Color',
            'zh-hant': '藍粉白色',
            'ja': '青ピンク白色',
            'de': 'Blau-Rosa-Weiß Farbe',
            'fr': 'Couleur bleu-rose-blanc',
            'it': 'Colore blu-rosa-bianco',
            'ko': '파랑-분홍-흰색'
          },
          {
            'order': 1,
            'zh-cn': '蓝粉黄',
            'en': 'blue-pink-yellow Color',
            'zh-hant': '藍粉黃色',
            'ja': '青ピンク黄色',
            'de': 'Blau-Rosa-Gelb Farbe',
            'fr': 'Couleur bleu-rose-jaune',
            'it': 'Colore blu-rosa-giallo',
            'ko': '파랑-분홍-노랑색'
          },
          {
            'order': 1,
            'zh-cn': '蓝绿色',
            'en': 'blue-green Color',
            'zh-hant': '藍綠色',
            'ja': '青緑色',
            'de': 'Blau-Grün Farbe',
            'fr': 'Couleur bleu-vert',
            'it': 'Colore blu-verde',
            'ko': '파랑-초록색'
          },
          {
            'order': 1,
            'zh-cn': '蓝紫白',
            'en': 'blue-purple-white Color',
            'zh-hant': '藍紫白色',
            'ja': '青紫白色',
            'de': 'Blau-Lila-Weiß Farbe',
            'fr': 'Couleur bleu-violet-blanc',
            'it': 'Colore blu-viola-bianco',
            'ko': '파랑-보라-흰색'
          },
          {
            'order': 1,
            'zh-cn': '绿白绿',
            'en': 'green-white-green Color',
            'zh-hant': '綠白綠色',
            'ja': '緑白緑色',
            'de': 'Grün-Weiß-Grün Farbe',
            'fr': 'Couleur vert-blanc-vert',
            'it': 'Colore verde-bianco-verde',
            'ko': '초록-흰색-초록색'
          },
          {
            'order': 1,
            'zh-cn': '绿橙紫',
            'en': 'green-orange-purple Color',
            'zh-hant': '綠橙紫色',
            'ja': '緑オレンジ紫色',
            'de': 'Grün-Orange-Lila Farbe',
            'fr': 'Couleur vert-orange-violet',
            'it': 'Colore verde-arancione-viola',
            'ko': '초록-주황-보라색'
          },
          {
            'order': 1,
            'zh-cn': '绿黄白',
            'en': 'green-yellow-white Color',
            'zh-hant': '綠黃白色',
            'ja': '緑黄色白色',
            'de': 'Grün-Gelb-Weiß Farbe',
            'fr': 'Couleur vert-jaune-blanc',
            'it': 'Colore verde-giallo-bianco',
            'ko': '초록-노랑-흰색'
          },
          {
            'order': 1,
            'zh-cn': '绿黄蓝',
            'en': 'green-yellow-blue Color',
            'zh-hant': '綠黃藍色',
            'ja': '緑黄色青色',
            'de': 'Grün-Gelb-Blau Farbe',
            'fr': 'Couleur vert-jaune-bleu',
            'it': 'Colore verde-giallo-blu',
            'ko': '초록-노랑-파랑색'
          },
          {
            'order': 1,
            'zh-cn': '绿黄紫',
            'en': 'green-yellow-purple Color',
            'zh-hant': '綠黃紫色',
            'ja': '緑黄色紫色',
            'de': 'Grün-Gelb-Lila Farbe',
            'fr': 'Couleur vert-jaune-violet',
            'it': 'Colore verde-giallo-viola',
            'ko': '초록-노랑-보라색'
          },
          {
            'order': 1,
            'zh-cn': '绿紫白',
            'en': 'green-purple-white Color',
            'zh-hant': '綠紫白色',
            'ja': '緑紫白色',
            'de': 'Grün-Lila-Weiß Farbe',
            'fr': 'Couleur vert-violet-blanc',
            'it': 'Colore verde-viola-bianco',
            'ko': '초록-보라-흰색'
          },
          {
            'order': 1,
            'zh-cn': '绿紫黄',
            'en': 'green-purple-yellow Color',
            'zh-hant': '綠紫黃色',
            'ja': '緑紫黄色',
            'de': 'Grün-Lila-Gelb Farbe',
            'fr': 'Couleur vert-violet-jaune',
            'it': 'Colore verde-viola-giallo',
            'ko': '초록-보라-노랑색'
          },
          {
            'order': 1,
            'zh-cn': '青蓝黄',
            'en': 'turquoise-blue-yellow Color',
            'zh-hant': '綠松石藍黃色',
            'ja': 'ターコイズ青黄色',
            'de': 'Türkis-Blau-Gelb Farbe',
            'fr': 'Couleur turquoise-bleu-jaune',
            'it': 'Colore turchese-blu-giallo',
            'ko': '청록-파랑-노랑색'
          },
          {
            'order': 1,
            'zh-cn': '青绿白',
            'en': 'teal-green-white Color',
            'zh-hant': '水鴨綠白色',
            'ja': 'ティール緑白色',
            'de': 'Teal-Grün-Weiß Farbe',
            'fr': 'Couleur bleu canard-vert-blanc',
            'it': 'Colore verde teal-bianco',
            'ko': '청록-초록-흰색'
          },
          {
            'order': 1,
            'zh-cn': '青绿黄',
            'en': 'teal-green-yellow Color',
            'zh-hant': '水鴨綠黃色',
            'ja': 'ティール緑黄色',
            'de': 'Teal-Grün-Gelb Farbe',
            'fr': 'Couleur bleu canard-vert-jaune',
            'it': 'Colore verde teal-giallo',
            'ko': '청록-초록-노랑색'
          },
          {
            'order': 1,
            'zh-cn': '青绿紫',
            'en': 'teal-green-purple Color',
            'zh-hant': '水鴨綠紫色',
            'ja': 'ティール緑紫色',
            'de': 'Teal-Grün-Lila Farbe',
            'fr': 'Couleur bleu canard-vert-violet',
            'it': 'Colore verde teal-viola',
            'ko': '청록-초록-보라색'
          },
          {
            'order': 1,
            'zh-cn': '深红金',
            'en': 'deep red-gold Color',
            'zh-hant': '深紅金色',
            'ja': '深紅色金色',
            'de': 'Dunkelrot-Gold Farbe',
            'fr': 'Couleur rouge profond-or',
            'it': 'Colore rosso profondo-oro',
            'ko': '진빨강-금색'
          },
          {
            'order': 1,
            'zh-cn': '深蓝金',
            'en': 'navy blue-gold Color',
            'zh-hant': '海軍藍金色',
            'ja': 'ネイビーブルー金色',
            'de': 'Marineblau-Gold Farbe',
            'fr': 'Couleur bleu marine-or',
            'it': 'Colore blu navy-oro',
            'ko': '네이비블루-금색'
          },
          {
            'order': 1,
            'zh-cn': '雪白银',
            'en': 'snow white-silver Color',
            'zh-hant': '雪白銀色',
            'ja': '雪白銀色',
            'de': 'Schneeweiß-Silber Farbe',
            'fr': 'Couleur blanc neige-argent',
            'it': 'Colore bianco neve-argento',
            'ko': '설백-은색'
          },
          {
            'order': 1,
            'zh-cn': '紫白粉',
            'en': 'purple-white-pink Color',
            'zh-hant': '紫白粉色',
            'ja': '紫白ピンク色',
            'de': 'Lila-Weiß-Rosa Farbe',
            'fr': 'Couleur violet-blanc-rose',
            'it': 'Colore viola-bianco-rosa',
            'ko': '보라-흰색-분홍색'
          },
          {
            'order': 1,
            'zh-cn': '紫红橙',
            'en': 'magenta-orange Color',
            'zh-hant': '洋紅橙色',
            'ja': 'マゼンタオレンジ色',
            'de': 'Magenta-Orange Farbe',
            'fr': 'Couleur magenta-orange',
            'it': 'Colore magenta-arancione',
            'ko': '자홍-주황색'
          },
          {
            'order': 1,
            'zh-cn': '紫红绿',
            'en': 'purple-red-green Color',
            'zh-hant': '紫紅綠',
            'ja': '紫赤緑',
            'de': 'Lila-Rot-Grün Farbe',
            'fr': 'Couleur violet-rouge-vert',
            'it': 'Colore viola-rosso-verde',
            'ko': '보라-빨강-초록색'
          },
          {
            'order': 1,
            'zh-cn': '紫蓝粉',
            'en': 'violet-blue-pink Color',
            'zh-hant': '紫藍粉',
            'ja': '紫青ピンク',
            'de': 'Lila-Blau-Rosa Farbe',
            'fr': 'Couleur violet-bleu-rose',
            'it': 'Colore viola-blu-rosa',
            'ko': '보라-파랑-분홍색'
          },
          {
            'order': 1,
            'zh-cn': '棕橙黄',
            'en': 'brown-orange-yellow Color',
            'zh-hant': '棕橙黃',
            'ja': '茶色オレンジ黄色',
            'de': 'Braun-Orange-Gelb Farbe',
            'fr': 'Couleur marron-orange-jaune',
            'it': 'Colore marrone-arancione-giallo',
            'ko': '갈색-주황-노랑색'
          },
          {
            'order': 1,
            'zh-cn': '棕黄黑',
            'en': 'brown-yellow-black Color',
            'zh-hant': '棕黃黑',
            'ja': '茶色黄色黒',
            'de': 'Braun-Gelb-Schwarz Farbe',
            'fr': 'Couleur marron-jaune-noir',
            'it': 'Colore marrone-giallo-nero',
            'ko': '갈색-노랑-검정색'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '色调氛围', en: 'Tone Atmosphere', 'zh-hant': '色調氛圍', ja: '色調の雰囲気', de: 'Farbtonatmosphäre', fr: 'Ambiance des tons', it: 'Atmosfera delle tonalità', ko: '톤 분위기' },
        'list': [
          {
            'order': 1,
            'zh-cn': '淡雅的色系',
            'en': 'muted color palette',
            'zh-hant': '柔和色調',
            'ja': '柔らかいカラーパレット',
            'de': 'Gedämpfte Farbpalette',
            'fr': 'Palette de couleurs atténuées',
            'it': 'Tavolozza di colori smorzati',
            'ko': '차분한 색상 팔레트'
          },
          {
            'order': 1,
            'zh-cn': '浓郁的色系',
            'en': 'rich color palette',
            'zh-hant': '豐富色調',
            'ja': '豊かなカラーパレット',
            'de': 'Reiche Farbpalette',
            'fr': 'Palette de couleurs riches',
            'it': 'Tavolozza di colori ricchi',
            'ko': '풍부한 색상 팔레트'
          },
          {
            'order': 1,
            'zh-cn': '孤独的色彩',
            'en': 'lonely colors',
            'zh-hant': '孤寂色調',
            'ja': '寂しい色',
            'de': 'Einsame Farben',
            'fr': 'Couleurs solitaires',
            'it': 'Colori solitari',
            'ko': '고독한 색상'
          },
          {
            'order': 1,
            'zh-cn': '忧郁的色彩',
            'en': 'melancholic colors',
            'zh-hant': '憂鬱色調',
            'ja': 'メランコリックな色',
            'de': 'Melancholische Farben',
            'fr': 'Couleurs mélancoliques',
            'it': 'Colori malinconici',
            'ko': '우울한 색상'
          },
          {
            'order': 1,
            'zh-cn': '清新的色彩',
            'en': 'fresh colors',
            'zh-hant': '清新色調',
            'ja': 'フレッシュな色',
            'de': 'Frische Farben',
            'fr': 'Couleurs fraîches',
            'it': 'Colori freschi',
            'ko': '산뜻한 색상'
          },
          {
            'order': 1,
            'zh-cn': '活力的色彩',
            'en': 'vibrant colors',
            'zh-hant': '鮮豔色調',
            'ja': '鮮やかな色',
            'de': 'Lebendige Farben',
            'fr': 'Couleurs vibrantes',
            'it': 'Colori vivaci',
            'ko': '생동감 있는 색상'
          },
          {
            'order': 1,
            'zh-cn': '平静的色彩',
            'en': 'calm colors',
            'zh-hant': '平靜色調',
            'ja': '落ち着いた色',
            'de': 'Ruhige Farben',
            'fr': 'Couleurs calmes',
            'it': 'Colori calmi',
            'ko': '차분한 색상'
          },
          {
            'order': 1,
            'zh-cn': '欢快的色彩',
            'en': 'cheerful colors',
            'zh-hant': '愉快色調',
            'ja': '明るい色',
            'de': 'Fröhliche Farben',
            'fr': 'Couleurs joyeuses',
            'it': 'Colori allegri',
            'ko': '명랑한 색상'
          },
          {
            'order': 1,
            'zh-cn': '夏日的色彩',
            'en': 'summery colors',
            'zh-hant': '夏日色調',
            'ja': '夏らしい色',
            'de': 'Sommerliche Farben',
            'fr': 'Couleurs estivales',
            'it': 'Colori estivi',
            'ko': '여름 색상'
          },
          {
            'order': 1,
            'zh-cn': '冬季的色彩',
            'en': 'wintry colors',
            'zh-hant': '冬日色調',
            'ja': '冬らしい色',
            'de': 'Winterliche Farben',
            'fr': 'Couleurs hivernales',
            'it': 'Colori invernali',
            'ko': '겨울 색상'
          },
          {
            'order': 1,
            'zh-cn': '地中海风格的色彩',
            'en': 'Mediterranean-style colors',
            'zh-hant': '地中海風格色調',
            'ja': '地中海風の色',
            'de': 'Mediterrane Farben',
            'fr': 'Couleurs de style méditerranéen',
            'it': 'Colori in stile mediterraneo',
            'ko': '지중해풍 색상'
          },
          {
            'order': 1,
            'zh-cn': '东方风情的色彩',
            'en': 'Oriental-inspired colors',
            'zh-hant': '東方風格色調',
            'ja': '東洋風の色',
            'de': 'Orientalisch inspirierte Farben',
            'fr': 'Couleurs d\'inspiration orientale',
            'it': 'Colori ispirati all\'Oriente',
            'ko': '동양풍 색상'
          },
          {
            'order': 1,
            'zh-cn': '自然的色彩',
            'en': 'natural colors',
            'zh-hant': '自然色調',
            'ja': '自然の色',
            'de': 'Natürliche Farben',
            'fr': 'Couleurs naturelles',
            'it': 'Colori naturali',
            'ko': '자연스러운 색상'
          },
          {
            'order': 1,
            'zh-cn': '高雅的色彩',
            'en': 'elegant colors',
            'zh-hant': '優雅色調',
            'ja': 'エレガントな色',
            'de': 'Elegante Farben',
            'fr': 'Couleurs élégantes',
            'it': 'Colori eleganti',
            'ko': '우아한 색상'
          },
          {
            'order': 1,
            'zh-cn': '朦胧的色彩',
            'en': 'hazy colors',
            'zh-hant': '朦朧色調',
            'ja': '霞んだ色',
            'de': 'Neblige Farben',
            'fr': 'Couleurs brumeuses',
            'it': 'Colori sfumati',
            'ko': '몽롱한 색상'
          },
          {
            'order': 1,
            'zh-cn': '惊艳的色彩',
            'en': 'dazzling colors',
            'zh-hant': '眩目色調',
            'ja': '眩しい色',
            'de': 'Blendende Farben',
            'fr': 'Couleurs éblouissantes',
            'it': 'Colori abbaglianti',
            'ko': '눈부신 색상'
          },
          {
            'order': 1,
            'zh-cn': '明亮的色彩',
            'en': 'bright colors',
            'zh-hant': '明亮色調',
            'ja': '明るい色',
            'de': 'Helle Farben',
            'fr': 'Couleurs vives',
            'it': 'Colori luminosi',
            'ko': '밝은 색상'
          },
          {
            'order': 1,
            'zh-cn': '柔和的色彩',
            'en': 'gentle colors',
            'zh-hant': '溫柔色調',
            'ja': '優しい色',
            'de': 'Sanfte Farben',
            'fr': 'Couleurs douces',
            'it': 'Colori delicati',
            'ko': '부드러운 색상'
          },
          {
            'order': 1,
            'zh-cn': '神秘的色彩',
            'en': 'mysterious colors',
            'zh-hant': '神秘色調',
            'ja': '神秘的な色',
            'de': 'Mysteriöse Farben',
            'fr': 'Couleurs mystérieuses',
            'it': 'Colori misteriosi',
            'ko': '신비로운 색상'
          },
          {
            'order': 1,
            'zh-cn': '愉悦的色彩',
            'en': 'joyful colors',
            'zh-hant': '喜悅色調',
            'ja': '喜びの色',
            'de': 'Freudige Farben',
            'fr': 'Couleurs joyeuses',
            'it': 'Colori gioiosi',
            'ko': '즐거운 색상'
          },
          {
            'order': 1,
            'zh-cn': '温馨的色彩',
            'en': 'cozy colors',
            'zh-hant': '溫馨色調',
            'ja': '居心地の良い色',
            'de': 'Gemütliche Farben',
            'fr': 'Couleurs confortables',
            'it': 'Colori accoglienti',
            'ko': '아늑한 색상'
          },
          {
            'order': 1,
            'zh-cn': '梦幻的色彩',
            'en': 'dreamy colors',
            'zh-hant': '夢幻色調',
            'ja': '夢のような色',
            'de': 'Traumhafte Farben',
            'fr': 'Couleurs rêveuses',
            'it': 'Colori da sogno',
            'ko': '몽환적인 색상'
          },
          {
            'order': 1,
            'zh-cn': '装饰的色彩',
            'en': 'ornamental colors',
            'zh-hant': '裝飾色',
            'ja': '装飾的な色',
            'de': 'Ornamentale Farben',
            'fr': 'Couleurs ornementales',
            'it': 'Colori ornamentali',
            'ko': '장식적인 색상'
          },
          {
            'order': 1,
            'zh-cn': '珍贵的色彩',
            'en': 'precious colors',
            'zh-hant': '珍貴色',
            'ja': '貴重な色',
            'de': 'Kostbare Farben',
            'fr': 'Couleurs précieuses',
            'it': 'Colori preziosi',
            'ko': '귀중한 색상'
          },
          {
            'order': 1,
            'zh-cn': '欢愉的色彩',
            'en': 'playful colors',
            'zh-hant': '玩樂色',
            'ja': '遊び心のある色',
            'de': 'Verspielte Farben',
            'fr': 'Couleurs ludiques',
            'it': 'Colori giocosi',
            'ko': '유쾌한 색상'
          },
          {
            'order': 1,
            'zh-cn': '冷静的色彩',
            'en': 'cool colors',
            'zh-hant': '冷色調',
            'ja': 'クールな色',
            'de': 'Kühle Farben',
            'fr': 'Couleurs froides',
            'it': 'Colori freddi',
            'ko': '차가운 색상'
          },
          {
            'order': 1,
            'zh-cn': '炽热的色彩',
            'en': 'fiery colors',
            'zh-hant': '火熱色調',
            'ja': '火のような色',
            'de': 'Feurige Farben',
            'fr': 'Couleurs ardentes',
            'it': 'Colori infuocati',
            'ko': '불타는 듯한 색상'
          },
          {
            'order': 1,
            'zh-cn': '平和的色彩',
            'en': 'serene colors',
            'zh-hant': '寧靜色調',
            'ja': '静かな色',
            'de': 'Gelassene Farben',
            'fr': 'Couleurs sereines',
            'it': 'Colori sereni',
            'ko': '평화로운 색상'
          },
          {
            'order': 1,
            'zh-cn': '诱人的色彩',
            'en': 'alluring colors',
            'zh-hant': '迷人色調',
            'ja': '魅惑的な色',
            'de': 'Verführerische Farben',
            'fr': 'Couleurs séduisantes',
            'it': 'Colori seducenti',
            'ko': '매혹적인 색상'
          },
          {
            'order': 1,
            'zh-cn': '落寞的色彩',
            'en': 'desolate colors',
            'zh-hant': '荒涼色調',
            'ja': '荒涼とした色',
            'de': 'Trostlose Farben',
            'fr': 'Couleurs désolées',
            'it': 'Colori desolati',
            'ko': '쓸쓸한 색상'
          },
          {
            'order': 1,
            'zh-cn': '安详的色彩',
            'en': 'tranquil colors',
            'zh-hant': '恬靜色調',
            'ja': '静かな色',
            'de': 'Ruhige Farben',
            'fr': 'Couleurs tranquilles',
            'it': 'Colori tranquilli',
            'ko': '평온한 색상'
          },
          {
            'order': 1,
            'zh-cn': '舒适的色彩',
            'en': 'comfortable colors',
            'zh-hant': '舒適色調',
            'ja': '快適な色',
            'de': 'Bequeme Farben',
            'fr': 'Couleurs confortables',
            'it': 'Colori confortevoli',
            'ko': '편안한 색상'
          },
          {
            'order': 1,
            'zh-cn': '富饶的色彩',
            'en': 'abundant colors',
            'zh-hant': '豐富色調',
            'ja': '豊かな色',
            'de': 'Reichhaltige Farben',
            'fr': 'Couleurs abondantes',
            'it': 'Colori abbondanti',
            'ko': '풍부한 색상'
          },
          {
            'order': 1,
            'zh-cn': '深邃的色彩',
            'en': 'profound colors',
            'zh-hant': '深邃色調',
            'ja': '深い色',
            'de': 'Tiefgründige Farben',
            'fr': 'Couleurs profondes',
            'it': 'Colori profondi',
            'ko': '심오한 색상'
          },
          {
            'order': 1,
            'zh-cn': '摄人心魄的色彩',
            'en': 'captivating colors',
            'zh-hant': '吸引色調',
            'ja': '魅力的な色',
            'de': 'Fesselnde Farben',
            'fr': 'Couleurs captivantes',
            'it': 'Colori affascinanti',
            'ko': '매혹적인 색상'
          },
          {
            'order': 1,
            'zh-cn': '悠闲的色彩',
            'en': 'leisurely colors',
            'zh-hant': '悠閒色調',
            'ja': 'ゆったりとした色',
            'de': 'Gemütliche Farben',
            'fr': 'Couleurs détendues',
            'it': 'Colori rilassanti',
            'ko': '여유로운 색상'
          },
          {
            'order': 1,
            'zh-cn': '活泼的色彩',
            'en': 'lively colors',
            'zh-hant': '活潑色調',
            'ja': '活気のある色',
            'de': 'Lebhafte Farben',
            'fr': 'Couleurs vives',
            'it': 'Colori vivaci',
            'ko': '활발한 색상'
          },
          {
            'order': 1,
            'zh-cn': '怀旧的色彩',
            'en': 'nostalgic colors',
            'zh-hant': '懷舊色調',
            'ja': 'ノスタルジックな色',
            'de': 'Nostalgische Farben',
            'fr': 'Couleurs nostalgiques',
            'it': 'Colori nostalgici',
            'ko': '향수를 불러일으키는 색상'
          },
          {
            'order': 1,
            'zh-cn': '感性的色彩',
            'en': 'emotive colors',
            'zh-hant': '情感色調',
            'ja': '感情的な色',
            'de': 'Emotionale Farben',
            'fr': 'Couleurs émotives',
            'it': 'Colori emotivi',
            'ko': '감성적인 색상'
          },
          {
            'order': 1,
            'zh-cn': '高效的色彩',
            'en': 'efficient colors',
            'zh-hant': '高效色調',
            'ja': '効率的な色',
            'de': 'Effiziente Farben',
            'fr': 'Couleurs efficaces',
            'it': 'Colori efficienti',
            'ko': '효율적인 색상'
          },
          {
            'order': 1,
            'zh-cn': '亲切的色彩',
            'en': 'inviting colors',
            'zh-hant': '誘人色調',
            'ja': '魅力的な色',
            'de': 'Einladende Farben',
            'fr': 'Couleurs accueillantes',
            'it': 'Colori invitanti',
            'ko': '친근한 색상'
          },
          {
            'order': 1,
            'zh-cn': '冒险的色彩',
            'en': 'adventurous colors',
            'zh-hant': '冒險色調',
            'ja': '冒険的な色',
            'de': 'Abenteuerliche Farben',
            'fr': 'Couleurs aventureuses',
            'it': 'Colori avventurosi',
            'ko': '모험적인 색상'
          },
          {
            'order': 1,
            'zh-cn': '奢华的色彩',
            'en': 'luxurious colors',
            'zh-hant': '奢華色調',
            'ja': '贅沢な色',
            'de': 'Luxuriöse Farben',
            'fr': 'Couleurs luxueuses',
            'it': 'Colori lussuosi',
            'ko': '호화로운 색상'
          },
          {
            'order': 1,
            'zh-cn': '幽暗的色彩',
            'en': 'dim colors',
            'zh-hant': '昏暗色調',
            'ja': '薄暗い色',
            'de': 'Gedimmte Farben',
            'fr': 'Couleurs tamisées',
            'it': 'Colori tenui',
            'ko': '어두운 색상'
          },
          {
            'order': 1,
            'zh-cn': '清醒的色彩',
            'en': 'wakeful colors',
            'zh-hant': '清醒的色彩',
            'ja': '目覚めの色',
            'de': 'Wachende Farben',
            'fr': 'Couleurs éveillées',
            'it': 'Colori svegli',
            'ko': '맑은 색상'
          },
          {
            'order': 1,
            'zh-cn': '神圣的色彩',
            'en': 'sacred colors',
            'zh-hant': '神聖的色彩',
            'ja': '神聖な色',
            'de': 'Heilige Farben',
            'fr': 'Couleurs sacrées',
            'it': 'Colori sacri',
            'ko': '신성한 색상'
          },
          {
            'order': 1,
            'zh-cn': '悲伤的色彩',
            'en': 'sorrowful colors',
            'zh-hant': '悲傷的色彩',
            'ja': '悲しい色',
            'de': 'Traurige Farben',
            'fr': 'Couleurs tristes',
            'it': 'Colori tristi',
            'ko': '슬픈 색상'
          },
          {
            'order': 1,
            'zh-cn': '活跃的色彩',
            'en': 'vibrant colors',
            'zh-hant': '鮮豔色調',
            'ja': '鮮やかな色',
            'de': 'Lebendige Farben',
            'fr': 'Couleurs vibrantes',
            'it': 'Colori vivaci',
            'ko': '활기찬 색상'
          },
          {
            'order': 1,
            'zh-cn': '自由的色彩',
            'en': 'liberated colors',
            'zh-hant': '自由的色彩',
            'ja': '自由な色',
            'de': 'Freie Farben',
            'fr': 'Couleurs libres',
            'it': 'Colori liberi',
            'ko': '자유로운 색상'
          },
          {
            'order': 1,
            'zh-cn': '积极的色彩',
            'en': 'positive colors',
            'zh-hant': '積極的色彩',
            'ja': '積極的な色',
            'de': 'Positive Farben',
            'fr': 'Couleurs positives',
            'it': 'Colori positivi',
            'ko': '긍정적인 색상'
          }
        ]
      }
    ]
  },
  {
    'order': 1,
    'name': { 'zh-cn': '廓形', en: 'Silhouette', 'zh-hant': '廓形', ja: 'シルエット', de: 'Silhouette', fr: 'Silhouette', it: 'Silhouette', ko: '실루엣' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '廓形', en: 'Silhouette', 'zh-hant': '廓形', ja: 'シルエット', de: 'Silhouette', fr: 'Silhouette', it: 'Silhouette', ko: '실루엣' },
        'list': [
          {
            'order': 1,
            'zh-cn': 'A型',
            'en': 'A-line',
            'zh-hant': 'A字型',
            'ja': 'Aライン',
            'de': 'A-Linie',
            'fr': 'Ligne A',
            'it': 'Linea ad A',
            'ko': 'A라인'
          },
          {
            'order': 1,
            'zh-cn': '茧型',
            'en': 'cocoon',
            'zh-hant': '茧型',
            'ja': 'コクーン',
            'de': 'Kokon',
            'fr': 'Cocoon',
            'it': 'A bozzolo',
            'ko': '코쿤'
          },
          {
            'order': 1,
            'zh-cn': '大廓形',
            'en': 'oversized',
            'zh-hant': '寬鬆',
            'ja': 'オーバーサイズ',
            'de': 'Übergröße',
            'fr': 'Surdimensionné',
            'it': 'Oversize',
            'ko': '오버사이즈'
          },
          {
            'order': 1,
            'zh-cn': 'H型',
            'en': 'straight',
            'zh-hant': '直筒',
            'ja': 'ストレート',
            'de': 'Gerade',
            'fr': 'Droit',
            'it': 'Dritto',
            'ko': '스트레이트'
          },
          {
            'order': 1,
            'zh-cn': '箱型',
            'en': 'boxy',
            'zh-hant': '方形',
            'ja': 'ボクシー',
            'de': 'Boxy',
            'fr': 'Boxy',
            'it': 'Boxy',
            'ko': '박시'
          },
          {
            'order': 1,
            'zh-cn': 'O型',
            'en': 'O-silhouette',
            'zh-hant': 'O型輪廓',
            'ja': 'Oシルエット',
            'de': 'O-Silhouette',
            'fr': 'Silhouette en O',
            'it': 'Silhouette a O',
            'ko': 'O실루엣'
          },
          {
            'order': 1,
            'zh-cn': '长款',
            'en': 'longline',
            'zh-hant': '長款',
            'ja': 'ロングライン',
            'de': 'Longline',
            'fr': 'Longline',
            'it': 'Longline',
            'ko': '롱라인'
          },
          {
            'order': 1,
            'zh-cn': '特殊版型',
            'en': 'unconventional',
            'zh-hant': '非傳統',
            'ja': '非定型',
            'de': 'Unkonventionell',
            'fr': 'Non conventionnel',
            'it': 'Non convenzionale',
            'ko': '비정형'
          },
          {
            'order': 1,
            'zh-cn': '短款',
            'en': 'cropped or short',
            'zh-hant': '短款或短版',
            'ja': 'クロップドまたはショート',
            'de': 'Kurz oder cropped',
            'fr': 'Court ou cropped',
            'it': 'Corto o cropped',
            'ko': '크롭 또는 숏'
          },
          {
            'order': 1,
            'zh-cn': '挂脖',
            'en': 'halterneck',
            'zh-hant': '領口',
            'ja': 'ホルターネック',
            'de': 'Neckholder',
            'fr': 'Col halter',
            'it': 'All\'americana',
            'ko': '홀터넥'
          },
          {
            'order': 1,
            'zh-cn': 'T型',
            'en': 'T-shirt',
            'zh-hant': 'T恤',
            'ja': 'Tシャツ',
            'de': 'T-Shirt',
            'fr': 'T-shirt',
            'it': 'T-shirt',
            'ko': 'T셔츠'
          },
          {
            'order': 1,
            'zh-cn': '宽松',
            'en': 'loose fit',
            'zh-hant': '寬鬆版型',
            'ja': 'ゆったりフィット',
            'de': 'Locker geschnitten',
            'fr': 'Coupe ample',
            'it': 'Vestibilità ampia',
            'ko': '루즈핏'
          },
          {
            'order': 1,
            'zh-cn': '收腰型',
            'en': 'cinched waist',
            'zh-hant': '束腰',
            'ja': '絞りウエスト',
            'de': 'Tailliert',
            'fr': 'Taille cintrée',
            'it': 'Vita stretta',
            'ko': '허리 조임'
          },
          {
            'order': 1,
            'zh-cn': 'X型',
            'en': 'hourglass',
            'zh-hant': '沙漏型',
            'ja': '砂時計型',
            'de': 'Sanduhrform',
            'fr': 'Sablier',
            'it': 'Clessidra',
            'ko': '모래시계형'
          },
          {
            'order': 1,
            'zh-cn': '紧身',
            'en': 'bodycon',
            'zh-hant': '緊身',
            'ja': 'ボディコン',
            'de': 'Figurbetont',
            'fr': 'Moulant',
            'it': 'Aderente',
            'ko': '바디콘'
          },
          {
            'order': 1,
            'zh-cn': '修身',
            'en': 'slim fit or fitted',
            'zh-hant': '修身或合身',
            'ja': 'スリムフィットまたはフィット',
            'de': 'Schmal geschnitten oder tailliert',
            'fr': 'Coupe slim ou ajustée',
            'it': 'Vestibilità slim o aderente',
            'ko': '슬림핏 또는 피티드'
          },
          {
            'order': 1,
            'zh-cn': 'V型',
            'en': 'V-shaped',
            'zh-hant': 'V型',
            'ja': 'V字型',
            'de': 'V-förmig',
            'fr': 'En forme de V',
            'it': 'A forma di V',
            'ko': 'V자형'
          },
          {
            'order': 1,
            'zh-cn': '量感',
            'en': 'relaxed fit',
            'zh-hant': '休閒版型',
            'ja': 'リラックスフィット',
            'de': 'Bequemer Schnitt',
            'fr': 'Coupe décontractée',
            'it': 'Vestibilità rilassata',
            'ko': '릴랙스핏'
          }
        ]
      }
    ]
  },
  {
    'order': 1,
    'name': { 'zh-cn': '面料 & 辅料', en: 'Fabric & Trims', 'zh-hant': '面料 & 輔料', ja: '生地 & 付属品', de: 'Stoff & Zubehör', fr: 'Tissu & Accessoires', it: 'Tessuto & Accessori', ko: '원단 및 부자재' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '面料', en: 'Fabric', 'zh-hant': '面料', ja: '生地', de: 'Stoff', fr: 'Tissu', it: 'Tessuto', ko: '원단' },
        'list': [
          {
            'order': 1,
            'zh-cn': '牛仔面料',
            'en': 'denim',
            'zh-hant': '丹寧',
            'ja': 'デニム',
            'de': 'Denim',
            'fr': 'Denim',
            'it': 'Denim',
            'ko': '데님'
          },
          {
            'order': 1,
            'zh-cn': '麂皮面料',
            'en': 'suede',
            'zh-hant': '麂皮',
            'ja': 'スエード',
            'de': 'Wildleder',
            'fr': 'Daim',
            'it': 'Scamosciato',
            'ko': '스웨이드'
          },
          {
            'order': 1,
            'zh-cn': '棉麻面料',
            'en': 'cotton-linen blend',
            'zh-hant': '棉麻混紡',
            'ja': 'コットンリネンブレンド',
            'de': 'Baumwoll-Leinen-Mischung',
            'fr': 'Mélange coton-lin',
            'it': 'Misto cotone-lino',
            'ko': '면마 혼방'
          },
          {
            'order': 1,
            'zh-cn': '褶皱面料',
            'en': 'pleated fabric',
            'zh-hant': '折皺布料',
            'ja': 'プリーツ生地',
            'de': 'Plissierter Stoff',
            'fr': 'Tissu plissé',
            'it': 'Tessuto plissettato',
            'ko': '주름 원단'
          },
          {
            'order': 1,
            'zh-cn': '羊毛',
            'en': 'wool',
            'zh-hant': '羊毛',
            'ja': 'ウール',
            'de': 'Wolle',
            'fr': 'Laine',
            'it': 'Lana',
            'ko': '울'
          },
          {
            'order': 1,
            'zh-cn': '羊绒',
            'en': 'cashmere',
            'zh-hant': '羊絨',
            'ja': 'カシミヤ',
            'de': 'Kaschmir',
            'fr': 'Cachemire',
            'it': 'Cashmere',
            'ko': '캐시미어'
          },
          {
            'order': 1,
            'zh-cn': 'PVC面料',
            'en': 'pvc',
            'zh-hant': 'PVC',
            'ja': 'PVC',
            'de': 'PVC',
            'fr': 'PVC',
            'it': 'PVC',
            'ko': 'PVC'
          },
          {
            'order': 1,
            'zh-cn': '功能性面料',
            'en': 'technical fabric',
            'zh-hant': '技術面料',
            'ja': '技術生地',
            'de': 'Technischer Stoff',
            'fr': 'Tissu technique',
            'it': 'Tessuto tecnico',
            'ko': '기능성 원단'
          },
          {
            'order': 1,
            'zh-cn': '毛料',
            'en': 'fur',
            'zh-hant': '毛皮',
            'ja': 'ファー',
            'de': 'Pelz',
            'fr': 'Fourrure',
            'it': 'Pelliccia',
            'ko': '모피'
          },
          {
            'order': 1,
            'zh-cn': '锁边面料',
            'en': 'overlock fabric',
            'zh-hant': '包邊布料',
            'ja': 'オーバーロック生地',
            'de': 'Overlock-Stoff',
            'fr': 'Tissu surfilé',
            'it': 'Tessuto overlock',
            'ko': '오버록 원단'
          },
          {
            'order': 1,
            'zh-cn': '面料再造',
            'en': 'recycled fabric',
            'zh-hant': '回收布料',
            'ja': 'リサイクル生地',
            'de': 'Recycelter Stoff',
            'fr': 'Tissu recyclé',
            'it': 'Tessuto riciclato',
            'ko': '재활용 원단'
          },
          {
            'order': 1,
            'zh-cn': '针织面料',
            'en': 'knit',
            'zh-hant': '針織',
            'ja': 'ニット',
            'de': 'Strick',
            'fr': 'Tricot',
            'it': 'Maglia',
            'ko': '니트'
          },
          {
            'order': 1,
            'zh-cn': '粗花呢',
            'en': 'tweed',
            'zh-hant': '斜紋粗花呢',
            'ja': 'ツイード',
            'de': 'Tweed',
            'fr': 'Tweed',
            'it': 'Tweed',
            'ko': '트위드'
          },
          {
            'order': 1,
            'zh-cn': '蕾丝面料',
            'en': 'lace',
            'zh-hant': '蕾絲',
            'ja': 'レース',
            'de': 'Spitze',
            'fr': 'Dentelle',
            'it': 'Pizzo',
            'ko': '레이스'
          },
          {
            'order': 1,
            'zh-cn': '睫毛蕾丝面料',
            'en': 'eyelash lace',
            'zh-hant': '睫毛蕾絲',
            'ja': 'アイラッシュレース',
            'de': 'Wimpernspitze',
            'fr': 'Dentelle à cils',
            'it': 'Pizzo a ciglia',
            'ko': '속눈썹 레이스'
          },
          {
            'order': 1,
            'zh-cn': '梭织面料',
            'en': 'woven fabric',
            'zh-hant': '織物',
            'ja': '織物',
            'de': 'Gewebter Stoff',
            'fr': 'Tissu tissé',
            'it': 'Tessuto tessuto',
            'ko': '직물'
          },
          {
            'order': 1,
            'zh-cn': '皮草',
            'en': 'leather fur',
            'zh-hant': '皮毛',
            'ja': 'レザーファー',
            'de': 'Lederfell',
            'fr': 'Fourrure en cuir',
            'it': 'Pelliccia di pelle',
            'ko': '가죽 퍼'
          },
          {
            'order': 1,
            'zh-cn': '尼龙面料',
            'en': 'nylon',
            'zh-hant': '尼龍',
            'ja': 'ナイロン',
            'de': 'Nylon',
            'fr': 'Nylon',
            'it': 'Nylon',
            'ko': '나일론'
          },
          {
            'order': 1,
            'zh-cn': '半透明材质面料',
            'en': 'sheer fabric',
            'zh-hant': '薄紗',
            'ja': 'シアー生地',
            'de': 'Transparenter Stoff',
            'fr': 'Tissu transparent',
            'it': 'Tessuto trasparente',
            'ko': '시스루 원단'
          },
          {
            'order': 1,
            'zh-cn': '华夫格面料',
            'en': 'waffle knit',
            'zh-hant': '華夫格針織',
            'ja': 'ワッフルニット',
            'de': 'Waffelstrick',
            'fr': 'Tricot gaufré',
            'it': 'Maglia a nido d\'ape',
            'ko': '와플 니트'
          },
          {
            'order': 1,
            'zh-cn': '夹棉面料',
            'en': 'quilted fabric',
            'zh-hant': '絎縫布料',
            'ja': 'キルティング生地',
            'de': 'Gestepptes Gewebe',
            'fr': 'Tissu matelassé',
            'it': 'Tessuto trapuntato',
            'ko': '퀼팅 원단'
          },
          {
            'order': 1,
            'zh-cn': '毛呢',
            'en': 'melton',
            'zh-hant': '美爾登呢',
            'ja': 'メルトン',
            'de': 'Melton',
            'fr': 'Melton',
            'it': 'Melton',
            'ko': '멜톤'
          },
          {
            'order': 1,
            'zh-cn': '漆皮',
            'en': 'patent leather',
            'zh-hant': '漆皮',
            'ja': 'エナメルレザー',
            'de': 'Lackleder',
            'fr': 'Cuir verni',
            'it': 'Pelle verniciata',
            'ko': '에나멜 가죽'
          },
          {
            'order': 1,
            'zh-cn': '呢料',
            'en': 'wool',
            'zh-hant': '羊毛',
            'ja': 'ウール',
            'de': 'Wolle',
            'fr': 'Laine',
            'it': 'Lana',
            'ko': '모직'
          },
          {
            'order': 1,
            'zh-cn': '皮革',
            'en': 'leather',
            'zh-hant': '皮革',
            'ja': 'レザー',
            'de': 'Leder',
            'fr': 'Cuir',
            'it': 'Pelle',
            'ko': '가죽'
          },
          {
            'order': 1,
            'zh-cn': '三醋酸',
            'en': 'acetate',
            'zh-hant': '醋酸纖維',
            'ja': 'アセテート',
            'de': 'Acetat',
            'fr': 'Acétate',
            'it': 'Acetato',
            'ko': '아세테이트'
          },
          {
            'order': 1,
            'zh-cn': '绒料',
            'en': 'plush fabrics',
            'zh-hant': '絨毛面料',
            'ja': 'プラッシュ生地',
            'de': 'Plüschstoffe',
            'fr': 'Tissus pelucheux',
            'it': 'Tessuti peluche',
            'ko': '플러시 원단'
          },
          {
            'order': 1,
            'zh-cn': '珊瑚绒',
            'en': 'coral fleece',
            'zh-hant': '珊瑚絨',
            'ja': 'コーラルフリース',
            'de': 'Korallenfleece',
            'fr': 'Laine de corail',
            'it': 'Coral fleece',
            'ko': '코랄 플리스'
          },
          {
            'order': 1,
            'zh-cn': '法兰绒',
            'en': 'flannel',
            'zh-hant': '法蘭絨',
            'ja': 'フランネル',
            'de': 'Flanell',
            'fr': 'Flanelle',
            'it': 'Flanella',
            'ko': '플란넬'
          },
          {
            'order': 1,
            'zh-cn': '平绒',
            'en': 'plain velvet',
            'zh-hant': '素面天鵝絨',
            'ja': 'プレーンベルベット',
            'de': 'Einfacher Samt',
            'fr': 'Velours uni',
            'it': 'Velluto semplice',
            'ko': '플레인 벨벳'
          },
          {
            'order': 1,
            'zh-cn': '半边绒',
            'en': 'half velvet',
            'zh-hant': '半天鵝絨',
            'ja': 'ハーフベルベット',
            'de': 'Halb-Samt',
            'fr': 'Demi-velours',
            'it': 'Mezzo velluto',
            'ko': '하프 벨벳'
          },
          {
            'order': 1,
            'zh-cn': '丝绒',
            'en': 'velvet',
            'zh-hant': '天鵝絨',
            'ja': 'ベルベット',
            'de': 'Samt',
            'fr': 'Velours',
            'it': 'Velluto',
            'ko': '벨벳'
          },
          {
            'order': 1,
            'zh-cn': '灯芯绒',
            'en': 'corduroy',
            'zh-hant': '燈芯絨',
            'ja': 'コーデュロイ',
            'de': 'Kord',
            'fr': 'Velours côtelé',
            'it': 'Velluto a coste',
            'ko': '코듀로이'
          },
          {
            'order': 1,
            'zh-cn': '摇粒绒',
            'en': 'shu velveteen',
            'zh-hant': '舒棉絨',
            'ja': 'シュベルベット',
            'de': 'Shu-Samt',
            'fr': 'Shu velours',
            'it': 'Vellutino shu',
            'ko': '슈 벨벳'
          },
          {
            'order': 1,
            'zh-cn': '泰迪绒',
            'en': 'teddy fleece',
            'zh-hant': '泰迪絨',
            'ja': 'テディフリース',
            'de': 'Teddyfleece',
            'fr': 'Laine Teddy',
            'it': 'Pile teddy',
            'ko': '테디 플리스'
          },
          {
            'order': 1,
            'zh-cn': '网纱面料',
            'en': 'mesh',
            'zh-hant': '網布',
            'ja': 'メッシュ',
            'de': 'Netzstoff',
            'fr': 'Maille',
            'it': 'Rete',
            'ko': '메쉬'
          },
          {
            'order': 1,
            'zh-cn': '腈纶面料',
            'en': 'acrylic',
            'zh-hant': '丙烯酸纖維',
            'ja': 'アクリル',
            'de': 'Acryl',
            'fr': 'Acrylique',
            'it': 'Acrilico',
            'ko': '아크릴'
          },
          {
            'order': 1,
            'zh-cn': '丝质面料',
            'en': 'silk',
            'zh-hant': '絲綢',
            'ja': 'シルク',
            'de': 'Seide',
            'fr': 'Soie',
            'it': 'Seta',
            'ko': '실크'
          },
          {
            'order': 1,
            'zh-cn': '涂层面料',
            'en': 'coated fabric',
            'zh-hant': '塗層面料',
            'ja': 'コーティングファブリック',
            'de': 'Beschichteter Stoff',
            'fr': 'Tissu enduit',
            'it': 'Tessuto rivestito',
            'ko': '코팅 원단'
          },
          {
            'order': 1,
            'zh-cn': '欧根纱',
            'en': 'organza',
            'zh-hant': '歐根紗',
            'ja': 'オーガンジー',
            'de': 'Organza',
            'fr': 'Organza',
            'it': 'Organza',
            'ko': '오간자'
          },
          {
            'order': 1,
            'zh-cn': '网眼面料',
            'en': 'tulle',
            'zh-hant': '纱網',
            'ja': 'チュール',
            'de': 'Tüll',
            'fr': 'Tulle',
            'it': 'Tulle',
            'ko': '튤'
          },
          {
            'order': 1,
            'zh-cn': '拉毛面料',
            'en': 'brushed fabric',
            'zh-hant': '磨毛面料',
            'ja': 'ブラッシュドファブリック',
            'de': 'Gebürsteter Stoff',
            'fr': 'Tissu brossé',
            'it': 'Tessuto spazzolato',
            'ko': '기모 원단'
          },
          {
            'order': 1,
            'zh-cn': '薄纱',
            'en': 'chiffon',
            'zh-hant': '雪紡',
            'ja': 'シフォン',
            'de': 'Chiffon',
            'fr': 'Mousseline',
            'it': 'Chiffon',
            'ko': '시폰'
          },
          {
            'order': 1,
            'zh-cn': '莫代尔',
            'en': 'modal',
            'zh-hant': '莫代爾',
            'ja': 'モダール',
            'de': 'Modal',
            'fr': 'Modal',
            'it': 'Modal',
            'ko': '모달'
          },
          {
            'order': 1,
            'zh-cn': '环保面料',
            'en': 'eco-friendly fabric',
            'zh-hant': '環保面料',
            'ja': 'エコフレンドリーファブリック',
            'de': 'Umweltfreundlicher Stoff',
            'fr': 'Tissu écologique',
            'it': 'Tessuto ecologico',
            'ko': '친환경 원단'
          },
          {
            'order': 1,
            'zh-cn': '棉质面料',
            'en': 'cotton',
            'zh-hant': '棉布',
            'ja': 'コットン',
            'de': 'Baumwolle',
            'fr': 'Coton',
            'it': 'Cotone',
            'ko': '면'
          },
          {
            'order': 1,
            'zh-cn': '雪纺面料',
            'en': 'georgette',
            'zh-hant': '喬其紗',
            'ja': 'ジョーゼット',
            'de': 'Georgette',
            'fr': 'Georgette',
            'it': 'Georgette',
            'ko': '조젯'
          },
          {
            'order': 1,
            'zh-cn': '提花面料',
            'en': 'brocade',
            'zh-hant': '錦緞',
            'ja': 'ブロケード',
            'de': 'Brokat',
            'fr': 'Brocart',
            'it': 'Broccato',
            'ko': '브로케이드'
          },
          {
            'order': 1,
            'zh-cn': '定位印花',
            'en': 'placement print',
            'zh-hant': '定位印花',
            'ja': 'プレースメントプリント',
            'de': 'Platzdruck',
            'fr': 'Imprimé placé',
            'it': 'Stampa posizionata',
            'ko': '플레이스먼트 프린트'
          },
          {
            'order': 1,
            'zh-cn': '泡泡纱',
            'en': 'bubble gauze',
            'zh-hant': '泡泡紗',
            'ja': 'バブルガーゼ',
            'de': 'Blasengaze',
            'fr': 'Gaze bouillonnante',
            'it': 'Garza a bolle',
            'ko': '버블 거즈'
          },
          {
            'order': 1,
            'zh-cn': '绣花面料',
            'en': 'embroidery',
            'zh-hant': '刺繡',
            'ja': '刺繍',
            'de': 'Stickerei',
            'fr': 'Broderie',
            'it': 'Ricamo',
            'ko': '자수'
          },
          {
            'order': 1,
            'zh-cn': '肌理面料',
            'en': 'textured fabric',
            'zh-hant': '紋理面料',
            'ja': 'テクスチャーファブリック',
            'de': 'Strukturierter Stoff',
            'fr': 'Tissu texturé',
            'it': 'Tessuto strutturato',
            'ko': '텍스처 원단'
          },
          {
            'order': 1,
            'zh-cn': '珠光面料',
            'en': 'lamé',
            'zh-hant': '金屬絲面料',
            'ja': 'ラメ',
            'de': 'Lamé',
            'fr': 'Lamé',
            'it': 'Lamé',
            'ko': '라메'
          },
          {
            'order': 1,
            'zh-cn': '有机纤维',
            'en': 'organic fiber',
            'zh-hant': '有機纖維',
            'ja': 'オーガニックファイバー',
            'de': 'Organische Faser',
            'fr': 'Fibre organique',
            'it': 'Fibra organica',
            'ko': '유기농 섬유'
          },
          {
            'order': 1,
            'zh-cn': '缎面面料',
            'en': 'satin',
            'zh-hant': '緞面',
            'ja': 'サテン',
            'de': 'Satin',
            'fr': 'Satin',
            'it': 'Raso',
            'ko': '새틴'
          },
          {
            'order': 1,
            'zh-cn': '混纺面料',
            'en': 'blended fabric',
            'zh-hant': '混紡面料',
            'ja': '混紡生地',
            'de': 'Mischgewebe',
            'fr': 'Tissu mélangé',
            'it': 'Tessuto misto',
            'ko': '혼방 원단'
          },
          {
            'order': 1,
            'zh-cn': '无缝一体面料',
            'en': 'seamless fabric',
            'zh-hant': '無縫面料',
            'ja': 'シームレス生地',
            'de': 'Nahtloser Stoff',
            'fr': 'Tissu sans couture',
            'it': 'Tessuto senza cuciture',
            'ko': '심리스 원단'
          },
          {
            'order': 1,
            'zh-cn': '麻料',
            'en': 'linen',
            'zh-hant': '亞麻',
            'ja': 'リネン',
            'de': 'Leinen',
            'fr': 'Lin',
            'it': 'Lino',
            'ko': '린넨'
          },
          {
            'order': 1,
            'zh-cn': '复合面料',
            'en': 'composite fabric',
            'zh-hant': '複合面料',
            'ja': '複合生地',
            'de': 'Verbundstoff',
            'fr': 'Tissu composite',
            'it': 'Tessuto composito',
            'ko': '복합 원단'
          },
          {
            'order': 1,
            'zh-cn': '珠片面料',
            'en': 'beaded fabric',
            'zh-hant': '珠繡面料',
            'ja': 'ビーズ生地',
            'de': 'Perlenstoff',
            'fr': 'Tissu perlé',
            'it': 'Tessuto con perline',
            'ko': '비즈 원단'
          },
          {
            'order': 1,
            'zh-cn': '马海毛',
            'en': 'mohair',
            'zh-hant': '馬海毛',
            'ja': 'モヘア',
            'de': 'Mohair',
            'fr': 'Mohair',
            'it': 'Mohair',
            'ko': '모헤어'
          },
          {
            'order': 1,
            'zh-cn': '金属材质',
            'en': 'metallic',
            'zh-hant': '金屬面料',
            'ja': 'メタリック',
            'de': 'Metallisch',
            'fr': 'Métallique',
            'it': 'Metallizzato',
            'ko': '메탈릭'
          },
          {
            'order': 1,
            'zh-cn': '纯棉',
            'en': 'cotton',
            'zh-hant': '棉布',
            'ja': 'コットン',
            'de': 'Baumwolle',
            'fr': 'Coton',
            'it': 'Cotone',
            'ko': '순면'
          },
          {
            'order': 1,
            'zh-cn': '氨纶',
            'en': 'spandex',
            'zh-hant': '彈力纖維',
            'ja': 'スパンデックス',
            'de': 'Spandex',
            'fr': 'Spandex',
            'it': 'Spandex',
            'ko': '스판덱스'
          },
          {
            'order': 1,
            'zh-cn': '长丝绸',
            'en': 'mulberry silk',
            'zh-hant': '桑蠶絲',
            'ja': 'マルベリーシルク',
            'de': 'Maulbeerseide',
            'fr': 'Soie de mûrier',
            'it': 'Seta di gelso',
            'ko': '뽕나무 실크'
          },
          {
            'order': 1,
            'zh-cn': '人造革',
            'en': 'artificial leather',
            'zh-hant': '人造皮革',
            'ja': '人工皮革',
            'de': 'Kunstleder',
            'fr': 'Cuir artificiel',
            'it': 'Pelle artificiale',
            'ko': '인조 가죽'
          },
          {
            'order': 1,
            'zh-cn': '亚麻',
            'en': 'linen',
            'zh-hant': '亞麻',
            'ja': 'リネン',
            'de': 'Leinen',
            'fr': 'Lin',
            'it': 'Lino',
            'ko': '마'
          },
          {
            'order': 1,
            'zh-cn': '聚脂',
            'en': 'polyester',
            'zh-hant': '聚酯纖維',
            'ja': 'ポリエステル',
            'de': 'Polyester',
            'fr': 'Polyester',
            'it': 'Poliestere',
            'ko': '폴리에스터'
          },
          {
            'order': 1,
            'zh-cn': '羊毛',
            'en': 'wool',
            'zh-hant': '羊毛',
            'ja': 'ウール',
            'de': 'Wolle',
            'fr': 'Laine',
            'it': 'Lana',
            'ko': '양모'
          },
          {
            'order': 1,
            'zh-cn': '尼龙',
            'en': 'nylon',
            'zh-hant': '尼龍',
            'ja': 'ナイロン',
            'de': 'Nylon',
            'fr': 'Nylon',
            'it': 'Nylon',
            'ko': '나일론'
          },
          {
            'order': 1,
            'zh-cn': '丝光棉',
            'en': 'sateen',
            'zh-hant': '緞棉',
            'ja': 'サテン',
            'de': 'Sateen',
            'fr': 'Satiné',
            'it': 'Sateen',
            'ko': '새틴'
          },
          {
            'order': 1,
            'zh-cn': '细微罗纹棉',
            'en': 'fine rib cotton',
            'zh-hant': '細羅紋棉',
            'ja': 'ファインリブコットン',
            'de': 'Feingerippte Baumwolle',
            'fr': 'Coton à fines côtes',
            'it': 'Cotone a costine fini',
            'ko': '파인립 코튼'
          },
          {
            'order': 1,
            'zh-cn': '帆布',
            'en': 'canvas',
            'zh-hant': '帆布',
            'ja': 'キャンバス',
            'de': 'Segeltuch',
            'fr': 'Toile',
            'it': 'Tela',
            'ko': '캔버스'
          },
          {
            'order': 1,
            'zh-cn': '弹力牛仔布',
            'en': 'stretch denim',
            'zh-hant': '彈性丹寧',
            'ja': 'ストレッチデニム',
            'de': 'Stretch-Denim',
            'fr': 'Denim extensible',
            'it': 'Denim elasticizzato',
            'ko': '스트레치 데님'
          },
          {
            'order': 1,
            'zh-cn': '纤维板',
            'en': 'fiberboard',
            'zh-hant': '纖維板',
            'ja': 'ファイバーボード',
            'de': 'Faserplatte',
            'fr': 'Panneau de fibres',
            'it': 'Pannello in fibra',
            'ko': '섬유판'
          },
          {
            'order': 1,
            'zh-cn': '粘胶纤维',
            'en': 'viscose',
            'zh-hant': '黏膠纖維',
            'ja': 'ビスコース',
            'de': 'Viskose',
            'fr': 'Viscose',
            'it': 'Viscosa',
            'ko': '비스코스'
          },
          {
            'order': 1,
            'zh-cn': '纯羊绒',
            'en': 'pure cashmere',
            'zh-hant': '純羊絨',
            'ja': 'ピュアカシミヤ',
            'de': 'Reines Kaschmir',
            'fr': 'Cachemire pur',
            'it': 'Puro cashmere',
            'ko': '순수 캐시미어'
          },
          {
            'order': 1,
            'zh-cn': '涤纶',
            'en': 'polyester',
            'zh-hant': '聚酯纖維',
            'ja': 'ポリエステル',
            'de': 'Polyester',
            'fr': 'Polyester',
            'it': 'Poliestere',
            'ko': '폴리에스터'
          },
          {
            'order': 1,
            'zh-cn': '丝绒',
            'en': 'velvet',
            'zh-hant': '天鵝絨',
            'ja': 'ベルベット',
            'de': 'Samt',
            'fr': 'Velours',
            'it': 'Velluto',
            'ko': '벨벳'
          },
          {
            'order': 1,
            'zh-cn': '牛皮',
            'en': 'cowhide',
            'zh-hant': '牛皮',
            'ja': '牛革',
            'de': 'Rindsleder',
            'fr': 'Cuir de vache',
            'it': 'Pelle bovina',
            'ko': '소가죽'
          },
          {
            'order': 1,
            'zh-cn': '公羊绒',
            'en': 'mohair',
            'zh-hant': '馬海毛',
            'ja': 'モヘア',
            'de': 'Mohair',
            'fr': 'Mohair',
            'it': 'Mohair',
            'ko': '모헤어'
          },
          {
            'order': 1,
            'zh-cn': '真皮',
            'en': 'genuine leather',
            'zh-hant': '真皮',
            'ja': '本革',
            'de': 'Echtes Leder',
            'fr': 'Cuir véritable',
            'it': 'Pelle genuina',
            'ko': '천연 가죽'
          },
          {
            'order': 1,
            'zh-cn': '卡其布',
            'en': 'khaki',
            'zh-hant': '卡其色',
            'ja': 'カーキ',
            'de': 'Khaki',
            'fr': 'Kaki',
            'it': 'Khaki',
            'ko': '카키'
          },
          {
            'order': 1,
            'zh-cn': '丝光聚酯',
            'en': 'satin polyester',
            'zh-hant': '緞面聚酯',
            'ja': 'サテンポリエステル',
            'de': 'Satinpolyester',
            'fr': 'Satin polyester',
            'it': 'Raso di poliestere',
            'ko': '새틴 폴리에스터'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '面料质感/性能', en: 'Fabric Texture/Performance', 'zh-hant': '面料質感/性能', ja: '生地の質感/性能', de: 'Stofftextur/Leistung', fr: 'Texture/Performance des tissus', it: 'Texture/Prestazioni dei tessuti', ko: '원단 질감/성능' },
        'list': [
          {
            'order': 1,
            'zh-cn': '柔软的',
            'en': 'soft',
            'zh-hant': '柔軟',
            'ja': '柔らかい',
            'de': 'Weich',
            'fr': 'Doux',
            'it': 'Morbido',
            'ko': '부드러운'
          },
          {
            'order': 1,
            'zh-cn': '蓬松的',
            'en': 'fluffy',
            'zh-hant': '蓬鬆',
            'ja': 'ふわふわ',
            'de': 'Flauschig',
            'fr': 'Moelleux',
            'it': 'Soffice',
            'ko': '푹신한'
          },
          {
            'order': 1,
            'zh-cn': '有光泽的',
            'en': 'shiny',
            'zh-hant': '有光澤',
            'ja': '光沢がある',
            'de': 'Glänzend',
            'fr': 'Brillant',
            'it': 'Lucido',
            'ko': '광택이 있는'
          },
          {
            'order': 1,
            'zh-cn': '有弹性的',
            'en': 'elastic',
            'zh-hant': '有彈性',
            'ja': '弾性がある',
            'de': 'Elastisch',
            'fr': 'Élastique',
            'it': 'Elastico',
            'ko': '탄력적인'
          },
          {
            'order': 1,
            'zh-cn': '透气的',
            'en': 'breathable',
            'zh-hant': '透氣',
            'ja': '通気性がある',
            'de': 'Atmungsaktiv',
            'fr': 'Respirant',
            'it': 'Traspirante',
            'ko': '통기성이 있는'
          },
          {
            'order': 1,
            'zh-cn': '吸湿的',
            'en': 'absorbent',
            'zh-hant': '吸水',
            'ja': '吸収性がある',
            'de': 'Saugfähig',
            'fr': 'Absorbant',
            'it': 'Assorbente',
            'ko': '흡습성이 있는'
          },
          {
            'order': 1,
            'zh-cn': '防水的',
            'en': 'waterproof',
            'zh-hant': '防水',
            'ja': '防水',
            'de': 'Wasserdicht',
            'fr': 'Imperméable',
            'it': 'Impermeabile',
            'ko': '방수'
          },
          {
            'order': 1,
            'zh-cn': '可循环利用的',
            'en': 'recyclable',
            'zh-hant': '可回收',
            'ja': 'リサイクル可能',
            'de': 'Recycelbar',
            'fr': 'Recyclable',
            'it': 'Riciclabile',
            'ko': '재활용 가능한'
          },
          {
            'order': 1,
            'zh-cn': '生物材质的',
            'en': 'biodegradable',
            'zh-hant': '可生物降解',
            'ja': '生分解性',
            'de': 'Biologisch abbaubar',
            'fr': 'Biodégradable',
            'it': 'Biodegradabile',
            'ko': '생분해성'
          },
          {
            'order': 1,
            'zh-cn': '半透明的',
            'en': 'semi-transparent',
            'zh-hant': '半透明',
            'ja': '半透明',
            'de': 'Halbtransparent',
            'fr': 'Semi-transparent',
            'it': 'Semitrasparente',
            'ko': '반투명'
          },
          {
            'order': 1,
            'zh-cn': '挺括的',
            'en': 'stiff',
            'zh-hant': '堅硬',
            'ja': '硬い',
            'de': 'Steif',
            'fr': 'Rigide',
            'it': 'Rigido',
            'ko': '뻣뻣한'
          },
          {
            'order': 1,
            'zh-cn': '有纱线节点的',
            'en': 'slub',
            'zh-hant': '雜色',
            'ja': 'スラブ',
            'de': 'Slub',
            'fr': 'Flammé',
            'it': 'Fiammato',
            'ko': '슬럽'
          },
          {
            'order': 1,
            'zh-cn': '冰凉感的',
            'en': 'cooling',
            'zh-hant': '涼爽',
            'ja': '涼感',
            'de': 'Kühlend',
            'fr': 'Rafraîchissant',
            'it': 'Rinfrescante',
            'ko': '시원한'
          },
          {
            'order': 1,
            'zh-cn': '贴身的',
            'en': 'fitted',
            'zh-hant': '合身',
            'ja': 'フィットした',
            'de': 'Passgenau',
            'fr': 'Ajusté',
            'it': 'Aderente',
            'ko': '몸에 맞는'
          },
          {
            'order': 1,
            'zh-cn': '光滑的',
            'en': 'smooth',
            'zh-hant': '光滑',
            'ja': '滑らか',
            'de': 'Glatt',
            'fr': 'Lisse',
            'it': 'Liscio',
            'ko': '매끄러운'
          },
          {
            'order': 1,
            'zh-cn': '厚实的',
            'en': 'thick',
            'zh-hant': '厚實',
            'ja': '厚い',
            'de': 'Dick',
            'fr': 'Épais',
            'it': 'Spesso',
            'ko': '두꺼운'
          },
          {
            'order': 1,
            'zh-cn': '轻盈的',
            'en': 'lightweight',
            'zh-hant': '輕便',
            'ja': '軽量',
            'de': 'Leicht',
            'fr': 'Léger',
            'it': 'Leggero',
            'ko': '가벼운'
          },
          {
            'order': 1,
            'zh-cn': '有质感的',
            'en': 'textured',
            'zh-hant': '有質感',
            'ja': 'テクスチャーがある',
            'de': 'Texturiert',
            'fr': 'Texturé',
            'it': 'Testurizzato',
            'ko': '질감이 있는'
          },
          {
            'order': 1,
            'zh-cn': '薄薄的',
            'en': 'thin',
            'zh-hant': '薄',
            'ja': '薄い',
            'de': 'Dünn',
            'fr': 'Mince',
            'it': 'Sottile',
            'ko': '얇은'
          },
          {
            'order': 1,
            'zh-cn': '紧身的',
            'en': 'tight-fitting',
            'zh-hant': '緊身',
            'ja': 'タイトフィット',
            'de': 'Enganliegend',
            'fr': 'Ajusté',
            'it': 'Aderente',
            'ko': '몸에 꼭 맞는'
          },
          {
            'order': 1,
            'zh-cn': '弯曲的',
            'en': 'flexible',
            'zh-hant': '靈活',
            'ja': '柔軟',
            'de': 'Flexibel',
            'fr': 'Flexible',
            'it': 'Flessibile',
            'ko': '유연한'
          },
          {
            'order': 1,
            'zh-cn': '抗皱的',
            'en': 'wrinkle-resistant',
            'zh-hant': '抗皺',
            'ja': 'しわになりにくい',
            'de': 'Knitterfrei',
            'fr': 'Résistant aux plis',
            'it': 'Resistente alle pieghe',
            'ko': '주름 방지'
          },
          {
            'order': 1,
            'zh-cn': '舒适的',
            'en': 'comfortable',
            'zh-hant': '舒適',
            'ja': '快適',
            'de': 'Bequem',
            'fr': 'Confortable',
            'it': 'Confortevole',
            'ko': '편안한'
          },
          {
            'order': 1,
            'zh-cn': '紧密的',
            'en': 'compact',
            'zh-hant': '緊湊',
            'ja': 'コンパクト',
            'de': 'Kompakt',
            'fr': 'Compact',
            'it': 'Compatto',
            'ko': '조밀한'
          },
          {
            'order': 1,
            'zh-cn': '有表面纹理的',
            'en': 'patterned',
            'zh-hant': '有圖案',
            'ja': 'パターン入り',
            'de': 'Gemustert',
            'fr': 'À motifs',
            'it': 'Motivo',
            'ko': '무늬가 있는'
          },
          {
            'order': 1,
            'zh-cn': '温暖的',
            'en': 'warm',
            'zh-hant': '溫暖',
            'ja': '暖かい',
            'de': 'Warm',
            'fr': 'Chaud',
            'it': 'Caldo',
            'ko': '따뜻한'
          },
          {
            'order': 1,
            'zh-cn': '有弹力的',
            'en': 'resilient',
            'zh-hant': '有彈性',
            'ja': '弾力がある',
            'de': 'Widerstandsfähig',
            'fr': 'Résilient',
            'it': 'Resiliente',
            'ko': '탄력 있는'
          },
          {
            'order': 1,
            'zh-cn': '具有层次感的',
            'en': 'layered',
            'zh-hant': '分層',
            'ja': 'レイヤード',
            'de': 'Geschichtet',
            'fr': 'Superposé',
            'it': 'Stratificato',
            'ko': '층이 있는'
          },
          {
            'order': 1,
            'zh-cn': '丝滑的',
            'en': 'silky',
            'zh-hant': '絲滑',
            'ja': 'シルクのような',
            'de': 'Seidig',
            'fr': 'Soyeux',
            'it': 'Seta',
            'ko': '비단결 같은'
          },
          {
            'order': 1,
            'zh-cn': '细腻的',
            'en': 'delicate',
            'zh-hant': '精緻',
            'ja': '繊細',
            'de': 'Zart',
            'fr': 'Délicat',
            'it': 'Delicato',
            'ko': '섬세한'
          },
          {
            'order': 1,
            'zh-cn': '有强度的',
            'en': 'strong',
            'zh-hant': '堅固',
            'ja': '強い',
            'de': 'Stark',
            'fr': 'Fort',
            'it': 'Forte',
            'ko': '강한'
          },
          {
            'order': 1,
            'zh-cn': '装饰性的',
            'en': 'decorative',
            'zh-hant': '裝飾性',
            'ja': '装飾的な',
            'de': 'Dekorativ',
            'fr': 'Décoratif',
            'it': 'Decorativo',
            'ko': '장식적인'
          },
          {
            'order': 1,
            'zh-cn': '有重量感的',
            'en': 'weighted',
            'zh-hant': '有重量',
            'ja': '重量感がある',
            'de': 'Gewichtet',
            'fr': 'Lesté',
            'it': 'Ponderato',
            'ko': '무게감이 있는'
          },
          {
            'order': 1,
            'zh-cn': '有层次的',
            'en': 'textured',
            'zh-hant': '有質感',
            'ja': 'テクスチャーがある',
            'de': 'Texturiert',
            'fr': 'Texturé',
            'it': 'Testurizzato',
            'ko': '질감이 있는'
          },
          {
            'order': 1,
            'zh-cn': '粗糙的',
            'en': 'rough',
            'zh-hant': '粗糙',
            'ja': '粗い',
            'de': 'Rau',
            'fr': 'Rugueux',
            'it': 'Ruvido',
            'ko': '거친'
          },
          {
            'order': 1,
            'zh-cn': '透明的',
            'en': 'transparent',
            'zh-hant': '透明',
            'ja': '透明',
            'de': 'Transparent',
            'fr': 'Transparent',
            'it': 'Trasparente',
            'ko': '투명한'
          },
          {
            'order': 1,
            'zh-cn': '柔韧的',
            'en': 'flexible',
            'zh-hant': '靈活',
            'ja': '柔軟',
            'de': 'Flexibel',
            'fr': 'Flexible',
            'it': 'Flessibile',
            'ko': '유연한'
          },
          {
            'order': 1,
            'zh-cn': '带有光泽感的',
            'en': 'lustrous',
            'zh-hant': '有光澤',
            'ja': '光沢がある',
            'de': 'Glänzend',
            'fr': 'Lustre',
            'it': 'Lucente',
            'ko': '광택이 나는'
          },
          {
            'order': 1,
            'zh-cn': '有风格的',
            'en': 'stylish',
            'zh-hant': '時尚',
            'ja': 'スタイリッシュ',
            'de': 'Stilvoll',
            'fr': 'Stylé',
            'it': 'Elegante',
            'ko': '스타일리시한'
          },
          {
            'order': 1,
            'zh-cn': '长寿命的',
            'en': 'durable',
            'zh-hant': '耐用',
            'ja': '耐久性がある',
            'de': 'Langlebig',
            'fr': 'Durable',
            'it': 'Durevole',
            'ko': '내구성이 있는'
          },
          {
            'order': 1,
            'zh-cn': '微粒的',
            'en': 'particle',
            'zh-hant': '顆粒狀',
            'ja': '粒子状',
            'de': 'Partikel',
            'fr': 'Particulaire',
            'it': 'Particellare',
            'ko': '입자상'
          },
          {
            'order': 1,
            'zh-cn': '密实的',
            'en': 'dense',
            'zh-hant': '密集',
            'ja': '密度が高い',
            'de': 'Dicht',
            'fr': 'Dense',
            'it': 'Denso',
            'ko': '밀도가 높은'
          },
          {
            'order': 1,
            'zh-cn': '高档的',
            'en': 'luxurious',
            'zh-hant': '奢華',
            'ja': '贅沢な',
            'de': 'Luxuriös',
            'fr': 'Luxueux',
            'it': 'Lussuoso',
            'ko': '고급스러운'
          },
          {
            'order': 1,
            'zh-cn': '玻璃纤维的',
            'en': 'fiberglass',
            'zh-hant': '玻璃纖維',
            'ja': 'ガラス繊維',
            'de': 'Fiberglas',
            'fr': 'Fibre de verre',
            'it': 'Fibra di vetro',
            'ko': '유리섬유'
          },
          {
            'order': 1,
            'zh-cn': '具有吸音性能的',
            'en': 'soundproofing',
            'zh-hant': '隔音',
            'ja': '防音',
            'de': 'Schalldämmung',
            'fr': 'Insonorisation',
            'it': 'Insonorizzazione',
            'ko': '방음'
          },
          {
            'order': 1,
            'zh-cn': '易清洁的',
            'en': 'easy-to-clean',
            'zh-hant': '易清潔',
            'ja': '掃除が簡単',
            'de': 'Leicht zu reinigen',
            'fr': 'Facile à nettoyer',
            'it': 'Facile da pulire',
            'ko': '청소가 쉬운'
          },
          {
            'order': 1,
            'zh-cn': '透气性好的',
            'en': 'air-permeable',
            'zh-hant': '透氣',
            'ja': '通気性',
            'de': 'Luftdurchlässig',
            'fr': 'Perméable à l\'air',
            'it': 'Permeabile all\'aria',
            'ko': '통기성이 좋은'
          },
          {
            'order': 1,
            'zh-cn': '防褪色的',
            'en': 'fade-resistant',
            'zh-hant': '抗褪色',
            'ja': '色あせ防止',
            'de': 'Lichtbeständig',
            'fr': 'Résistant à la décoloration',
            'it': 'Resistente allo sbiadimento',
            'ko': '색바램 방지'
          },
          {
            'order': 1,
            'zh-cn': '防紫外线的',
            'en': 'uv-resistant',
            'zh-hant': '抗紫外線',
            'ja': 'UV耐性',
            'de': 'UV-beständig',
            'fr': 'Résistant aux UV',
            'it': 'Resistente ai raggi UV',
            'ko': '자외선 차단'
          },
          {
            'order': 1,
            'zh-cn': '防静电的',
            'en': 'anti-static',
            'zh-hant': '防靜電',
            'ja': '静電気防止',
            'de': 'Antistatisch',
            'fr': 'Antistatique',
            'it': 'Antistatico',
            'ko': '정전기 방지'
          },
          {
            'order': 1,
            'zh-cn': '防尘的',
            'en': 'dust-proof',
            'zh-hant': '防塵',
            'ja': '防塵',
            'de': 'Staubdicht',
            'fr': 'Antipoussière',
            'it': 'Antipolvere',
            'ko': '방진'
          },
          {
            'order': 1,
            'zh-cn': '防霉菌的',
            'en': 'mold-resistant',
            'zh-hant': '防霉',
            'ja': '防カビ',
            'de': 'Schimmelresistent',
            'fr': 'Résistant à la moisissure',
            'it': 'Resistente alla muffa',
            'ko': '곰팡이 방지'
          },
          {
            'order': 1,
            'zh-cn': '防异味的',
            'en': 'odor-resistant',
            'zh-hant': '抗異味',
            'ja': '臭い防止',
            'de': 'Geruchsresistent',
            'fr': 'Résistant aux odeurs',
            'it': 'Resistente agli odori',
            'ko': '냄새 방지'
          },
          {
            'order': 1,
            'zh-cn': '防刮擦的',
            'en': 'scratch-resistant',
            'zh-hant': '抗刮',
            'ja': '傷つきにくい',
            'de': 'Kratzfest',
            'fr': 'Résistant aux rayures',
            'it': 'Resistente ai graffi',
            'ko': '스크래치 방지'
          },
          {
            'order': 1,
            'zh-cn': '防皱的',
            'en': 'crease-resistant',
            'zh-hant': '抗皺',
            'ja': 'しわになりにくい',
            'de': 'Knitterfrei',
            'fr': 'Résistant aux plis',
            'it': 'Resistente alle pieghe',
            'ko': '주름 방지'
          },
          {
            'order': 1,
            'zh-cn': '隔热的',
            'en': 'thermal insulation',
            'zh-hant': '保溫',
            'ja': '断熱',
            'de': 'Wärmedämmung',
            'fr': 'Isolation thermique',
            'it': 'Isolamento termico',
            'ko': '단열'
          },
          {
            'order': 1,
            'zh-cn': '隔音的',
            'en': 'acoustic insulation',
            'zh-hant': '隔音',
            'ja': '吸音',
            'de': 'Akustische Isolierung',
            'fr': 'Isolation acoustique',
            'it': 'Isolamento acustico',
            'ko': '방음'
          },
          {
            'order': 1,
            'zh-cn': '具有抗菌性能的',
            'en': 'antibacterial',
            'zh-hant': '抗菌',
            'ja': '抗菌',
            'de': 'Antibakteriell',
            'fr': 'Antibactérien',
            'it': 'Antibatterico',
            'ko': '항균'
          },
          {
            'order': 1,
            'zh-cn': '绝缘的',
            'en': 'insulating',
            'zh-hant': '絕緣',
            'ja': '断熱',
            'de': 'Isolierend',
            'fr': 'Isolant',
            'it': 'Isolante',
            'ko': '절연'
          },
          {
            'order': 1,
            'zh-cn': '具有抗菌性能的',
            'en': 'antibacterial',
            'zh-hant': '抗菌',
            'ja': '抗菌',
            'de': 'Antibakteriell',
            'fr': 'Antibactérien',
            'it': 'Antibatterico',
            'ko': '항균'
          },
          {
            'order': 1,
            'zh-cn': '干爽的',
            'en': 'dry',
            'zh-hant': '乾燥',
            'ja': '乾燥',
            'de': 'Trocken',
            'fr': 'Sec',
            'it': 'Asciutto',
            'ko': '건조한'
          },
          {
            'order': 1,
            'zh-cn': '具有阻燃功能的',
            'en': 'flame-resistant',
            'zh-hant': '防火',
            'ja': '難燃性',
            'de': 'Flammenresistent',
            'fr': 'Résistant aux flammes',
            'it': 'Resistente alle fiamme',
            'ko': '난연성'
          },
          {
            'order': 1,
            'zh-cn': '防臭的',
            'en': 'deodorant',
            'zh-hant': '除臭',
            'ja': '消臭',
            'de': 'Deodorierend',
            'fr': 'Désodorisant',
            'it': 'Deodorante',
            'ko': '방취'
          },
          {
            'order': 1,
            'zh-cn': '具有抗菌性能的',
            'en': 'antimicrobial',
            'zh-hant': '抗微生物',
            'ja': '抗微生物',
            'de': 'Antimikrobiell',
            'fr': 'Antimicrobien',
            'it': 'Antimicrobico',
            'ko': '항균'
          },
          {
            'order': 1,
            'zh-cn': '网状的',
            'en': 'netted',
            'zh-hant': '網狀',
            'ja': 'ネット',
            'de': 'Netzartig',
            'fr': 'En filet',
            'it': 'Rete',
            'ko': '망사'
          },
          {
            'order': 1,
            'zh-cn': '需要特殊保养的',
            'en': 'delicate',
            'zh-hant': '精緻',
            'ja': '繊細',
            'de': 'Zart',
            'fr': 'Délicat',
            'it': 'Delicato',
            'ko': '섬세한 관리가 필요한'
          },
          {
            'order': 1,
            'zh-cn': '耐磨的',
            'en': 'abrasion-resistant',
            'zh-hant': '耐磨',
            'ja': '耐摩耗性',
            'de': 'Abriebfest',
            'fr': 'Résistant à l\'abrasion',
            'it': 'Resistente all\'abrasione',
            'ko': '내마모성'
          },
          {
            'order': 1,
            'zh-cn': '弹力好的',
            'en': 'stretchy',
            'zh-hant': '有彈性',
            'ja': '伸縮性',
            'de': 'Dehnbar',
            'fr': 'Extensible',
            'it': 'Elastico',
            'ko': '신축성이 좋은'
          },
          {
            'order': 1,
            'zh-cn': '暖和的',
            'en': 'cozy',
            'zh-hant': '舒適',
            'ja': '居心地の良い',
            'de': 'Gemütlich',
            'fr': 'Confortable',
            'it': 'Accogliente',
            'ko': '아늑한'
          },
          {
            'order': 1,
            'zh-cn': '静电强的',
            'en': 'static-prone',
            'zh-hant': '易產生靜電',
            'ja': '静電気を起こしやすい',
            'de': 'Statikanfällig',
            'fr': 'Sujet à l\'électricité statique',
            'it': 'Soggetto a elettricità statica',
            'ko': '정전기가 잘 생기는'
          },
          {
            'order': 1,
            'zh-cn': '透视的',
            'en': 'see-through',
            'zh-hant': '透視',
            'ja': 'シースルー',
            'de': 'Durchsichtig',
            'fr': 'Transparent',
            'it': 'Trasparente',
            'ko': '비치는'
          },
          {
            'order': 1,
            'zh-cn': '带有细纹路的',
            'en': 'striped',
            'zh-hant': '條紋',
            'ja': 'ストライプ',
            'de': 'Gestreift',
            'fr': 'Rayé',
            'it': 'A righe',
            'ko': '줄무늬'
          },
          {
            'order': 1,
            'zh-cn': '厚重的',
            'en': 'heavy',
            'zh-hant': '重',
            'ja': '重い',
            'de': 'Schwer',
            'fr': 'Lourd',
            'it': 'Pesante',
            'ko': '무거운'
          },
          {
            'order': 1,
            'zh-cn': '具有防紫外线功效的',
            'en': 'sun-protective',
            'zh-hant': '防曬',
            'ja': '日焼け防止',
            'de': 'Sonnenschutz',
            'fr': 'Protecteur solaire',
            'it': 'Protettivo solare',
            'ko': '자외선 차단'
          },
          {
            'order': 1,
            'zh-cn': '具有隔音性能的',
            'en': 'soundproof',
            'zh-hant': '隔音',
            'ja': '防音',
            'de': 'Schalldicht',
            'fr': 'Insonorisant',
            'it': 'Insonorizzato',
            'ko': '방음'
          },
          {
            'order': 1,
            'zh-cn': '具有防水性能的',
            'en': 'water-resistant',
            'zh-hant': '防水',
            'ja': '耐水性',
            'de': 'Wasserabweisend',
            'fr': 'Résistant à l\'eau',
            'it': 'Resistente all\'acqua',
            'ko': '방수'
          },
          {
            'order': 1,
            'zh-cn': '具有防污性能的',
            'en': 'stain-resistant',
            'zh-hant': '抗污',
            'ja': '防汚',
            'de': 'Fleckenresistent',
            'fr': 'Résistant aux taches',
            'it': 'Resistente alle macchie',
            'ko': '오염 방지'
          },
          {
            'order': 1,
            'zh-cn': '具有防寒功能的',
            'en': 'insulated',
            'zh-hant': '絕緣',
            'ja': '断熱',
            'de': 'Isoliert',
            'fr': 'Isolé',
            'it': 'Isolato',
            'ko': '단열'
          },
          {
            'order': 1,
            'zh-cn': '具有防紫外线功效的',
            'en': 'uv-protective',
            'zh-hant': '防紫外線',
            'ja': 'UVカット',
            'de': 'UV-Schutz',
            'fr': 'Protecteur UV',
            'it': 'Protettivo UV',
            'ko': '자외선 차단'
          },
          {
            'order': 1,
            'zh-cn': '具有抗菌性能的',
            'en': 'antibacterial',
            'zh-hant': '抗菌',
            'ja': '抗菌',
            'de': 'Antibakteriell',
            'fr': 'Antibactérien',
            'it': 'Antibatterico',
            'ko': '항균'
          }
        ]
      },
      {
        'order': 1,
        'name': {
          'zh-cn': '服装辅料',
          'en': 'Garment Accessories',
          'zh-hant': '服裝輔料',
          'ja': '衣服の副資材',
          'de': 'Bekleidungszubehör',
          'fr': 'Accessoires de vêtement',
          'it': 'Accessori per abbigliamento',
          'ko': '의류 부자재'
        },
        'list': [
          {
            'order': 1,
            'zh-cn': '纽扣',
            'en': 'buttons',
            'zh-hant': '鈕扣',
            'ja': 'ボタン',
            'de': 'Knöpfe',
            'fr': 'Boutons',
            'it': 'Bottoni',
            'ko': '단추'
          },
          {
            'order': 1,
            'zh-cn': '拉链',
            'en': 'zippers',
            'zh-hant': '拉鍊',
            'ja': 'ファスナー',
            'de': 'Reißverschlüsse',
            'fr': 'Fermetures éclair',
            'it': 'Cerniere',
            'ko': '지퍼'
          },
          {
            'order': 1,
            'zh-cn': '缝纫线',
            'en': 'sewing thread',
            'zh-hant': '縫紉線',
            'ja': '縫製糸',
            'de': 'Nähgarn',
            'fr': 'Fil à coudre',
            'it': 'Filo da cucito',
            'ko': '재봉실'
          },
          {
            'order': 1,
            'zh-cn': '蕾丝',
            'en': 'lace',
            'zh-hant': '蕾絲',
            'ja': 'レース',
            'de': 'Spitze',
            'fr': 'Dentelle',
            'it': 'Pizzo',
            'ko': '레이스'
          },
          {
            'order': 1,
            'zh-cn': '钩眼',
            'en': 'hooks and eyes',
            'zh-hant': '鉤眼扣',
            'ja': 'ホックとアイ',
            'de': 'Haken und Ösen',
            'fr': 'Agrafes',
            'it': 'Ganci e occhielli',
            'ko': '훅 앤 아이'
          },
          {
            'order': 1,
            'zh-cn': '扣子',
            'en': 'fasteners',
            'zh-hant': '扣件',
            'ja': '留め具',
            'de': 'Verschlüsse',
            'fr': 'Attaches',
            'it': 'Chiusure',
            'ko': '잠금장치'
          },
          {
            'order': 1,
            'zh-cn': '衬布',
            'en': 'interfacing',
            'zh-hant': '襯布',
            'ja': '接着芯',
            'de': 'Einlage',
            'fr': 'Entoilage',
            'it': 'Tele adesive',
            'ko': '심감'
          },
          {
            'order': 1,
            'zh-cn': '肩垫',
            'en': 'shoulder pads',
            'zh-hant': '墊肩',
            'ja': '肩パッド',
            'de': 'Schulterpolster',
            'fr': 'Épaulettes',
            'it': 'Spalline',
            'ko': '어깨 패드'
          },
          {
            'order': 1,
            'zh-cn': '带子',
            'en': 'ribbons',
            'zh-hant': '緞帶',
            'ja': 'リボン',
            'de': 'Bänder',
            'fr': 'Rubans',
            'it': 'Nastri',
            'ko': '리본'
          },
          {
            'order': 1,
            'zh-cn': '织带',
            'en': 'tape',
            'zh-hant': '膠帶',
            'ja': 'テープ',
            'de': 'Klebeband',
            'fr': 'Ruban adhésif',
            'it': 'Nastro adesivo',
            'ko': '테이프'
          },
          {
            'order': 1,
            'zh-cn': '肩带',
            'en': 'straps',
            'zh-hant': '肩帶',
            'ja': 'ストラップ',
            'de': 'Träger',
            'fr': 'Sangles',
            'it': 'Cinghie',
            'ko': '어깨끈'
          },
          {
            'order': 1,
            'zh-cn': '扣眼带',
            'en': 'grosgrain ribbon',
            'zh-hant': '橫紋帶',
            'ja': 'グログランリボン',
            'de': 'Ripsband',
            'fr': 'Ruban gros-grain',
            'it': 'Nastro gros-grain',
            'ko': '그로그랭 리본'
          },
          {
            'order': 1,
            'zh-cn': '钩带',
            'en': 'velcro',
            'zh-hant': '魔鬼氈',
            'ja': 'ベルクロ',
            'de': 'Klettverschluss',
            'fr': 'Velcro',
            'it': 'Velcro',
            'ko': '벨크로'
          },
          {
            'order': 1,
            'zh-cn': '亚克力钉扣',
            'en': 'snap buttons',
            'zh-hant': '按扣',
            'ja': 'スナップボタン',
            'de': 'Druckknöpfe',
            'fr': 'Boutons-pression',
            'it': 'Bottoni a pressione',
            'ko': '스냅 단추'
          },
          {
            'order': 1,
            'zh-cn': '按钮扣带',
            'en': 'buttonhole elastic',
            'zh-hant': '鈕扣孔橡皮筋',
            'ja': 'ボタンホールエラスティック',
            'de': 'Knopflochgummi',
            'fr': 'Élastique à boutonnière',
            'it': 'Elastico per asole',
            'ko': '단추구멍 고무줄'
          },
          {
            'order': 1,
            'zh-cn': '眼口线',
            'en': 'bar tacks',
            'zh-hant': '加固縫',
            'ja': 'バータック',
            'de': 'Riegelnähte',
            'fr': 'Barrettes d\'arrêt',
            'it': 'Barrette',
            'ko': '바텍'
          },
          {
            'order': 1,
            'zh-cn': '织带',
            'en': 'webbing',
            'zh-hant': '織帶',
            'ja': 'ウェビング',
            'de': 'Gurtband',
            'fr': 'Sangle',
            'it': 'Fettuccia',
            'ko': '웨빙'
          },
          {
            'order': 1,
            'zh-cn': '皮革标签',
            'en': 'leather labels',
            'zh-hant': '皮標',
            'ja': 'レザーレーベル',
            'de': 'Lederetiketten',
            'fr': 'Étiquettes en cuir',
            'it': 'Etichette in pelle',
            'ko': '가죽 라벨'
          },
          {
            'order': 1,
            'zh-cn': '抽绳',
            'en': 'cord lock',
            'zh-hant': '繩鎖',
            'ja': 'コードロック',
            'de': 'Kordelstopper',
            'fr': 'Bloque-cordon',
            'it': 'Blocco corda',
            'ko': '코드락'
          },
          {
            'order': 1,
            'zh-cn': '缝纫辅助工具',
            'en': 'sewing notions',
            'zh-hant': '縫紉用品',
            'ja': '裁縫用品',
            'de': 'Nähzubehör',
            'fr': 'Articles de couture',
            'it': 'Accessori per cucito',
            'ko': '재봉 부자재'
          },
          {
            'order': 1,
            'zh-cn': '珠片',
            'en': 'beads',
            'zh-hant': '珠子',
            'ja': 'ビーズ',
            'de': 'Perlen',
            'fr': 'Perles',
            'it': 'Perline',
            'ko': '구슬'
          },
          {
            'order': 1,
            'zh-cn': '绒面布',
            'en': 'velveteen',
            'zh-hant': '平絨',
            'ja': 'ベルベット',
            'de': 'Velours',
            'fr': 'Velours',
            'it': 'Velluto',
            'ko': '벨벳'
          },
          {
            'order': 1,
            'zh-cn': '珠链',
            'en': 'beaded trim',
            'zh-hant': '珠繡飾邊',
            'ja': 'ビーズトリム',
            'de': 'Perlenbesatz',
            'fr': 'Bordure perlée',
            'it': 'Bordo con perline',
            'ko': '비즈 장식'
          },
          {
            'order': 1,
            'zh-cn': '刺绣',
            'en': 'embroidery',
            'zh-hant': '刺繡',
            'ja': '刺繍',
            'de': 'Stickerei',
            'fr': 'Broderie',
            'it': 'Ricamo',
            'ko': '자수'
          },
          {
            'order': 1,
            'zh-cn': '肩章',
            'en': 'epaulettes',
            'zh-hant': '肩章',
            'ja': 'エポレット',
            'de': 'Epauletten',
            'fr': 'Épaulettes',
            'it': 'Spalline',
            'ko': '견장'
          },
          {
            'order': 1,
            'zh-cn': '布标签',
            'en': 'woven labels',
            'zh-hant': '織標',
            'ja': '織ラベル',
            'de': 'Gewebte Etiketten',
            'fr': 'Étiquettes tissées',
            'it': 'Etichette tessute',
            'ko': '직조 라벨'
          },
          {
            'order': 1,
            'zh-cn': '海绵垫',
            'en': 'foam pads',
            'zh-hant': '泡棉墊',
            'ja': 'フォームパッド',
            'de': 'Schaumpolster',
            'fr': 'Coussins en mousse',
            'it': 'Imbottiture in schiuma',
            'ko': '폼 패드'
          },
          {
            'order': 1,
            'zh-cn': '洗水标',
            'en': 'care label',
            'zh-hant': '洗滌標籤',
            'ja': 'ケアラベル',
            'de': 'Pflegeetikett',
            'fr': 'Étiquette de soins',
            'it': 'Etichetta di cura',
            'ko': '세탁 라벨'
          },
          {
            'order': 1,
            'zh-cn': '吊带扣',
            'en': 'suspender clip',
            'zh-hant': '吊帶夾',
            'ja': 'サスペンダークリップ',
            'de': 'Hosenträgerclip',
            'fr': 'Clip de bretelle',
            'it': 'Clip per bretelle',
            'ko': '멜빵 클립'
          },
          {
            'order': 1,
            'zh-cn': '前襟花边',
            'en': 'front lace',
            'zh-hant': '前蕾絲',
            'ja': 'フロントレース',
            'de': 'Vorderes Spitzenband',
            'fr': 'Dentelle avant',
            'it': 'Pizzo frontale',
            'ko': '앞면 레이스'
          },
          {
            'order': 1,
            'zh-cn': '麻绳',
            'en': 'hemp twine',
            'zh-hant': '麻繩',
            'ja': '麻ひも',
            'de': 'Hanfschnur',
            'fr': 'Ficelle de chanvre',
            'it': 'Spago di canapa',
            'ko': '삼 끈'
          },
          {
            'order': 1,
            'zh-cn': '弹力带',
            'en': 'elastic band',
            'zh-hant': '橡皮筋',
            'ja': 'ゴムバンド',
            'de': 'Gummiband',
            'fr': 'Bande élastique',
            'it': 'Fascia elastica',
            'ko': '고무줄'
          },
          {
            'order': 1,
            'zh-cn': '线扣',
            'en': 'thread clippers',
            'zh-hant': '線剪',
            'ja': '糸切り',
            'de': 'Fadenschneider',
            'fr': 'Coupe-fil',
            'it': 'Tagliafili',
            'ko': '실 가위'
          },
          {
            'order': 1,
            'zh-cn': '可拆卸拉链',
            'en': 'detachable zipper',
            'zh-hant': '可拆卸拉鍊',
            'ja': '取り外し可能なジッパー',
            'de': 'Abnehmbarer Reißverschluss',
            'fr': 'Fermeture éclair amovible',
            'it': 'Cerniera staccabile',
            'ko': '탈부착 지퍼'
          },
          {
            'order': 1,
            'zh-cn': '防滑胶带',
            'en': 'anti-slip tape',
            'zh-hant': '防滑膠帶',
            'ja': '滑り止めテープ',
            'de': 'Antirutschband',
            'fr': 'Ruban antidérapant',
            'it': 'Nastro antiscivolo',
            'ko': '미끄럼 방지 테이프'
          },
          {
            'order': 1,
            'zh-cn': '衬里',
            'en': 'lining',
            'zh-hant': '裡襯',
            'ja': '裏地',
            'de': 'Futter',
            'fr': 'Doublure',
            'it': 'Fodera',
            'ko': '안감'
          },
          {
            'order': 1,
            'zh-cn': '网眼',
            'en': 'mesh',
            'zh-hant': '網布',
            'ja': 'メッシュ',
            'de': 'Netzstoff',
            'fr': 'Maille',
            'it': 'Rete',
            'ko': '메쉬'
          },
          {
            'order': 1,
            'zh-cn': '内衬',
            'en': 'inner padding',
            'zh-hant': '內墊',
            'ja': 'インナーパッド',
            'de': 'Innenpolsterung',
            'fr': 'Rembourrage intérieur',
            'it': 'Imbottitura interna',
            'ko': '내부 패딩'
          },
          {
            'order': 1,
            'zh-cn': '金属拉锁',
            'en': 'metal zipper',
            'zh-hant': '金屬拉鍊',
            'ja': '金属ジッパー',
            'de': 'Metallreißverschluss',
            'fr': 'Fermeture éclair en métal',
            'it': 'Cerniera in metallo',
            'ko': '금속 지퍼'
          },
          {
            'order': 1,
            'zh-cn': '绒线',
            'en': 'fleece',
            'zh-hant': '羊絨',
            'ja': 'フリース',
            'de': 'Fleece',
            'fr': 'Laine polaire',
            'it': 'Pile',
            'ko': '플리스'
          },
          {
            'order': 1,
            'zh-cn': '胶粘剂',
            'en': 'adhesive',
            'zh-hant': '膠黏劑',
            'ja': '接着剤',
            'de': 'Klebstoff',
            'fr': 'Adhésif',
            'it': 'Adesivo',
            'ko': '접착제'
          },
          {
            'order': 1,
            'zh-cn': '针线包',
            'en': 'sewing kit',
            'zh-hant': '縫紉套件',
            'ja': '裁縫セット',
            'de': 'Nähset',
            'fr': 'Kit de couture',
            'it': 'Kit da cucito',
            'ko': '바느질 세트'
          },
          {
            'order': 1,
            'zh-cn': '绒球',
            'en': 'pom-poms',
            'zh-hant': '毛絨球',
            'ja': 'ポンポン',
            'de': 'Pompons',
            'fr': 'Pompons',
            'it': 'Pompon',
            'ko': '폼폼'
          },
          {
            'order': 1,
            'zh-cn': '手机袋',
            'en': 'phone pocket',
            'zh-hant': '手機口袋',
            'ja': '携帯ポケット',
            'de': 'Handytasche',
            'fr': 'Poche pour téléphone',
            'it': 'Tasca per telefono',
            'ko': '휴대폰 주머니'
          },
          {
            'order': 1,
            'zh-cn': '海绵背胶',
            'en': 'sponge foam tape',
            'zh-hant': '海綿泡棉膠帶',
            'ja': 'スポンジフォームテープ',
            'de': 'Schwammschaumband',
            'fr': 'Ruban en mousse éponge',
            'it': 'Nastro in schiuma di spugna',
            'ko': '스펀지 폼 테이프'
          },
          {
            'order': 1,
            'zh-cn': '绒布',
            'en': 'flannel',
            'zh-hant': '法蘭絨',
            'ja': 'フランネル',
            'de': 'Flanell',
            'fr': 'Flanelle',
            'it': 'Flanella',
            'ko': '플란넬'
          }
        ]
      }
    ]
  },
  {
    'order': 1,
    'name': { 'zh-cn': '工艺细节', en: 'Craftsmanship Details', 'zh-hant': '工藝細節', ja: 'ディテール', de: 'Technische Details', fr: 'Détails techniques', it: 'Dettagli tecnici', ko: '제작 세부사항' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '工艺', en: 'Craftsmanship', 'zh-hant': '工藝', ja: '工芸', de: 'Handwerkskunst', fr: 'Artisanat', it: 'Artigianato', ko: '공예' },
        'list': [
          {
            'order': 1,
            'zh-cn': '截短',
            'en': 'shorten',
            'zh-hant': '縮短',
            'ja': '短くする',
            'de': 'Verkürzen',
            'fr': 'Raccourcir',
            'it': 'Accorciare',
            'ko': '짧게 하다'
          },
          {
            'order': 1,
            'zh-cn': '无痕',
            'en': 'invisible',
            'zh-hant': '隱形',
            'ja': '目立たない',
            'de': 'Unsichtbar',
            'fr': 'Invisible',
            'it': 'Invisibile',
            'ko': '보이지 않는'
          },
          {
            'order': 1,
            'zh-cn': '散边脚口',
            'en': 'frayed hem',
            'zh-hant': '毛邊褶',
            'ja': 'ほつれた裾',
            'de': 'Ausgefranster Saum',
            'fr': 'Ourlet effiloché',
            'it': 'Orlo sfrangiato',
            'ko': '닳아해진 밑단'
          },
          {
            'order': 1,
            'zh-cn': '内衣造型',
            'en': 'undergarment shaping',
            'zh-hant': '塑形內衣',
            'ja': 'シェーピング下着',
            'de': 'Formende Unterwäsche',
            'fr': 'Sous-vêtement sculptant',
            'it': 'Indumento modellante',
            'ko': '속옷 쉐이핑'
          },
          {
            'order': 1,
            'zh-cn': '明线缝',
            'en': 'visible stitching',
            'zh-hant': '明線縫製',
            'ja': '見えるステッチ',
            'de': 'Sichtbare Nähte',
            'fr': 'Couture visible',
            'it': 'Cucitura visibile',
            'ko': '보이는 스티치'
          },
          {
            'order': 1,
            'zh-cn': '反面',
            'en': 'reverse',
            'zh-hant': '反向',
            'ja': '逆',
            'de': 'Umkehren',
            'fr': 'Inverser',
            'it': 'Invertire',
            'ko': '뒤집기'
          },
          {
            'order': 1,
            'zh-cn': '特殊缝合方式',
            'en': 'special stitching',
            'zh-hant': '特殊縫線',
            'ja': '特別なステッチ',
            'de': 'Spezielle Nähte',
            'fr': 'Couture spéciale',
            'it': 'Cucitura speciale',
            'ko': '특수 스티치'
          },
          {
            'order': 1,
            'zh-cn': '正反两穿',
            'en': 'reversible',
            'zh-hant': '可反轉',
            'ja': 'リバーシブル',
            'de': 'Wende-',
            'fr': 'Réversible',
            'it': 'Reversibile',
            'ko': '양면'
          },
          {
            'order': 1,
            'zh-cn': '侧缝装饰',
            'en': 'side seam decoration',
            'zh-hant': '側縫裝飾',
            'ja': 'サイドシームデコレーション',
            'de': 'Seitennähte Dekoration',
            'fr': 'Décoration de couture latérale',
            'it': 'Decorazione della cucitura laterale',
            'ko': '옆선 장식'
          },
          {
            'order': 1,
            'zh-cn': '绗缝',
            'en': 'topstitching',
            'zh-hant': '明線',
            'ja': 'トップステッチ',
            'de': 'Steppnaht',
            'fr': 'Surpiqûre',
            'it': 'Impuntura',
            'ko': '탑스티치'
          },
          {
            'order': 1,
            'zh-cn': '烫钻',
            'en': 'hot drilling',
            'zh-hant': '熱鑽',
            'ja': 'ホットドリル',
            'de': 'Heißbohren',
            'fr': 'Perçage à chaud',
            'it': 'Trapano caldo',
            'ko': '핫드릴링'
          },
          {
            'order': 1,
            'zh-cn': '激光切割',
            'en': 'laser cutting',
            'zh-hant': '雷射切割',
            'ja': 'レーザーカット',
            'de': 'Laserschneiden',
            'fr': 'Découpe laser',
            'it': 'Taglio laser',
            'ko': '레이저 커팅'
          },
          {
            'order': 1,
            'zh-cn': '几何切割',
            'en': 'geometric cutting',
            'zh-hant': '幾何切割',
            'ja': '幾何学的カット',
            'de': 'Geometrisches Schneiden',
            'fr': 'Découpe géométrique',
            'it': 'Taglio geometrico',
            'ko': '기하학적 커팅'
          },
          {
            'order': 1,
            'zh-cn': '花式镂空',
            'en': 'fancy perforation',
            'zh-hant': '精美打孔',
            'ja': 'ファンシーパーフォレーション',
            'de': 'Verzierte Perforation',
            'fr': 'Perforation fantaisie',
            'it': 'Perforazione decorativa',
            'ko': '장식 천공'
          },
          {
            'order': 1,
            'zh-cn': '提花',
            'en': 'jacquard',
            'zh-hant': '提花',
            'ja': 'ジャカード',
            'de': 'Jacquard',
            'fr': 'Jacquard',
            'it': 'Jacquard',
            'ko': '자카드'
          },
          {
            'order': 1,
            'zh-cn': '杂色',
            'en': 'variegated',
            'zh-hant': '變色',
            'ja': '変化に富んだ',
            'de': 'Bunt',
            'fr': 'Varié',
            'it': 'Variegato',
            'ko': '얼룩무늬'
          },
          {
            'order': 1,
            'zh-cn': '喷溅染色',
            'en': 'spray dyeing',
            'zh-hant': '噴染',
            'ja': 'スプレー染色',
            'de': 'Sprühfärbung',
            'fr': 'Teinture par pulvérisation',
            'it': 'Tintura a spruzzo',
            'ko': '스프레이 염색'
          },
          {
            'order': 1,
            'zh-cn': '不对称',
            'en': 'asymmetric',
            'zh-hant': '不對稱',
            'ja': '非対称',
            'de': 'Asymmetrisch',
            'fr': 'Asymétrique',
            'it': 'Asimmetrico',
            'ko': '비대칭'
          },
          {
            'order': 1,
            'zh-cn': '围裹式',
            'en': 'wraparound',
            'zh-hant': '環繞',
            'ja': 'ラップアラウンド',
            'de': 'Wickel-',
            'fr': 'Enveloppant',
            'it': 'Avvolgente',
            'ko': '랩어라운드'
          },
          {
            'order': 1,
            'zh-cn': '褶裥',
            'en': 'pleating',
            'zh-hant': '打褶',
            'ja': 'プリーツ',
            'de': 'Falten',
            'fr': 'Plissage',
            'it': 'Pieghettatura',
            'ko': '주름'
          },
          {
            'order': 1,
            'zh-cn': '倒褶',
            'en': 'inverted pleat',
            'zh-hant': '反褶',
            'ja': 'インバーテッドプリーツ',
            'de': 'Eingefaltete Falte',
            'fr': 'Pli inversé',
            'it': 'Pieghe invertite',
            'ko': '역주름'
          },
          {
            'order': 1,
            'zh-cn': '工字褶',
            'en': 'box pleat',
            'zh-hant': '箱型褶',
            'ja': 'ボックスプリーツ',
            'de': 'Kastenfalte',
            'fr': 'Pli creux',
            'it': 'Pieghe a scatola',
            'ko': '박스 주름'
          },
          {
            'order': 1,
            'zh-cn': '局部压褶',
            'en': 'crush pleat',
            'zh-hant': '壓皺褶',
            'ja': 'クラッシュプリーツ',
            'de': 'Knitterfalte',
            'fr': 'Pli écrasé',
            'it': 'Pieghe stropicciate',
            'ko': '크러시 주름'
          },
          {
            'order': 1,
            'zh-cn': '撞色压褶',
            'en': 'color-blocked pleat',
            'zh-hant': '色塊拼接褶',
            'ja': 'カラーブロックプリーツ',
            'de': 'Farbblock-Falte',
            'fr': 'Pli à blocs de couleur',
            'it': 'Pieghe a blocchi di colore',
            'ko': '컬러블록 주름'
          },
          {
            'order': 1,
            'zh-cn': '图案压褶',
            'en': 'patterned pleat',
            'zh-hant': '有圖案的褶',
            'ja': 'パターンプリーツ',
            'de': 'Gemusterte Falte',
            'fr': 'Pli plissé',
            'it': 'Pieghe con motivo',
            'ko': '패턴 주름'
          },
          {
            'order': 1,
            'zh-cn': '钻石褶',
            'en': 'diamond pleat',
            'zh-hant': '菱形褶',
            'ja': 'ダイヤモンドプリーツ',
            'de': 'Diamantfalten',
            'fr': 'Pli diamant',
            'it': 'Pieghe a diamante',
            'ko': '다이아몬드 주름'
          },
          {
            'order': 1,
            'zh-cn': '牙签褶',
            'en': 'knife pleat',
            'zh-hant': '刀褶',
            'ja': 'ナイフプリーツ',
            'de': 'Messerfalte',
            'fr': 'Pli plat',
            'it': 'Pieghe a coltello',
            'ko': '나이프 주름'
          },
          {
            'order': 1,
            'zh-cn': '流苏',
            'en': 'tassels',
            'zh-hant': '流蘇',
            'ja': 'タッセル',
            'de': 'Quasten',
            'fr': 'Glands',
            'it': 'Nappe',
            'ko': '태슬'
          },
          {
            'order': 1,
            'zh-cn': '图案流苏',
            'en': 'patterned fringe',
            'zh-hant': '有圖案的流蘇',
            'ja': 'パターンフリンジ',
            'de': 'Gemusterte Fransen',
            'fr': 'Franges à motifs',
            'it': 'Frange con motivo',
            'ko': '패턴 프린지'
          },
          {
            'order': 1,
            'zh-cn': '装饰流苏',
            'en': 'decorative fringe',
            'zh-hant': '裝飾性流蘇',
            'ja': '装飾的なフリンジ',
            'de': 'Dekorative Fransen',
            'fr': 'Franges décoratives',
            'it': 'Frange decorative',
            'ko': '장식 프린지'
          },
          {
            'order': 1,
            'zh-cn': '彩色流苏',
            'en': 'multicolored tassels',
            'zh-hant': '多色流蘇',
            'ja': '多色タッセル',
            'de': 'Mehrfarbige Quasten',
            'fr': 'Glands multicolores',
            'it': 'Nappe multicolori',
            'ko': '다색 태슬'
          },
          {
            'order': 1,
            'zh-cn': '吊穗',
            'en': 'hanging tassels',
            'zh-hant': '懸掛流蘇',
            'ja': '吊るしタッセル',
            'de': 'Hängende Quasten',
            'fr': 'Glands suspendus',
            'it': 'Nappe pendenti',
            'ko': '매달린 태슬'
          },
          {
            'order': 1,
            'zh-cn': '流苏边缘',
            'en': 'fringed edge',
            'zh-hant': '流蘇邊',
            'ja': 'フリンジエッジ',
            'de': 'Fransenrand',
            'fr': 'Bordure à franges',
            'it': 'Bordo sfrangiato',
            'ko': '프린지 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '加长流苏',
            'en': 'extended fringe',
            'zh-hant': '加長流蘇',
            'ja': 'エクステンドフリンジ',
            'de': 'Verlängerte Fransen',
            'fr': 'Franges étendues',
            'it': 'Frange estese',
            'ko': '연장 프린지'
          },
          {
            'order': 1,
            'zh-cn': '蝴蝶结',
            'en': 'bow',
            'zh-hant': '蝴蝶結',
            'ja': 'リボン',
            'de': 'Schleife',
            'fr': 'Nœud',
            'it': 'Fiocco',
            'ko': '리본'
          },
          {
            'order': 1,
            'zh-cn': '蝴蝶结装饰',
            'en': 'bow decoration',
            'zh-hant': '蝴蝶結裝飾',
            'ja': 'リボン装飾',
            'de': 'Schleifendekoration',
            'fr': 'Décoration en nœud',
            'it': 'Decorazione a fiocco',
            'ko': '리본 장식'
          },
          {
            'order': 1,
            'zh-cn': '系结',
            'en': 'bow-tie',
            'zh-hant': '蝴蝶領結',
            'ja': '蝶ネクタイ',
            'de': 'Fliege',
            'fr': 'Nœud papillon',
            'it': 'Papillon',
            'ko': '보타이'
          },
          {
            'order': 1,
            'zh-cn': '立体造型',
            'en': '3d construction',
            'zh-hant': '立體結構',
            'ja': '3D構造',
            'de': '3D-Konstruktion',
            'fr': 'Construction 3D',
            'it': 'Costruzione 3D',
            'ko': '3D 구조'
          },
          {
            'order': 1,
            'zh-cn': '毛衫针法',
            'en': 'knitting stitches',
            'zh-hant': '針織針法',
            'ja': 'ニットステッチ',
            'de': 'Strickstiche',
            'fr': 'Points de tricot',
            'it': 'Punti di maglia',
            'ko': '니팅 스티치'
          },
          {
            'order': 1,
            'zh-cn': '细针',
            'en': 'fine gauge',
            'zh-hant': '細針規',
            'ja': '細ゲージ',
            'de': 'Feine Maschenweite',
            'fr': 'Jauge fine',
            'it': 'Fine gauge',
            'ko': '파인 게이지'
          },
          {
            'order': 1,
            'zh-cn': '钩编',
            'en': 'crochet',
            'zh-hant': '鉤針編織',
            'ja': 'かぎ針編み',
            'de': 'Häkeln',
            'fr': 'Crochet',
            'it': 'Uncinetto',
            'ko': '크로셰'
          },
          {
            'order': 1,
            'zh-cn': '粗针',
            'en': 'chunky knit',
            'zh-hant': '粗針織',
            'ja': 'チャンキーニット',
            'de': 'Grobstrick',
            'fr': 'Tricot épais',
            'it': 'Maglia grossa',
            'ko': '청키 니트'
          },
          {
            'order': 1,
            'zh-cn': '漏针',
            'en': 'drop stitch',
            'zh-hant': '掉針',
            'ja': 'ドロップステッチ',
            'de': 'Fallmasche',
            'fr': 'Point goutte',
            'it': 'Punto a goccia',
            'ko': '드롭 스티치'
          },
          {
            'order': 1,
            'zh-cn': '挑孔',
            'en': 'eyelet',
            'zh-hant': '鉤眼',
            'ja': 'アイレット',
            'de': 'Öse',
            'fr': 'Œillet',
            'it': 'Occhiello',
            'ko': '아일렛'
          },
          {
            'order': 1,
            'zh-cn': '扭纹',
            'en': 'twisted rib',
            'zh-hant': '扭羅紋',
            'ja': 'ツイストリブ',
            'de': 'Verdrillte Rippe',
            'fr': 'Côte torsadée',
            'it': 'Costine ritorte',
            'ko': '트위스트 립'
          },
          {
            'order': 1,
            'zh-cn': '绞花',
            'en': 'cable knit',
            'zh-hant': '麻花針織',
            'ja': 'ケーブルニット',
            'de': 'Zopfmuster',
            'fr': 'Tricot torsadé',
            'it': 'Maglia a trecce',
            'ko': '케이블 니트'
          },
          {
            'order': 1,
            'zh-cn': '螺纹',
            'en': 'spiral stitch',
            'zh-hant': '螺旋針法',
            'ja': 'スパイラルステッチ',
            'de': 'Spiralstich',
            'fr': 'Point spiralé',
            'it': 'Punto a spirale',
            'ko': '나선형 스티치'
          },
          {
            'order': 1,
            'zh-cn': '特色织带',
            'en': 'novelty tape',
            'zh-hant': '新奇膠帶',
            'ja': 'ノベルティーテープ',
            'de': 'Neuheit Band',
            'fr': 'Ruban fantaisie',
            'it': 'Nastro originale',
            'ko': '노벨티 테이프'
          },
          {
            'order': 1,
            'zh-cn': '可拆卸',
            'en': 'detachable',
            'zh-hant': '可拆卸',
            'ja': '取り外し可能',
            'de': 'Abnehmbar',
            'fr': 'Détachable',
            'it': 'Staccabile',
            'ko': '탈착식'
          },
          {
            'order': 1,
            'zh-cn': '缩褶',
            'en': 'shirring',
            'zh-hant': '縐摺',
            'ja': 'シャーリング',
            'de': 'Kräuseln',
            'fr': 'Fronces',
            'it': 'Arricciature',
            'ko': '셔링'
          },
          {
            'order': 1,
            'zh-cn': '串珠',
            'en': 'beaded',
            'zh-hant': '珠飾',
            'ja': 'ビーズ付き',
            'de': 'Perlenbesetzt',
            'fr': 'Perlées',
            'it': 'Perlato',
            'ko': '비즈'
          },
          {
            'order': 1,
            'zh-cn': '手工艺',
            'en': 'handcrafted',
            'zh-hant': '手工製作',
            'ja': '手作り',
            'de': 'Handgefertigt',
            'fr': 'Fait main',
            'it': 'Fatto a mano',
            'ko': '수공예'
          },
          {
            'order': 1,
            'zh-cn': '交叉',
            'en': 'crossing',
            'zh-hant': '交叉',
            'ja': '交差',
            'de': 'Kreuzend',
            'fr': 'Croisement',
            'it': 'Incrociato',
            'ko': '교차'
          },
          {
            'order': 1,
            'zh-cn': '亮片',
            'en': 'sequins',
            'zh-hant': '亮片',
            'ja': 'スパンコール',
            'de': 'Pailletten',
            'fr': 'Paillettes',
            'it': 'Paillettes',
            'ko': '스팽글'
          },
          {
            'order': 1,
            'zh-cn': '镂空',
            'en': 'cutout',
            'zh-hant': '鑽孔',
            'ja': 'カットアウト',
            'de': 'Ausschnitt',
            'fr': 'Découpe',
            'it': 'Ritaglio',
            'ko': '컷아웃'
          },
          {
            'order': 1,
            'zh-cn': '贴花',
            'en': 'appliqué',
            'zh-hant': '貼花',
            'ja': 'アップリケ',
            'de': 'Applikation',
            'fr': 'Appliqué',
            'it': 'Applicazione',
            'ko': '아플리케'
          },
          {
            'order': 1,
            'zh-cn': '烫画',
            'en': 'heat transfer',
            'zh-hant': '熱轉印',
            'ja': '熱転写',
            'de': 'Hitzetransfer',
            'fr': 'Transfert thermique',
            'it': 'Trasferimento termico',
            'ko': '열전사'
          },
          {
            'order': 1,
            'zh-cn': '打结',
            'en': 'tie knot',
            'zh-hant': '打結',
            'ja': '結び目',
            'de': 'Knoten',
            'fr': 'Nœud',
            'it': 'Nodo',
            'ko': '매듭'
          },
          {
            'order': 1,
            'zh-cn': '满版',
            'en': 'all-over print',
            'zh-hant': '全面印花',
            'ja': 'オールオーバープリント',
            'de': 'Allover-Druck',
            'fr': 'Impression totale',
            'it': 'Stampa totale',
            'ko': '올오버 프린트'
          },
          {
            'order': 1,
            'zh-cn': '贴台',
            'en': 'patchwork',
            'zh-hant': '拼布',
            'ja': 'パッチワーク',
            'de': 'Patchwork',
            'fr': 'Patchwork',
            'it': 'Patchwork',
            'ko': '패치워크'
          },
          {
            'order': 1,
            'zh-cn': '前扣',
            'en': 'front closure',
            'zh-hant': '前閉合',
            'ja': 'フロントクロージャー',
            'de': 'Vorderer Verschluss',
            'fr': 'Fermeture avant',
            'it': 'Chiusura frontale',
            'ko': '앞면 잠금'
          },
          {
            'order': 1,
            'zh-cn': '羽毛',
            'en': 'feathers',
            'zh-hant': '羽毛',
            'ja': '羽',
            'de': 'Federn',
            'fr': 'Plumes',
            'it': 'Piume',
            'ko': '깃털'
          },
          {
            'order': 1,
            'zh-cn': '做旧处理',
            'en': 'distressing',
            'zh-hant': '磨損',
            'ja': 'ディストレッシング',
            'de': 'Distressing',
            'fr': 'Délavage',
            'it': 'Distressing',
            'ko': '디스트레싱'
          },
          {
            'order': 1,
            'zh-cn': '磨损破洞',
            'en': 'distressed holes',
            'zh-hant': '磨損洞',
            'ja': 'ダメージホール',
            'de': 'Distressed-Löcher',
            'fr': 'Trous usés',
            'it': 'Buchi usurati',
            'ko': '디스트레스드 홀'
          },
          {
            'order': 1,
            'zh-cn': '毛边',
            'en': 'frayed edges',
            'zh-hant': '毛邊',
            'ja': 'ほつれた端',
            'de': 'Fransen',
            'fr': 'Bords effilochés',
            'it': 'Bordi sfrangiati',
            'ko': '닳아해진 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '做旧洗水',
            'en': 'vintage washed',
            'zh-hant': '復古洗',
            'ja': 'ヴィンテージウォッシュ',
            'de': 'Vintage-Wäsche',
            'fr': 'Lavé vintage',
            'it': 'Lavaggio vintage',
            'ko': '빈티지 워시'
          },
          {
            'order': 1,
            'zh-cn': '饰边',
            'en': 'edging',
            'zh-hant': '邊緣',
            'ja': '縁取り',
            'de': 'Einfassung',
            'fr': 'Bordure',
            'it': 'Orlatura',
            'ko': '가장자리 장식'
          },
          {
            'order': 1,
            'zh-cn': '镶边',
            'en': 'bordered',
            'zh-hant': '有邊框',
            'ja': 'ボーダー付き',
            'de': 'Gerahmt',
            'fr': 'Bordé',
            'it': 'Bordato',
            'ko': '테두리 장식'
          },
          {
            'order': 1,
            'zh-cn': '滚边',
            'en': 'rolled hem',
            'zh-hant': '捲邊',
            'ja': 'ロールドヘム',
            'de': 'Gerollter Saum',
            'fr': 'Ourlet roulé',
            'it': 'Orlo arrotolato',
            'ko': '말아박기'
          },
          {
            'order': 1,
            'zh-cn': '翻边',
            'en': 'fold-over',
            'zh-hant': '折疊',
            'ja': 'フォールドオーバー',
            'de': 'Umschlag',
            'fr': 'Replié',
            'it': 'Ripiegato',
            'ko': '접어 넣기'
          },
          {
            'order': 1,
            'zh-cn': '卷边',
            'en': 'curled',
            'zh-hant': '捲曲',
            'ja': 'カールした',
            'de': 'Gekräuselt',
            'fr': 'Bouclé',
            'it': 'Arricciato',
            'ko': '말린'
          },
          {
            'order': 1,
            'zh-cn': '外露接缝线',
            'en': 'exposed seams',
            'zh-hant': '外露縫線',
            'ja': '露出した縫い目',
            'de': 'Sichtbare Nähte',
            'fr': 'Coutures exposées',
            'it': 'Cuciture esposte',
            'ko': '노출 솔기'
          },
          {
            'order': 1,
            'zh-cn': '瑕疵感',
            'en': 'distressed look',
            'zh-hant': '做舊外觀',
            'ja': 'ダメージ加工',
            'de': 'Used-LOOK',
            'fr': 'Aspect vieilli',
            'it': 'Aspetto consumato',
            'ko': '빈티지 룩'
          },
          {
            'order': 1,
            'zh-cn': '随意裁',
            'en': 'cut randomly',
            'zh-hant': '隨機剪裁',
            'ja': 'ランダムにカット',
            'de': 'Zufällig geschnitten',
            'fr': 'Coupé au hasard',
            'it': 'Tagliato casualmente',
            'ko': '랜덤 컷'
          },
          {
            'order': 1,
            'zh-cn': '暗夜反光',
            'en': 'night-time reflectivity',
            'zh-hant': '夜間反光',
            'ja': '夜間反射性',
            'de': 'Nachtreflexion',
            'fr': 'Réflectivité nocturne',
            'it': 'Riflettività notturna',
            'ko': '야간 반사'
          },
          {
            'order': 1,
            'zh-cn': '特种缝制',
            'en': 'specialty stitching',
            'zh-hant': '特殊縫線',
            'ja': '特殊な縫製',
            'de': 'Spezialnähte',
            'fr': 'Couture spéciale',
            'it': 'Cucitura speciale',
            'ko': '특수 스티치'
          },
          {
            'order': 1,
            'zh-cn': '三角针',
            'en': 'triangle stitch',
            'zh-hant': '三角縫',
            'ja': 'トライアングルステッチ',
            'de': 'Dreieckstich',
            'fr': 'Point triangle',
            'it': 'Punto triangolo',
            'ko': '삼각 스티치'
          },
          {
            'order': 1,
            'zh-cn': '花式缝',
            'en': 'decorative stitching',
            'zh-hant': '裝飾縫線',
            'ja': '装飾縫い',
            'de': 'Ziernähte',
            'fr': 'Couture décorative',
            'it': 'Cucitura decorativa',
            'ko': '장식 스티치'
          },
          {
            'order': 1,
            'zh-cn': '脊骨缝',
            'en': 'flat-felled seam',
            'zh-hant': '平伏縫',
            'ja': 'フラットフェルドシーム',
            'de': 'Kappnaht',
            'fr': 'Couture rabattue',
            'it': 'Cucitura ribattuta piatta',
            'ko': '플랫 펠 심'
          },
          {
            'order': 1,
            'zh-cn': '打条',
            'en': 'bartack stitch',
            'zh-hant': '加固縫',
            'ja': 'バータックステッチ',
            'de': 'Riegelstich',
            'fr': 'Point de renfort',
            'it': 'Punto di rinforzo',
            'ko': '바텍 스티치'
          },
          {
            'order': 1,
            'zh-cn': '对丝',
            'en': 'french seam',
            'zh-hant': '法式縫',
            'ja': 'フレンチシーム',
            'de': 'Französische Naht',
            'fr': 'Couture française',
            'it': 'Cucitura francese',
            'ko': '프렌치 심'
          },
          {
            'order': 1,
            'zh-cn': '贝壳绣',
            'en': 'scallop stitch',
            'zh-hant': '扇形縫',
            'ja': 'スカラップステッチ',
            'de': 'Zickzackstich',
            'fr': 'Point feston',
            'it': 'Punto a conchiglia',
            'ko': '스캘럽 스티치'
          },
          {
            'order': 1,
            'zh-cn': '曲牙边',
            'en': 'serpentine edge',
            'zh-hant': '蛇形邊',
            'ja': '蛇行エッジ',
            'de': 'Serpentinenkante',
            'fr': 'Bord serpentin',
            'it': 'Bordo serpentino',
            'ko': '곡선 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '珠边缝',
            'en': 'beaded seam',
            'zh-hant': '珠飾縫',
            'ja': 'ビーズシーム',
            'de': 'Perlennaht',
            'fr': 'Couture perlée',
            'it': 'Cucitura con perline',
            'ko': '비즈 심'
          },
          {
            'order': 1,
            'zh-cn': '密边',
            'en': 'clean finish',
            'zh-hant': '干淨處理',
            'ja': 'クリーンフィニッシュ',
            'de': 'Saubere Verarbeitung',
            'fr': 'Finition propre',
            'it': 'Finitura pulita',
            'ko': '깔끔한 마감'
          },
          {
            'order': 1,
            'zh-cn': '拼接',
            'en': 'patchwork',
            'zh-hant': '拼布',
            'ja': 'パッチワーク',
            'de': 'Patchwork',
            'fr': 'Patchwork',
            'it': 'Patchwork',
            'ko': '패치워크'
          },
          {
            'order': 1,
            'zh-cn': '拼皮',
            'en': 'patchwork leather',
            'zh-hant': '皮革拼布',
            'ja': 'レザーパッチワーク',
            'de': 'Lederpatchwork',
            'fr': 'Patchwork en cuir',
            'it': 'Patchwork in pelle',
            'ko': '가죽 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '针梭织拼接',
            'en': 'knit and weave patchwork',
            'zh-hant': '針織和織物拼布',
            'ja': 'ニットと織物のパッチワーク',
            'de': 'Strick- und Webpatchwork',
            'fr': 'Patchwork tricoté et tissé',
            'it': 'Patchwork a maglia e tessuto',
            'ko': '니트와 직물 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '图案花型拼接',
            'en': 'patterned patchwork',
            'zh-hant': '有圖案的拼布',
            'ja': 'パターンパッチワーク',
            'de': 'Gemustertes Patchwork',
            'fr': 'Patchwork à motifs',
            'it': 'Patchwork a motivi',
            'ko': '패턴 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '蕾丝拼接',
            'en': 'lace patchwork',
            'zh-hant': '蕾絲拼布',
            'ja': 'レースパッチワーク',
            'de': 'Spitzenpatchwork',
            'fr': 'Patchwork en dentelle',
            'it': 'Patchwork in pizzo',
            'ko': '레이스 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '罗纹拼接',
            'en': 'ribbed patchwork',
            'zh-hant': '羅紋拼布',
            'ja': 'リブパッチワーク',
            'de': 'Ripp-Patchwork',
            'fr': 'Patchwork côtelé',
            'it': 'Patchwork a coste',
            'ko': '립 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '解构拼接',
            'en': 'deconstructed patchwork',
            'zh-hant': '解構拼布',
            'ja': 'デコンストラクションパッチワーク',
            'de': 'Dekonstruiertes Patchwork',
            'fr': 'Patchwork déstructuré',
            'it': 'Patchwork decostruito',
            'ko': '해체 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '异料拼接',
            'en': 'mixed-material patchwork',
            'zh-hant': '混合材料拼布',
            'ja': '混合素材パッチワーク',
            'de': 'Patchwork aus verschiedenen Materialien',
            'fr': 'Patchwork en matériaux mixtes',
            'it': 'Patchwork di materiali misti',
            'ko': '혼합 소재 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '多片式拼接',
            'en': 'multi-panel patchwork',
            'zh-hant': '多拼布拼接',
            'ja': 'マルチパネルパッチワーク',
            'de': 'Mehrteiliger Patchwork',
            'fr': 'Patchwork multi-panneaux',
            'it': 'Patchwork multi-pannello',
            'ko': '멀티 패널 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '对半拼接',
            'en': 'half and half patchwork',
            'zh-hant': '半拼布拼接',
            'ja': 'ハーフアンドハーフパッチワーク',
            'de': 'Halb-und-Halb-Patchwork',
            'fr': 'Patchwork moitié-moitié',
            'it': 'Patchwork metà e metà',
            'ko': '반반 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '反底为面拼接',
            'en': 'reverse-facing patchwork',
            'zh-hant': '反向拼布',
            'ja': '逆向きパッチワーク',
            'de': 'Umgekehrter Patchwork',
            'fr': 'Patchwork inversé',
            'it': 'Patchwork con faccia inversa',
            'ko': '리버스 패치워크'
          },
          {
            'order': 1,
            'zh-cn': '两件套',
            'en': 'two-piece set',
            'zh-hant': '兩件套',
            'ja': '2ピースセット',
            'de': 'Zweiteiliges Set',
            'fr': 'Ensemble deux pièces',
            'it': 'Completo due pezzi',
            'ko': '투피스 세트'
          },
          {
            'order': 1,
            'zh-cn': '立体花',
            'en': '3d flower',
            'zh-hant': '3D花卉',
            'ja': '3Dフラワー',
            'de': '3D-Blume',
            'fr': 'Fleur 3D',
            'it': 'Fiore 3D',
            'ko': '3D 꽃'
          },
          {
            'order': 1,
            'zh-cn': '线迹',
            'en': 'stitching lines',
            'zh-hant': '縫線',
            'ja': 'ステッチライン',
            'de': 'Nahtlinien',
            'fr': 'Lignes de couture',
            'it': 'Linee di cucitura',
            'ko': '스티치 라인'
          },
          {
            'order': 1,
            'zh-cn': '打揽',
            'en': 'draping',
            'zh-hant': '垂墜',
            'ja': 'ドレープ',
            'de': 'Drapierung',
            'fr': 'Drapé',
            'it': 'Drappeggio',
            'ko': '드레이핑'
          },
          {
            'order': 1,
            'zh-cn': '美背',
            'en': 'backless',
            'zh-hant': '露背',
            'ja': 'バックレス',
            'de': 'Rückenfrei',
            'fr': 'Dos nu',
            'it': 'Schiena scoperta',
            'ko': '백리스'
          },
          {
            'order': 1,
            'zh-cn': '假两件',
            'en': 'false two-piece',
            'zh-hant': '假兩件',
            'ja': 'フェイク2ピース',
            'de': 'Falsches Zweiteiler',
            'fr': 'Fausse deux pièces',
            'it': 'Finto due pezzi',
            'ko': '가짜 투피스'
          },
          {
            'order': 1,
            'zh-cn': '染色工艺',
            'en': 'dyeing',
            'zh-hant': '染色',
            'ja': '染色',
            'de': 'Färbung',
            'fr': 'Teinture',
            'it': 'Tintura',
            'ko': '염색'
          },
          {
            'order': 1,
            'zh-cn': '扎染',
            'en': 'tie-dye',
            'zh-hant': '扎染',
            'ja': 'タイダイ',
            'de': 'Batik',
            'fr': 'Tie-dye',
            'it': 'Tie-dye',
            'ko': '타이다이'
          },
          {
            'order': 1,
            'zh-cn': '渐变',
            'en': 'gradient',
            'zh-hant': '漸變',
            'ja': 'グラデーション',
            'de': 'Farbverlauf',
            'fr': 'Dégradé',
            'it': 'Gradiente',
            'ko': '그라데이션'
          },
          {
            'order': 1,
            'zh-cn': '漂白染',
            'en': 'bleach dye',
            'zh-hant': '漂染',
            'ja': 'ブリーチ染め',
            'de': 'Bleichfärbung',
            'fr': 'Teinture à la javel',
            'it': 'Tintura con candeggina',
            'ko': '표백 염색'
          },
          {
            'order': 1,
            'zh-cn': '吊染',
            'en': 'hanging dyeing',
            'zh-hant': '掛染',
            'ja': '吊るし染め',
            'de': 'Hängefärbung',
            'fr': 'Teinture suspendue',
            'it': 'Tintura sospesa',
            'ko': '행잉 염색'
          },
          {
            'order': 1,
            'zh-cn': '反光条',
            'en': 'reflective stripe',
            'zh-hant': '反光條紋',
            'ja': '反射ストライプ',
            'de': 'Reflektierender Streifen',
            'fr': 'Bande réfléchissante',
            'it': 'Striscia riflettente',
            'ko': '반사 스트라이프'
          },
          {
            'order': 1,
            'zh-cn': '挖空',
            'en': 'hollow out',
            'zh-hant': '鏤空',
            'ja': '穴あき',
            'de': 'Ausgeschnitten',
            'fr': 'Découpe',
            'it': 'Scollo a V',
            'ko': '중공'
          },
          {
            'order': 1,
            'zh-cn': '弹力带',
            'en': 'elastic band',
            'zh-hant': '橡皮筋',
            'ja': 'ゴムバンド',
            'de': 'Gummiband',
            'fr': 'Bande élastique',
            'it': 'Fascia elastica',
            'ko': '고무밴드'
          },
          {
            'order': 1,
            'zh-cn': '打孔',
            'en': 'punching',
            'zh-hant': '打孔',
            'ja': 'パンチング',
            'de': 'Perforation',
            'fr': 'Perforation',
            'it': 'Perforazione',
            'ko': '펀칭'
          },
          {
            'order': 1,
            'zh-cn': '洗水',
            'en': 'water-washed',
            'zh-hant': '水洗',
            'ja': 'ウォッシュド',
            'de': 'Wassergewaschen',
            'fr': 'Lavé à l\'eau',
            'it': 'Lavato con acqua',
            'ko': '워터워시'
          },
          {
            'order': 1,
            'zh-cn': '绣花',
            'en': 'embroidery',
            'zh-hant': '刺繡',
            'ja': '刺繍',
            'de': 'Stickerei',
            'fr': 'Broderie',
            'it': 'Ricamo',
            'ko': '자수'
          },
          {
            'order': 1,
            'zh-cn': '贴布绣',
            'en': 'applique embroidery',
            'zh-hant': '貼花刺繡',
            'ja': 'アップリケ刺繍',
            'de': 'Applikationsstickerei',
            'fr': 'Broderie appliquée',
            'it': 'Ricamo applicato',
            'ko': '아플리케 자수'
          },
          {
            'order': 1,
            'zh-cn': '镂空绣',
            'en': 'hollow-out embroidery',
            'zh-hant': '鏤空刺繡',
            'ja': '穴あき刺繍',
            'de': 'Ausgeschnittene Stickerei',
            'fr': 'Broderie ajourée',
            'it': 'Ricamo traforato',
            'ko': '중공 자수'
          },
          {
            'order': 1,
            'zh-cn': '平绣',
            'en': 'flat embroidery',
            'zh-hant': '平面刺繡',
            'ja': '平刺繍',
            'de': 'Flachstickerei',
            'fr': 'Broderie plate',
            'it': 'Ricamo piatto',
            'ko': '플랫 자수'
          },
          {
            'order': 1,
            'zh-cn': '立体绣',
            'en': '3d embroidery',
            'zh-hant': '3D刺繡',
            'ja': '3D刺繍',
            'de': '3D-Stickerei',
            'fr': 'Broderie 3D',
            'it': 'Ricamo 3D',
            'ko': '3D 자수'
          },
          {
            'order': 1,
            'zh-cn': '牙刷绣',
            'en': 'brush embroidery',
            'zh-hant': '刷子刺繡',
            'ja': 'ブラシ刺繍',
            'de': 'Pinselstickerei',
            'fr': 'Broderie au pinceau',
            'it': 'Ricamo a pennello',
            'ko': '브러시 자수'
          },
          {
            'order': 1,
            'zh-cn': '毛巾绣',
            'en': 'towel embroidery',
            'zh-hant': '毛巾刺繡',
            'ja': 'タオル刺繍',
            'de': 'Handtuchstickerei',
            'fr': 'Broderie en éponge',
            'it': 'Ricamo in spugna',
            'ko': '타월 자수'
          },
          {
            'order': 1,
            'zh-cn': '粗线绣',
            'en': 'thick thread embroidery',
            'zh-hant': '粗線刺繡',
            'ja': '太糸刺繍',
            'de': 'Dickfadenstickerei',
            'fr': 'Broderie au fil épais',
            'it': 'Ricamo con filo spesso',
            'ko': '굵은 실 자수'
          },
          {
            'order': 1,
            'zh-cn': '珠片绣',
            'en': 'beaded embroidery',
            'zh-hant': '珠飾刺繡',
            'ja': 'ビーズ刺繍',
            'de': 'Perlenstickerei',
            'fr': 'Broderie perlée',
            'it': 'Ricamo con perline',
            'ko': '비즈 자수'
          },
          {
            'order': 1,
            'zh-cn': '金线刺绣',
            'en': 'gold thread embroidery',
            'zh-hant': '金線刺繡',
            'ja': '金糸刺繍',
            'de': 'Goldfadenstickerei',
            'fr': 'Broderie au fil d\'or',
            'it': 'Ricamo con filo d\'oro',
            'ko': '금사 자수'
          },
          {
            'order': 1,
            'zh-cn': '绣片',
            'en': 'embroidered patch',
            'zh-hant': '刺繡補丁',
            'ja': '刺繍パッチ',
            'de': 'Besticktes Patch',
            'fr': 'Patch brodé',
            'it': 'Toppa ricamata',
            'ko': '자수 패치'
          },
          {
            'order': 1,
            'zh-cn': '刺绣',
            'en': 'embroidery',
            'zh-hant': '刺繡',
            'ja': '刺繍',
            'de': 'Stickerei',
            'fr': 'Broderie',
            'it': 'Ricamo',
            'ko': '자수'
          },
          {
            'order': 1,
            'zh-cn': '贴皮绣',
            'en': 'skin-attached embroidery',
            'zh-hant': '貼皮刺繡',
            'ja': 'スキンアタッチ刺繍',
            'de': 'Hautangelegte Stickerei',
            'fr': 'Broderie collée à la peau',
            'it': 'Ricamo aderente alla pelle',
            'ko': '스킨 부착 자수'
          },
          {
            'order': 1,
            'zh-cn': '十字绣',
            'en': 'cross-stitch embroidery',
            'zh-hant': '十字繡',
            'ja': 'クロスステッチ刺繍',
            'de': 'Kreuzstichstickerei',
            'fr': 'Broderie au point de croix',
            'it': 'Ricamo a punto croce',
            'ko': '십자수'
          },
          {
            'order': 1,
            'zh-cn': '荷叶边',
            'en': 'ruffle',
            'zh-hant': '荷葉邊',
            'ja': 'フリル',
            'de': 'Rüsche',
            'fr': 'Volant',
            'it': 'Volant',
            'ko': '러플'
          },
          {
            'order': 1,
            'zh-cn': '结构边缘荷叶边',
            'en': 'structural edge ruffle',
            'zh-hant': '結構性邊緣荷葉邊',
            'ja': '構造的なエッジフリル',
            'de': 'Strukturelle Randrüsche',
            'fr': 'Volant à bord structurel',
            'it': 'Volant con bordo strutturale',
            'ko': '구조적 엣지 러플'
          },
          {
            'order': 1,
            'zh-cn': '重复荷叶边组合',
            'en': 'repeated ruffle combination',
            'zh-hant': '重複荷葉邊組合',
            'ja': '繰り返しフリルの組み合わせ',
            'de': 'Wiederholte Rüschenkombination',
            'fr': 'Combinaison de volants répétés',
            'it': 'Combinazione di volant ripetuti',
            'ko': '반복 러플 조합'
          },
          {
            'order': 1,
            'zh-cn': '超大荷叶边',
            'en': 'extra-large ruffle',
            'zh-hant': '超大荷葉邊',
            'ja': '特大フリル',
            'de': 'Extra große Rüsche',
            'fr': 'Volant extra-large',
            'it': 'Volant extra-large',
            'ko': '특대형 러플'
          },
          {
            'order': 1,
            'zh-cn': '压花',
            'en': 'embossing',
            'zh-hant': '浮雕',
            'ja': 'エンボス加工',
            'de': 'Prägung',
            'fr': 'Gaufrage',
            'it': 'Stampa a rilievo',
            'ko': '엠보싱'
          },
          {
            'order': 1,
            'zh-cn': '补丁',
            'en': 'patch',
            'zh-hant': '補丁',
            'ja': 'パッチ',
            'de': 'Patch',
            'fr': 'Patch',
            'it': 'Toppa',
            'ko': '패치'
          },
          {
            'order': 1,
            'zh-cn': '撞色',
            'en': 'color-blocking',
            'zh-hant': '色塊拼接',
            'ja': 'カラーブロッキング',
            'de': 'Farbblockierung',
            'fr': 'Color-blocking',
            'it': 'Blocco di colore',
            'ko': '컬러 블로킹'
          },
          {
            'order': 1,
            'zh-cn': '植绒',
            'en': 'flocking',
            'zh-hant': '植絨',
            'ja': '植毛',
            'de': 'Beflockung',
            'fr': 'Flocage',
            'it': 'Flockatura',
            'ko': '플로킹'
          },
          {
            'order': 1,
            'zh-cn': '涂层',
            'en': 'coating',
            'zh-hant': '塗層',
            'ja': 'コーティング',
            'de': 'Beschichtung',
            'fr': 'Enduction',
            'it': 'Rivestimento',
            'ko': '코팅'
          },
          {
            'order': 1,
            'zh-cn': '收纳式',
            'en': 'storage design',
            'zh-hant': '收納設計',
            'ja': 'ストレージデザイン',
            'de': 'Aufbewahrungsdesign',
            'fr': 'Conception de rangement',
            'it': 'Design per la conservazione',
            'ko': '수납 디자인'
          },
          {
            'order': 1,
            'zh-cn': '立体烫',
            'en': '3d ironing',
            'zh-hant': '3D燙印',
            'ja': '3Dアイロン',
            'de': '3D-Bügeln',
            'fr': 'Repassage 3D',
            'it': 'Stiratura 3D',
            'ko': '3D 다림질'
          },
          {
            'order': 1,
            'zh-cn': '扭结',
            'en': 'twist knot',
            'zh-hant': '扭結',
            'ja': 'ツイストノット',
            'de': 'Knoten',
            'fr': 'Nœud torsadé',
            'it': 'Nodo a torsione',
            'ko': '트위스트 매듭'
          },
          {
            'order': 1,
            'zh-cn': '钩针',
            'en': 'crochet',
            'zh-hant': '鉤針編織',
            'ja': 'かぎ針編み',
            'de': 'Häkeln',
            'fr': 'Crochet',
            'it': 'Uncinetto',
            'ko': '코바늘'
          },
          {
            'order': 1,
            'zh-cn': '解构',
            'en': 'deconstruction',
            'zh-hant': '解構',
            'ja': 'デコンストラクション',
            'de': 'Dekonstruktion',
            'fr': 'Déconstruction',
            'it': 'Decostruzione',
            'ko': '해체'
          },
          {
            'order': 1,
            'zh-cn': '钉珠',
            'en': 'beading',
            'zh-hant': '串珠',
            'ja': 'ビーズ',
            'de': 'Perlenstickerei',
            'fr': 'Perlage',
            'it': 'Perline',
            'ko': '비즈 장식'
          },
          {
            'order': 1,
            'zh-cn': '立体管珠',
            'en': 'tubular beading',
            'zh-hant': '管狀串珠',
            'ja': 'チューブビーズ',
            'de': 'Röhrenperlen',
            'fr': 'Perles tubulaires',
            'it': 'Perline tubolari',
            'ko': '튜브형 비즈'
          },
          {
            'order': 1,
            'zh-cn': '趣味配件',
            'en': 'decorative accessories',
            'zh-hant': '裝飾配件',
            'ja': '装飾アクセサリー',
            'de': 'Dekorative Accessoires',
            'fr': 'Accessoires décoratifs',
            'it': 'Accessori decorativi',
            'ko': '장식용 액세서리'
          },
          {
            'order': 1,
            'zh-cn': '亚克力',
            'en': 'acrylic',
            'zh-hant': '丙烯酸纖維',
            'ja': 'アクリル',
            'de': 'Acryl',
            'fr': 'Acrylique',
            'it': 'Acrilico',
            'ko': '아크릴'
          },
          {
            'order': 1,
            'zh-cn': '印花',
            'en': 'printing',
            'zh-hant': '印刷',
            'ja': '印刷',
            'de': 'Druck',
            'fr': 'Impression',
            'it': 'Stampa',
            'ko': '프린팅'
          },
          {
            'order': 1,
            'zh-cn': '胶印',
            'en': 'rubber printing',
            'zh-hant': '橡膠印刷',
            'ja': 'ゴム印刷',
            'de': 'Gummidruck',
            'fr': 'Impression en caoutchouc',
            'it': 'Stampa in gomma',
            'ko': '고무 인쇄'
          },
          {
            'order': 1,
            'zh-cn': '拔印',
            'en': 'lift printing',
            'zh-hant': '提升印刷',
            'ja': 'リフト印刷',
            'de': 'Reliefruck',
            'fr': 'Impression en relief',
            'it': 'Stampa a rilievo',
            'ko': '리프트 프린팅'
          },
          {
            'order': 1,
            'zh-cn': '发泡印花',
            'en': 'foaming printing',
            'zh-hant': '發泡印刷',
            'ja': '発泡印刷',
            'de': 'Schaumbildung',
            'fr': 'Impression en mousse',
            'it': 'Stampa in schiuma',
            'ko': '발포 프린팅'
          },
          {
            'order': 1,
            'zh-cn': '水浆印',
            'en': 'water paste printing',
            'zh-hant': '水漿印刷',
            'ja': '水性ペースト印刷',
            'de': 'Wasserpaste-Druck',
            'fr': 'Impression par pâte à eau',
            'it': 'Stampa con pasta ad acqua',
            'ko': '수성 페이스트 프린팅'
          },
          {
            'order': 1,
            'zh-cn': '热转印',
            'en': 'heat transfer printing',
            'zh-hant': '熱轉印',
            'ja': '熱転写印刷',
            'de': 'Hitzetransferdruck',
            'fr': 'Impression par transfert thermique',
            'it': 'Stampa a trasferimento termico',
            'ko': '열전사 프린팅'
          },
          {
            'order': 1,
            'zh-cn': '烫金',
            'en': 'gold foil stamping',
            'zh-hant': '金箔壓印',
            'ja': '金箔スタンピング',
            'de': 'Goldfolienprägung',
            'fr': 'Estampage à la feuille d\'or',
            'it': 'Stampa a foglia d\'oro',
            'ko': '금박 스탬핑'
          },
          {
            'order': 1,
            'zh-cn': '烫银',
            'en': 'silver foil stamping',
            'zh-hant': '銀箔壓印',
            'ja': '銀箔スタンピング',
            'de': 'Silberfolienprägung',
            'fr': 'Estampage à la feuille d\'argent',
            'it': 'Stampa a foglia d\'argento',
            'ko': '은박 스탬핑'
          },
          {
            'order': 1,
            'zh-cn': '数码印',
            'en': 'digital printing',
            'zh-hant': '數碼印刷',
            'ja': 'デジタル印刷',
            'de': 'Digitaldruck',
            'fr': 'Impression numérique',
            'it': 'Stampa digitale',
            'ko': '디지털 프린팅'
          },
          {
            'order': 1,
            'zh-cn': '封胶印',
            'en': 'sealed glue printing',
            'zh-hant': '密封膠印刷',
            'ja': 'シールドグルー印刷',
            'de': 'Versiegelter Klebstoffdruck',
            'fr': 'Impression avec colle scellée',
            'it': 'Stampa con colla sigillata',
            'ko': '밀봉 접착 프린팅'
          },
          {
            'order': 1,
            'zh-cn': '滴胶印',
            'en': 'dropping glue printing',
            'zh-hant': '滴膠印刷',
            'ja': 'ドロップグルー印刷',
            'de': 'Tropfenkleberdruck',
            'fr': 'Impression avec colle à goutte',
            'it': 'Stampa con colla a goccia',
            'ko': '드롭 접착 프린팅'
          },
          {
            'order': 1,
            'zh-cn': '3D立体压胶',
            'en': '3d embossed glue printing',
            'zh-hant': '3D浮雕膠印刷',
            'ja': '3D浮き出しグルー印刷',
            'de': '3D-Reliefkleberdruck',
            'fr': 'Impression en relief 3D avec colle',
            'it': 'Stampa 3D in rilievo con colla',
            'ko': '3D 엠보싱 접착 프린팅'
          },
          {
            'order': 1,
            'zh-cn': '开叉',
            'en': 'slit',
            'zh-hant': '裂口',
            'ja': 'スリット',
            'de': 'Schlitz',
            'fr': 'Fente',
            'it': 'Spacco',
            'ko': '슬릿'
          },
          {
            'order': 1,
            'zh-cn': '前开叉',
            'en': 'front slit',
            'zh-hant': '前開衩',
            'ja': 'フロントスリット',
            'de': 'Frontschlitz',
            'fr': 'Fente avant',
            'it': 'Spacco anteriore',
            'ko': '앞면 슬릿'
          },
          {
            'order': 1,
            'zh-cn': '后开叉',
            'en': 'back slit',
            'zh-hant': '後開衩',
            'ja': 'バックスリット',
            'de': 'Rückenschlitz',
            'fr': 'Fente arrière',
            'it': 'Spacco posteriore',
            'ko': '뒷면 슬릿'
          },
          {
            'order': 1,
            'zh-cn': '肩部开叉',
            'en': 'shoulder slit',
            'zh-hant': '肩部開衩',
            'ja': 'ショルダースリット',
            'de': 'Schulter-Schlitz',
            'fr': 'Fente à l\'épaule',
            'it': 'Spacco sulla spalla',
            'ko': '어깨 슬릿'
          },
          {
            'order': 1,
            'zh-cn': '袖开叉',
            'en': 'sleeve slit',
            'zh-hant': '袖子開衩',
            'ja': 'スリーブスリット',
            'de': 'Ärmelschlitz',
            'fr': 'Fente de manche',
            'it': 'Spacco sulla manica',
            'ko': '소매 슬릿'
          },
          {
            'order': 1,
            'zh-cn': '侧边开叉',
            'en': 'side slit',
            'zh-hant': '側邊開叉',
            'ja': 'サイドスリット',
            'de': 'Seitenschlitz',
            'fr': 'Fente latérale',
            'it': 'Spacco laterale',
            'ko': '옆면 슬릿'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '细节', en: 'Details', 'zh-hant': '細節', ja: '詳細', de: 'Details', fr: 'Détails', it: 'Dettagli', 'ko': '세부사항' },
        'list': [
          {
            'order': 1,
            'zh-cn': '侧面',
            'en': 'side',
            'zh-hant': '側面',
            'ja': '側面',
            'de': 'Seite',
            'fr': 'Côté',
            'it': 'Lato',
            'ko': '측면'
          },
          {
            'order': 1,
            'zh-cn': '肩部',
            'en': 'shoulders',
            'zh-hant': '肩部',
            'ja': '肩',
            'de': 'Schulter',
            'fr': 'Épaule',
            'it': 'Spalla',
            'ko': '어깨'
          },
          {
            'order': 1,
            'zh-cn': '一字肩',
            'en': 'off-the-shoulder',
            'zh-hant': '一字肩',
            'ja': 'オフショルダー',
            'de': 'Schulterfrei',
            'fr': 'Épaule dénudée',
            'it': 'Spalla scoperta',
            'ko': '오프숄더'
          },
          {
            'order': 1,
            'zh-cn': '检点设计',
            'en': 'modesty design',
            'zh-hant': '檢點設計',
            'ja': '露出デザイン',
            'de': 'Minimalistisches Design',
            'fr': 'Conception épurée',
            'it': 'Design pulito',
            'ko': '단정한 디자인'
          },
          {
            'order': 1,
            'zh-cn': '挖空露肩',
            'en': 'cold shoulder',
            'zh-hant': '挖空露肩',
            'ja': 'カットアウトショルダー',
            'de': 'Schulter mit Ausschnitt',
            'fr': 'Épaule ajourée',
            'it': 'Spalla con apertura',
            'ko': '콜드숄더'
          },
          {
            'order': 1,
            'zh-cn': '斜肩',
            'en': 'asymmetric shoulder',
            'zh-hant': '斜肩',
            'ja': 'アシンメトリーショルダー',
            'de': 'Asymmetrische Schulter',
            'fr': 'Épaule asymétrique',
            'it': 'Spalla asimmetrica',
            'ko': '비대칭 어깨'
          },
          {
            'order': 1,
            'zh-cn': '后背/后片',
            'en': 'back panel',
            'zh-hant': '後背/後片',
            'ja': '背中/バックパネル',
            'de': 'Rücken/Rückenpaneel',
            'fr': 'Dos/dos panneau',
            'it': 'Schiena/pannello posteriore',
            'ko': '등/뒷판'
          },
          {
            'order': 1,
            'zh-cn': '连帽',
            'en': 'hood',
            'zh-hant': '連帽',
            'ja': 'フード付き',
            'de': 'Kapuze',
            'fr': 'Capuche',
            'it': 'Cappuccio',
            'ko': '후드'
          },
          {
            'order': 1,
            'zh-cn': '皮草连帽',
            'en': 'fur-lined hood',
            'zh-hant': '皮草連帽',
            'ja': 'ファーフード付き',
            'de': 'Pelzkapuze',
            'fr': 'Capuche en fourrure',
            'it': 'Cappuccio in pelliccia',
            'ko': '모피 후드'
          },
          {
            'order': 1,
            'zh-cn': '特色连帽',
            'en': 'distinctive hood',
            'zh-hant': '特色連帽',
            'ja': '特徴的なフード',
            'de': 'Besonderer Kapuze',
            'fr': 'Capuche spéciale',
            'it': 'Cappuccio speciale',
            'ko': '특별한 후드'
          },
          {
            'order': 1,
            'zh-cn': '领口',
            'en': 'collar',
            'zh-hant': '領口',
            'ja': 'ネックライン',
            'de': 'Ausschnitt',
            'fr': 'Encolure',
            'it': 'Scollo',
            'ko': '칼라'
          },
          {
            'order': 1,
            'zh-cn': '前胸',
            'en': 'front chest',
            'zh-hant': '前胸',
            'ja': '胸',
            'de': 'Brust',
            'fr': 'Poitrine',
            'it': 'Petto',
            'ko': '가슴'
          },
          {
            'order': 1,
            'zh-cn': '口袋',
            'en': 'pocket',
            'zh-hant': '口袋',
            'ja': 'ポケット',
            'de': 'Tasche',
            'fr': 'Poche',
            'it': 'Tasca',
            'ko': '주머니'
          },
          {
            'order': 1,
            'zh-cn': '暗袋',
            'en': 'hidden pocket',
            'zh-hant': '暗袋',
            'ja': '隠しポケット',
            'de': 'Verborgene Tasche',
            'fr': 'Poche cachée',
            'it': 'Tasca nascosta',
            'ko': '숨겨진 주머니'
          },
          {
            'order': 1,
            'zh-cn': '袋口',
            'en': 'pocket flap',
            'zh-hant': '袋口',
            'ja': 'ポケット口',
            'de': 'Taschenöffnung',
            'fr': 'Ouverture de poche',
            'it': 'Apertura della tasca',
            'ko': '주머니 덮개'
          },
          {
            'order': 1,
            'zh-cn': '立体袋',
            'en': '3d pocket',
            'zh-hant': '立體袋',
            'ja': '立体ポケット',
            'de': '3D-Tasche',
            'fr': 'Poche en relief',
            'it': 'Tasca tridimensionale',
            'ko': '입체 주머니'
          },
          {
            'order': 1,
            'zh-cn': '贴袋',
            'en': 'patch pocket',
            'zh-hant': '貼袋',
            'ja': 'パッチポケット',
            'de': 'Aufgesetzte Tasche',
            'fr': 'Poche plaquée',
            'it': 'Tasca applicata',
            'ko': '패치 포켓'
          },
          {
            'order': 1,
            'zh-cn': '多袋',
            'en': 'multiple pockets',
            'zh-hant': '多袋',
            'ja': '多ポケット',
            'de': 'Mehrere Taschen',
            'fr': 'Multi-poches',
            'it': 'Tasche multiple',
            'ko': '다중 주머니'
          },
          {
            'order': 1,
            'zh-cn': '双唇袋',
            'en': 'welcoming pocket',
            'zh-hant': '雙唇袋',
            'ja': 'ダブルウェルトポケット',
            'de': 'Doppelpaspeltasche',
            'fr': 'Poche passepoilée double',
            'it': 'Tasca a doppio filetto',
            'ko': '웰트 포켓'
          },
          {
            'order': 1,
            'zh-cn': '特色口袋',
            'en': 'distinctive pocket',
            'zh-hant': '特色口袋',
            'ja': '特徴的なポケット',
            'de': 'Besondere Tasche',
            'fr': 'Poche spéciale',
            'it': 'Tasca speciale',
            'ko': '특별한 주머니'
          },
          {
            'order': 1,
            'zh-cn': '前袋',
            'en': 'front pocket',
            'zh-hant': '前袋',
            'ja': 'フロントポケット',
            'de': 'Vordertasche',
            'fr': 'Poche avant',
            'it': 'Tasca anteriore',
            'ko': '앞주머니'
          },
          {
            'order': 1,
            'zh-cn': '袋鼠袋',
            'en': 'kangaroo pocket',
            'zh-hant': '袋鼠袋',
            'ja': 'カンガルーポケット',
            'de': 'Kängurutasche',
            'fr': 'Poche kangourou',
            'it': 'Tasca a marsupio',
            'ko': '캥거루 주머니'
          },
          {
            'order': 1,
            'zh-cn': '后袋',
            'en': 'back pocket',
            'zh-hant': '後袋',
            'ja': 'バックポケット',
            'de': 'Gesäßtasche',
            'fr': 'Poche arrière',
            'it': 'Tasca posteriore',
            'ko': '뒷주머니'
          },
          {
            'order': 1,
            'zh-cn': '插袋',
            'en': 'in-seam pocket',
            'zh-hant': '裏縫口袋',
            'ja': 'インシームポケット',
            'de': 'Nahttasche',
            'fr': 'Poche dans la couture',
            'it': 'Tasca nella cucitura',
            'ko': '솔기 주머니'
          },
          {
            'order': 1,
            'zh-cn': '脚口',
            'en': 'pant cuff',
            'zh-hant': '褲腳',
            'ja': 'パンツの裾',
            'de': 'Hosenaufschlag',
            'fr': 'Revers de pantalon',
            'it': 'Risvolto dei pantaloni',
            'ko': '바지 단'
          },
          {
            'order': 1,
            'zh-cn': '收脚',
            'en': 'gathered hem',
            'zh-hant': '聚攏下擺',
            'ja': 'ギャザー裾',
            'de': 'Geraffter Saum',
            'fr': 'Ourlet froncé',
            'it': 'Orlo arricciato',
            'ko': '주름 단'
          },
          {
            'order': 1,
            'zh-cn': '松紧脚口',
            'en': 'elasticized hem',
            'zh-hant': '彈性下擺',
            'ja': 'ゴム裾',
            'de': 'Elastischer Saum',
            'fr': 'Ourlet élastiqué',
            'it': 'Orlo elasticizzato',
            'ko': '고무줄 단'
          },
          {
            'order': 1,
            'zh-cn': '特殊脚口',
            'en': 'distinctive hem',
            'zh-hant': '獨特下擺',
            'ja': '特徴的な裾',
            'de': 'Markanter Saum',
            'fr': 'Ourlet distinctif',
            'it': 'Orlo distintivo',
            'ko': '특별한 단'
          },
          {
            'order': 1,
            'zh-cn': '毛边脚口',
            'en': 'frayed hem',
            'zh-hant': '毛邊褶',
            'ja': 'ほつれた裾',
            'de': 'Ausgefranster Saum',
            'fr': 'Ourlet effiloché',
            'it': 'Orlo sfrangiato',
            'ko': '올 풀린 단'
          },
          {
            'order': 1,
            'zh-cn': '抽绳脚口',
            'en': 'drawstring hem',
            'zh-hant': '抽繩下擺',
            'ja': 'ドローストリング裾',
            'de': 'Kordelzugsaum',
            'fr': 'Ourlet à cordon',
            'it': 'Orlo con coulisse',
            'ko': '끈 조임 단'
          },
          {
            'order': 1,
            'zh-cn': '双层脚口',
            'en': 'double-layered hem',
            'zh-hant': '雙層下擺',
            'ja': 'ダブルレイヤー裾',
            'de': 'Doppelter Saum',
            'fr': 'Ourlet à double couche',
            'it': 'Orlo a doppio strato',
            'ko': '이중 단'
          },
          {
            'order': 1,
            'zh-cn': '拉链脚口',
            'en': 'zippered hem',
            'zh-hant': '拉鍊下擺',
            'ja': 'ジッパー裾',
            'de': 'Reißverschluss-Saum',
            'fr': 'Ourlet zippé',
            'it': 'Orlo con cerniera',
            'ko': '지퍼 단'
          },
          {
            'order': 1,
            'zh-cn': '开叉脚口',
            'en': 'slit hem',
            'zh-hant': '開衩下擺',
            'ja': 'スリット裾',
            'de': 'Schlitzsaum',
            'fr': 'Ourlet fendu',
            'it': 'Orlo con spacco',
            'ko': '트임 단'
          },
          {
            'order': 1,
            'zh-cn': '侧缝',
            'en': 'side seam',
            'zh-hant': '側縫',
            'ja': 'サイドシーム',
            'de': 'Seitennähte',
            'fr': 'Couture latérale',
            'it': 'Cucitura laterale',
            'ko': '옆솔기'
          },
          {
            'order': 1,
            'zh-cn': '前中',
            'en': 'center front',
            'zh-hant': '中央前面',
            'ja': '中央フロント',
            'de': 'Vorderes Zentrum',
            'fr': 'Devant centre',
            'it': 'Centro davanti',
            'ko': '앞중심'
          },
          {
            'order': 1,
            'zh-cn': '袖口',
            'en': 'cuffs',
            'zh-hant': '袖口',
            'ja': 'カフス',
            'de': 'Manschetten',
            'fr': 'Poignets',
            'it': 'Polsini',
            'ko': '소매 단'
          },
          {
            'order': 1,
            'zh-cn': '门襟',
            'en': 'placket',
            'zh-hant': '門襟',
            'ja': 'プラケット',
            'de': 'Knopfleiste',
            'fr': 'Patte de boutonnage',
            'it': 'Abbottonatura',
            'ko': '플래킷'
          },
          {
            'order': 1,
            'zh-cn': '暗门襟',
            'en': 'hidden placket',
            'zh-hant': '隱藏門襟',
            'ja': '隠しプラケット',
            'de': 'Verdeckte Knopfleiste',
            'fr': 'Patte cachée',
            'it': 'Abbottonatura nascosta',
            'ko': '숨겨진 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '双排扣',
            'en': 'double-breasted placket',
            'zh-hant': '雙排扣門襟',
            'ja': 'ダブルブレストプラケット',
            'de': 'Doppelreihige Knopfleiste',
            'fr': 'Patte double boutonnage',
            'it': 'Abbottonatura doppiopetto',
            'ko': '더블 브레스트 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '斜门襟',
            'en': 'diagonal placket',
            'zh-hant': '斜門襟',
            'ja': '斜めプラケット',
            'de': 'Diagonale Knopfleiste',
            'fr': 'Patte diagonale',
            'it': 'Abbottonatura diagonale',
            'ko': '대각선 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '隐形门襟',
            'en': 'concealed placket',
            'zh-hant': '隱藏門襟',
            'ja': '隠されたプラケット',
            'de': 'Verdeckte Knopfleiste',
            'fr': 'Patte dissimulée',
            'it': 'Abbottonatura nascosta',
            'ko': '숨겨진 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '半开领/半门襟',
            'en': 'half-placket',
            'zh-hant': '半門襟',
            'ja': 'ハーフプラケット',
            'de': 'Halbe Knopfleiste',
            'fr': 'Demi-patte',
            'it': 'Mezza abbottonatura',
            'ko': '하프 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '双门襟',
            'en': 'double placket',
            'zh-hant': '雙門襟',
            'ja': 'ダブルプラケット',
            'de': 'Doppelte Knopfleiste',
            'fr': 'Patte double',
            'it': 'Doppia abbottonatura',
            'ko': '더블 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '村衫门襟',
            'en': 'traditional chinese-style placket',
            'zh-hant': '傳統中式門襟',
            'ja': '伝統的な中国風のプラケット',
            'de': 'Traditionelle chinesische Knopfleiste',
            'fr': 'Patte de style chinois traditionnel',
            'it': 'Abbottonatura in stile tradizionale cinese',
            'ko': '전통 중국식 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '开襟',
            'en': 'open placket',
            'zh-hant': '開放式門襟',
            'ja': 'オープンプラケット',
            'de': 'Offene Knopfleiste',
            'fr': 'Patte ouverte',
            'it': 'Abbottonatura aperta',
            'ko': '오픈 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '裤子特色门襟',
            'en': 'distinctive pant placket',
            'zh-hant': '獨特的褲門襟',
            'ja': '特徴的なパンツプラケット',
            'de': 'Markante Hosenknopfleiste',
            'fr': 'Patte de pantalon distinctive',
            'it': 'Abbottonatura distintiva dei pantaloni',
            'ko': '특별한 바지 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '特色门襟',
            'en': 'distinctive placket',
            'zh-hant': '獨特門襟',
            'ja': '特徴的なプラケット',
            'de': 'Markante Knopfleiste',
            'fr': 'Patte de boutonnage distinctive',
            'it': 'Abbottonatura distintiva',
            'ko': '특별한 플래킷'
          },
          {
            'order': 1,
            'zh-cn': '肩带',
            'en': 'shoulder straps',
            'zh-hant': '肩帶',
            'ja': '肩ストラップ',
            'de': 'Schulterträger',
            'fr': 'Bretelles',
            'it': 'Spalline',
            'ko': '어깨끈'
          },
          {
            'order': 1,
            'zh-cn': '不同材质肩带',
            'en': 'different material straps',
            'zh-hant': '不同材質肩帶',
            'ja': '異素材ストラップ',
            'de': 'Träger aus verschiedenen Materialien',
            'fr': 'Bretelles en matériaux différents',
            'it': 'Spalline in materiale diverso',
            'ko': '다른 소재 어깨끈'
          },
          {
            'order': 1,
            'zh-cn': '细肩带',
            'en': 'thin straps',
            'zh-hant': '細肩帶',
            'ja': '細ストラップ',
            'de': 'Dünne Träger',
            'fr': 'Bretelles fines',
            'it': 'Spalline sottili',
            'ko': '얇은 어깨끈'
          },
          {
            'order': 1,
            'zh-cn': '系带肩带',
            'en': 'tie straps',
            'zh-hant': '綁帶',
            'ja': 'タイストラップ',
            'de': 'Bindeträger',
            'fr': 'Bretelles à nouer',
            'it': 'Spalline con fiocco',
            'ko': '묶는 어깨끈'
          },
          {
            'order': 1,
            'zh-cn': '装饰肩带',
            'en': 'decorative straps',
            'zh-hant': '裝飾肩帶',
            'ja': '装飾ストラップ',
            'de': 'Dekorative Träger',
            'fr': 'Bretelles décoratives',
            'it': 'Spalline decorative',
            'ko': '장식 어깨끈'
          },
          {
            'order': 1,
            'zh-cn': '任意勾肩带',
            'en': 'adjustable hook straps',
            'zh-hant': '可調鉤肩帶',
            'ja': '調整可能なフックストラップ',
            'de': 'Verstellbare Haken-Träger',
            'fr': 'Bretelles réglables avec crochet',
            'it': 'Spalline regolabili con gancio',
            'ko': '조절 가능한 후크 어깨끈'
          },
          {
            'order': 1,
            'zh-cn': '宽肩带',
            'en': 'wide straps',
            'zh-hant': '寬肩帶',
            'ja': '幅広ストラップ',
            'de': 'Breite Träger',
            'fr': 'Bretelles larges',
            'it': 'Spalline larghe',
            'ko': '넓은 어깨끈'
          },
          {
            'order': 1,
            'zh-cn': '后幅',
            'en': 'back panel',
            'zh-hant': '後背/後片',
            'ja': '背中/バックパネル',
            'de': 'Rücken/Rückenpaneel',
            'fr': 'Dos/dos panneau',
            'it': 'Schiena/pannello posteriore',
            'ko': '등/뒷판'
          },
          {
            'order': 1,
            'zh-cn': '下摆',
            'en': 'hem',
            'zh-hant': '下擺',
            'ja': '裾',
            'de': 'Saum',
            'fr': 'Ourlet',
            'it': 'Orlo',
            'ko': '밑단'
          },
          {
            'order': 1,
            'zh-cn': '领部',
            'en': 'neckline',
            'zh-hant': '領口',
            'ja': 'ネックライン',
            'de': 'Ausschnitt',
            'fr': 'Encolure',
            'it': 'Scollo',
            'ko': '네크라인'
          },
          {
            'order': 1,
            'zh-cn': '青果领',
            'en': 'mandarin collar',
            'zh-hant': '立領',
            'ja': 'マンダリンカラー',
            'de': 'Stehkragen',
            'fr': 'Col mandarin',
            'it': 'Collo alla coreana',
            'ko': '차이나 칼라'
          },
          {
            'order': 1,
            'zh-cn': '立领',
            'en': 'stand-up collar',
            'zh-hant': '立領',
            'ja': 'スタンドカラー',
            'de': 'Stehkragen',
            'fr': 'Col montant',
            'it': 'Collo a montante',
            'ko': '스탠드 칼라'
          },
          {
            'order': 1,
            'zh-cn': '披肩领',
            'en': 'shawl collar',
            'zh-hant': '披肩領',
            'ja': 'ショールカラー',
            'de': 'Schalkragen',
            'fr': 'Col châle',
            'it': 'Collo a scialle',
            'ko': '숄 칼라'
          },
          {
            'order': 1,
            'zh-cn': '大翻领',
            'en': 'notched collar',
            'zh-hant': '平驳領',
            'ja': 'ノッチカラー',
            'de': 'Reverskragen',
            'fr': 'Col à cran',
            'it': 'Collo a lancia',
            'ko': '노치드 칼라'
          },
          {
            'order': 1,
            'zh-cn': 'POLO领',
            'en': 'polo collar',
            'zh-hant': 'Polo領',
            'ja': 'ポロカラー',
            'de': 'Polokragen',
            'fr': 'Col polo',
            'it': 'Collo polo',
            'ko': '폴로 칼라'
          },
          {
            'order': 1,
            'zh-cn': '平驳领',
            'en': 'notch lapel',
            'zh-hant': '平驳領',
            'ja': 'ノッチラペル',
            'de': 'Revers mit Kerbe',
            'fr': 'Revers à cran',
            'it': 'Revers a dente',
            'ko': '노치 라펠'
          },
          {
            'order': 1,
            'zh-cn': '棒球领',
            'en': 'baseball collar',
            'zh-hant': '棒球領',
            'ja': 'ベースボールカラー',
            'de': 'Baseballkragen',
            'fr': 'Col baseball',
            'it': 'Collo da baseball',
            'ko': '베이스볼 칼라'
          },
          {
            'order': 1,
            'zh-cn': '海军领',
            'en': 'navy collar',
            'zh-hant': '海軍領',
            'ja': 'ネイビーカラー',
            'de': 'Marinekragen',
            'fr': 'Col marin',
            'it': 'Collo alla marinara',
            'ko': '해군 칼라'
          },
          {
            'order': 1,
            'zh-cn': '风衣领',
            'en': 'trench collar',
            'zh-hant': '風衣領',
            'ja': 'トレンチカラー',
            'de': 'Trenchkragen',
            'fr': 'Col trench',
            'it': 'Collo da trench',
            'ko': '트렌치 칼라'
          },
          {
            'order': 1,
            'zh-cn': 'U领',
            'en': 'u-neck',
            'zh-hant': 'U型領',
            'ja': 'Uネック',
            'de': 'U-Ausschnitt',
            'fr': 'Col en U',
            'it': 'Scollo a U',
            'ko': 'U넥'
          },
          {
            'order': 1,
            'zh-cn': '枪驳领',
            'en': 'peak lapel',
            'zh-hant': '尖驳領',
            'ja': 'ピークラペル',
            'de': 'Spitzes Revers',
            'fr': 'Revers en pointe',
            'it': 'Revers a punta',
            'ko': '피크 라펠'
          },
          {
            'order': 1,
            'zh-cn': '西服领',
            'en': 'suit collar',
            'zh-hant': '西裝領',
            'ja': 'スーツカラー',
            'de': 'Anzugkragen',
            'fr': 'Col de costume',
            'it': 'Collo del completo',
            'ko': '수트 칼라'
          },
          {
            'order': 1,
            'zh-cn': '荷叶边领',
            'en': 'peter pan collar',
            'zh-hant': '彼得潘領',
            'ja': 'ピーターパンカラー',
            'de': 'Peter-Pan-Kragen',
            'fr': 'Col Claudine',
            'it': 'Collo Peter Pan',
            'ko': '피터팬 칼라'
          },
          {
            'order': 1,
            'zh-cn': '不对称领',
            'en': 'asymmetric collar',
            'zh-hant': '不對稱領',
            'ja': 'アシンメトリーカラー',
            'de': 'Asymmetrischer Kragen',
            'fr': 'Col asymétrique',
            'it': 'Collo asimmetrico',
            'ko': '비대칭 칼라'
          },
          {
            'order': 1,
            'zh-cn': '特色领口',
            'en': 'feature neckline',
            'zh-hant': '特色領口',
            'ja': '特徴的なネックライン',
            'de': 'Besondere Halslinie',
            'fr': 'Encolure distinctive',
            'it': 'Scollo caratteristico',
            'ko': '특색있는 넥라인'
          },
          {
            'order': 1,
            'zh-cn': '翻领',
            'en': 'fold-over collar',
            'zh-hant': '翻領',
            'ja': '折り返し襟',
            'de': 'Umlegekragen',
            'fr': 'Col rabattu',
            'it': 'Collo ripiegato',
            'ko': '접이 칼라'
          },
          {
            'order': 1,
            'zh-cn': '圆领',
            'en': 'round neck',
            'zh-hant': '圓領',
            'ja': '丸首',
            'de': 'Rundhalsausschnitt',
            'fr': 'Encolure ronde',
            'it': 'Scollo tondo',
            'ko': '라운드넥'
          },
          {
            'order': 1,
            'zh-cn': '系结领',
            'en': 'tie neck',
            'zh-hant': '系帶領',
            'ja': 'タイネック',
            'de': 'Schleifenkragen',
            'fr': 'Col cravate',
            'it': 'Collo a fiocco',
            'ko': '타이넥'
          },
          {
            'order': 1,
            'zh-cn': '毛领',
            'en': 'fur collar',
            'zh-hant': '毛皮領',
            'ja': 'ファーカラー',
            'de': 'Pelzkragen',
            'fr': 'Col en fourrure',
            'it': 'Collo di pelliccia',
            'ko': '퍼 칼라'
          },
          {
            'order': 1,
            'zh-cn': '深',
            'en': 'v deep v-neck',
            'zh-hant': '深V領',
            'ja': '深Vネック',
            'de': 'Tiefer V-Ausschnitt',
            'fr': 'Col V profond',
            'it': 'Scollo a V profondo',
            'ko': '깊은 V넥'
          },
          {
            'order': 1,
            'zh-cn': 'V领',
            'en': 'v-neck',
            'zh-hant': 'V領',
            'ja': 'Vネック',
            'de': 'V-Ausschnitt',
            'fr': 'Col en V',
            'it': 'Scollo a V',
            'ko': 'V넥'
          },
          {
            'order': 1,
            'zh-cn': '方型领',
            'en': 'square neck',
            'zh-hant': '方領',
            'ja': 'スクエアネック',
            'de': 'Quadratischer Ausschnitt',
            'fr': 'Encolure carrée',
            'it': 'Scollo quadrato',
            'ko': '스퀘어넥'
          },
          {
            'order': 1,
            'zh-cn': '高领',
            'en': 'turtleneck',
            'zh-hant': '高領',
            'ja': 'タートルネック',
            'de': 'Rollkragen',
            'fr': 'Col roulé',
            'it': 'Dolcevita',
            'ko': '터틀넥'
          },
          {
            'order': 1,
            'zh-cn': '无领',
            'en': 'collarless',
            'zh-hant': '無領',
            'ja': 'ノーカラー',
            'de': 'Kragenlos',
            'fr': 'Sans col',
            'it': 'Senza colletto',
            'ko': '칼라리스'
          },
          {
            'order': 1,
            'zh-cn': '亨利领',
            'en': 'henley neckline',
            'zh-hant': '亨利領',
            'ja': 'ヘンリーネックライン',
            'de': 'Henley-Ausschnitt',
            'fr': 'Encolure Henley',
            'it': 'Scollo Henley',
            'ko': '헨리넥'
          },
          {
            'order': 1,
            'zh-cn': '双层领',
            'en': 'double collar',
            'zh-hant': '雙層領',
            'ja': 'ダブルカラー',
            'de': 'Doppelkragen',
            'fr': 'Double col',
            'it': 'Doppio colletto',
            'ko': '더블 칼라'
          },
          {
            'order': 1,
            'zh-cn': '尖角领',
            'en': 'wing collar',
            'zh-hant': '翅領',
            'ja': 'ウィングカラー',
            'de': 'Flügelkragen',
            'fr': 'Col ailé',
            'it': 'Collo ad aletta',
            'ko': '윙 칼라'
          },
          {
            'order': 1,
            'zh-cn': '西装领',
            'en': 'blazer collar',
            'zh-hant': '西裝領',
            'ja': 'ブレザーカラー',
            'de': 'Blazerkargen',
            'fr': 'Col de blazer',
            'it': 'Collo da blazer',
            'ko': '블레이저 칼라'
          },
          {
            'order': 1,
            'zh-cn': '和服领',
            'en': 'kimono collar',
            'zh-hant': '和服領',
            'ja': '着物カラー',
            'de': 'Kimonokragen',
            'fr': 'Col kimono',
            'it': 'Collo kimono',
            'ko': '기모노 칼라'
          },
          {
            'order': 1,
            'zh-cn': '荡领',
            'en': 'drape neck',
            'zh-hant': '垂領',
            'ja': 'ドレープネック',
            'de': 'Wasserfallkragen',
            'fr': 'Encolure drapée',
            'it': 'Scollo drappeggiato',
            'ko': '드레이프 넥'
          },
          {
            'order': 1,
            'zh-cn': '边缘',
            'en': 'edge',
            'zh-hant': '邊緣',
            'ja': 'エッジ',
            'de': 'Kante',
            'fr': 'Bord',
            'it': 'Bordo',
            'ko': '가장자리'
          },
          {
            'order': 1,
            'zh-cn': '包边',
            'en': 'bound edge',
            'zh-hant': '包邊',
            'ja': 'バインディングエッジ',
            'de': 'Eingefasste Kante',
            'fr': 'Bord gansé',
            'it': 'Bordo rilegato',
            'ko': '바인딩 엣지'
          },
          {
            'order': 1,
            'zh-cn': '嵌条',
            'en': 'piping',
            'zh-hant': '滾邊',
            'ja': 'パイピング',
            'de': 'Paspel',
            'fr': 'Passepoil',
            'it': 'Profilo',
            'ko': '파이핑'
          },
          {
            'order': 1,
            'zh-cn': '无规则边缘',
            'en': 'raw edge',
            'zh-hant': '毛邊',
            'ja': 'ローエッジ',
            'de': 'Rohe Kante',
            'fr': 'Bord brut',
            'it': 'Bordo grezzo',
            'ko': '로우 엣지'
          },
          {
            'order': 1,
            'zh-cn': '翻边',
            'en': 'fold-over',
            'zh-hant': '折疊',
            'ja': 'フォールドオーバー',
            'de': 'Umschlag',
            'fr': 'Replié',
            'it': 'Ripiegato',
            'ko': '접어 올린 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '蕾丝边',
            'en': 'lace edge',
            'zh-hant': '彼得潘領',
            'ja': 'ピーターパンカラー',
            'de': 'Peter-Pan-Kragen',
            'fr': 'Col Claudine',
            'it': 'Collo Peter Pan',
            'ko': '레이스 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '织带边',
            'en': 'woven tape edge',
            'zh-hant': '不對稱領',
            'ja': 'アシンメトリーカラー',
            'de': 'Asymmetrischer Kragen',
            'fr': 'Col asymétrique',
            'it': 'Collo asimmetrico',
            'ko': '직조 테이프 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '压边',
            'en': 'rolled edge',
            'zh-hant': '特色領口',
            'ja': '特徴的なネックライン',
            'de': 'Besondere Halslinie',
            'fr': 'Encolure distinctive',
            'it': 'Scollo caratteristico',
            'ko': '말린 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '毛边',
            'en': 'frilly edge',
            'zh-hant': '翻領',
            'ja': '折り返し襟',
            'de': 'Umlegekragen',
            'fr': 'Col rabattu',
            'it': 'Collo ripiegato',
            'ko': '프릴 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '齿边',
            'en': 'serrated edge',
            'zh-hant': '圓領',
            'ja': '丸首',
            'de': 'Rundhalsausschnitt',
            'fr': 'Encolure ronde',
            'it': 'Scollo tondo',
            'ko': '톱니 모양 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '拉链边',
            'en': 'zipper edge',
            'zh-hant': '系帶領',
            'ja': 'タイネック',
            'de': 'Schleifenkragen',
            'fr': 'Col cravate',
            'it': 'Collo a fiocco',
            'ko': '지퍼 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '蝴蝶边',
            'en': 'butterfly edge',
            'zh-hant': '毛皮領',
            'ja': 'ファーカラー',
            'de': 'Pelzkragen',
            'fr': 'Col en fourrure',
            'it': 'Collo di pelliccia',
            'ko': '나비 모양 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '空心边',
            'en': 'cutout edge',
            'zh-hant': '深V領',
            'ja': '深Vネック',
            'de': 'Tiefer V-Ausschnitt',
            'fr': 'Col V profond',
            'it': 'Scollo a V profondo',
            'ko': '컷아웃 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '双色边',
            'en': 'two-tone edge',
            'zh-hant': 'V領',
            'ja': 'Vネック',
            'de': 'V-Ausschnitt',
            'fr': 'Col en V',
            'it': 'Scollo a V',
            'ko': '투톤 가장자리'
          },
          {
            'order': 1,
            'zh-cn': '夹穹',
            'en': 'gusset',
            'zh-hant': '方領',
            'ja': 'スクエアネック',
            'de': 'Quadratischer Ausschnitt',
            'fr': 'Encolure carrée',
            'it': 'Scollo quadrato',
            'ko': '거싯'
          },
          {
            'order': 1,
            'zh-cn': '袖子',
            'en': 'sleeves',
            'zh-hant': '高領',
            'ja': 'タートルネック',
            'de': 'Rollkragen',
            'fr': 'Col roulé',
            'it': 'Dolcevita',
            'ko': '소매'
          },
          {
            'order': 1,
            'zh-cn': '灯笼袖',
            'en': 'lantern sleeve',
            'zh-hant': '無領',
            'ja': 'ノーカラー',
            'de': 'Kragenlos',
            'fr': 'Sans col',
            'it': 'Senza colletto',
            'ko': '랜턴 소매'
          },
          {
            'order': 1,
            'zh-cn': '中长抽',
            'en': 'bishop sleeve',
            'zh-hant': '亨利領',
            'ja': 'ヘンリーネックライン',
            'de': 'Henley-Ausschnitt',
            'fr': 'Encolure Henley',
            'it': 'Scollo Henley',
            'ko': '비숍 소매'
          },
          {
            'order': 1,
            'zh-cn': '花苞袖',
            'en': 'cap sleeve',
            'zh-hant': '雙層領',
            'ja': 'ダブルカラー',
            'de': 'Doppelkragen',
            'fr': 'Double col',
            'it': 'Doppio colletto',
            'ko': '캡 소매'
          },
          {
            'order': 1,
            'zh-cn': '衬衫袖',
            'en': 'shirt sleeve',
            'zh-hant': '翅領',
            'ja': 'ウィングカラー',
            'de': 'Flügelkragen',
            'fr': 'Col ailé',
            'it': 'Collo ad aletta',
            'ko': '셔츠 소매'
          },
          {
            'order': 1,
            'zh-cn': '喇叭袖',
            'en': 'bell sleeve',
            'zh-hant': '西裝領',
            'ja': 'ブレザーカラー',
            'de': 'Blazerkargen',
            'fr': 'Col de blazer',
            'it': 'Collo da blazer',
            'ko': '벨 소매'
          },
          {
            'order': 1,
            'zh-cn': '莲藕袖',
            'en': 'lotus sleeve',
            'zh-hant': '和服領',
            'ja': '着物カラー',
            'de': 'Kimonokragen',
            'fr': 'Col kimono',
            'it': 'Collo kimono',
            'ko': '연꽃 소매'
          },
          {
            'order': 1,
            'zh-cn': '短袖',
            'en': 'short sleeve',
            'zh-hant': '垂領',
            'ja': 'ドレープネック',
            'de': 'Wasserfallkragen',
            'fr': 'Encolure drapée',
            'it': 'Scollo drappeggiato',
            'ko': '반소매'
          },
          {
            'order': 1,
            'zh-cn': '泡泡袖',
            'en': 'puff sleeve',
            'zh-hant': '邊緣',
            'ja': 'エッジ',
            'de': 'Kante',
            'fr': 'Bord',
            'it': 'Bordo',
            'ko': '퍼프 소매'
          },
          {
            'order': 1,
            'zh-cn': '拼接袖子',
            'en': 'patchwork sleeve',
            'zh-hant': '包邊',
            'ja': 'バインディングエッジ',
            'de': 'Eingefasste Kante',
            'fr': 'Bord gansé',
            'it': 'Bordo rilegato',
            'ko': '패치워크 소매'
          },
          {
            'order': 1,
            'zh-cn': '长袖',
            'en': 'long sleeve',
            'zh-hant': '滾邊',
            'ja': 'パイピング',
            'de': 'Paspel',
            'fr': 'Passepoil',
            'it': 'Profilo',
            'ko': '긴소매'
          },
          {
            'order': 1,
            'zh-cn': '超长袖',
            'en': 'extra-long sleeve',
            'zh-hant': '毛邊',
            'ja': 'ローエッジ',
            'de': 'Rohe Kante',
            'fr': 'Bord brut',
            'it': 'Bordo grezzo',
            'ko': '엑스트라 롱 소매'
          },
          {
            'order': 1,
            'zh-cn': '特色袖子',
            'en': 'statement sleeve',
            'zh-hant': '翻折邊',
            'ja': '折り返し',
            'de': 'Umschlag',
            'fr': 'Replié',
            'it': 'Ripiegato',
            'ko': '스테이트먼트 소매'
          },
          {
            'order': 1,
            'zh-cn': '插肩袖',
            'en': 'drop shoulder sleeve',
            'zh-hant': '低肩袖',
            'ja': 'ドロップショルダースリーブ',
            'de': 'Tiefer angesetzter Ärmel',
            'fr': 'Manche à épaule tombante',
            'it': 'Manica a spalla scesa',
            'ko': '드롭 숄더 소매'
          },
          {
            'order': 1,
            'zh-cn': '露指袖',
            'en': 'thumbhole sleeve',
            'zh-hant': '拇指孔袖',
            'ja': 'サムホールスリーブ',
            'de': 'Daumenlochärmel',
            'fr': 'Manche avec trou pour le pouce',
            'it': 'Manica con foro per il pollice',
            'ko': '엄지구멍 소매'
          },
          {
            'order': 1,
            'zh-cn': '落肩被',
            'en': 'slouchy sleeve',
            'zh-hant': '寬鬆袖',
            'ja': 'ルーズスリーブ',
            'de': 'Schluffiger Ärmel',
            'fr': 'Manche ample',
            'it': 'Manica larga',
            'ko': '슬러치 소매'
          },
          {
            'order': 1,
            'zh-cn': '袖肘袖',
            'en': 'elbow sleeve',
            'zh-hant': '肘袖',
            'ja': 'エルボースリーブ',
            'de': 'Ellenbogenärmel',
            'fr': 'Manche au coude',
            'it': 'Manica al gomito',
            'ko': '엘보우 소매'
          },
          {
            'order': 1,
            'zh-cn': '特殊袖口',
            'en': 'special cuff',
            'zh-hant': '特殊袖口',
            'ja': '特別なカフス',
            'de': 'Besonderer Manschette',
            'fr': 'Poignet spécial',
            'it': 'Polsino speciale',
            'ko': '특수 커프스'
          },
          {
            'order': 1,
            'zh-cn': '背勾',
            'en': 'back hook',
            'zh-hant': '後掛鉤',
            'ja': 'バックフック',
            'de': 'Rückenverschluss',
            'fr': 'Crochet arrière',
            'it': 'Gancio posteriore',
            'ko': '백 훅'
          },
          {
            'order': 1,
            'zh-cn': '裤腿',
            'en': 'pant leg',
            'zh-hant': '褲腿',
            'ja': 'パンツレッグ',
            'de': 'Hosenbein',
            'fr': 'Jambe de pantalon',
            'it': 'Gamba dei pantaloni',
            'ko': '바지 다리'
          },
          {
            'order': 1,
            'zh-cn': '腰部',
            'en': 'waist',
            'zh-hant': '腰部',
            'ja': 'ウエスト',
            'de': 'Taille',
            'fr': 'Taille',
            'it': 'Vita',
            'ko': '허리'
          },
          {
            'order': 1,
            'zh-cn': '束腰',
            'en': 'waist cinching',
            'zh-hant': '束腰',
            'ja': 'ウエストシンチング',
            'de': 'Taillenbetonung',
            'fr': 'Cintrage de la taille',
            'it': 'Stringivita',
            'ko': '허리 조임'
          },
          {
            'order': 1,
            'zh-cn': '加宽腰部',
            'en': 'wide waistband',
            'zh-hant': '寬腰帶',
            'ja': 'ワイドウエストバンド',
            'de': 'Breiter Taillenbund',
            'fr': 'Large ceinture',
            'it': 'Ampia fascia in vita',
            'ko': '와이드 웨이스트밴드'
          },
          {
            'order': 1,
            'zh-cn': '皮带运用',
            'en': 'belted waist',
            'zh-hant': '腰帶腰',
            'ja': 'ベルト付きウエスト',
            'de': 'Taillengürtel',
            'fr': 'Taille ceinturée',
            'it': 'Vita con cintura',
            'ko': '벨티드 웨이스트'
          },
          {
            'order': 1,
            'zh-cn': '松紧带腰头',
            'en': 'elastic waistband',
            'zh-hant': '彈性腰帶',
            'ja': 'ゴムウエストバンド',
            'de': 'Elastischer Taillenbund',
            'fr': 'Ceinture élastique',
            'it': 'Fascia elastica in vita',
            'ko': '고무줄 허리밴드'
          },
          {
            'order': 1,
            'zh-cn': '抽绳腰头',
            'en': 'drawstring waist',
            'zh-hant': '抽繩腰',
            'ja': 'ドローストリングウエスト',
            'de': 'Taillenkordelzug',
            'fr': 'Taille à cordon',
            'it': 'Vita con coulisse',
            'ko': '끈 조임 허리'
          },
          {
            'order': 1,
            'zh-cn': '双层摇头',
            'en': 'double-buckle closure',
            'zh-hant': '雙扣閉合',
            'ja': 'ダブルバックル閉鎖',
            'de': 'Doppelverschluss mit Schnalle',
            'fr': 'Fermeture à double boucle',
            'it': 'Chiusura a doppia fibbia',
            'ko': '더블 버클 잠금'
          },
          {
            'order': 1,
            'zh-cn': '里布/内里',
            'en': 'lining',
            'zh-hant': '裡襯',
            'ja': '裏地',
            'de': 'Futter',
            'fr': 'Doublure',
            'it': 'Fodera',
            'ko': '안감'
          },
          {
            'order': 1,
            'zh-cn': '模杯',
            'en': 'molded cup',
            'zh-hant': '模壓杯',
            'ja': 'モールドカップ',
            'de': 'Vorgeformtes Körbchen',
            'fr': 'Bonnet moulé',
            'it': 'Coppa sagomata',
            'ko': '몰드 컵'
          },
          {
            'order': 1,
            'zh-cn': '鸡心',
            'en': 'chest embroidery',
            'zh-hant': '胸部刺繡',
            'ja': '胸部刺繍',
            'de': 'Bruststickerei',
            'fr': 'Broderie poitrine',
            'it': 'Ricamo sul petto',
            'ko': '가슴 자수'
          },
          {
            'order': 1,
            'zh-cn': '下脚',
            'en': 'hem',
            'zh-hant': '下擺',
            'ja': '裾',
            'de': 'Saum',
            'fr': 'Ourlet',
            'it': 'Orlo',
            'ko': '밑단'
          },
          {
            'order': 1,
            'zh-cn': '腰头',
            'en': 'waistband',
            'zh-hant': '腰帶',
            'ja': 'ウエストバンド',
            'de': 'Taillenbund',
            'fr': 'Ceinture',
            'it': 'Fascia in vita',
            'ko': '허리밴드'
          },
          {
            'order': 1,
            'zh-cn': '松紧腰头',
            'en': 'elastic waist',
            'zh-hant': '彈性腰',
            'ja': 'ゴムウエスト',
            'de': 'Elastische Taille',
            'fr': 'Taille élastique',
            'it': 'Vita elastica',
            'ko': '고무줄 허리'
          }
        ]
      }
    ]
  },
  {
    'order': 1,
    'name': { 'zh-cn': '穿搭风格', en: 'Outfit Style', 'zh-hant': '穿搭風格', ja: 'スタイリング', de: 'Kleidungsstil', fr: 'Style vestimentaire', it: 'Stile d\'abbigliamento', ko: '의상 스타일' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '风格风貌', en: 'Style and Appearance', 'zh-hant': '風格風貌', ja: 'スタイルと風貌', de: 'Stil und Erscheinungsbild', fr: 'Style et apparence', it: 'Stile e aspetto', ko: '스타일과 외모' },
        'list': [
          {
            'order': 1,
            'zh-cn': '小香风',
            'en': 'Chanel Style',
            'zh-hant': '香奈兒風格',
            'ja': 'シャネルスタイル',
            'de': 'Chanel-Stil',
            'fr': 'Style Chanel',
            'it': 'Stile Chanel',
            'ko': '샤넬 스타일'
          },
          {
            'order': 1,
            'zh-cn': 'Y2K',
            'en': 'Y2K',
            'zh-hant': 'Y2K風格',
            'ja': 'Y2Kスタイル',
            'de': 'Y2K-Stil',
            'fr': 'Style Y2K',
            'it': 'Stile Y2K',
            'ko': 'Y2K 스타일'
          },
          {
            'order': 1,
            'zh-cn': '纯欲风',
            'en': 'Minimalism',
            'zh-hant': '極簡主義',
            'ja': 'ミニマリズム',
            'de': 'Minimalismus',
            'fr': 'Minimalisme',
            'it': 'Minimalismo',
            'ko': '미니멀리즘'
          },
          {
            'order': 1,
            'zh-cn': '快时尚',
            'en': 'Fast Fashion',
            'zh-hant': '快時尚',
            'ja': 'ファストファッション',
            'de': 'Fast Fashion',
            'fr': 'Mode rapide',
            'it': 'Fast Fashion',
            'ko': '패스트 패션'
          },
          {
            'order': 1,
            'zh-cn': '雅痞',
            'en': 'Yuppie',
            'zh-hant': '雅痞',
            'ja': 'ヤッピー',
            'de': 'Yuppie',
            'fr': 'Yuppie',
            'it': 'Yuppie',
            'ko': '야피'
          },
          {
            'order': 1,
            'zh-cn': '学院',
            'en': 'Preppy',
            'zh-hant': '學院風',
            'ja': 'プレッピー',
            'de': 'Preppy-Stil',
            'fr': 'Style Preppy',
            'it': 'Stile Preppy',
            'ko': '프레피 스타일'
          },
          {
            'order': 1,
            'zh-cn': '极简风',
            'en': 'Minimalist Style',
            'zh-hant': '極簡風格',
            'ja': 'ミニマリストスタイル',
            'de': 'Minimalistischer Stil',
            'fr': 'Style minimaliste',
            'it': 'Stile minimalista',
            'ko': '미니멀리스트 스타일'
          },
          {
            'order': 1,
            'zh-cn': '甜酷风',
            'en': 'Sweet and Cool',
            'zh-hant': '甜酷風',
            'ja': 'スイート&クール',
            'de': 'Süß und cool',
            'fr': 'Style doux et cool',
            'it': 'Dolce e cool',
            'ko': '스윗 앤 쿨'
          },
          {
            'order': 1,
            'zh-cn': '千禧风',
            'en': 'Millennial Style',
            'zh-hant': '千禧風格',
            'ja': 'ミレニアルスタイル',
            'de': 'Millennial-Stil',
            'fr': 'Style Millénaire',
            'it': 'Stile Millennial',
            'ko': '밀레니얼 스타일'
          },
          {
            'order': 1,
            'zh-cn': '元宇宙',
            'en': 'Metaverse',
            'zh-hant': '元宇宙',
            'ja': 'メタバース',
            'de': 'Metaverse',
            'fr': 'Métavers',
            'it': 'Metaverso',
            'ko': '메타버스'
          },
          {
            'order': 1,
            'zh-cn': '轻熟',
            'en': 'Light Mature',
            'zh-hant': '輕熟風',
            'ja': 'ライトマチュア',
            'de': 'Leichter reifer Stil',
            'fr': 'Style mature léger',
            'it': 'Stile maturo leggero',
            'ko': '라이트 성숙'
          },
          {
            'order': 1,
            'zh-cn': '摇滚',
            'en': 'Rock Style',
            'zh-hant': '搖滾風格',
            'ja': 'ロックスタイル',
            'de': 'Rockstil',
            'fr': 'Style rock',
            'it': 'Stile rock',
            'ko': '록 스타일'
          },
          {
            'order': 1,
            'zh-cn': '轻奢',
            'en': 'Luxury Casual',
            'zh-hant': '奢華休閒',
            'ja': 'ラグジュアリーカジュアル',
            'de': 'Luxus-Casual',
            'fr': 'Luxe décontracté',
            'it': 'Lusso casual',
            'ko': '럭셔리 캐주얼'
          },
          {
            'order': 1,
            'zh-cn': '辣妹风',
            'en': 'Girl Power',
            'zh-hant': '女力風',
            'ja': 'ガールパワー',
            'de': 'Mädchen-Power',
            'fr': 'Pouvoir féminin',
            'it': 'Potere delle ragazze',
            'ko': '걸 파워'
          },
          {
            'order': 1,
            'zh-cn': 'City boy',
            'en': 'City boy',
            'zh-hant': '城市男孩風',
            'ja': 'シティボーイ',
            'de': 'Cityboy',
            'fr': 'Garçon de la ville',
            'it': 'Stile City Boy',
            'ko': '시티보이'
          },
          {
            'order': 1,
            'zh-cn': '多巴胺',
            'en': 'Dopamine',
            'zh-hant': '多巴胺風格',
            'ja': 'ドーパミン',
            'de': 'Dopamin',
            'fr': 'Dopamine',
            'it': 'Dopamina',
            'ko': '도파민'
          },
          {
            'order': 1,
            'zh-cn': '芭蕾风',
            'en': 'Balletcore',
            'zh-hant': '芭蕾風',
            'ja': 'バレエコア',
            'de': 'Balletcore',
            'fr': 'Balletcore',
            'it': 'Balletcore',
            'ko': '발레코어'
          },
          {
            'order': 1,
            'zh-cn': '甜美',
            'en': 'Sweet Style',
            'zh-hant': '甜美風格',
            'ja': 'スイートスタイル',
            'de': 'Süßer Stil',
            'fr': 'Style doux',
            'it': 'Stile dolce',
            'ko': '스위트 스타일'
          },
          {
            'order': 1,
            'zh-cn': '柔美',
            'en': 'Soft Style',
            'zh-hant': '柔和風',
            'ja': 'ソフトスタイル',
            'de': 'Weicher Stil',
            'fr': 'Style doux',
            'it': 'Stile morbido',
            'ko': '소프트 스타일'
          },
          {
            'order': 1,
            'zh-cn': '新中式',
            'en': 'New Chinese Style',
            'zh-hant': '新中式風格',
            'ja': '新中国風スタイル',
            'de': 'Neuer chinesischer Stil',
            'fr': 'Nouveau style chinois',
            'it': 'Nuovo stile cinese',
            'ko': '뉴 차이니즈 스타일'
          },
          {
            'order': 1,
            'zh-cn': '美式',
            'en': 'American Style',
            'zh-hant': '美式風格',
            'ja': 'アメリカンスタイル',
            'de': 'Amerikanischer Stil',
            'fr': 'Style américain',
            'it': 'Stile americano',
            'ko': '아메리칸 스타일'
          },
          {
            'order': 1,
            'zh-cn': '朋克',
            'en': 'Punk Style',
            'zh-hant': '朋克風格',
            'ja': 'パンクスタイル',
            'de': 'Punkstil',
            'fr': 'Style punk',
            'it': 'Stile punk',
            'ko': '펑크 스타일'
          },
          {
            'order': 1,
            'zh-cn': '知识分子风',
            'en': 'Intellectual Style',
            'zh-hant': '知性風格',
            'ja': 'インテリジェントスタイル',
            'de': 'Intellektueller Stil',
            'fr': 'Style intellectuel',
            'it': 'Stile intellettuale',
            'ko': '지식인 스타일'
          },
          {
            'order': 1,
            'zh-cn': '优雅',
            'en': 'Elegant',
            'zh-hant': '優雅風格',
            'ja': 'エレガント',
            'de': 'Elegant',
            'fr': 'Élégant',
            'it': 'Elegante',
            'ko': '우아한'
          },
          {
            'order': 1,
            'zh-cn': '靓仔',
            'en': 'Fashionable Man',
            'zh-hant': '時尚男士',
            'ja': 'ファッショナブルな男性',
            'de': 'Modebewusster Mann',
            'fr': 'Homme à la mode',
            'it': 'Uomo alla moda',
            'ko': '패셔너블한 남성'
          },
          {
            'order': 1,
            'zh-cn': '废土风',
            'en': 'Post-Apocalyptic Style',
            'zh-hant': '末日風格',
            'ja': 'ポストアポカリプススタイル',
            'de': 'Postapokalyptischer Stil',
            'fr': 'Style post-apocalyptique',
            'it': 'Stile post-apocalittico',
            'ko': '포스트 아포칼립스 스타일'
          },
          {
            'order': 1,
            'zh-cn': '轻商务',
            'en': 'Casual Business',
            'zh-hant': '商務休閒',
            'ja': 'カジュアルビジネス',
            'de': 'Business Casual',
            'fr': 'Business décontracté',
            'it': 'Business casual',
            'ko': '캐주얼 비즈니스'
          },
          {
            'order': 1,
            'zh-cn': '北欧风',
            'en': 'Nordic Style',
            'zh-hant': '北歐風格',
            'ja': '北欧スタイル',
            'de': 'Nordischer Stil',
            'fr': 'Style nordique',
            'it': 'Stile nordico',
            'ko': '노르딕 스타일'
          },
          {
            'order': 1,
            'zh-cn': '游牧风',
            'en': 'Nomadic Style',
            'zh-hant': '遊牧風格',
            'ja': '遊牧スタイル',
            'de': 'Nomadenstil',
            'fr': 'Style nomade',
            'it': 'Stile nomade',
            'ko': '유목민 스타일'
          },
          {
            'order': 1,
            'zh-cn': '宫廷风',
            'en': 'Court Style',
            'zh-hant': '宮廷風格',
            'ja': '宮廷スタイル',
            'de': 'Hofstil',
            'fr': 'Style cour',
            'it': 'Stile da corte',
            'ko': '궁정 스타일'
          },
          {
            'order': 1,
            'zh-cn': '工装',
            'en': 'Workwear',
            'zh-hant': '工裝風',
            'ja': 'ワークウェア',
            'de': 'Arbeitskleidung',
            'fr': 'Vêtements de travail',
            'it': 'Abbigliamento da lavoro',
            'ko': '워크웨어'
          },
          {
            'order': 1,
            'zh-cn': '侘寂风',
            'en': 'Wabi-Sabi Style',
            'zh-hant': '侘寂風',
            'ja': '侘寂スタイル',
            'de': 'Wabi-Sabi-Stil',
            'fr': 'Style wabi-sabi',
            'it': 'Stile wabi-sabi',
            'ko': '와비사비 스타일'
          },
          {
            'order': 1,
            'zh-cn': 'INS风',
            'en': 'Instagram Style',
            'zh-hant': 'Instagram風格',
            'ja': 'Instagramスタイル',
            'de': 'Instagram-Stil',
            'fr': 'Style Instagram',
            'it': 'Stile Instagram',
            'ko': '인스타그램 스타일'
          },
          {
            'order': 1,
            'zh-cn': '舒适',
            'en': 'Comfortable',
            'zh-hant': '舒適風',
            'ja': '快適',
            'de': 'Bequem',
            'fr': 'Confortable',
            'it': 'Confortevole',
            'ko': '편안한'
          },
          {
            'order': 1,
            'zh-cn': '日韩风',
            'en': 'Japanese and Korean Style',
            'zh-hant': '日韓風格',
            'ja': '日韓スタイル',
            'de': 'Japanischer und koreanischer Stil',
            'fr': 'Style japonais et coréen',
            'it': 'Stile giapponese e coreano',
            'ko': '한일 스타일'
          },
          {
            'order': 1,
            'zh-cn': '元气少女风',
            'en': 'Fresh and Girly',
            'zh-hant': '清新少女風',
            'ja': 'フレッシュでガーリー',
            'de': 'Frisch und mädchenhaft',
            'fr': 'Frais et girly',
            'it': 'Fresco e femminile',
            'ko': '발랄한 소녀 스타일'
          },
          {
            'order': 1,
            'zh-cn': '健康运动风',
            'en': 'Active and Healthy',
            'zh-hant': '活力健康風',
            'ja': 'アクティブで健康的',
            'de': 'Aktiv und gesund',
            'fr': 'Actif et sain',
            'it': 'Attivo e sano',
            'ko': '액티브 앤 헬시'
          },
          {
            'order': 1,
            'zh-cn': '城市运动风',
            'en': 'Urban Sporty',
            'zh-hant': '都市運動風',
            'ja': '都市スポーティ',
            'de': 'Urbaner Sportstil',
            'fr': 'Sportif urbain',
            'it': 'Sportivo urbano',
            'ko': '어반 스포티'
          },
          {
            'order': 1,
            'zh-cn': '复古风',
            'en': 'Vintage Style',
            'zh-hant': '復古風',
            'ja': 'ヴィンテージスタイル',
            'de': 'Vintage-Stil',
            'fr': 'Style vintage',
            'it': 'Stile vintage',
            'ko': '빈티지 스타일'
          },
          {
            'order': 1,
            'zh-cn': '中国风',
            'en': 'Chinese Style',
            'zh-hant': '中國風',
            'ja': '中国風',
            'de': 'Chinesischer Stil',
            'fr': 'Style chinois',
            'it': 'Stile cinese',
            'ko': '차이니즈 스타일'
          },
          {
            'order': 1,
            'zh-cn': '女性主义风',
            'en': 'Feminist Style',
            'zh-hant': '女權風格',
            'ja': 'フェミニストスタイル',
            'de': 'Feministischer Stil',
            'fr': 'Style féministe',
            'it': 'Stile femminista',
            'ko': '페미니스트 스타일'
          },
          {
            'order': 1,
            'zh-cn': '阳光海岛风',
            'en': 'Sunny Beach',
            'zh-hant': '陽光海灘風',
            'ja': 'サニービーチ',
            'de': 'Sonniger Strand',
            'fr': 'Plage ensoleillée',
            'it': 'Spiaggia soleggiata',
            'ko': '써니 비치'
          },
          {
            'order': 1,
            'zh-cn': '花花公子风',
            'en': 'Playboy Style',
            'zh-hant': '花花公子風',
            'ja': 'プレイボーイスタイル',
            'de': 'Playboy-Stil',
            'fr': 'Style playboy',
            'it': 'Stile playboy',
            'ko': '플레이보이 스타일'
          },
          {
            'order': 1,
            'zh-cn': '贵族风',
            'en': 'Noble and Aristocratic',
            'zh-hant': '貴族風',
            'ja': '高貴なアリストクラティック',
            'de': 'Edler und aristokratischer Stil',
            'fr': 'Noble et aristocratique',
            'it': 'Nobile e aristocratico',
            'ko': '귀족 스타일'
          },
          {
            'order': 1,
            'zh-cn': '都市丽人',
            'en': 'Sophisticated Urban Chic',
            'zh-hant': '精緻都市時尚',
            'ja': '洗練された都会のシック',
            'de': 'Raffinierter urbaner Chic',
            'fr': 'Chic urbain sophistiqué',
            'it': 'Chic urbano sofisticato',
            'ko': '세련된 어반 시크'
          },
          {
            'order': 1,
            'zh-cn': '摩登复古',
            'en': 'Modern Vintage',
            'zh-hant': '現代復古',
            'ja': 'モダンヴィンテージ',
            'de': 'Moderner Vintage',
            'fr': 'Vintage moderne',
            'it': 'Vintage moderno',
            'ko': '모던 빈티지'
          },
          {
            'order': 1,
            'zh-cn': '工艺感风',
            'en': 'Artsy Style',
            'zh-hant': '藝術風格',
            'ja': 'アーティスティックスタイル',
            'de': 'Künstlerischer Stil',
            'fr': 'Style artistique',
            'it': 'Stile artistico',
            'ko': '아티스틱 스타일'
          },
          {
            'order': 1,
            'zh-cn': '街头运动风',
            'en': 'Street Sports',
            'zh-hant': '街頭運動',
            'ja': 'ストリートスポーツ',
            'de': 'Street Sports',
            'fr': 'Sports de rue',
            'it': 'Sport da strada',
            'ko': '스트리트 스포츠'
          },
          {
            'order': 1,
            'zh-cn': '家居休闲风',
            'en': 'Home Leisure',
            'zh-hant': '家居休閒',
            'ja': 'ホームレジャー',
            'de': 'Hausfreizeit',
            'fr': 'Loisirs à la maison',
            'it': 'Tempo libero a casa',
            'ko': '홈 레저'
          },
          {
            'order': 1,
            'zh-cn': '独立摇滚',
            'en': 'Indie Rock',
            'zh-hant': '獨立搖滾',
            'ja': 'インディーロック',
            'de': 'Indie-Rock',
            'fr': 'Rock indépendant',
            'it': 'Indie rock',
            'ko': '인디 록'
          },
          {
            'order': 1,
            'zh-cn': '小清新',
            'en': 'Fresh and Clean',
            'zh-hant': '清新簡潔',
            'ja': 'フレッシュでクリーン',
            'de': 'Frisch und sauber',
            'fr': 'Frais et propre',
            'it': 'Fresco e pulito',
            'ko': '프레시 앤 클린'
          },
          {
            'order': 1,
            'zh-cn': '老钱风',
            'en': 'Old Money Style',
            'zh-hant': '老錢風格',
            'ja': 'オールドマネースタイル',
            'de': 'Alter Geldstil',
            'fr': 'Style vieille richesse',
            'it': 'Stile vecchi soldi',
            'ko': '올드 머니 스타일'
          },
          {
            'order': 1,
            'zh-cn': '奶奶风',
            'en': 'Grandma Chic',
            'zh-hant': '奶奶時尚',
            'ja': 'グランマシック',
            'de': 'Oma-Schick',
            'fr': 'Chic grand-mère',
            'it': 'Chic da nonna',
            'ko': '그랜마 시크'
          },
          {
            'order': 1,
            'zh-cn': '德国工匠',
            'en': 'Germanic Crafts',
            'zh-hant': '日耳曼工藝',
            'ja': 'ゲルマン工芸',
            'de': 'Germanische Handwerkskunst',
            'fr': 'Artisanat germanique',
            'it': 'Artigianato germanico',
            'ko': '게르만 공예'
          },
          {
            'order': 1,
            'zh-cn': '童话王国',
            'en': 'Fairytale Kingdom',
            'zh-hant': '童話王國',
            'ja': 'フェアリーテイルキングダム',
            'de': 'Märchenkönigreich',
            'fr': 'Royaume féerique',
            'it': 'Regno delle fiabe',
            'ko': '동화 왕국'
          },
          {
            'order': 1,
            'zh-cn': '意大利风情',
            'en': 'Italian Style',
            'zh-hant': '意大利風格',
            'ja': 'イタリアンスタイル',
            'de': 'Italienischer Stil',
            'fr': 'Style italien',
            'it': 'Stile italiano',
            'ko': '이탈리안 스타일'
          },
          {
            'order': 1,
            'zh-cn': '波西米亚风',
            'en': 'Bohemian Style',
            'zh-hant': '波西米亞風格',
            'ja': 'ボヘミアンスタイル',
            'de': 'Bohemian Stil',
            'fr': 'Style bohémien',
            'it': 'Stile bohemien',
            'ko': '보헤미안 스타일'
          },
          {
            'order': 1,
            'zh-cn': '复古波西米亚',
            'en': 'Retro Bohemian',
            'zh-hant': '復古波西米亞',
            'ja': 'レトロボヘミアン',
            'de': 'Retro-Bohemian',
            'fr': 'Bohème rétro',
            'it': 'Bohemien retrò',
            'ko': '레트로 보헤미안'
          },
          {
            'order': 1,
            'zh-cn': '70年代复古',
            'en': '70s Retro',
            'zh-hant': '70年代復古',
            'ja': '70年代レトロ',
            'de': '70er Retro',
            'fr': 'Rétro des années 70',
            'it': 'Anni \'70 retrò',
            'ko': '70년대 레트로'
          },
          {
            'order': 1,
            'zh-cn': '格子风',
            'en': 'Plaid Style',
            'zh-hant': '格子風格',
            'ja': 'チェック柄スタイル',
            'de': 'Karo-Stil',
            'fr': 'Style à carreaux',
            'it': 'Stile a quadri',
            'ko': '체크 스타일'
          },
          {
            'order': 1,
            'zh-cn': '刺绣风',
            'en': 'Embroidery Style',
            'zh-hant': '刺繡風格',
            'ja': '刺繍スタイル',
            'de': 'Stickereistil',
            'fr': 'Style broderie',
            'it': 'Stile ricamo',
            'ko': '자수 스타일'
          },
          {
            'order': 1,
            'zh-cn': '大胆印花',
            'en': 'Bold Prints',
            'zh-hant': '大膽印花',
            'ja': '大胆なプリント',
            'de': 'Fett gedruckte Muster',
            'fr': 'Imprimés audacieux',
            'it': 'Stampe audaci',
            'ko': '볼드 프린트'
          },
          {
            'order': 1,
            'zh-cn': '运动休闲',
            'en': 'Athleisure',
            'zh-hant': '運動休閒',
            'ja': 'アスレジャー',
            'de': 'Athleisure',
            'fr': 'Athleisure',
            'it': 'Athleisure',
            'ko': '애슬레저'
          },
          {
            'order': 1,
            'zh-cn': '病态美学',
            'en': 'Sickly Aesthetic',
            'zh-hant': '病態美學',
            'ja': '病的な美学',
            'de': 'Kränkliche Ästhetik',
            'fr': 'Esthétique maladive',
            'it': 'Estetica malata',
            'ko': '병적인 미학'
          },
          {
            'order': 1,
            'zh-cn': '韩范儿',
            'en': 'Korean Style',
            'zh-hant': '韓風',
            'ja': '韓国スタイル',
            'de': 'Koreanischer Stil',
            'fr': 'Style coréen',
            'it': 'Stile coreano',
            'ko': '한국 스타일'
          },
          {
            'order': 1,
            'zh-cn': '日系潮流',
            'en': 'Japanese Streetwear',
            'zh-hant': '日本街頭服飾',
            'ja': '日本のストリートウェア',
            'de': 'Japanische Straßenmode',
            'fr': 'Streetwear japonais',
            'it': 'Streetwear giapponese',
            'ko': '일본 스트리트웨어'
          },
          {
            'order': 1,
            'zh-cn': '西班牙风情',
            'en': 'Spanish Style',
            'zh-hant': '西班牙風格',
            'ja': 'スペイン風',
            'de': 'Spanischer Stil',
            'fr': 'Style espagnol',
            'it': 'Stile spagnolo',
            'ko': '스페인 스타일'
          },
          {
            'order': 1,
            'zh-cn': '巴洛克式装饰',
            'en': 'Baroque Decoration',
            'zh-hant': '巴洛克裝飾',
            'ja': 'バロック装飾',
            'de': 'Barockdekoration',
            'fr': 'Décoration baroque',
            'it': 'Decorazione barocca',
            'ko': '바로크 장식'
          },
          {
            'order': 1,
            'zh-cn': '前卫摇滚',
            'en': 'Avant-garde Rock',
            'zh-hant': '前衛搖滾',
            'ja': 'アバンギャルドロック',
            'de': 'Avantgarde-Rock',
            'fr': 'Rock avant-gardiste',
            'it': 'Rock d\'avanguardia',
            'ko': '아방가르드 록'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '造型穿搭', en: 'Outfit and Styling', 'zh-hant': '造型穿搭', ja: 'スタイリングとコーディネート', de: 'Outfit und Styling', fr: 'Tenue et stylisme', it: 'Abbigliamento e stile', ko: '스타일링과 코디네이션' },
        'list': [
          {
            'order': 1,
            'zh-cn': '民族',
            'en': 'Ethnic',
            'zh-hant': '民族風',
            'ja': 'エスニック',
            'de': 'Ethnisch',
            'fr': 'Ethnique',
            'it': 'Etnico',
            'ko': '민족'
          },
          {
            'order': 1,
            'zh-cn': '棉麻',
            'en': 'Cotton and Linen',
            'zh-hant': '棉麻',
            'ja': 'コットンとリネン',
            'de': 'Baumwolle und Leinen',
            'fr': 'Coton et lin',
            'it': 'Cotone e lino',
            'ko': '면마'
          },
          {
            'order': 1,
            'zh-cn': '解构',
            'en': 'Deconstruction',
            'zh-hant': '解構',
            'ja': 'デコンストラクション',
            'de': 'Dekonstruktion',
            'fr': 'Déconstruction',
            'it': 'Decostruzione',
            'ko': '해체'
          },
          {
            'order': 1,
            'zh-cn': '旗袍',
            'en': 'Cheongsam',
            'zh-hant': '旗袍',
            'ja': 'チャイナドレス',
            'de': 'Cheongsam',
            'fr': 'Qipao',
            'it': 'Qipao',
            'ko': '치파오'
          },
          {
            'order': 1,
            'zh-cn': '赛博朋克',
            'en': 'Cyberpunk',
            'zh-hant': '賽博朋克',
            'ja': 'サイバーパンク',
            'de': 'Cyberpunk',
            'fr': 'Cyberpunk',
            'it': 'Cyberpunk',
            'ko': '사이버펑크'
          },
          {
            'order': 1,
            'zh-cn': '微潮',
            'en': 'Micro Trend',
            'zh-hant': '微趨勢',
            'ja': 'マイクロトレンド',
            'de': 'Mikrotrend',
            'fr': 'Micro tendance',
            'it': 'Micro tendenza',
            'ko': '마이크로 트렌드'
          },
          {
            'order': 1,
            'zh-cn': '度假',
            'en': 'Resort',
            'zh-hant': '度假風',
            'ja': 'リゾート',
            'de': 'Resort',
            'fr': 'Resort',
            'it': 'Resort',
            'ko': '리조트'
          },
          {
            'order': 1,
            'zh-cn': '潮牌',
            'en': 'Streetwear',
            'zh-hant': '街頭風',
            'ja': 'ストリートウェア',
            'de': 'Streetwear',
            'fr': 'Streetwear',
            'it': 'Streetwear',
            'ko': '스트리트웨어'
          },
          {
            'order': 1,
            'zh-cn': '前卫',
            'en': 'Avant-garde',
            'zh-hant': '前衛風',
            'ja': 'アバンギャルド',
            'de': 'Avantgarde',
            'fr': 'Avant-garde',
            'it': 'Avanguardia',
            'ko': '아방가르드'
          },
          {
            'order': 1,
            'zh-cn': '森女',
            'en': 'Forest Girl',
            'zh-hant': '森系',
            'ja': 'フォレストガール',
            'de': 'Waldmädchen',
            'fr': 'Fille de la forêt',
            'it': 'Ragazza della foresta',
            'ko': '포레스트 걸'
          },
          {
            'order': 1,
            'zh-cn': '汉服',
            'en': 'Hanfu',
            'zh-hant': '漢服',
            'ja': '漢服',
            'de': 'Hanfu',
            'fr': 'Hanfu',
            'it': 'Hanfu',
            'ko': '한복'
          },
          {
            'order': 1,
            'zh-cn': '未来',
            'en': 'Futuristic',
            'zh-hant': '未來風',
            'ja': 'フューチャリスティック',
            'de': 'Futuristisch',
            'fr': 'Futuriste',
            'it': 'Futuristico',
            'ko': '미래적'
          },
          {
            'order': 1,
            'zh-cn': 'clean fit',
            'en': 'clean fit',
            'zh-hant': '清爽合身',
            'ja': 'クリーンフィット',
            'de': 'Sauberer Schnitt',
            'fr': 'Coupe propre',
            'it': 'Vestibilità pulita',
            'ko': '클린 핏'
          },
          {
            'order': 1,
            'zh-cn': '英伦',
            'en': 'British Style',
            'zh-hant': '英倫風',
            'ja': 'ブリティッシュスタイル',
            'de': 'Britischer Stil',
            'fr': 'Style britannique',
            'it': 'Stile britannico',
            'ko': '브리티시 스타일'
          },
          {
            'order': 1,
            'zh-cn': '情趣',
            'en': 'Sensual',
            'zh-hant': '性感風',
            'ja': 'センシュアル',
            'de': 'Sinnlich',
            'fr': 'Sensuel',
            'it': 'Sensuale',
            'ko': '관능적'
          },
          {
            'order': 1,
            'zh-cn': '国潮',
            'en': 'Chinese Style',
            'zh-hant': '中國風',
            'ja': '中国風',
            'de': 'Chinesischer Stil',
            'fr': 'Style chinois',
            'it': 'Stile cinese',
            'ko': '중국 스타일'
          },
          {
            'order': 1,
            'zh-cn': '文艺',
            'en': 'Artsy',
            'zh-hant': '藝術風',
            'ja': 'アート系',
            'de': 'Künstlerisch',
            'fr': 'Artistique',
            'it': 'Artistico',
            'ko': '예술적'
          },
          {
            'order': 1,
            'zh-cn': '趣味',
            'en': 'Fun',
            'zh-hant': '趣味風',
            'ja': 'ファン',
            'de': 'Spaßig',
            'fr': 'Amusant',
            'it': 'Divertente',
            'ko': '재미있는'
          },
          {
            'order': 1,
            'zh-cn': '韩系',
            'en': 'Korean Style',
            'zh-hant': '韓風',
            'ja': '韓国スタイル',
            'de': 'Koreanischer Stil',
            'fr': 'Style coréen',
            'it': 'Stile coreano',
            'ko': '한국 스타일'
          },
          {
            'order': 1,
            'zh-cn': '波西米亚',
            'en': 'Bohemian',
            'zh-hant': '波西米亞風',
            'ja': 'ボヘミアン',
            'de': 'Bohemien',
            'fr': 'Bohémien',
            'it': 'Bohemien',
            'ko': '보헤미안'
          },
          {
            'order': 1,
            'zh-cn': '性感',
            'en': 'Sexy',
            'zh-hant': '性感風',
            'ja': 'セクシー',
            'de': 'Sexy',
            'fr': 'Sexy',
            'it': 'Sexy',
            'ko': '섹시'
          },
          {
            'order': 1,
            'zh-cn': '田园',
            'en': 'Countryside',
            'zh-hant': '鄉村風',
            'ja': 'カントリースタイル',
            'de': 'Landstil',
            'fr': 'Style campagnard',
            'it': 'Stile campagna',
            'ko': '전원 스타일'
          },
          {
            'order': 1,
            'zh-cn': '日系',
            'en': 'Japanese Style',
            'zh-hant': '日式風格',
            'ja': '日本スタイル',
            'de': 'Japanischer Stil',
            'fr': 'Style japonais',
            'it': 'Stile giapponese',
            'ko': '일본 스타일'
          },
          {
            'order': 1,
            'zh-cn': '少女',
            'en': 'Girl\'s Style',
            'zh-hant': '少女風',
            'ja': 'ガールズスタイル',
            'de': 'Mädchenstil',
            'fr': 'Style fille',
            'it': 'Stile ragazza',
            'ko': '소녀 스타일'
          },
          {
            'order': 1,
            'zh-cn': '透视',
            'en': 'Transparency',
            'zh-hant': '透明風',
            'ja': '透け感',
            'de': 'Transparenz',
            'fr': 'Transparence',
            'it': 'Trasparenza',
            'ko': '시스루'
          },
          {
            'order': 1,
            'zh-cn': '男女同款',
            'en': 'Unisex',
            'zh-hant': '中性風',
            'ja': 'ユニセックス',
            'de': 'Unisex',
            'fr': 'Unisexe',
            'it': 'Unisex',
            'ko': '유니섹스'
          },
          {
            'order': 1,
            'zh-cn': '浪漫',
            'en': 'Romantic',
            'zh-hant': '浪漫風',
            'ja': 'ロマンチック',
            'de': 'Romantisch',
            'fr': 'Romantique',
            'it': 'Romantico',
            'ko': '로맨틱'
          },
          {
            'order': 1,
            'zh-cn': '情侣',
            'en': 'Couple\'s Style',
            'zh-hant': '情侶風',
            'ja': 'カップルスタイル',
            'de': 'Paarstil',
            'fr': 'Style de couple',
            'it': 'Stile di coppia',
            'ko': '커플 스타일'
          },
          {
            'order': 1,
            'zh-cn': '暗黑',
            'en': 'Gothic',
            'zh-hant': '哥德風',
            'ja': 'ゴシック',
            'de': 'Gotisch',
            'fr': 'Gothique',
            'it': 'Gotico',
            'ko': '고딕'
          },
          {
            'order': 1,
            'zh-cn': '简欧',
            'en': 'Simple European',
            'zh-hant': '簡約歐洲風',
            'ja': 'シンプルなヨーロッパ風',
            'de': 'Einfacher europäischer Stil',
            'fr': 'Style européen simple',
            'it': 'Stile europeo semplice',
            'ko': '심플 유럽 스타일'
          },
          {
            'order': 1,
            'zh-cn': '少淑/淑女',
            'en': 'Ladylike style',
            'zh-hant': '淑女風',
            'ja': 'レディライクスタイル',
            'de': 'Damenhafter Stil',
            'fr': 'Style féminin',
            'it': 'Stile signorile',
            'ko': '숙녀 스타일'
          },
          {
            'order': 1,
            'zh-cn': '小众潮牌',
            'en': 'Niche Brands',
            'zh-hant': '小眾品牌',
            'ja': 'ニッチブランド',
            'de': 'Nischenmarken',
            'fr': 'Marques de niche',
            'it': 'Marchi di nicchia',
            'ko': '니치 브랜드'
          },
          {
            'order': 1,
            'zh-cn': '情侣穿搭',
            'en': 'Matching Couple\'s Outfits',
            'zh-hant': '情侶裝',
            'ja': 'お揃いのカップル服',
            'de': 'Passende Partneroutfits',
            'fr': 'Tenues assorties pour couples',
            'it': 'Abiti coordinati per coppie',
            'ko': '커플 매칭 의상'
          },
          {
            'order': 1,
            'zh-cn': '巴洛克',
            'en': 'Baroque',
            'zh-hant': '巴洛克風格',
            'ja': 'バロック',
            'de': 'Barock',
            'fr': 'Baroque',
            'it': 'Barocco',
            'ko': '바로크'
          },
          {
            'order': 1,
            'zh-cn': '复古',
            'en': 'Retro',
            'zh-hant': '復古風',
            'ja': 'レトロ',
            'de': 'Retro',
            'fr': 'Rétro',
            'it': 'Retrò',
            'ko': '레트로'
          },
          {
            'order': 1,
            'zh-cn': '国风',
            'en': 'Chinese Style',
            'zh-hant': '中國風',
            'ja': '中国風',
            'de': 'Chinesischer Stil',
            'fr': 'Style chinois',
            'it': 'Stile cinese',
            'ko': '중국풍'
          },
          {
            'order': 1,
            'zh-cn': '西部风格',
            'en': 'Western Style',
            'zh-hant': '西部風',
            'ja': '西部スタイル',
            'de': 'Westernstil',
            'fr': 'Style western',
            'it': 'Stile western',
            'ko': '웨스턴 스타일'
          },
          {
            'order': 1,
            'zh-cn': '法式',
            'en': 'French Style',
            'zh-hant': '法式風格',
            'ja': 'フランス風',
            'de': 'Französischer Stil',
            'fr': 'Style français',
            'it': 'Stile francese',
            'ko': '프렌치 스타일'
          },
          {
            'order': 1,
            'zh-cn': 'IP联名',
            'en': 'IP Collaborations',
            'zh-hant': 'IP聯名',
            'ja': 'IPコラボレーション',
            'de': 'IP-Kollaborationen',
            'fr': 'Collaborations IP',
            'it': 'Collaborazioni IP',
            'ko': 'IP 콜라보레이션'
          },
          {
            'order': 1,
            'zh-cn': '哥特风',
            'en': 'Gothic Style',
            'zh-hant': '哥德風格',
            'ja': 'ゴシックスタイル',
            'de': 'Gotikstil',
            'fr': 'Style gothique',
            'it': 'Stile gotico',
            'ko': '고딕 스타일'
          },
          {
            'order': 1,
            'zh-cn': '邋遢摇滚风',
            'en': 'Messy Rock Style',
            'zh-hant': '混亂搖滾風',
            'ja': '混沌としたロックスタイル',
            'de': 'Chaotischer Rockstil',
            'fr': 'Style rock désordonné',
            'it': 'Stile rock disordinato',
            'ko': '지저분한 록 스타일'
          },
          {
            'order': 1,
            'zh-cn': '田园摇滚风',
            'en': 'Rustic Rock Style',
            'zh-hant': '鄉村搖滾風',
            'ja': '田舎風ロックスタイル',
            'de': 'Rustikaler Rockstil',
            'fr': 'Style rock rustique',
            'it': 'Stile rock rustico',
            'ko': '전원 록 스타일'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '场合', en: 'Occasion', 'zh-hant': '場合', ja: '場合', de: 'Anlass', fr: 'Occasion', it: 'Occasione', ko: '상황' },
        'list': [
          {
            'order': 1,
            'zh-cn': '时装',
            'en': 'Fashion',
            'zh-hant': '時尚',
            'ja': 'ファッション',
            'de': 'Mode',
            'fr': 'Mode',
            'it': 'Moda',
            'ko': '패션'
          },
          {
            'order': 1,
            'zh-cn': '海边沙滩',
            'en': 'Beachwear',
            'zh-hant': '海灘裝',
            'ja': 'ビーチウェア',
            'de': 'Strandkleidung',
            'fr': 'Tenue de plage',
            'it': 'Abbigliamento da spiaggia',
            'ko': '비치웨어'
          },
          {
            'order': 1,
            'zh-cn': '商务',
            'en': 'Business',
            'zh-hant': '商務',
            'ja': 'ビジネス',
            'de': 'Geschäftlich',
            'fr': 'Affaires',
            'it': 'Business',
            'ko': '비즈니스'
          },
          {
            'order': 1,
            'zh-cn': '都市',
            'en': 'Urban',
            'zh-hant': '都市',
            'ja': 'アーバン',
            'de': 'Urban',
            'fr': 'Urbain',
            'it': 'Urbano',
            'ko': '도시'
          },
          {
            'order': 1,
            'zh-cn': '通勤',
            'en': 'Commute',
            'zh-hant': '通勤',
            'ja': '通勤',
            'de': 'Pendeln',
            'fr': 'Commute',
            'it': 'Pendolarismo',
            'ko': '통근'
          },
          {
            'order': 1,
            'zh-cn': '休闲',
            'en': 'Casual',
            'zh-hant': '休閒',
            'ja': 'カジュアル',
            'de': 'Freizeit',
            'fr': 'Décontracté',
            'it': 'Casual',
            'ko': '캐주얼'
          },
          {
            'order': 1,
            'zh-cn': '户外',
            'en': 'Outdoor',
            'zh-hant': '戶外',
            'ja': 'アウトドア',
            'de': 'Outdoor',
            'fr': 'Plein air',
            'it': 'Outdoor',
            'ko': '아웃도어'
          },
          {
            'order': 1,
            'zh-cn': '无性别',
            'en': 'Unisex',
            'zh-hant': '中性風',
            'ja': 'ユニセックス',
            'de': 'Unisex',
            'fr': 'Unisexe',
            'it': 'Unisex',
            'ko': '유니섹스'
          },
          {
            'order': 1,
            'zh-cn': '街头',
            'en': 'Streetwear',
            'zh-hant': '街頭風',
            'ja': 'ストリートウェア',
            'de': 'Streetwear',
            'fr': 'Streetwear',
            'it': 'Streetwear',
            'ko': '스트리트웨어'
          },
          {
            'order': 1,
            'zh-cn': '军装风',
            'en': 'Military Style',
            'zh-hant': '軍事風格',
            'ja': 'ミリタリースタイル',
            'de': 'Militärstil',
            'fr': 'Style militaire',
            'it': 'Stile militare',
            'ko': '밀리터리 스타일'
          },
          {
            'order': 1,
            'zh-cn': '新年限定',
            'en': 'New Year\'s Limited',
            'zh-hant': '新年限定',
            'ja': '新年限定',
            'de': 'Neujahrsedition',
            'fr': 'Édition limitée du Nouvel An',
            'it': 'Edizione limitata di Capodanno',
            'ko': '신년 한정'
          },
          {
            'order': 1,
            'zh-cn': '中性',
            'en': 'Neutral',
            'zh-hant': '中性風',
            'ja': 'ニュートラル',
            'de': 'Neutral',
            'fr': 'Neutre',
            'it': 'Neutro',
            'ko': '중성'
          },
          {
            'order': 1,
            'zh-cn': '派对',
            'en': 'Party',
            'zh-hant': '派對',
            'ja': 'パーティー',
            'de': 'Party',
            'fr': 'Fête',
            'it': 'Festa',
            'ko': '파티'
          },
          {
            'order': 1,
            'zh-cn': '情人节限定',
            'en': 'Valentine\'s Day Limited',
            'zh-hant': '情人節限定',
            'ja': 'バレンタイン限定',
            'de': 'Valentinstag-Edition',
            'fr': 'Édition limitée de la Saint-Valentin',
            'it': 'Edizione limitata di San Valentino',
            'ko': '발렌타인데이 한정'
          },
          {
            'order': 1,
            'zh-cn': '运动',
            'en': 'Athletic',
            'zh-hant': '運動',
            'ja': 'アスレチック',
            'de': 'Athletik',
            'fr': 'Athlétique',
            'it': 'Atletica',
            'ko': '운동'
          },
          {
            'order': 1,
            'zh-cn': '居家',
            'en': 'Loungewear',
            'zh-hant': '居家服',
            'ja': 'ルームウェア',
            'de': 'Loungewear',
            'fr': 'Vêtements de détente',
            'it': 'Abbigliamento da casa',
            'ko': '홈웨어'
          },
          {
            'order': 1,
            'zh-cn': '简约',
            'en': 'Minimalist',
            'zh-hant': '極簡風',
            'ja': 'ミニマリスト',
            'de': 'Minimalistisch',
            'fr': 'Minimaliste',
            'it': 'Minimalista',
            'ko': '미니멀리스트'
          },
          {
            'order': 1,
            'zh-cn': '婚礼/正式场合',
            'en': 'Wedding/Formal Occasions',
            'zh-hant': '婚禮/正式場合',
            'ja': '結婚式/フォーマルな場面',
            'de': 'Hochzeit/Formelle Anlässe',
            'fr': 'Mariage/Occasions formelles',
            'it': 'Matrimonio/Occasioni formali',
            'ko': '결혼식/정장'
          },
          {
            'order': 1,
            'zh-cn': '舞蹈/表演',
            'en': 'Dance/Performance',
            'zh-hant': '舞蹈/表演',
            'ja': 'ダンス/パフォーマンス',
            'de': 'Tanz/Aufführung',
            'fr': 'Danse/Performance',
            'it': 'Danza/Performance',
            'ko': '댄스/공연'
          },
          {
            'order': 1,
            'zh-cn': '活动/节日',
            'en': 'Events/Festivals',
            'zh-hant': '活動/節日',
            'ja': 'イベント/フェスティバル',
            'de': 'Veranstaltungen/Festivals',
            'fr': 'Événements/Festivals',
            'it': 'Eventi/Festival',
            'ko': '이벤트/축제'
          },
          {
            'order': 1,
            'zh-cn': '旅游',
            'en': 'Travel',
            'zh-hant': '旅行',
            'ja': '旅行',
            'de': 'Reisen',
            'fr': 'Voyage',
            'it': 'Viaggio',
            'ko': '여행'
          },
          {
            'order': 1,
            'zh-cn': '职业',
            'en': 'Occupational',
            'zh-hant': '職業裝',
            'ja': '職業',
            'de': 'Berufsbekleidung',
            'fr': 'Professionnel',
            'it': 'Professionale',
            'ko': '직업'
          },
          {
            'order': 1,
            'zh-cn': '宗教仪式',
            'en': 'Religious Ceremonies',
            'zh-hant': '宗教儀式',
            'ja': '宗教儀式',
            'de': 'Religiöse Zeremonien',
            'fr': 'Cérémonies religieuses',
            'it': 'Cerimonie religiose',
            'ko': '종교 의식'
          },
          {
            'order': 1,
            'zh-cn': '室内/家庭聚会',
            'en': 'Indoor/Home Gathering',
            'zh-hant': '室內/家庭聚會',
            'ja': '室内/ホームギャザリング',
            'de': 'Indoor/Häusliche Versammlung',
            'fr': 'Réunion intérieure/domestique',
            'it': 'Riunione interna/domestica',
            'ko': '실내/가정 모임'
          },
          {
            'order': 1,
            'zh-cn': '夜生活',
            'en': 'Nightlife',
            'zh-hant': '夜生活',
            'ja': 'ナイトライフ',
            'de': 'Nachtleben',
            'fr': 'Vie nocturne',
            'it': 'Vita notturna',
            'ko': '나이트라이프'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '运动', en: 'Sports', 'zh-hant': '運動', ja: 'スポーツ', de: 'Sport', fr: 'Sports', it: 'Sport', ko: '스포츠' },
        'list': [
          {
            'order': 1,
            'zh-cn': '山系风',
            'en': 'Mountain Style',
            'zh-hant': '山地風格',
            'ja': 'マウンテンスタイル',
            'de': 'Bergstil',
            'fr': 'Style montagne',
            'it': 'Stile montagna',
            'ko': '마운틴 스타일'
          },
          {
            'order': 1,
            'zh-cn': '高尔夫运动',
            'en': 'Golf',
            'zh-hant': '高爾夫',
            'ja': 'ゴルフ',
            'de': 'Golf',
            'fr': 'Golf',
            'it': 'Golf',
            'ko': '골프'
          },
          {
            'order': 1,
            'zh-cn': '世界杯',
            'en': 'World Cup',
            'zh-hant': '世界盃',
            'ja': 'ワールドカップ',
            'de': 'Weltmeisterschaft',
            'fr': 'Coupe du Monde',
            'it': 'Coppa del Mondo',
            'ko': '월드컵'
          },
          {
            'order': 1,
            'zh-cn': '骑行',
            'en': 'Cycling',
            'zh-hant': '騎行',
            'ja': 'サイクリング',
            'de': 'Radfahren',
            'fr': 'Cyclisme',
            'it': 'Ciclismo',
            'ko': '사이클링'
          },
          {
            'order': 1,
            'zh-cn': '竞技/赛车',
            'en': 'Athletic/Racing',
            'zh-hant': '運動/賽車',
            'ja': 'アスレチック/レーシング',
            'de': 'Sport/Rennen',
            'fr': 'Athlétisme/Course',
            'it': 'Atletica/Corsa',
            'ko': '육상/레이싱'
          },
          {
            'order': 1,
            'zh-cn': '垂钓',
            'en': 'Fishing',
            'zh-hant': '釣魚',
            'ja': '釣り',
            'de': 'Angeln',
            'fr': 'Pêche',
            'it': 'Pesca',
            'ko': '낚시'
          },
          {
            'order': 1,
            'zh-cn': '冲浪',
            'en': 'Surfing',
            'zh-hant': '衝浪',
            'ja': 'サーフィン',
            'de': 'Surfen',
            'fr': 'Surf',
            'it': 'Surf',
            'ko': '서핑'
          },
          {
            'order': 1,
            'zh-cn': '足球',
            'en': 'Football/Soccer',
            'zh-hant': '足球',
            'ja': 'サッカー',
            'de': 'Fußball',
            'fr': 'Football',
            'it': 'Calcio',
            'ko': '축구'
          },
          {
            'order': 1,
            'zh-cn': '机能风',
            'en': 'Technical Style',
            'zh-hant': '技術風格',
            'ja': 'テクニカルスタイル',
            'de': 'Technischer Stil',
            'fr': 'Style technique',
            'it': 'Stile tecnico',
            'ko': '테크니컬 스타일'
          },
          {
            'order': 1,
            'zh-cn': '徒步',
            'en': 'Hiking/Trekking',
            'zh-hant': '徒步/登山',
            'ja': 'ハイキング/トレッキング',
            'de': 'Wandern/Trekking',
            'fr': 'Randonnée/Trekking',
            'it': 'Escursionismo/Trekking',
            'ko': '하이킹/트레킹'
          },
          {
            'order': 1,
            'zh-cn': '篮球',
            'en': 'Basketball',
            'zh-hant': '籃球',
            'ja': 'バスケットボール',
            'de': 'Basketball',
            'fr': 'Basketball',
            'it': 'Basket',
            'ko': '농구'
          },
          {
            'order': 1,
            'zh-cn': '攀岩',
            'en': 'Rock Climbing',
            'zh-hant': '攀岩',
            'ja': 'ロッククライミング',
            'de': 'Klettern',
            'fr': 'Escalade',
            'it': 'Arrampicata',
            'ko': '암벽등반'
          },
          {
            'order': 1,
            'zh-cn': '跑步训练',
            'en': 'Running',
            'zh-hant': '跑步',
            'ja': 'ランニング',
            'de': 'Laufen',
            'fr': 'Course à pied',
            'it': 'Corsa',
            'ko': '달리기'
          },
          {
            'order': 1,
            'zh-cn': '滑雪',
            'en': 'Skiing',
            'zh-hant': '滑雪',
            'ja': 'スキー',
            'de': 'Skifahren',
            'fr': 'Ski',
            'it': 'Sci',
            'ko': '스키'
          },
          {
            'order': 1,
            'zh-cn': '网球',
            'en': 'Tennis',
            'zh-hant': '網球',
            'ja': 'テニス',
            'de': 'Tennis',
            'fr': 'Tennis',
            'it': 'Tennis',
            'ko': '테니스'
          },
          {
            'order': 1,
            'zh-cn': '露营',
            'en': 'Camping',
            'zh-hant': '露營',
            'ja': 'キャンプ',
            'de': 'Camping',
            'fr': 'Camping',
            'it': 'Campeggio',
            'ko': '캠핑'
          },
          {
            'order': 1,
            'zh-cn': '登山',
            'en': 'Mountaineering',
            'zh-hant': '登山',
            'ja': '登山',
            'de': 'Bergsteigen',
            'fr': 'Alpinisme',
            'it': 'Alpinismo',
            'ko': '등산'
          },
          {
            'order': 1,
            'zh-cn': '滑板',
            'en': 'Skateboarding',
            'zh-hant': '滑板',
            'ja': 'スケートボード',
            'de': 'Skateboarden',
            'fr': 'Skateboard',
            'it': 'Skateboard',
            'ko': '스케이트보드'
          },
          {
            'order': 1,
            'zh-cn': '轻运动',
            'en': 'Light Exercise',
            'zh-hant': '輕運動',
            'ja': '軽い運動',
            'de': 'Leichtes Training',
            'fr': 'Exercice léger',
            'it': 'Esercizio leggero',
            'ko': '가벼운 운동'
          },
          {
            'order': 1,
            'zh-cn': '健身',
            'en': 'Fitness',
            'zh-hant': '健身',
            'ja': 'フィットネス',
            'de': 'Fitness',
            'fr': 'Fitness',
            'it': 'Fitness',
            'ko': '피트니스'
          },
          {
            'order': 1,
            'zh-cn': '飞盘',
            'en': 'Frisbee',
            'zh-hant': '飛盤',
            'ja': 'フリスビー',
            'de': 'Frisbee',
            'fr': 'Frisbee',
            'it': 'Frisbee',
            'ko': '프리스비'
          },
          {
            'order': 1,
            'zh-cn': '瑜伽',
            'en': 'Yoga',
            'zh-hant': '瑜伽',
            'ja': 'ヨガ',
            'de': 'Yoga',
            'fr': 'Yoga',
            'it': 'Yoga',
            'ko': '요가'
          },
          {
            'order': 1,
            'zh-cn': '拳击/搏击',
            'en': 'Boxing/Martial Arts',
            'zh-hant': '拳擊/武術',
            'ja': 'ボクシング/武道',
            'de': 'Boxen/Kampfsport',
            'fr': 'Boxe/Arts martiaux',
            'it': 'Boxe/Arti marziali',
            'ko': '복싱/무술'
          },
          {
            'order': 1,
            'zh-cn': '排球',
            'en': 'Volleyball',
            'zh-hant': '排球',
            'ja': 'バレーボール',
            'de': 'Volleyball',
            'fr': 'Volleyball',
            'it': 'Pallavolo',
            'ko': '배구'
          },
          {
            'order': 1,
            'zh-cn': '健身操',
            'en': 'body building exercise',
            'zh-hant': '健美運動',
            'ja': 'ボディビル運動',
            'de': 'Bodybuilding-Übung',
            'fr': 'Exercice de musculation',
            'it': 'Esercizio di body building',
            'ko': '보디빌딩 운동'
          }
        ]
      }
    ]
  },
  {
    'order': 1,
    'name': { 'zh-cn': '风格 & 情绪', en: 'Style & Mood', 'zh-hant': '風格 & 情緒', ja: 'スタイル & 感情', de: 'Stil & Stimmung', fr: 'Style & Émotion', it: 'Stile & Emozione', 'ko': '스타일 및 무드' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '服装设计师', en: 'Fashion Designer', 'zh-hant': '服裝設計師', ja: 'ファッションデザイナー', de: 'Modedesigner', fr: 'Designer de mode', it: 'Stilista di moda', ko: '패션 디자이너' },
        'list': [
          {
            'order': 1,
            'zh-cn': '乔治·阿玛尼',
            'en': 'Giorgio Armani',
            'zh-hant': '喬治·阿瑪尼（Giorgio Armani）',
            'ja': 'ジョルジオ・アルマーニ（Giorgio Armani）',
            'de': 'Giorgio Armani',
            'fr': 'Giorgio Armani',
            'it': 'Giorgio Armani',
            'ko': '조르지오 아르마니'
          },
          {
            'order': 1,
            'zh-cn': '可可·香奈儿',
            'en': 'Coco Chanel',
            'zh-hant': '可可·香奈兒（Coco Chanel）',
            'ja': 'ココ・シャネル（Coco Chanel）',
            'de': 'Coco Chanel',
            'fr': 'Coco Chanel',
            'it': 'Coco Chanel',
            'ko': '코코 샤넬'
          },
          {
            'order': 1,
            'zh-cn': '克里斯汀·迪奥',
            'en': 'Christian Dior',
            'zh-hant': '克里斯汀·迪奧（Christian Dior）',
            'ja': 'クリスチャン・ディオール（Christian Dior）',
            'de': 'Christian Dior',
            'fr': 'Christian Dior',
            'it': 'Christian Dior',
            'ko': '크리스티앙 디오르'
          },
          {
            'order': 1,
            'zh-cn': '汤姆·福特',
            'en': 'Tom Ford',
            'zh-hant': '湯姆·福特（Tom Ford）',
            'ja': 'トム・フォード（Tom Ford）',
            'de': 'Tom Ford',
            'fr': 'Tom Ford',
            'it': 'Tom Ford',
            'ko': '톰 포드'
          },
          {
            'order': 1,
            'zh-cn': '让·保罗·高缇耶',
            'en': 'Jean Paul Gaultier',
            'zh-hant': '讓·保羅·高緹耶（Jean Paul Gaultier）',
            'ja': 'ジャン＝ポール・ゴルチエ（Jean Paul Gaultier）',
            'de': 'Jean Paul Gaultier',
            'fr': 'Jean Paul Gaultier',
            'it': 'Jean Paul Gaultier',
            'ko': '장 폴 고티에'
          },
          {
            'order': 1,
            'zh-cn': '马克·雅可布',
            'en': 'Marc Jacobs',
            'zh-hant': '馬克·雅可布（Marc Jacobs）',
            'ja': 'マーク・ジェイコブス（Marc Jacobs）',
            'de': 'Marc Jacobs',
            'fr': 'Marc Jacobs',
            'it': 'Marc Jacobs',
            'ko': '마크 제이콥스'
          },
          {
            'order': 1,
            'zh-cn': '亚历山大·麦昆',
            'en': 'Alexander McQueen',
            'zh-hant': '亞歷山大·麥昆（Alexander McQueen）',
            'ja': 'アレキサンダー・マックイーン（Alexander McQueen）',
            'de': 'Alexander McQueen',
            'fr': 'Alexander McQueen',
            'it': 'Alexander McQueen',
            'ko': '알렉산더 맥퀸'
          },
          {
            'order': 1,
            'zh-cn': '伊夫·圣洛朗',
            'en': 'Yves Saint Laurent',
            'zh-hant': '伊夫·聖羅蘭（Yves Saint Laurent）',
            'ja': 'イヴ・サンローラン（Yves Saint Laurent）',
            'de': 'Yves Saint Laurent',
            'fr': 'Yves Saint Laurent',
            'it': 'Yves Saint Laurent',
            'ko': '이브 생 로랑'
          },
          {
            'order': 1,
            'zh-cn': '薇薇恩·韦斯特伍德',
            'en': 'Vivienne Westwood',
            'zh-hant': '薇薇安·魏斯伍德（Vivienne Westwood）',
            'ja': 'ヴィヴィアン・ウエストウッド（Vivienne Westwood）',
            'de': 'Vivienne Westwood',
            'fr': 'Vivienne Westwood',
            'it': 'Vivienne Westwood',
            'ko': '비비안 웨스트우드'
          },
          {
            'order': 1,
            'zh-cn': '川久保玲',
            'en': 'Rei Kawakubo',
            'zh-hant': '川久保玲（Rei Kawakubo）',
            'ja': '川久保玲（Rei Kawakubo）',
            'de': 'Rei Kawakubo',
            'fr': 'Rei Kawakubo',
            'it': 'Rei Kawakubo',
            'ko': '가와쿠보 레이'
          },
          {
            'order': 1,
            'zh-cn': '拉尔夫·劳伦',
            'en': 'Ralph Lauren',
            'zh-hant': '拉爾夫·勞倫（Ralph Lauren）',
            'ja': 'ラルフ・ローレン（Ralph Lauren）',
            'de': 'Ralph Lauren',
            'fr': 'Ralph Lauren',
            'it': 'Ralph Lauren',
            'ko': '랄프 로렌'
          },
          {
            'order': 1,
            'zh-cn': '多娜泰拉·范思哲',
            'en': 'Donatella Versace',
            'zh-hant': '多娜泰拉·范思哲（Donatella Versace）',
            'ja': 'ドナテラ・ヴェルサーチ（Donatella Versace）',
            'de': 'Donatella Versace',
            'fr': 'Donatella Versace',
            'it': 'Donatella Versace',
            'ko': '도나텔라 베르사체'
          },
          {
            'order': 1,
            'zh-cn': '卡尔·拉格斐',
            'en': 'Karl Lagerfeld',
            'zh-hant': '卡爾·拉格斐（Karl Lagerfeld）',
            'ja': 'カール・ラガーフェルド（Karl Lagerfeld）',
            'de': 'Karl Lagerfeld',
            'fr': 'Karl Lagerfeld',
            'it': 'Karl Lagerfeld',
            'ko': '칼 라거펠트'
          },
          {
            'order': 1,
            'zh-cn': '斯特拉·麦卡特尼',
            'en': 'Stella McCartney',
            'zh-hant': '史黛拉·麥卡特尼（Stella McCartney）',
            'ja': 'ステラ・マッカートニー（Stella McCartney）',
            'de': 'Stella McCartney',
            'fr': 'Stella McCartney',
            'it': 'Stella McCartney',
            'ko': '스텔라 매카트니'
          },
          {
            'order': 1,
            'zh-cn': '戴安·冯·芙丝汀柏格',
            'en': 'Diane Von Furstenberg',
            'zh-hant': '黛安·馮·芙絲汀寶（Diane Von Furstenberg）',
            'ja': 'ダイアン・フォン・ファステンバーグ（Diane Von Furstenberg）',
            'de': 'Diane Von Furstenberg',
            'fr': 'Diane Von Furstenberg',
            'it': 'Diane Von Furstenberg',
            'ko': '다이앤 본 퍼스텐버그'
          },
          {
            'order': 1,
            'zh-cn': '乔治·纪梵希',
            'en': 'Hubert De Givenchy',
            'zh-hant': '于貝爾·德·紀梵希（Hubert De Givenchy）',
            'ja': 'ユベール・ド・ジバンシィ（Hubert De Givenchy）',
            'de': 'Hubert De Givenchy',
            'fr': 'Hubert De Givenchy',
            'it': 'Hubert De Givenchy',
            'ko': '위베르 드 지방시'
          },
          {
            'order': 1,
            'zh-cn': '卡尔文·克莱恩',
            'en': 'Calvin Klein',
            'zh-hant': '凱文·克萊（Calvin Klein）',
            'ja': 'カルバン・クライン（Calvin Klein）',
            'de': 'Calvin Klein',
            'fr': 'Calvin Klein',
            'it': 'Calvin Klein',
            'ko': '캘빈 클라인'
          },
          {
            'order': 1,
            'zh-cn': '三宅一生',
            'en': 'Issey Miyake',
            'zh-hant': '三宅一生（Issey Miyake）',
            'ja': '三宅一生（Issey Miyake）',
            'de': 'Issey Miyake',
            'fr': 'Issey Miyake',
            'it': 'Issey Miyake',
            'ko': '이세이 미야케'
          },
          {
            'order': 1,
            'zh-cn': '卡罗琳娜·赫雷拉',
            'en': 'Carolina Herrera',
            'zh-hant': '卡羅琳娜·海萊娜（Carolina Herrera）',
            'ja': 'キャロリーナ・ヘレラ（Carolina Herrera）',
            'de': 'Carolina Herrera',
            'fr': 'Carolina Herrera',
            'it': 'Carolina Herrera',
            'ko': '캐롤리나 헤레라'
          },
          {
            'order': 1,
            'zh-cn': '约翰·加利亚诺',
            'en': 'John Galliano',
            'zh-hant': '約翰·加利亞諾（John Galliano）',
            'ja': 'ジョン・ガリアーノ（John Galliano）',
            'de': 'John Galliano',
            'fr': 'John Galliano',
            'it': 'John Galliano',
            'ko': '존 갈리아노'
          },
          {
            'order': 1,
            'zh-cn': '贝特西·约翰逊',
            'en': 'Betsey Johnson',
            'zh-hant': '貝特西·約翰遜（Betsey Johnson）',
            'ja': 'ベッツィ・ジョンソン（Betsey Johnson）',
            'de': 'Betsey Johnson',
            'fr': 'Betsey Johnson',
            'it': 'Betsey Johnson',
            'ko': '벳시 존슨'
          },
          {
            'order': 1,
            'zh-cn': '亚历山大·王',
            'en': 'Alexander Wang',
            'zh-hant': '王大仁（Alexander Wang）',
            'ja': 'アレキサンダー・ワン（Alexander Wang）',
            'de': 'Alexander Wang',
            'fr': 'Alexander Wang',
            'it': 'Alexander Wang',
            'ko': '알렉산더 왕'
          },
          {
            'order': 1,
            'zh-cn': '迈克尔·科尔斯',
            'en': 'Michael Kors',
            'zh-hant': '麥克·高仕（Michael Kors）',
            'ja': 'マイケル・コース（Michael Kors）',
            'de': 'Michael Kors',
            'fr': 'Michael Kors',
            'it': 'Michael Kors',
            'ko': '마이클 코어스'
          },
          {
            'order': 1,
            'zh-cn': '杰瑞米·斯科特',
            'en': 'Jeremy Scott',
            'zh-hant': '傑瑞米·斯科特（Jeremy Scott）',
            'ja': 'ジェレミー・スコット（Jeremy Scott）',
            'de': 'Jeremy Scott',
            'fr': 'Jeremy Scott',
            'it': 'Jeremy Scott',
            'ko': '제레미 스콧'
          },
          {
            'order': 1,
            'zh-cn': '巴黎世家',
            'en': 'Balenciaga',
            'zh-hant': '巴黎世家（Balenciaga）',
            'ja': 'バレンシアガ（Balenciaga）',
            'de': 'Balenciaga',
            'fr': 'Balenciaga',
            'it': 'Balenciaga',
            'ko': '발렌시아가'
          },
          {
            'order': 1,
            'zh-cn': '古驰',
            'en': 'Gucci',
            'zh-hant': '古馳（Gucci）',
            'ja': 'グッチ（Gucci）',
            'de': 'Gucci',
            'fr': 'Gucci',
            'it': 'Gucci',
            'ko': '구찌'
          },
          {
            'order': 1,
            'zh-cn': '普拉达',
            'en': 'Prada',
            'zh-hant': '普拉達（Prada）',
            'ja': 'プラダ（Prada）',
            'de': 'Prada',
            'fr': 'Prada',
            'it': 'Prada',
            'ko': '프라다'
          },
          {
            'order': 1,
            'zh-cn': '路易·威登',
            'en': 'Louis Vuitton',
            'zh-hant': '路易·威登（Louis Vuitton）',
            'ja': 'ルイ・ヴィトン（Louis Vuitton）',
            'de': 'Louis Vuitton',
            'fr': 'Louis Vuitton',
            'it': 'Louis Vuitton',
            'ko': '루이 비통'
          },
          {
            'order': 1,
            'zh-cn': '纪梵希',
            'en': 'Givenchy',
            'zh-hant': '紀梵希（Givenchy）',
            'ja': 'ジバンシィ（Givenchy）',
            'de': 'Givenchy',
            'fr': 'Givenchy',
            'it': 'Givenchy',
            'ko': '지방시'
          },
          {
            'order': 1,
            'zh-cn': '范思哲',
            'en': 'Versace',
            'zh-hant': '范思哲（Versace）',
            'ja': 'ヴェルサーチ（Versace）',
            'de': 'Versace',
            'fr': 'Versace',
            'it': 'Versace',
            'ko': '베르사체'
          },
          {
            'order': 1,
            'zh-cn': '高田贤三',
            'en': 'Kenzo',
            'zh-hant': '高田賢三（Kenzo）',
            'ja': 'ケンゾー（Kenzo）',
            'de': 'Kenzo',
            'fr': 'Kenzo',
            'it': 'Kenzo',
            'ko': '겐조'
          },
          {
            'order': 1,
            'zh-cn': '无印良品',
            'en': 'Comme Des GarçOns',
            'zh-hant': '川久保玲（Comme Des Garçons）',
            'ja': 'コム・デ・ギャルソン（Comme Des Garçons）',
            'de': 'Comme Des Garçons',
            'fr': 'Comme Des Garçons',
            'it': 'Comme Des Garçons',
            'ko': '꼼데가르송'
          },
          {
            'order': 1,
            'zh-cn': '让·保罗·高缇耶',
            'en': 'Jean-Paul Gautier',
            'zh-hant': '讓·保羅·高緹耶（Jean-Paul Gaultier）',
            'ja': 'ジャン＝ポール・ゴルチエ（Jean-Paul Gaultier）',
            'de': 'Jean-Paul Gaultier',
            'fr': 'Jean-Paul Gaultier',
            'it': 'Jean-Paul Gaultier',
            'ko': '장 폴 고티에'
          },
          {
            'order': 1,
            'zh-cn': '安娜·苏',
            'en': 'Anna Sui',
            'zh-hant': '安娜·蘇（Anna Sui）',
            'ja': 'アナ・スイ（Anna Sui）',
            'de': 'Anna Sui',
            'fr': 'Anna Sui',
            'it': 'Anna Sui',
            'ko': '안나 수이'
          },
          {
            'order': 1,
            'zh-cn': '唐娜·卡兰',
            'en': 'Donna Karan',
            'zh-hant': '唐娜·凱倫（Donna Karan）',
            'ja': 'ドナ・カラン（Donna Karan）',
            'de': 'Donna Karan',
            'fr': 'Donna Karan',
            'it': 'Donna Karan',
            'ko': '도나 카란'
          },
          {
            'order': 1,
            'zh-cn': '汤米·希尔费格',
            'en': 'Tommy Hilfiger',
            'zh-hant': '湯米·希爾費格（Tommy Hilfiger）',
            'ja': 'トミー・ヒルフィガー（Tommy Hilfiger）',
            'de': 'Tommy Hilfiger',
            'fr': 'Tommy Hilfiger',
            'it': 'Tommy Hilfiger',
            'ko': '타미 힐피거'
          },
          {
            'order': 1,
            'zh-cn': '阿扎丁·阿拉亚',
            'en': 'Azzedine AlaïA',
            'zh-hant': '阿茲丁·阿拉亞（Azzedine Alaïa）',
            'ja': 'アズディン・アライア（Azzedine Alaïa）',
            'de': 'Azzedine Alaïa',
            'fr': 'Azzedine Alaïa',
            'it': 'Azzedine Alaïa',
            'ko': '아제딘 알라이아'
          },
          {
            'order': 1,
            'zh-cn': '巴尔曼',
            'en': 'Balmain',
            'zh-hant': '巴爾曼（Balmain）',
            'ja': 'バルマン（Balmain）',
            'de': 'Balmain',
            'fr': 'Balmain',
            'it': 'Balmain',
            'ko': '발망'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '呈现方式/创作手法', en: 'Presentation/Creative Techniques', 'zh-hant': '呈現方式/創作手法', ja: 'プレゼンテーション/創作手法', de: 'Präsentations-/Kreativtechniken', fr: 'Présentation/Techniques créatives', it: 'Presentazione/Tecniche creative', ko: '표현 방식/창작 기법' },
        'list': [
          {
            'order': 1,
            'zh-cn': '插画',
            'en': 'illustration',
            'zh-hant': '插畫',
            'ja': 'イラスト',
            'de': 'Illustration',
            'fr': 'Illustration',
            'it': 'Illustrazione',
            'ko': '일러스트레이션'
          },
          {
            'order': 1,
            'zh-cn': '矢量图',
            'en': 'vector',
            'zh-hant': '矢量圖',
            'ja': 'ベクター',
            'de': 'Vektor',
            'fr': 'Vecteur',
            'it': 'Vettore',
            'ko': '벡터'
          },
          {
            'order': 1,
            'zh-cn': '油画',
            'en': 'oil painting',
            'zh-hant': '油畫',
            'ja': '油絵',
            'de': 'Ölmalerei',
            'fr': 'Peinture à l\'huile',
            'it': 'Pittura a olio',
            'ko': '유화'
          },
          {
            'order': 1,
            'zh-cn': '摄影',
            'en': 'photography',
            'zh-hant': '攝影',
            'ja': '写真',
            'de': 'Fotografie',
            'fr': 'Photographie',
            'it': 'Fotografia',
            'ko': '사진'
          },
          {
            'order': 1,
            'zh-cn': '水彩',
            'en': 'watercolor',
            'zh-hant': '水彩畫',
            'ja': '水彩画',
            'de': 'Aquarell',
            'fr': 'Aquarelle',
            'it': 'Acquerello',
            'ko': '수채화'
          },
          {
            'order': 1,
            'zh-cn': '素描',
            'en': 'sketch',
            'zh-hant': '素描',
            'ja': 'スケッチ',
            'de': 'Skizze',
            'fr': 'Croquis',
            'it': 'Schizzo',
            'ko': '스케치'
          },
          {
            'order': 1,
            'zh-cn': '雕塑',
            'en': 'ink painting',
            'zh-hant': '水墨畫',
            'ja': '墨絵',
            'de': 'Tuschmalerei',
            'fr': 'Peinture à l\'encre',
            'it': 'Pittura a inchiostro',
            'ko': '수묵화'
          },
          {
            'order': 1,
            'zh-cn': '水墨画',
            'en': 'sculpture',
            'zh-hant': '雕塑',
            'ja': '彫刻',
            'de': 'Skulptur',
            'fr': 'Sculpture',
            'it': 'Scultura',
            'ko': '조각'
          },
          {
            'order': 1,
            'zh-cn': '印刷版画',
            'en': 'blockprint',
            'zh-hant': '版畫',
            'ja': '木版画',
            'de': 'Holzschnitt',
            'fr': 'Gravure',
            'it': 'Stampa a blocchi',
            'ko': '판화'
          },
          {
            'order': 1,
            'zh-cn': '利诺剪裁',
            'en': 'lino cut',
            'zh-hant': '油印版畫',
            'ja': 'リノカット',
            'de': 'Linolschnitt',
            'fr': 'Linogravure',
            'it': 'Linoleografia',
            'ko': '리놀륨 판화'
          },
          {
            'order': 1,
            'zh-cn': '手稿',
            'en': 'manuscript',
            'zh-hant': '手稿',
            'ja': '原稿',
            'de': 'Manuskript',
            'fr': 'Manuscrit',
            'it': 'Manoscritto',
            'ko': '원고'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '风格', en: 'Style', 'zh-hant': '風格', ja: 'スタイル', de: 'Stil', fr: 'Style', it: 'Stile', ko: '스타일' },
        'list': [
          {
            'order': 1,
            'zh-cn': '像素方块风',
            'en': 'pixel art',
            'zh-hant': '像素藝術',
            'ja': 'ピクセルアート',
            'de': 'Pixelkunst',
            'fr': 'Pixel art',
            'it': 'Pixel art',
            'ko': '픽셀 아트'
          },
          {
            'order': 1,
            'zh-cn': '神秘生物',
            'en': 'mystical creatures',
            'zh-hant': '神秘生物',
            'ja': '神秘的な生き物',
            'de': 'Mystische Kreaturen',
            'fr': 'Créatures mystiques',
            'it': 'Creature misteriose',
            'ko': '신비한 생물'
          },
          {
            'order': 1,
            'zh-cn': '角色设计',
            'en': 'character design',
            'zh-hant': '角色設計',
            'ja': 'キャラクターデザイン',
            'de': 'Charakterdesign',
            'fr': 'Design de personnages',
            'it': 'Design dei personaggi',
            'ko': '캐릭터 디자인'
          },
          {
            'order': 1,
            'zh-cn': '角色概念艺术',
            'en': 'character conceptart',
            'zh-hant': '角色概念藝術',
            'ja': 'キャラクターコンセプトアート',
            'de': 'Charakterkonzeptkunst',
            'fr': 'Concept art de personnages',
            'it': 'Concept art dei personaggi',
            'ko': '캐릭터 컨셉 아트'
          },
          {
            'order': 1,
            'zh-cn': '设计方案',
            'en': 'concept design sheet',
            'zh-hant': '概念設計圖',
            'ja': 'コンセプトデザインシート',
            'de': 'Konzeptentwurfsblatt',
            'fr': 'Feuille de conception de concepts',
            'it': 'Foglio di design concettuale',
            'ko': '컨셉 디자인 시트'
          },
          {
            'order': 1,
            'zh-cn': '多种概念设计',
            'en': 'multiple concept designs',
            'zh-hant': '多重概念設計',
            'ja': '複数のコンセプトデザイン',
            'de': 'Mehrfache Konzeptdesigns',
            'fr': 'Conceptions multiples',
            'it': 'Molteplici concept design',
            'ko': '다중 컨셉 디자인'
          },
          {
            'order': 1,
            'zh-cn': '日本漫画风格',
            'en': 'japanese comics',
            'zh-hant': '日本漫畫',
            'ja': '日本の漫画',
            'de': 'Japanische Comics',
            'fr': 'Mangas japonais',
            'it': 'Fumetti giapponesi',
            'ko': '일본 만화'
          },
          {
            'order': 1,
            'zh-cn': '童话故事书插图风格',
            'en': 'stock illustration style',
            'zh-hant': '庫存插畫風格',
            'ja': 'ストックイラストスタイル',
            'de': 'Stockillustrationsstil',
            'fr': 'Style d\'illustration de stock',
            'it': 'Stile illustrazione stock',
            'ko': '스톡 일러스트레이션 스타일'
          },
          {
            'order': 1,
            'zh-cn': '梦工厂动西风格',
            'en': 'cgsociety',
            'zh-hant': 'CGSociety',
            'ja': 'CGSociety',
            'de': 'CGSociety',
            'fr': 'CGSociety',
            'it': 'CGSociety',
            'ko': 'CGSociety'
          },
          {
            'order': 1,
            'zh-cn': '梦工厂影业',
            'en': 'dreamworkspictures',
            'zh-hant': '夢工廠動畫',
            'ja': 'ドリームワークスピクチャーズ',
            'de': 'DreamWorks Pictures',
            'fr': 'DreamWorks Pictures',
            'it': 'DreamWorks Pictures',
            'ko': '드림웍스 픽처스'
          },
          {
            'order': 1,
            'zh-cn': '皮克斯',
            'en': 'pixar',
            'zh-hant': '皮克斯',
            'ja': 'ピクサー',
            'de': 'Pixar',
            'fr': 'Pixar',
            'it': 'Pixar',
            'ko': '픽사'
          },
          {
            'order': 1,
            'zh-cn': '时尚',
            'en': 'fashion',
            'zh-hant': '時尚',
            'ja': 'ファッション',
            'de': 'Mode',
            'fr': 'Mode',
            'it': 'Moda',
            'ko': '패션'
          },
          {
            'order': 1,
            'zh-cn': '日本海报风格',
            'en': 'poster of japanese graphic design',
            'zh-hant': '日本平面設計海報',
            'ja': '日本のグラフィックデザインポスター',
            'de': 'Poster japanisches Grafikdesign',
            'fr': 'Affiche de design graphique japonais',
            'it': 'Poster di design grafico giapponese',
            'ko': '일본 그래픽 디자인 포스터'
          },
          {
            'order': 1,
            'zh-cn': '90年代电视游戏',
            'en': '90 svideo game',
            'zh-hant': '90年代電子遊戲',
            'ja': '90年代のビデオゲーム',
            'de': '90er Videospiel',
            'fr': 'Jeu vidéo des années 90',
            'it': 'Videogioco anni \'90',
            'ko': '90년대 비디오 게임'
          },
          {
            'order': 1,
            'zh-cn': '法国艺术',
            'en': 'frenchart',
            'zh-hant': '法國藝術',
            'ja': 'フランスアート',
            'de': 'Französische Kunst',
            'fr': 'Art français',
            'it': 'Arte francese',
            'ko': '프랑스 예술'
          },
          {
            'order': 1,
            'zh-cn': '包豪斯',
            'en': 'bauhaus',
            'zh-hant': '包豪斯',
            'ja': 'バウハウス',
            'de': 'Bauhaus',
            'fr': 'Bauhaus',
            'it': 'Bauhaus',
            'ko': '바우하우스'
          },
          {
            'order': 1,
            'zh-cn': '日本动画片',
            'en': 'anime',
            'zh-hant': '動漫',
            'ja': 'アニメ',
            'de': 'Anime',
            'fr': 'Anime',
            'it': 'Anime',
            'ko': '애니메이션'
          },
          {
            'order': 1,
            'zh-cn': '东方山水画',
            'en': 'tradition chinese ink painting',
            'zh-hant': '傳統中國水墨畫',
            'ja': '伝統的な中国の水墨画',
            'de': 'Traditionelle chinesische Tuschmalerei',
            'fr': 'Peinture à l\'encre traditionnelle chinoise',
            'it': 'Pittura a inchiostro tradizionale cinese',
            'ko': '전통 중국 수묵화'
          },
          {
            'order': 1,
            'zh-cn': '古典风',
            'en': 'vintage',
            'zh-hant': '復古',
            'ja': 'ビンテージ',
            'de': 'Vintage',
            'fr': 'Vintage',
            'it': 'Vintage',
            'ko': '빈티지'
          },
          {
            'order': 1,
            'zh-cn': '国家地理',
            'en': 'national geographic',
            'zh-hant': '國家地理',
            'ja': 'ナショナルジオグラフィック',
            'de': 'National Geographic',
            'fr': 'National Geographic',
            'it': 'National Geographic',
            'ko': '내셔널 지오그래픽'
          },
          {
            'order': 1,
            'zh-cn': '乡村风格',
            'en': 'country style',
            'zh-hant': '鄉村風格',
            'ja': 'カントリースタイル',
            'de': 'Landhausstil',
            'fr': 'Style campagnard',
            'it': 'Stile country',
            'ko': '컨트리 스타일'
          },
          {
            'order': 1,
            'zh-cn': '抽象风',
            'en': 'abstract',
            'zh-hant': '抽象',
            'ja': '抽象',
            'de': 'Abstrakt',
            'fr': 'Abstrait',
            'it': 'Astratto',
            'ko': '추상'
          },
          {
            'order': 1,
            'zh-cn': 'riso印刷风',
            'en': 'risograph',
            'zh-hant': '孔版印刷',
            'ja': 'リソグラフ',
            'de': 'Risographie',
            'fr': 'Risographie',
            'it': 'Risografia',
            'ko': '리소그래프'
          },
          {
            'order': 1,
            'zh-cn': '设计风',
            'en': 'graphic',
            'zh-hant': '平面設計',
            'ja': 'グラフィック',
            'de': 'Grafik',
            'fr': 'Graphique',
            'it': 'Grafica',
            'ko': '그래픽'
          },
          {
            'order': 1,
            'zh-cn': '墨水渲染',
            'en': 'ink render',
            'zh-hant': '墨渲染',
            'ja': 'インクレンダリング',
            'de': 'Tintenrendering',
            'fr': 'Rendu à l\'encre',
            'it': 'Rendering a inchiostro',
            'ko': '잉크 렌더링'
          },
          {
            'order': 1,
            'zh-cn': '民族艺术',
            'en': 'ethnic art',
            'zh-hant': '民族藝術',
            'ja': 'エスニックアート',
            'de': 'Ethnische Kunst',
            'fr': 'Art ethnique',
            'it': 'Arte etnica',
            'ko': '민족 예술'
          },
          {
            'order': 1,
            'zh-cn': '复古黑暗',
            'en': 'retro dark vintage',
            'zh-hant': '復古黑暗風格',
            'ja': 'レトロダークヴィンテージ',
            'de': 'Retro Dunkel Vintage',
            'fr': 'Vintage rétro sombre',
            'it': 'Retrò scuro vintage',
            'ko': '레트로 다크 빈티지'
          },
          {
            'order': 1,
            'zh-cn': '国风',
            'en': 'tradition chineseink paintingstyle',
            'zh-hant': '傳統中國水墨畫風格',
            'ja': '伝統的な中国の水墨画スタイル',
            'de': 'Traditioneller chinesischer Tuschmalereistil',
            'fr': 'Style de peinture à l\'encre chinoise traditionnelle',
            'it': 'Stile di pittura a inchiostro tradizionale cinese',
            'ko': '전통 중국 수묵화 스타일'
          },
          {
            'order': 1,
            'zh-cn': '蒸汽朋克',
            'en': 'steampunk',
            'zh-hant': '蒸汽龐克',
            'ja': 'スチームパンク',
            'de': 'Steampunk',
            'fr': 'Steampunk',
            'it': 'Steampunk',
            'ko': '스팀펑크'
          },
          {
            'order': 1,
            'zh-cn': '超写实主义',
            'en': 'hyperrealism',
            'zh-hant': '超現實主義',
            'ja': 'ハイパーリアリズム',
            'de': 'Hyperrealismus',
            'fr': 'Hyperréalisme',
            'it': 'Iperrealismo',
            'ko': '하이퍼리얼리즘'
          },
          {
            'order': 1,
            'zh-cn': '概念艺术',
            'en': 'conceptart',
            'zh-hant': '概念藝術',
            'ja': 'コンセプトアート',
            'de': 'Konzeptkunst',
            'fr': 'Art conceptuel',
            'it': 'Arte concettuale',
            'ko': '컨셉 아트'
          },
          {
            'order': 1,
            'zh-cn': '剪辑',
            'en': 'montage',
            'zh-hant': '蒙太奇',
            'ja': 'モンタージュ',
            'de': 'Montage',
            'fr': 'Montage',
            'it': 'Montaggio',
            'ko': '몽타주'
          },
          {
            'order': 1,
            'zh-cn': '充满细节',
            'en': 'full details',
            'zh-hant': '全細節',
            'ja': 'フルディテール',
            'de': 'Vollständige Details',
            'fr': 'Détails complets',
            'it': 'Dettagli completi',
            'ko': '상세한 디테일'
          },
          {
            'order': 1,
            'zh-cn': '哥特式黑暗',
            'en': 'gothic gloomy',
            'zh-hant': '哥德陰鬱風格',
            'ja': 'ゴシック陰鬱スタイル',
            'de': 'Gotisch düster',
            'fr': 'Gothique lugubre',
            'it': 'Gotico cupo',
            'ko': '고딕 음울'
          },
          {
            'order': 1,
            'zh-cn': '写实主义',
            'en': 'realism',
            'zh-hant': '現實主義',
            'ja': 'リアリズム',
            'de': 'Realismus',
            'fr': 'Réalisme',
            'it': 'Realismo',
            'ko': '사실주의'
          },
          {
            'order': 1,
            'zh-cn': '黑白',
            'en': 'black and white',
            'zh-hant': '黑白',
            'ja': '白黒',
            'de': 'Schwarz und Weiß',
            'fr': 'Noir et blanc',
            'it': 'Bianco e nero',
            'ko': '흑백'
          },
          {
            'order': 1,
            'zh-cn': '统一创作',
            'en': 'unity creations',
            'zh-hant': '統一創作',
            'ja': '統一クリエーション',
            'de': 'Einheitskreationen',
            'fr': 'Créations unifiées',
            'it': 'Creazioni unificate',
            'ko': '통일된 창작'
          },
          {
            'order': 1,
            'zh-cn': '巴洛克时期',
            'en': 'baroque',
            'zh-hant': '巴洛克風格',
            'ja': 'バロック',
            'de': 'Barock',
            'fr': 'Baroque',
            'it': 'Barocco',
            'ko': '바로크'
          },
          {
            'order': 1,
            'zh-cn': '印象派',
            'en': 'impressionism',
            'zh-hant': '印象派',
            'ja': '印象派',
            'de': 'Impressionismus',
            'fr': 'Impressionnisme',
            'it': 'Impressionismo',
            'ko': '인상주의'
          },
          {
            'order': 1,
            'zh-cn': '新艺术风格',
            'en': 'art nouveau',
            'zh-hant': '新藝術風格',
            'ja': 'アール・ヌーヴォー',
            'de': 'Jugendstil',
            'fr': 'Art nouveau',
            'it': 'Art Nouveau',
            'ko': '아르누보'
          },
          {
            'order': 1,
            'zh-cn': '新艺术',
            'en': 'rococo',
            'zh-hant': '洛可可風格',
            'ja': 'ロココ',
            'de': 'Rokoko',
            'fr': 'Rococo',
            'it': 'Rococò',
            'ko': '로코코'
          },
          {
            'order': 1,
            'zh-cn': '局部解剖',
            'en': 'partial anatomy',
            'zh-hant': '部分解剖',
            'ja': '部分解剖',
            'de': 'Teilweise Anatomie',
            'fr': 'Anatomie partielle',
            'it': 'Anatomia parziale',
            'ko': '부분 해부'
          },
          {
            'order': 1,
            'zh-cn': '彩墨纸本',
            'en': 'color ink on paper',
            'zh-hant': '紙上彩墨',
            'ja': '紙にカラーインク',
            'de': 'Farbige Tinte auf Papier',
            'fr': 'Encre de couleur sur papier',
            'it': 'Inchiostro colorato su carta',
            'ko': '종이에 컬러 잉크'
          },
          {
            'order': 1,
            'zh-cn': '涂鸦',
            'en': 'doodle',
            'zh-hant': '塗鴉',
            'ja': '落書き',
            'de': 'Kritzelei',
            'fr': 'Gribouillage',
            'it': 'Scarabocchio',
            'ko': '낙서'
          },
          {
            'order': 1,
            'zh-cn': '伏尼契手稿',
            'en': 'voynich manuscript',
            'zh-hant': '沃伊尼奇手稿',
            'ja': 'ヴォイニッチ手稿',
            'de': 'Voynich-Manuskript',
            'fr': 'Manuscrit de Voynich',
            'it': 'Manoscritto Voynich',
            'ko': '보이니치 수고'
          },
          {
            'order': 1,
            'zh-cn': '书页',
            'en': 'book page',
            'zh-hant': '書頁',
            'ja': '本のページ',
            'de': 'Buchseite',
            'fr': 'Page de livre',
            'it': 'Pagina del libro',
            'ko': '책 페이지'
          },
          {
            'order': 1,
            'zh-cn': '真实的',
            'en': 'realistic',
            'zh-hant': '現實主義',
            'ja': 'リアリズム',
            'de': 'Realistisch',
            'fr': 'Réaliste',
            'it': 'Realistico',
            'ko': '사실적인'
          },
          {
            'order': 1,
            'zh-cn': '3d风格',
            'en': '3d',
            'zh-hant': '3D',
            'ja': '3D',
            'de': '3D',
            'fr': '3D',
            'it': '3D',
            'ko': '3D'
          },
          {
            'order': 1,
            'zh-cn': '剪纸风格',
            'en': 'layered paper',
            'zh-hant': '分層紙',
            'ja': 'レイヤードペーパー',
            'de': 'Geschichtetes Papier',
            'fr': 'Papier en couches',
            'it': 'Carta stratificata',
            'ko': '레이어드 페이퍼'
          },
          {
            'order': 1,
            'zh-cn': 'ins风',
            'en': 'insta',
            'zh-hant': 'Instagram風格',
            'ja': 'インスタ',
            'de': 'Insta',
            'fr': 'Insta',
            'it': 'Insta',
            'ko': '인스타'
          },
          {
            'order': 1,
            'zh-cn': '浮世绘',
            'en': 'japanese ukiyo-e',
            'zh-hant': '日本浮世繪',
            'ja': '浮世絵',
            'de': 'Japanisches Ukiyo-e',
            'fr': 'Ukiyo-e japonais',
            'it': 'Ukiyo-e giapponese',
            'ko': '일본 우키요에'
          },
          {
            'order': 1,
            'zh-cn': '动漫风格',
            'en': 'anime style',
            'zh-hant': '動漫風格',
            'ja': 'アニメスタイル',
            'de': 'Anime-Stil',
            'fr': 'Style anime',
            'it': 'Stile anime',
            'ko': '애니메이션 스타일'
          },
          {
            'order': 1,
            'zh-cn': '文艺复兴',
            'en': 'renaissance',
            'zh-hant': '文藝復興',
            'ja': 'ルネサンス',
            'de': 'Renaissance',
            'fr': 'Renaissance',
            'it': 'Rinascimento',
            'ko': '르네상스'
          },
          {
            'order': 1,
            'zh-cn': '野兽派',
            'en': 'fauvism',
            'zh-hant': '野獸派',
            'ja': 'フォービズム',
            'de': 'Fauvismus',
            'fr': 'Fauvisme',
            'it': 'Fauvismo',
            'ko': '야수파'
          },
          {
            'order': 1,
            'zh-cn': '立体派',
            'en': 'cubism',
            'zh-hant': '立體派',
            'ja': 'キュビズム',
            'de': 'Kubismus',
            'fr': 'Cubisme',
            'it': 'Cubismo',
            'ko': '입체파'
          },
          {
            'order': 1,
            'zh-cn': '抽象表现主义',
            'en': 'abstractart',
            'zh-hant': '抽象藝術',
            'ja': '抽象アート',
            'de': 'Abstrakte Kunst',
            'fr': 'Art abstrait',
            'it': 'Arte astratta',
            'ko': '추상 예술'
          },
          {
            'order': 1,
            'zh-cn': '超现实主义',
            'en': 'surrealism',
            'zh-hant': '超現實主義',
            'ja': 'シュルレアリスム',
            'de': 'Surrealismus',
            'fr': 'Surréalisme',
            'it': 'Surrealismo',
            'ko': '초현실주의'
          },
          {
            'order': 1,
            'zh-cn': '欧普艺术/光效应艺术',
            'en': 'op art/optical art',
            'zh-hant': '視覺藝術/光學藝術',
            'ja': 'オプアート/視覚芸術',
            'de': 'Op-Art/Optische Kunst',
            'fr': 'Art optique',
            'it': 'Op art/arte ottica',
            'ko': '옵아트/광학 예술'
          },
          {
            'order': 1,
            'zh-cn': '维多利亚时代',
            'en': 'victorian',
            'zh-hant': '維多利亞風格',
            'ja': 'ヴィクトリアンスタイル',
            'de': 'Viktorianischer Stil',
            'fr': 'Style victorien',
            'it': 'Stile vittoriano',
            'ko': '빅토리아 시대'
          },
          {
            'order': 1,
            'zh-cn': '未来主义',
            'en': 'futuristic',
            'zh-hant': '未來風',
            'ja': 'フューチャリスティック',
            'de': 'Futuristisch',
            'fr': 'Futuriste',
            'it': 'Futuristico',
            'ko': '미래주의'
          },
          {
            'order': 1,
            'zh-cn': '极简主义',
            'en': 'minimalist',
            'zh-hant': '極簡主義',
            'ja': 'ミニマリズム',
            'de': 'Minimalistisch',
            'fr': 'Minimaliste',
            'it': 'Minimalista',
            'ko': '미니멀리즘'
          },
          {
            'order': 1,
            'zh-cn': '粗犷主义',
            'en': 'brutalist',
            'zh-hant': '粗獷主義',
            'ja': 'ブルータリズム',
            'de': 'Brutalistisch',
            'fr': 'Brutaliste',
            'it': 'Brutalista',
            'ko': '브루탈리즘'
          },
          {
            'order': 1,
            'zh-cn': '建构主义',
            'en': 'constructivist',
            'zh-hant': '構成主義',
            'ja': 'コンストラクティヴィズム',
            'de': 'Konstruktivistisch',
            'fr': 'Constructiviste',
            'it': 'Costruttivista',
            'ko': '구성주의'
          },
          {
            'order': 1,
            'zh-cn': '旷野之息',
            'en': 'botw',
            'zh-hant': '《薩爾達傳說：荒野之息》',
            'ja': 'ブレス オブ ザ ワイルド（BotW）',
            'de': 'Breath of the Wild',
            'fr': 'The Legend of Zelda: Breath of the Wild',
            'it': 'Breath of the Wild',
            'ko': '젤다의 전설: 브레스 오브 더 와일드'
          },
          {
            'order': 1,
            'zh-cn': '星际战甲',
            'en': 'warframe',
            'zh-hant': '《戰甲神兵》',
            'ja': 'ウォーフレーム',
            'de': 'Warframe',
            'fr': 'Warframe',
            'it': 'Warframe',
            'ko': '워프레임'
          },
          {
            'order': 1,
            'zh-cn': '英雄联盟',
            'en': 'league ofl egends',
            'zh-hant': '《英雄聯盟》',
            'ja': 'リーグ・オブ・レジェンド',
            'de': 'League of Legends',
            'fr': 'League of Legends',
            'it': 'League of Legends',
            'ko': '리그 오브 레전드'
          },
          {
            'order': 1,
            'zh-cn': 'jolo的奇妙冒险',
            'en': 'jojo\'sbizarreadventure',
            'zh-hant': '《JOJO的奇妙冒險》',
            'ja': 'ジョジョの奇妙な冒険',
            'de': 'JoJo\'s Bizarre Adventure',
            'fr': 'JoJo\'s Bizarre Adventure',
            'it': 'JoJo\'s Bizarre Adventure',
            'ko': '조조의 기묘한 모험'
          },
          {
            'order': 1,
            'zh-cn': '新海诚',
            'en': 'makoto shinkai',
            'zh-hant': '新海誠',
            'ja': '新海誠',
            'de': 'Makoto Shinkai',
            'fr': 'Makoto Shinkai',
            'it': 'Makoto Shinkai',
            'ko': '신카이 마코토'
          },
          {
            'order': 1,
            'zh-cn': '副岛成记',
            'en': 'soejima shigenori',
            'zh-hant': '副島成記',
            'ja': '副島成記',
            'de': 'Soejima Shigenori',
            'fr': 'Soejima Shigenori',
            'it': 'Soejima Shigenori',
            'ko': '소에지마 시게노리'
          },
          {
            'order': 1,
            'zh-cn': '山田章博',
            'en': 'yamada akihiro',
            'zh-hant': '山田章博',
            'ja': '山田章博',
            'de': 'Yamada Akihiro',
            'fr': 'Yamada Akihiro',
            'it': 'Yamada Akihiro',
            'ko': '야마다 아키히로'
          },
          {
            'order': 1,
            'zh-cn': '六七质',
            'en': 'munashichi',
            'zh-hant': '六七質',
            'ja': 'むなしち',
            'de': 'Munashichi',
            'fr': 'Munashichi',
            'it': 'Munashichi',
            'ko': '무나시치'
          },
          {
            'order': 1,
            'zh-cn': '水彩儿童插画',
            'en': 'watercolor children\'s illustration',
            'zh-hant': '兒童水彩插畫',
            'ja': '水彩子供のイラスト',
            'de': 'Aquarell-Kinderillustration',
            'fr': 'Illustration d\'enfants à l\'aquarelle',
            'it': 'Illustrazione per bambini ad acquerello',
            'ko': '수채화 어린이 일러스트레이션'
          },
          {
            'order': 1,
            'zh-cn': '吉卜力风格',
            'en': 'ghibli studio',
            'zh-hant': '吉卜力工作室',
            'ja': 'ジブリスタジオ',
            'de': 'Ghibli Studio',
            'fr': 'Studio Ghibli',
            'it': 'Studio Ghibli',
            'ko': '지브리 스튜디오'
          },
          {
            'order': 1,
            'zh-cn': '彩色玻璃窗',
            'en': 'stained glass window',
            'zh-hant': '彩色玻璃窗',
            'ja': 'ステンドグラスの窓',
            'de': 'Buntglasfenster',
            'fr': 'Vitrail',
            'it': 'Vetrata',
            'ko': '스테인드글라스 창'
          },
          {
            'order': 1,
            'zh-cn': '水墨插图',
            'en': 'ink illustration',
            'zh-hant': '墨畫插圖',
            'ja': 'インクイラスト',
            'de': 'Tintenillustration',
            'fr': 'Illustration à l\'encre',
            'it': 'Illustrazione a inchiostro',
            'ko': '수묵 일러스트레이션'
          },
          {
            'order': 1,
            'zh-cn': '宫崎骏风格',
            'en': 'miyazaki hayao style',
            'zh-hant': '宮崎駿風格',
            'ja': '宮崎駿風',
            'de': 'Miyazaki Hayao Stil',
            'fr': 'Style Miyazaki Hayao',
            'it': 'Stile Miyazaki Hayao',
            'ko': '미야자키 하야오 스타일'
          },
          {
            'order': 1,
            'zh-cn': '梵高',
            'en': 'vincent vangogh',
            'zh-hant': '文森特·梵高',
            'ja': 'ヴィンセント・ヴァン・ゴッホ',
            'de': 'Vincent van Gogh',
            'fr': 'Vincent Van Gogh',
            'it': 'Vincent Van Gogh',
            'ko': '빈센트 반 고흐'
          },
          {
            'order': 1,
            'zh-cn': '达芬奇',
            'en': 'leonardo davinci',
            'zh-hant': '列奧納多·達芬奇',
            'ja': 'レオナルド・ダ・ヴィンチ',
            'de': 'Leonardo da Vinci',
            'fr': 'Léonard de Vinci',
            'it': 'Leonardo da Vinci',
            'ko': '레오나르도 다빈치'
          },
          {
            'order': 1,
            'zh-cn': '漫画',
            'en': 'manga',
            'zh-hant': '漫畫',
            'ja': '漫画',
            'de': 'Manga',
            'fr': 'Manga',
            'it': 'Manga',
            'ko': '만화'
          },
          {
            'order': 1,
            'zh-cn': '点彩派',
            'en': 'pointillism',
            'zh-hant': '點描法',
            'ja': '点描',
            'de': 'Pointillismus',
            'fr': 'Pointillisme',
            'it': 'Puntinismo',
            'ko': '점묘법'
          },
          {
            'order': 1,
            'zh-cn': '克劳德莫奈',
            'en': 'claude monet',
            'zh-hant': '克勞德·莫奈',
            'ja': 'クロード・モネ',
            'de': 'Claude Monet',
            'fr': 'Claude Monet',
            'it': 'Claude Monet',
            'ko': '클로드 모네'
          },
          {
            'order': 1,
            'zh-cn': '绗缝艺术',
            'en': 'quiltedart',
            'zh-hant': '絎縫藝術',
            'ja': 'キルトアート',
            'de': 'Gepolsterte Kunst',
            'fr': 'Art quilté',
            'it': 'Arte trapuntata',
            'ko': '퀼트 아트'
          },
          {
            'order': 1,
            'zh-cn': '游戏场景图',
            'en': 'game scene graph',
            'zh-hant': '遊戲場景圖',
            'ja': 'ゲームシーングラフ',
            'de': 'Spielszene-Graph',
            'fr': 'Graphique de scène de jeu',
            'it': 'Grafico della scena di gioco',
            'ko': '게임 장면 그래프'
          },
          {
            'order': 1,
            'zh-cn': '建筑素描',
            'en': 'architectural sketching',
            'zh-hant': '建築素描',
            'ja': '建築スケッチ',
            'de': 'Architekturskizze',
            'fr': 'Croquis architectural',
            'it': 'Schizzo architettonico',
            'ko': '건축 스케치'
          },
          {
            'order': 1,
            'zh-cn': '工业设计',
            'en': 'industrial design',
            'zh-hant': '工業設計',
            'ja': 'インダストリアルデザイン',
            'de': 'Industriedesign',
            'fr': 'Design industriel',
            'it': 'Design industriale',
            'ko': '산업 디자인'
          },
          {
            'order': 1,
            'zh-cn': '盲盒风格',
            'en': 'blind box style',
            'zh-hant': '盲盒風格',
            'ja': 'ブラインドボックススタイル',
            'de': 'Blindbox-Stil',
            'fr': 'Style boîte aveugle',
            'it': 'Stile blind box',
            'ko': '블라인드 박스 스타일'
          },
          {
            'order': 1,
            'zh-cn': '室内设计',
            'en': 'interior design',
            'zh-hant': '室內設計',
            'ja': 'インテリアデザイン',
            'de': 'Innendesign',
            'fr': 'Design d\'intérieur',
            'it': 'Design d\'interni',
            'ko': '인테리어 디자인'
          },
          {
            'order': 1,
            'zh-cn': '武器设计',
            'en': 'weapon design',
            'zh-hant': '武器設計',
            'ja': '武器デザイン',
            'de': 'Waffendesign',
            'fr': 'Conception d\'arme',
            'it': 'Design di armi',
            'ko': '무기 디자인'
          },
          {
            'order': 1,
            'zh-cn': '次表面散射',
            'en': 'subsurfaces cattering',
            'zh-hant': '次表面散射',
            'ja': 'サブサーフェス・スキャッタリング',
            'de': 'Subsurface-Scattering',
            'fr': 'Dispersion sous-surface',
            'it': 'Scattering subsuperficiale',
            'ko': '서브서피스 스캐터링'
          },
          {
            'order': 1,
            'zh-cn': '逼真照片',
            'en': 'realisticphotostyle',
            'zh-hant': '實景照片風格',
            'ja': 'リアルフォトスタイル',
            'de': 'Realistischer Fotostil',
            'fr': 'Style photo réaliste',
            'it': 'Stile fotografico realistico',
            'ko': '사실적인 사진 스타일'
          },
          {
            'order': 1,
            'zh-cn': '获奖摄影作品',
            'en': 'award winning photography',
            'zh-hant': '獲獎攝影',
            'ja': '受賞歴のある写真',
            'de': 'Preisgekrönte Fotografie',
            'fr': 'Photographie primée',
            'it': 'Fotografia premiata',
            'ko': '수상 사진'
          },
          {
            'order': 1,
            'zh-cn': '电影摄影风格',
            'en': 'film photography',
            'zh-hant': '膠片攝影',
            'ja': 'フィルム写真',
            'de': 'Filmfotografie',
            'fr': 'Photographie argentique',
            'it': 'Fotografia su pellicola',
            'ko': '필름 사진'
          },
          {
            'order': 1,
            'zh-cn': '黑白电影时期',
            'en': 'pulpnoir',
            'zh-hant': '低俗小說黑色風格',
            'ja': 'パルプノワール',
            'de': 'Pulp Noir',
            'fr': 'Pulp noir',
            'it': 'Pulp noir',
            'ko': '펄프 누아르'
          },
          {
            'order': 1,
            'zh-cn': '电影般的',
            'en': 'cinematic',
            'zh-hant': '電影風格',
            'ja': 'シネマティック',
            'de': 'Kinematisch',
            'fr': 'Cinématique',
            'it': 'Cinematico',
            'ko': '영화적인'
          },
          {
            'order': 1,
            'zh-cn': '真实感',
            'en': 'photoreal',
            'zh-hant': '寫實風格',
            'ja': 'フォトリアル',
            'de': 'Photoreal',
            'fr': 'Photoréaliste',
            'it': 'Fotorealistico',
            'ko': '포토리얼'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '画面整体情绪', en: 'Overall Mood of the Image', 'zh-hant': '画面全体の雰囲気', ja: 'スタイル', de: 'Gesamtstimmung des Bildes', fr: 'Ambiance générale de l\'image', it: 'Atmosfera generale dell\'immagine', 'ko': '이미지 전체 분위기' },
        'list': [
          {
            'order': 1,
            'zh-cn': '惊喜',
            'en': 'surprised',
            'zh-hant': '驚訝',
            'ja': '驚いた',
            'de': 'Überraschung',
            'fr': 'Surpris',
            'it': 'Sorprendente',
            'ko': '놀란'
          },
          {
            'order': 1,
            'zh-cn': '黑暗的',
            'en': 'dark',
            'zh-hant': '黑暗',
            'ja': '暗い',
            'de': 'Dunkel',
            'fr': 'Sombre',
            'it': 'Scuro',
            'ko': '어두운'
          },
          {
            'order': 1,
            'zh-cn': '厌恶的',
            'en': 'disgusted',
            'zh-hant': '厭惡',
            'ja': '嫌悪感',
            'de': 'Angeekelt',
            'fr': 'Dégoûté',
            'it': 'Disgustato',
            'ko': '혐오스러운'
          },
          {
            'order': 1,
            'zh-cn': '残酷的/破碎的',
            'en': 'brutal',
            'zh-hant': '殘酷',
            'ja': '残酷',
            'de': 'Brutal',
            'fr': 'Brutal',
            'it': 'Brutale',
            'ko': '잔인한'
          },
          {
            'order': 1,
            'zh-cn': '强烈对比的',
            'en': 'dramatic contrast',
            'zh-hant': '戲劇性對比',
            'ja': '劇的な対比',
            'de': 'Dramatischer Kontrast',
            'fr': 'Contraste dramatique',
            'it': 'Contrasto drammatico',
            'ko': '극적인 대비'
          },
          {
            'order': 1,
            'zh-cn': '充满希望的',
            'en': 'hopeful',
            'zh-hant': '充滿希望',
            'ja': '希望に満ちた',
            'de': 'Hoffnungsvoll',
            'fr': 'Plein d\'espoir',
            'it': 'Speranzoso',
            'ko': '희망찬'
          },
          {
            'order': 1,
            'zh-cn': '焦虑的',
            'en': 'anxious',
            'zh-hant': '焦慮',
            'ja': '不安',
            'de': 'Ängstlich',
            'fr': 'Anxieux',
            'it': 'Ansioso',
            'ko': '불안한'
          },
          {
            'order': 1,
            'zh-cn': '沮丧',
            'en': 'depressed',
            'zh-hant': '沮喪',
            'ja': '鬱',
            'de': 'Depressiv',
            'fr': 'Déprimé',
            'it': 'Depresso',
            'ko': '우울한'
          },
          {
            'order': 1,
            'zh-cn': '高兴地',
            'en': 'elated',
            'zh-hant': '狂喜',
            'ja': '大喜び',
            'de': 'Erfreut',
            'fr': 'Ravi',
            'it': 'Euforico',
            'ko': '기쁜'
          },
          {
            'order': 1,
            'zh-cn': '难过的',
            'en': 'upset',
            'zh-hant': '心煩',
            'ja': '動揺した',
            'de': 'Verärgert',
            'fr': 'Bouleversé',
            'it': 'Turbato',
            'ko': '속상한'
          },
          {
            'order': 1,
            'zh-cn': '令人恐惧的',
            'en': 'fearful',
            'zh-hant': '恐懼',
            'ja': '恐れる',
            'de': 'Furchtsam',
            'fr': 'Craintif',
            'it': 'Spaventato',
            'ko': '두려운'
          },
          {
            'order': 1,
            'zh-cn': '令人憎恨的',
            'en': 'hateful',
            'zh-hant': '憎恨',
            'ja': '憎い',
            'de': 'Hassvoll',
            'fr': 'Haineux',
            'it': 'Odioso',
            'ko': '증오스러운'
          },
          {
            'order': 1,
            'zh-cn': '高兴',
            'en': 'happy',
            'zh-hant': '快樂',
            'ja': '幸せ',
            'de': 'Glücklich',
            'fr': 'Heureux',
            'it': 'Felice',
            'ko': '행복한'
          },
          {
            'order': 1,
            'zh-cn': '兴奋',
            'en': 'excited',
            'zh-hant': '興奮',
            'ja': '興奮した',
            'de': 'Aufgeregt',
            'fr': 'Excité',
            'it': 'Eccitato',
            'ko': '흥분된'
          },
          {
            'order': 1,
            'zh-cn': '生气',
            'en': 'angry',
            'zh-hant': '憤怒',
            'ja': '怒った',
            'de': 'Wütend',
            'fr': 'En colère',
            'it': 'Arrabbiato',
            'ko': '화난'
          },
          {
            'order': 1,
            'zh-cn': '害怕',
            'en': 'afraid',
            'zh-hant': '害怕',
            'ja': '怖い',
            'de': 'Verängstigt',
            'fr': 'Effrayé',
            'it': 'Pauroso',
            'ko': '무서운'
          },
          {
            'order': 1,
            'zh-cn': '辉煌的',
            'en': 'splendid',
            'zh-hant': '壯麗',
            'ja': '華麗な',
            'de': 'Prächtig',
            'fr': 'Splendide',
            'it': 'Splendido',
            'ko': '화려한'
          },
          {
            'order': 1,
            'zh-cn': '威严的',
            'en': 'imposing',
            'zh-hant': '氣勢磅礡',
            'ja': '堂々とした',
            'de': 'Imposant',
            'fr': 'Imposant',
            'it': 'Imponente',
            'ko': '위엄있는'
          },
          {
            'order': 1,
            'zh-cn': '巨大的',
            'en': 'monumental',
            'zh-hant': '紀念性',
            'ja': '記念碑的な',
            'de': 'Monumental',
            'fr': 'Monumental',
            'it': 'Monumentale',
            'ko': '기념비적인'
          },
          {
            'order': 1,
            'zh-cn': '宏伟的',
            'en': 'magnificent',
            'zh-hant': '宏偉',
            'ja': '壮大な',
            'de': 'Großartig',
            'fr': 'Magnifique',
            'it': 'Magnifico',
            'ko': '웅장한'
          },
          {
            'order': 1,
            'zh-cn': '华丽的',
            'en': 'exquisite',
            'zh-hant': '精緻',
            'ja': '絶妙な',
            'de': 'Exquisit',
            'fr': 'Exquis',
            'it': 'Squisito',
            'ko': '정교한'
          },
          {
            'order': 1,
            'zh-cn': '极好的',
            'en': 'superb',
            'zh-hant': '極好',
            'ja': '素晴らしい',
            'de': 'Hervorragend',
            'fr': 'Superbe',
            'it': 'Superbo',
            'ko': '훌륭한'
          },
          {
            'order': 1,
            'zh-cn': '神秘的',
            'en': 'mysterious',
            'zh-hant': '神秘',
            'ja': '神秘的な',
            'de': 'Geheimnisvoll',
            'fr': 'Mystérieux',
            'it': 'Misterioso',
            'ko': '신비로운'
          },
          {
            'order': 1,
            'zh-cn': '谜一般的',
            'en': 'enigmatic',
            'zh-hant': '神秘',
            'ja': '謎めいた',
            'de': 'Rätselhaft',
            'fr': 'Enigmatique',
            'it': 'Enigmatico',
            'ko': '수수께끼 같은'
          },
          {
            'order': 1,
            'zh-cn': '深奥的',
            'en': 'esoteric',
            'zh-hant': '深奧',
            'ja': '秘教的な',
            'de': 'Esoterisch',
            'fr': 'Ésotérique',
            'it': 'Esoterico',
            'ko': '심오한'
          },
          {
            'order': 1,
            'zh-cn': '难以解释的',
            'en': 'inexplicable',
            'zh-hant': '無法解釋',
            'ja': '説明できない',
            'de': 'Unerklärlich',
            'fr': 'Inexplicable',
            'it': 'Inesplicabile',
            'ko': '설명할 수 없는'
          },
          {
            'order': 1,
            'zh-cn': '难以理解的',
            'en': 'unfathomable',
            'zh-hant': '高深莫測',
            'ja': '計り知れない',
            'de': 'Unergründlich',
            'fr': 'Impénétrable',
            'it': 'Insondabile',
            'ko': '헤아릴 수 없는'
          },
          {
            'order': 1,
            'zh-cn': '令人迷惑的',
            'en': 'puzzling',
            'zh-hant': '令人費解',
            'ja': '不可解な',
            'de': 'Rätselhaft',
            'fr': 'Déroutant',
            'it': 'Sconcertante',
            'ko': '당혹스러운'
          },
          {
            'order': 1,
            'zh-cn': '不可思议的',
            'en': 'uncanny',
            'zh-hant': '神秘詭異',
            'ja': '不気味な',
            'de': 'Unheimlich',
            'fr': 'Étrange',
            'it': 'Strano',
            'ko': '기이한'
          },
          {
            'order': 1,
            'zh-cn': '迷人的',
            'en': 'enchanting',
            'zh-hant': '迷人',
            'ja': '魅力的な',
            'de': 'Bezaubernd',
            'fr': 'Enchantant',
            'it': 'Incantevole',
            'ko': '매혹적인'
          },
          {
            'order': 1,
            'zh-cn': '魔法般的',
            'en': 'magical',
            'zh-hant': '魔法般的',
            'ja': '魔法のような',
            'de': 'Magisch',
            'fr': 'Magique',
            'it': 'Magico',
            'ko': '마법같은'
          },
          {
            'order': 1,
            'zh-cn': '了不起的',
            'en': 'marvelous',
            'zh-hant': '奇妙',
            'ja': '素晴らしい',
            'de': 'Wundervoll',
            'fr': 'Merveilleux',
            'it': 'Meraviglioso',
            'ko': '놀라운'
          },
          {
            'order': 1,
            'zh-cn': '令人震惊的',
            'en': 'astounding',
            'zh-hant': '令人震驚',
            'ja': '驚くべき',
            'de': 'Erstaunlich',
            'fr': 'Stupéfiant',
            'it': 'Sbalorditivo',
            'ko': '충격적인'
          },
          {
            'order': 1,
            'zh-cn': '难以置信的',
            'en': 'incredible',
            'zh-hant': '難以置信',
            'ja': '信じられない',
            'de': 'Unglaublich',
            'fr': 'Incroyable',
            'it': 'Incredibile',
            'ko': '믿을 수 없는'
          },
          {
            'order': 1,
            'zh-cn': '非凡的',
            'en': 'extraordinary',
            'zh-hant': '非凡',
            'ja': '並外れた',
            'de': 'Außergewöhnlich',
            'fr': 'Extraordinaire',
            'it': 'Straordinario',
            'ko': '비범한'
          },
          {
            'order': 1,
            'zh-cn': '令人惊叹的',
            'en': 'phenomenal',
            'zh-hant': '驚人的',
            'ja': '驚異的な',
            'de': 'Phänomenal',
            'fr': 'Phénoménal',
            'it': 'Fenomenale',
            'ko': '현상적인'
          },
          {
            'order': 1,
            'zh-cn': '几乎不可能的',
            'en': 'improbable',
            'zh-hant': '不大可能',
            'ja': 'あり得ない',
            'de': 'Unwahrscheinlich',
            'fr': 'Improbable',
            'it': 'Improbabile',
            'ko': '있을 수 없는'
          },
          {
            'order': 1,
            'zh-cn': '难以置信的',
            'en': 'unbelievable',
            'zh-hant': '難以置信',
            'ja': '信じられない',
            'de': 'Unglaublich',
            'fr': 'Incrédule',
            'it': 'Incredibile',
            'ko': '믿을 수 없는'
          },
          {
            'order': 1,
            'zh-cn': '奇迹般的',
            'en': 'miraculous',
            'zh-hant': '奇蹟般的',
            'ja': '奇跡的な',
            'de': 'Wundervoll',
            'fr': 'Miraculeux',
            'it': 'Miracoloso',
            'ko': '기적적인'
          },
          {
            'order': 1,
            'zh-cn': '令人惊叹的',
            'en': 'breathtaking',
            'zh-hant': '令人嘆為觀止',
            'ja': '息を呑むような',
            'de': 'Atemberaubend',
            'fr': 'À couper le souffle',
            'it': 'Mozzafiato',
            'ko': '숨막히는'
          },
          {
            'order': 1,
            'zh-cn': '宏伟的',
            'en': 'grandiose',
            'zh-hant': '宏偉',
            'ja': '壮大な',
            'de': 'Grandios',
            'fr': 'Grandiose',
            'it': 'Grandioso',
            'ko': '웅장한'
          },
          {
            'order': 1,
            'zh-cn': '壮丽的',
            'en': 'majestic',
            'zh-hant': '壯麗',
            'ja': '威厳のある',
            'de': 'Majestätisch',
            'fr': 'Majestueux',
            'it': 'Maestoso',
            'ko': '장엄한'
          },
          {
            'order': 1,
            'zh-cn': '绝妙的',
            'en': 'impressive',
            'zh-hant': '令人印象深刻',
            'ja': '印象的な',
            'de': 'Eindrucksvoll',
            'fr': 'Impressionnant',
            'it': 'Impressionante',
            'ko': '인상적인'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '艺术家', en: 'Artist', 'zh-hant': '藝術家', ja: 'アーティスト', de: 'Künstler', fr: 'Artiste', it: 'Artista', ko: '예술가' },
        'list': [
          {
            'order': 1,
            'zh-cn': '阿尔丰斯·慕夏',
            'en': 'Alfons Maria Mucha',
            'zh-hant': '阿爾豐斯·瑪麗亞·穆夏（Alfons Maria Mucha）',
            'ja': 'アルフォンス・マリア・ミュシャ（Alfons Maria Mucha）',
            'de': 'Alfons Maria Mucha',
            'fr': 'Alfons Maria Mucha',
            'it': 'Alfons Maria Mucha',
            'ko': '알폰스 무하'
          },
          {
            'order': 1,
            'zh-cn': '毕卡索',
            'en': 'Pablo Picasso',
            'zh-hant': '巴勃羅·畢卡索（Pablo Picasso）',
            'ja': 'パブロ・ピカソ（Pablo Picasso）',
            'de': 'Pablo Picasso',
            'fr': 'Pablo Picasso',
            'it': 'Pablo Picasso',
            'ko': '파블로 피카소'
          },
          {
            'order': 1,
            'zh-cn': '秀拉',
            'en': 'Seurat',
            'zh-hant': '喬治·修拉（Seurat）',
            'ja': 'ジョルジュ・スーラ（Seurat）',
            'de': 'Georges Seurat',
            'fr': 'Georges Seurat',
            'it': 'Georges Seurat',
            'ko': '조르주 쇠라'
          },
          {
            'order': 1,
            'zh-cn': '拉斐尔',
            'en': 'Raffaello Sanzio Da Urbino',
            'zh-hant': '拉斐爾·桑西奧·達·烏爾比諾（Raffaello Sanzio Da Urbino）',
            'ja': 'ラファエロ・サンティ（Raffaello Sanzio Da Urbino）',
            'de': 'Raffael Santi Da Urbino',
            'fr': 'Raphaël Sanzio Da Urbino',
            'it': 'Raffaello Sanzio Da Urbino',
            'ko': '라파엘로 산치오 다 우르비노'
          },
          {
            'order': 1,
            'zh-cn': '米开朗基罗',
            'en': 'Michelangelo',
            'zh-hant': '米開朗基羅（Michelangelo）',
            'ja': 'ミケランジェロ（Michelangelo）',
            'de': 'Michelangelo',
            'fr': 'Michel-Ange',
            'it': 'Michelangelo',
            'ko': '미켈란젤로'
          },
          {
            'order': 1,
            'zh-cn': '达文西',
            'en': 'Leonardo Da Vinci',
            'zh-hant': '列奧納多·達芬奇（Leonardo Da Vinci）',
            'ja': 'レオナルド・ダ・ヴィンチ（Leonardo Da Vinci）',
            'de': 'Leonardo Da Vinci',
            'fr': 'Léonard de Vinci',
            'it': 'Leonardo Da Vinci',
            'ko': '레오나르도 다 빈치'
          },
          {
            'order': 1,
            'zh-cn': '桑德罗·波提切利',
            'en': 'Sandro Botticelli',
            'zh-hant': '桑德羅·波提切利（Sandro Botticelli）',
            'ja': 'サンドロ・ボッティチェリ（Sandro Botticelli）',
            'de': 'Sandro Botticelli',
            'fr': 'Sandro Botticelli',
            'it': 'Sandro Botticelli',
            'ko': '산드로 보티첼리'
          },
          {
            'order': 1,
            'zh-cn': '让·奥诺雷·弗拉戈纳尔',
            'en': 'Jean-Honoré Fragonard',
            'zh-hant': '讓-奧諾雷·弗拉戈納爾（Jean-Honoré Fragonard）',
            'ja': 'ジャン＝オノレ・フラゴナール（Jean-Honoré Fragonard）',
            'de': 'Jean-Honoré Fragonard',
            'fr': 'Jean-Honoré Fragonard',
            'it': 'Jean-Honoré Fragonard',
            'ko': '장 오노레 프라고나르'
          },
          {
            'order': 1,
            'zh-cn': '古斯塔夫·克里姆特',
            'en': 'Gustav Klimt',
            'zh-hant': '古斯塔夫·克林姆（Gustav Klimt）',
            'ja': 'グスタフ・クリムト（Gustav Klimt）',
            'de': 'Gustav Klimt',
            'fr': 'Gustav Klimt',
            'it': 'Gustav Klimt',
            'ko': '구스타프 클림트'
          },
          {
            'order': 1,
            'zh-cn': '保罗 塞尚',
            'en': 'Paul CéZanne',
            'zh-hant': '保羅·塞尚（Paul Cézanne）',
            'ja': 'ポール・セザンヌ（Paul Cézanne）',
            'de': 'Paul Cézanne',
            'fr': 'Paul Cézanne',
            'it': 'Paul Cézanne',
            'ko': '폴 세잔'
          },
          {
            'order': 1,
            'zh-cn': '文森梵谷',
            'en': 'Vincent Van Gogh',
            'zh-hant': '文森特·梵高（Vincent Van Gogh）',
            'ja': 'フィンセント・ファン・ゴッホ（Vincent Van Gogh）',
            'de': 'Vincent Van Gogh',
            'fr': 'Vincent Van Gogh',
            'it': 'Vincent Van Gogh',
            'ko': '빈센트 반 고흐'
          },
          {
            'order': 1,
            'zh-cn': '保罗高更',
            'en': 'Paul Gauguin',
            'zh-hant': '保羅·高更（Paul Gauguin）',
            'ja': 'ポール・ゴーギャン（Paul Gauguin）',
            'de': 'Paul Gauguin',
            'fr': 'Paul Gauguin',
            'it': 'Paul Gauguin',
            'ko': '폴 고갱'
          },
          {
            'order': 1,
            'zh-cn': '达利',
            'en': 'Salvador Dali',
            'zh-hant': '薩爾瓦多·達利（Salvador Dali）',
            'ja': 'サルバドール・ダリ（Salvador Dali）',
            'de': 'Salvador Dali',
            'fr': 'Salvador Dali',
            'it': 'Salvador Dali',
            'ko': '살바도르 달리'
          },
          {
            'order': 1,
            'zh-cn': '莫内',
            'en': 'Monet',
            'zh-hant': '克勞德·莫奈（Claude Monet）',
            'ja': 'クロード・モネ（Claude Monet）',
            'de': 'Claude Monet',
            'fr': 'Claude Monet',
            'it': 'Claude Monet',
            'ko': '클로드 모네'
          },
          {
            'order': 1,
            'zh-cn': '康丁斯基',
            'en': 'Wassily Kandinsky',
            'zh-hant': '瓦西里·康丁斯基（Wassily Kandinsky）',
            'ja': 'ワシリー・カンディンスキー（Wassily Kandinsky）',
            'de': 'Wassily Kandinsky',
            'fr': 'Wassily Kandinsky',
            'it': 'Wassily Kandinsky',
            'ko': '바실리 칸딘스키'
          },
          {
            'order': 1,
            'zh-cn': '欧姬芙',
            'en': 'O\'Keeffe',
            'zh-hant': '喬治亞·歐姬芙（Georgia O\'Keeffe）',
            'ja': 'ジョージア・オキーフ（Georgia O\'Keeffe）',
            'de': 'Georgia O\'Keeffe',
            'fr': 'Georgia O\'Keeffe',
            'it': 'Georgia O\'Keeffe',
            'ko': '조지아 오키프'
          },
          {
            'order': 1,
            'zh-cn': '马列维奇',
            'en': 'Kazimir Malevich',
            'zh-hant': '卡濟米爾·馬列維奇（Kazimir Malevich）',
            'ja': 'カジミール・マレーヴィチ（Kazimir Malevich）',
            'de': 'Kasimir Malewitsch',
            'fr': 'Kazimir Malevich',
            'it': 'Kazimir Malevich',
            'ko': '카지미르 말레비치'
          },
          {
            'order': 1,
            'zh-cn': '蒙德里安',
            'en': 'Piet Mondrian',
            'zh-hant': '皮特·蒙德里安（Piet Mondrian）',
            'ja': 'ピート・モンドリアン（Piet Mondrian）',
            'de': 'Piet Mondrian',
            'fr': 'Piet Mondrian',
            'it': 'Piet Mondrian',
            'ko': '피트 몬드리안'
          },
          {
            'order': 1,
            'zh-cn': '安迪沃荷',
            'en': 'Andy Warhol',
            'zh-hant': '安迪·沃荷（Andy Warhol）',
            'ja': 'アンディ・ウォーホル（Andy Warhol）',
            'de': 'Andy Warhol',
            'fr': 'Andy Warhol',
            'it': 'Andy Warhol',
            'ko': '앤디 워홀'
          },
          {
            'order': 1,
            'zh-cn': '葛饰北斎',
            'en': 'Katsushika Hokusai',
            'zh-hant': '葛飾北齋（Katsushika Hokusai）',
            'ja': '葛飾北斎',
            'de': 'Katsushika Hokusai',
            'fr': 'Katsushika Hokusai',
            'it': 'Katsushika Hokusai',
            'ko': '가쓰시카 호쿠사이'
          },
          {
            'order': 1,
            'zh-cn': '竹久梦二',
            'en': 'TAKEHISA YUMEJI',
            'zh-hant': '竹久夢二（Takehisa Yumeji）',
            'ja': '竹久夢二',
            'de': 'Takehisa Yumeji',
            'fr': 'Takehisa Yumeji',
            'it': 'Takehisa Yumeji',
            'ko': '다케히사 유메지'
          },
          {
            'order': 1,
            'zh-cn': '古斯塔夫·多雷',
            'en': 'Gustave Doré',
            'zh-hant': '古斯塔夫·多雷（Gustave Doré）',
            'ja': 'ギュスターヴ・ドレ（Gustave Doré）',
            'de': 'Gustave Doré',
            'fr': 'Gustave Doré',
            'it': 'Gustave Doré',
            'ko': '귀스타브 도레'
          },
          {
            'order': 1,
            'zh-cn': '唐寅',
            'en': 'Tang Yin',
            'zh-hant': '唐寅',
            'ja': '唐寅',
            'de': 'Tang Yin',
            'fr': 'Tang Yin',
            'it': 'Tang Yin',
            'ko': '당인'
          },
          {
            'order': 1,
            'zh-cn': '约翰·辛格·萨金特',
            'en': 'John Singer Sargent',
            'zh-hant': '約翰·辛格·薩金特（John Singer Sargent）',
            'ja': 'ジョン・シンガー・サージェント（John Singer Sargent）',
            'de': 'John Singer Sargent',
            'fr': 'John Singer Sargent',
            'it': 'John Singer Sargent',
            'ko': '존 싱어 사전트'
          },
          {
            'order': 1,
            'zh-cn': '伊藤润二',
            'en': 'Junji Ito',
            'zh-hant': '伊藤潤二（Junji Ito）',
            'ja': '伊藤潤二（Junji Ito）',
            'de': 'Junji Ito',
            'fr': 'Junji Ito',
            'it': 'Junji Ito',
            'ko': '이토 준지'
          },
          {
            'order': 1,
            'zh-cn': '张大千',
            'en': 'Zhang Daqian',
            'zh-hant': '張大千',
            'ja': '張大千',
            'de': 'Zhang Daqian',
            'fr': 'Zhang Daqian',
            'it': 'Zhang Daqian',
            'ko': '장다첸'
          },
          {
            'order': 1,
            'zh-cn': '伊东深水',
            'en': 'Ito Shinsui',
            'zh-hant': '伊東深水（Ito Shinsui）',
            'ja': '伊東深水（Ito Shinsui）',
            'de': 'Ito Shinsui',
            'fr': 'Ito Shinsui',
            'it': 'Ito Shinsui',
            'ko': '이토 신수이'
          },
          {
            'order': 1,
            'zh-cn': '上村松园',
            'en': 'Matsuo Basho',
            'zh-hant': '松尾芭蕉（Matsuo Basho）',
            'ja': '松尾芭蕉（Matsuo Basho）',
            'de': 'Matsuo Basho',
            'fr': 'Matsuo Basho',
            'it': 'Matsuo Basho',
            'ko': '마쓰오 바쇼'
          },
          {
            'order': 1,
            'zh-cn': '尾田荣一郎',
            'en': 'Eiichiro Oda',
            'zh-hant': '尾田榮一郎（Eiichiro Oda）',
            'ja': '尾田栄一郎（Eiichiro Oda）',
            'de': 'Eiichiro Oda',
            'fr': 'Eiichiro Oda',
            'it': 'Eiichiro Oda',
            'ko': '오다 에이치로'
          },
          {
            'order': 1,
            'zh-cn': '庵野秀明',
            'en': 'Hideaki Anno',
            'zh-hant': '庵野秀明（Hideaki Anno）',
            'ja': '庵野秀明（Hideaki Anno）',
            'de': 'Hideaki Anno',
            'fr': 'Hideaki Anno',
            'it': 'Hideaki Anno',
            'ko': '안노 히데아키'
          },
          {
            'order': 1,
            'zh-cn': '岛山明',
            'en': 'Akira Toriyama',
            'zh-hant': '鳥山明（Akira Toriyama）',
            'ja': '鳥山明（Akira Toriyama）',
            'de': 'Akira Toriyama',
            'fr': 'Akira Toriyama',
            'it': 'Akira Toriyama',
            'ko': '토리야마 아키라'
          },
          {
            'order': 1,
            'zh-cn': '大友克洋',
            'en': 'Katsuhiro Otomo',
            'zh-hant': '大友克洋（Katsuhiro Otomo）',
            'ja': '大友克洋（Katsuhiro Otomo）',
            'de': 'Katsuhiro Otomo',
            'fr': 'Katsuhiro Otomo',
            'it': 'Katsuhiro Otomo',
            'ko': '오토모 가쓰히로'
          },
          {
            'order': 1,
            'zh-cn': '奈良美智',
            'en': 'Yoshitomo Nara',
            'zh-hant': '奈良美智（Yoshitomo Nara）',
            'ja': '奈良美智（Yoshitomo Nara）',
            'de': 'Yoshitomo Nara',
            'fr': 'Yoshitomo Nara',
            'it': 'Yoshitomo Nara',
            'ko': '나라 요시토모'
          },
          {
            'order': 1,
            'zh-cn': '村上隆',
            'en': 'Takashi Murakami',
            'zh-hant': '村上隆（Takashi Murakami）',
            'ja': '村上隆（Takashi Murakami）',
            'de': 'Takashi Murakami',
            'fr': 'Takashi Murakami',
            'it': 'Takashi Murakami',
            'ko': '무라카미 다카시'
          },
          {
            'order': 1,
            'zh-cn': '吉卜力工作室',
            'en': 'Ghibli Studio',
            'zh-hant': '吉卜力工作室（Ghibli Studio）',
            'ja': 'ジブリスタジオ（Ghibli Studio）',
            'de': 'Ghibli Studio',
            'fr': 'Studio Ghibli',
            'it': 'Studio Ghibli',
            'ko': '지브리 스튜디오'
          },
          {
            'order': 1,
            'zh-cn': '新海诚',
            'en': 'Shinkai Makoto',
            'zh-hant': '新海誠（Shinkai Makoto）',
            'ja': '新海誠（Shinkai Makoto）',
            'de': 'Shinkai Makoto',
            'fr': 'Shinkai Makoto',
            'it': 'Shinkai Makoto',
            'ko': '신카이 마코토'
          },
          {
            'order': 1,
            'zh-cn': '宫崎骏',
            'en': 'Miyazaki Hayao',
            'zh-hant': '宮崎駿（Miyazaki Hayao）',
            'ja': '宮崎駿（Miyazaki Hayao）',
            'de': 'Miyazaki Hayao',
            'fr': 'Miyazaki Hayao',
            'it': 'Miyazaki Hayao',
            'ko': '미야자키 하야오'
          },
          {
            'order': 1,
            'zh-cn': '藤ちょこ',
            'en': 'Fuji Choko',
            'zh-hant': '藤ちょこ（Fuji Choko）',
            'ja': '藤ちょこ（Fuji Choko）',
            'de': 'Fuji Choko',
            'fr': 'Fuji Choko',
            'it': 'Fuji Choko',
            'ko': '후지 초코'
          },
          {
            'order': 1,
            'zh-cn': 'James Jean',
            'en': 'James Jean',
            'zh-hant': '詹姆斯·讓（James Jean）',
            'ja': 'ジェームズ・ジーン（James Jean）',
            'de': 'James Jean',
            'fr': 'James Jean',
            'it': 'James Jean',
            'ko': '제임스 진'
          },
          {
            'order': 1,
            'zh-cn': 'Craig Mullins',
            'en': 'Craig Mullins',
            'zh-hant': '克雷格·穆林斯（Craig Mullins）',
            'ja': 'クレイグ・マリンズ（Craig Mullins）',
            'de': 'Craig Mullins',
            'fr': 'Craig Mullins',
            'it': 'Craig Mullins',
            'ko': '크레이그 멀린스'
          },
          {
            'order': 1,
            'zh-cn': 'Sylvain Sarrailh',
            'en': 'Sylvain Sarrailh',
            'zh-hant': '西爾萬·薩拉伊（Sylvain Sarrailh）',
            'ja': 'シルヴァン・サライ（Sylvain Sarrailh）',
            'de': 'Sylvain Sarrailh',
            'fr': 'Sylvain Sarrailh',
            'it': 'Sylvain Sarrailh',
            'ko': '실뱅 사라이'
          },
          {
            'order': 1,
            'zh-cn': 'Peter Mohrbacher',
            'en': 'Peter Mohrbacher',
            'zh-hant': '彼得·莫赫巴赫（Peter Mohrbacher）',
            'ja': 'ピーター・モールバッハー（Peter Mohrbacher）',
            'de': 'Peter Mohrbacher',
            'fr': 'Peter Mohrbacher',
            'it': 'Peter Mohrbacher',
            'ko': '피터 모어바커'
          },
          {
            'order': 1,
            'zh-cn': 'Nekro',
            'en': 'Nekro',
            'zh-hant': 'Nekro',
            'ja': 'ネクロ（Nekro）',
            'de': 'Nekro',
            'fr': 'Nekro',
            'it': 'Nekro',
            'ko': '네크로'
          },
          {
            'order': 1,
            'zh-cn': '林布兰',
            'en': 'Rembrandt',
            'zh-hant': '倫勃朗（Rembrandt）',
            'ja': 'レンブラント（Rembrandt）',
            'de': 'Rembrandt',
            'fr': 'Rembrandt',
            'it': 'Rembrandt',
            'ko': '렘브란트'
          },
          {
            'order': 1,
            'zh-cn': 'Mike Mignola',
            'en': 'Mike Mignola',
            'zh-hant': '邁克·米格諾拉（Mike Mignola）',
            'ja': 'マイク・ミニョーラ（Mike Mignola）',
            'de': 'Mike Mignola',
            'fr': 'Mike Mignola',
            'it': 'Mike Mignola',
            'ko': '마이크 미뇰라'
          },
          {
            'order': 1,
            'zh-cn': 'Dan Mumford',
            'en': 'Dan Mumford',
            'zh-hant': '丹·曼福德（Dan Mumford）',
            'ja': 'ダン・マンフォード（Dan Mumford）',
            'de': 'Dan Mumford',
            'fr': 'Dan Mumford',
            'it': 'Dan Mumford',
            'ko': '댄 멈포드'
          },
          {
            'order': 1,
            'zh-cn': '罗斯·特兰',
            'en': 'Ross Tran',
            'zh-hant': '羅斯·陳（Ross Tran）',
            'ja': 'ロス・トラン（Ross Tran）',
            'de': 'Ross Tran',
            'fr': 'Ross Tran',
            'it': 'Ross Tran',
            'ko': '로스 트란'
          },
          {
            'order': 1,
            'zh-cn': 'Loish',
            'en': 'Loish',
            'zh-hant': 'Loish',
            'ja': 'Loish',
            'de': 'Loish',
            'fr': 'Loish',
            'it': 'Loish',
            'ko': '로이시'
          },
          {
            'order': 1,
            'zh-cn': '马克·西莫内蒂',
            'en': 'Marc Simonetti',
            'zh-hant': '馬克·西蒙內蒂（Marc Simonetti）',
            'ja': 'マーク・シモネッティ（Marc Simonetti）',
            'de': 'Marc Simonetti',
            'fr': 'Marc Simonetti',
            'it': 'Marc Simonetti',
            'ko': '마크 시모네티'
          },
          {
            'order': 1,
            'zh-cn': '碎形几何',
            'en': 'Hal Tenny',
            'zh-hant': '哈爾·特尼（Hal Tenny）',
            'ja': 'ハル・テニー（Hal Tenny）',
            'de': 'Hal Tenny',
            'fr': 'Hal Tenny',
            'it': 'Hal Tenny',
            'ko': '할 테니'
          },
          {
            'order': 1,
            'zh-cn': '知名电影海报创作',
            'en': 'Works ADV',
            'zh-hant': 'Works ADV',
            'ja': 'Works ADV',
            'de': 'Works ADV',
            'fr': 'Works ADV',
            'it': 'Works ADV',
            'ko': 'Works ADV'
          },
          {
            'order': 1,
            'zh-cn': '漫威视觉总监',
            'en': 'Andyparkart',
            'zh-hant': '安迪·帕克（Andy Park）',
            'ja': 'アンディ・パーク（Andy Park）',
            'de': 'Andy Park',
            'fr': 'Andy Park',
            'it': 'Andy Park',
            'ko': '앤디 파크'
          },
          {
            'order': 1,
            'zh-cn': 'DC漫画人物设计',
            'en': 'Artgerm',
            'zh-hant': 'Artgerm',
            'ja': 'Artgerm',
            'de': 'Artgerm',
            'fr': 'Artgerm',
            'it': 'Artgerm',
            'ko': '아트젬'
          },
          {
            'order': 1,
            'zh-cn': '奇幻般的美女和华丽细节',
            'en': 'WLOP',
            'zh-hant': 'WLOP',
            'ja': 'WLOP',
            'de': 'WLOP',
            'fr': 'WLOP',
            'it': 'WLOP',
            'ko': 'WLOP'
          },
          {
            'order': 1,
            'zh-cn': '人物概念设计 场景皆有',
            'en': 'Andrei Riabovitchev',
            'zh-hant': '安德烈·利亞博維切夫（Andrei Riabovitchev）',
            'ja': 'アンドレイ・リャボヴィチェフ（Andrei Riabovitchev）',
            'de': 'Andrei Riabovitchev',
            'fr': 'Andrei Riabovitchev',
            'it': 'Andrei Riabovitchev',
            'ko': '안드레이 리아보비체프'
          },
          {
            'order': 1,
            'zh-cn': '巴洛克、空想猎奇',
            'en': 'Zdzislaw Beksinski',
            'zh-hant': '茲德斯瓦夫·貝克辛斯基（Zdzislaw Beksinski）',
            'ja': 'ズジスワフ・ベクシンスキー（Zdzislaw Beksinski）',
            'de': 'Zdzislaw Beksinski',
            'fr': 'Zdzislaw Beksinski',
            'it': 'Zdzislaw Beksinski',
            'ko': '즈지스와프 벡신스키'
          },
          {
            'order': 1,
            'zh-cn': '皆叶英夫',
            'en': 'Minaba Hideo',
            'zh-hant': '美納巴·英夫（Minaba Hideo）',
            'ja': '皆葉英夫（Minaba Hideo）',
            'de': 'Minaba Hideo',
            'fr': 'Minaba Hideo',
            'it': 'Minaba Hideo',
            'ko': '미나바 히데오'
          },
          {
            'order': 1,
            'zh-cn': '欧文·戴维',
            'en': 'Owen Davey',
            'zh-hant': '歐文·戴維（Owen Davey）',
            'ja': 'オーウェン・デイビー（Owen Davey）',
            'de': 'Owen Davey',
            'fr': 'Owen Davey',
            'it': 'Owen Davey',
            'ko': '오웬 데이비'
          },
          {
            'order': 1,
            'zh-cn': '菲利普·博尔特',
            'en': 'Philip Boelter',
            'zh-hant': '菲利普·博爾特（Philip Boelter）',
            'ja': 'フィリップ・ボールター（Philip Boelter）',
            'de': 'Philip Boelter',
            'fr': 'Philip Boelter',
            'it': 'Philip Boelter',
            'ko': '필립 볼터'
          },
          {
            'order': 1,
            'zh-cn': '爱德华·戈瑞',
            'en': 'Edward Gorey',
            'zh-hant': '愛德華·戈里（Edward Gorey）',
            'ja': 'エドワード・ゴーリー（Edward Gorey）',
            'de': 'Edward Gorey',
            'fr': 'Edward Gorey',
            'it': 'Edward Gorey',
            'ko': '에드워드 고리'
          },
          {
            'order': 1,
            'zh-cn': '吉田博',
            'en': 'Hiroshi Yoshida',
            'zh-hant': '吉田博（Hiroshi Yoshida）',
            'ja': '吉田博（Hiroshi Yoshida）',
            'de': 'Hiroshi Yoshida',
            'fr': 'Hiroshi Yoshida',
            'it': 'Hiroshi Yoshida',
            'ko': '요시다 히로시'
          },
          {
            'order': 1,
            'zh-cn': '马克斯·恩斯特',
            'en': 'Max Ernst',
            'zh-hant': '馬克斯·恩斯特（Max Ernst）',
            'ja': 'マックス・エルンスト（Max Ernst）',
            'de': 'Max Ernst',
            'fr': 'Max Ernst',
            'it': 'Max Ernst',
            'ko': '막스 에른스트'
          },
          {
            'order': 1,
            'zh-cn': '保罗·希涅克',
            'en': 'Paul Signac',
            'zh-hant': '保羅·西涅克（Paul Signac）',
            'ja': 'ポール・シニャック（Paul Signac）',
            'de': 'Paul Signac',
            'fr': 'Paul Signac',
            'it': 'Paul Signac',
            'ko': '폴 시냑'
          },
          {
            'order': 1,
            'zh-cn': '詹姆斯·格尼',
            'en': 'James Gurney',
            'zh-hant': '詹姆斯·格尼（James Gurney）',
            'ja': 'ジェームズ・ガーニー（James Gurney）',
            'de': 'James Gurney',
            'fr': 'James Gurney',
            'it': 'James Gurney',
            'ko': '제임스 거니'
          },
          {
            'order': 1,
            'zh-cn': '摩里茨·科奈里斯·埃舍尔',
            'en': 'M.C. Escher',
            'zh-hant': 'M.C.艾舍爾（M.C. Escher）',
            'ja': 'M.C.エッシャー（M.C. Escher）',
            'de': 'M.C. Escher',
            'fr': 'M.C. Escher',
            'it': 'M.C. Escher',
            'ko': 'M.C. 에셔'
          },
          {
            'order': 1,
            'zh-cn': '汤玛斯·金凯德',
            'en': 'Thomas Kinkade',
            'zh-hant': '湯瑪斯·金凱德（Thomas Kinkade）',
            'ja': 'トーマス・キンケード（Thomas Kinkade）',
            'de': 'Thomas Kinkade',
            'fr': 'Thomas Kinkade',
            'it': 'Thomas Kinkade',
            'ko': '토마스 킨케이드'
          },
          {
            'order': 1,
            'zh-cn': '伊凡·康斯坦丁诺维奇·艾瓦佐夫斯基',
            'en': 'Ivan Aivazovsky',
            'zh-hant': '伊凡·艾瓦佐夫斯基（Ivan Aivazovsky）',
            'ja': 'イヴァン・アイヴァゾフスキー（Ivan Aivazovsky）',
            'de': 'Ivan Aivazovsky',
            'fr': 'Ivan Aivazovsky',
            'it': 'Ivan Aivazovsky',
            'ko': '이반 아이바조프스키'
          },
          {
            'order': 1,
            'zh-cn': '卡尔维诺',
            'en': 'Italo Calvino',
            'zh-hant': '伊塔洛·卡爾維諾（Italo Calvino）',
            'ja': 'イタロ・カルヴィーノ（Italo Calvino）',
            'de': 'Italo Calvino',
            'fr': 'Italo Calvino',
            'it': 'Italo Calvino',
            'ko': '이탈로 칼비노'
          },
          {
            'order': 1,
            'zh-cn': '诺曼·洛克威尔',
            'en': 'Norman Rockwell',
            'zh-hant': '諾曼·洛克威爾（Norman Rockwell）',
            'ja': 'ノーマン・ロックウェル（Norman Rockwell）',
            'de': 'Norman Rockwell',
            'fr': 'Norman Rockwell',
            'it': 'Norman Rockwell',
            'ko': '노먼 록웰'
          },
          {
            'order': 1,
            'zh-cn': '阿尔伯特·比尔施塔特',
            'en': 'Albert Bierstadt',
            'zh-hant': '阿爾伯特·比爾施塔特（Albert Bierstadt）',
            'ja': 'アルバート・ビアスタット（Albert Bierstadt）',
            'de': 'Albert Bierstadt',
            'fr': 'Albert Bierstadt',
            'it': 'Albert Bierstadt',
            'ko': '알버트 비어슈타트'
          },
          {
            'order': 1,
            'zh-cn': '乔治欧·德·奇里诃',
            'en': 'Giorgio De Chirico',
            'zh-hant': '喬治·德·基里科（Giorgio De Chirico）',
            'ja': 'ジョルジョ・デ・キリコ（Giorgio De Chirico）',
            'de': 'Giorgio De Chirico',
            'fr': 'Giorgio De Chirico',
            'it': 'Giorgio De Chirico',
            'ko': '조르조 데 키리코'
          },
          {
            'order': 1,
            'zh-cn': '雷内·马格利特',
            'en': 'Rene Magritte',
            'zh-hant': '勒內·馬格利特（Rene Magritte）',
            'ja': 'ルネ・マグリット（Rene Magritte）',
            'de': 'René Magritte',
            'fr': 'René Magritte',
            'it': 'René Magritte',
            'ko': '르네 마그리트'
          },
          {
            'order': 1,
            'zh-cn': '约翰·哈里斯',
            'en': 'John Harris',
            'zh-hant': '約翰·哈里斯（John Harris）',
            'ja': 'ジョン・ハリス（John Harris）',
            'de': 'John Harris',
            'fr': 'John Harris',
            'it': 'John Harris',
            'ko': '존 해리스'
          },
          {
            'order': 1,
            'zh-cn': '希尔玛·阿芙·克林特',
            'en': 'Hilma Af Klint',
            'zh-hant': '希爾瑪·阿夫·克林特（Hilma Af Klint）',
            'ja': 'ヒルマ・アフ・クリント（Hilma Af Klint）',
            'de': 'Hilma Af Klint',
            'fr': 'Hilma Af Klint',
            'it': 'Hilma Af Klint',
            'ko': '힐마 아프 클린트'
          },
          {
            'order': 1,
            'zh-cn': '乔治·英尼斯',
            'en': 'George Inness',
            'zh-hant': '喬治·伊尼斯（George Inness）',
            'ja': 'ジョージ・イネス（George Inness）',
            'de': 'George Inness',
            'fr': 'George Inness',
            'it': 'George Inness',
            'ko': '조지 이네스'
          },
          {
            'order': 1,
            'zh-cn': '威廉·布莱克',
            'en': 'William Blake',
            'zh-hant': '威廉·布雷克（William Blake）',
            'ja': 'ウィリアム・ブレイク（William Blake）',
            'de': 'William Blake',
            'fr': 'William Blake',
            'it': 'William Blake',
            'ko': '윌리엄 블레이크'
          },
          {
            'order': 1,
            'zh-cn': '格雷戈里·鲁特科夫斯基',
            'en': 'Greg Rutkowski',
            'zh-hant': '格雷格·魯特科夫斯基（Greg Rutkowski）',
            'ja': 'グレッグ・ルトコウスキー（Greg Rutkowski）',
            'de': 'Greg Rutkowski',
            'fr': 'Greg Rutkowski',
            'it': 'Greg Rutkowski',
            'ko': '그렉 루트코프스키'
          },
          {
            'order': 1,
            'zh-cn': '史蒂文·贝勒丁',
            'en': 'Steven Belledin',
            'zh-hant': '史蒂文·貝爾丁（Steven Belledin）',
            'ja': 'スティーブン・ベレディン（Steven Belledin）',
            'de': 'Steven Belledin',
            'fr': 'Steven Belledin',
            'it': 'Steven Belledin',
            'ko': '스티븐 벨레딘'
          },
          {
            'order': 1,
            'zh-cn': '吉卜力工作室',
            'en': 'Studio Ghibli',
            'zh-hant': '吉卜力工作室（Studio Ghibli）',
            'ja': 'スタジオジブリ（Studio Ghibli）',
            'de': 'Studio Ghibli',
            'fr': 'Studio Ghibli',
            'it': 'Studio Ghibli',
            'ko': '스튜디오 지브리'
          },
          {
            'order': 1,
            'zh-cn': '杰拉德·布罗姆',
            'en': 'Gerald Brom',
            'zh-hant': '傑拉德·布羅姆（Gerald Brom）',
            'ja': 'ジェラルド・ブロム（Gerald Brom）',
            'de': 'Gerald Brom',
            'fr': 'Gerald Brom',
            'it': 'Gerald Brom',
            'ko': '제럴드 브롬'
          },
          {
            'order': 1,
            'zh-cn': '伊万·比里宾',
            'en': 'Ivan Bilibin',
            'zh-hant': '伊萬·比利賓（Ivan Bilibin）',
            'ja': 'イワン・ビリビン（Ivan Bilibin）',
            'de': 'Ivan Bilibin',
            'fr': 'Ivan Bilibin',
            'it': 'Ivan Bilibin',
            'ko': '이반 빌리빈'
          },
          {
            'order': 1,
            'zh-cn': '亚瑟·拉克姆',
            'en': 'Arthur Rackham',
            'zh-hant': '阿瑟·拉克姆（Arthur Rackham）',
            'ja': 'アーサー・ラッカム（Arthur Rackham）',
            'de': 'Arthur Rackham',
            'fr': 'Arthur Rackham',
            'it': 'Arthur Rackham',
            'ko': '아서 랙햄'
          },
          {
            'order': 1,
            'zh-cn': '埃德蒙·杜拉克',
            'en': 'Edmund Dulac',
            'zh-hant': '埃德蒙·杜拉克（Edmund Dulac）',
            'ja': 'エドマンド・デュラック（Edmund Dulac）',
            'de': 'Edmund Dulac',
            'fr': 'Edmund Dulac',
            'it': 'Edmund Dulac',
            'ko': '에드먼드 듈락'
          },
          {
            'order': 1,
            'zh-cn': '约翰·威廉·瓦特豪斯',
            'en': 'John William Waterhouse',
            'zh-hant': '約翰·威廉·沃特豪斯（John William Waterhouse）',
            'ja': 'ジョン・ウィリアム・ウォーターハウス（John William Waterhouse）',
            'de': 'John William Waterhouse',
            'fr': 'John William Waterhouse',
            'it': 'John William Waterhouse',
            'ko': '존 윌리엄 워터하우스'
          },
          {
            'order': 1,
            'zh-cn': '麦可·惠伦',
            'en': 'Michael Whelan',
            'zh-hant': '麥可·惠蘭（Michael Whelan）',
            'ja': 'マイケル・ウェラン（Michael Whelan）',
            'de': 'Michael Whelan',
            'fr': 'Michael Whelan',
            'it': 'Michael Whelan',
            'ko': '마이클 웰란'
          },
          {
            'order': 1,
            'zh-cn': '魏斯·安德森',
            'en': 'Wes Anderson',
            'zh-hant': '韋斯·安德森（Wes Anderson）',
            'ja': 'ウェス・アンダーソン（Wes Anderson）',
            'de': 'Wes Anderson',
            'fr': 'Wes Anderson',
            'it': 'Wes Anderson',
            'ko': '웨스 앤더슨'
          },
          {
            'order': 1,
            'zh-cn': '陈志勇',
            'en': 'Shaun Tan',
            'zh-hant': '湯紹涵（Shaun Tan）',
            'ja': 'シャオウン・タン（Shaun Tan）',
            'de': 'Shaun Tan',
            'fr': 'Shaun Tan',
            'it': 'Shaun Tan',
            'ko': '숀 탄'
          },
          {
            'order': 1,
            'zh-cn': 'タケダヒロキ',
            'en': 'Hiroki Takeda',
            'zh-hant': '竹田弘樹（Hiroki Takeda）',
            'ja': '竹田弘樹（Hiroki Takeda）',
            'de': 'Hiroki Takeda',
            'fr': 'Hiroki Takeda',
            'it': 'Hiroki Takeda',
            'ko': '다케다 히로키'
          },
          {
            'order': 1,
            'zh-cn': '质物霁画',
            'en': 'BOTANIPLAN VON LEE CHI',
            'zh-hant': '李翊（BOTANIPLAN VON LEE CHI）',
            'ja': 'BOTANIPLAN VON LEE CHI（李翊）',
            'de': 'BOTANIPLAN VON LEE CHI',
            'fr': 'BOTANIPLAN VON LEE CHI',
            'it': 'BOTANIPLAN VON LEE CHI',
            'ko': 'BOTANIPLAN VON LEE CHI'
          },
          {
            'order': 1,
            'zh-cn': '汤姆·萨克斯',
            'en': 'Tom Sachs',
            'zh-hant': '湯姆·薩克斯（Tom Sachs）',
            'ja': 'トム・サックス（Tom Sachs）',
            'de': 'Tom Sachs',
            'fr': 'Tom Sachs',
            'it': 'Tom Sachs',
            'ko': '톰 삭스'
          },
          {
            'order': 1,
            'zh-cn': '阿什利·伍德',
            'en': 'Ashley Wood',
            'zh-hant': '艾希禮·伍德（Ashley Wood）',
            'ja': 'アシュリー・ウッド（Ashley Wood）',
            'de': 'Ashley Wood',
            'fr': 'Ashley Wood',
            'it': 'Ashley Wood',
            'ko': '애슐리 우드'
          },
          {
            'order': 1,
            'zh-cn': '空山基',
            'en': 'Hajime Sorayama',
            'zh-hant': '空山基（Hajime Sorayama）',
            'ja': '空山基（Hajime Sorayama）',
            'de': 'Hajime Sorayama',
            'fr': 'Hajime Sorayama',
            'it': 'Hajime Sorayama',
            'ko': '소라야마 하지메'
          },
          {
            'order': 1,
            'zh-cn': '盐田千春',
            'en': 'Chiharu Shiota',
            'zh-hant': '塩田千春（Chiharu Shiota）',
            'ja': '塩田千春（Chiharu Shiota）',
            'de': 'Chiharu Shiota',
            'fr': 'Chiharu Shiota',
            'it': 'Chiharu Shiota',
            'ko': '시오타 치하루'
          },
          {
            'order': 1,
            'zh-cn': '米尔科·赖瑟',
            'en': 'Mirko Reisser',
            'zh-hant': '米爾科·雷瑟（Mirko Reisser）',
            'ja': 'ミルコ・レイサー（Mirko Reisser）',
            'de': 'Mirko Reisser',
            'fr': 'Mirko Reisser',
            'it': 'Mirko Reisser',
            'ko': '미르코 라이서'
          },
          {
            'order': 1,
            'zh-cn': '克丽丝托·瓦格纳',
            'en': 'Crystal Wagner',
            'zh-hant': '克里斯塔·瓦格納（Crystal Wagner）',
            'ja': 'クリスタル・ワグナー（Crystal Wagner）',
            'de': 'Crystal Wagner',
            'fr': 'Crystal Wagner',
            'it': 'Crystal Wagner',
            'ko': '크리스탈 와그너'
          },
          {
            'order': 1,
            'zh-cn': '郑问',
            'en': 'Zheng Wen',
            'zh-hant': '鄭問',
            'ja': '鄭問（Zheng Wen）',
            'de': 'Zheng Wen',
            'fr': 'Zheng Wen',
            'it': 'Zheng Wen',
            'ko': '정 원'
          },
          {
            'order': 1,
            'zh-cn': '乔纳森·索尔特',
            'en': 'Jonathan Solter',
            'zh-hant': '喬納森·索特（Jonathan Solter）',
            'ja': 'ジョナサン・ソルター（Jonathan Solter）',
            'de': 'Jonathan Solter',
            'fr': 'Jonathan Solter',
            'it': 'Jonathan Solter',
            'ko': '조나단 솔터'
          },
          {
            'order': 1,
            'zh-cn': '布赖恩·弗劳德',
            'en': 'Brian Froud',
            'zh-hant': '布萊恩·弗勞德（Brian Froud）',
            'ja': 'ブライアン・フラウド（Brian Froud）',
            'de': 'Brian Froud',
            'fr': 'Brian Froud',
            'it': 'Brian Froud',
            'ko': '브라이언 프라우드'
          },
          {
            'order': 1,
            'zh-cn': '罗杰·迪恩',
            'en': 'Roger Dean',
            'zh-hant': '羅傑·迪恩（Roger Dean）',
            'ja': 'ロジャー・ディーン（Roger Dean）',
            'de': 'Roger Dean',
            'fr': 'Roger Dean',
            'it': 'Roger Dean',
            'ko': '로저 딘'
          },
          {
            'order': 1,
            'zh-cn': '罗文娜·米克斯·阿布迪',
            'en': 'Rowena Meeks Abdy',
            'zh-hant': '羅溫娜·米克斯·阿布迪（Rowena Meeks Abdy）',
            'ja': 'ロウェナ・ミークス・アブディ（Rowena Meeks Abdy）',
            'de': 'Rowena Meeks Abdy',
            'fr': 'Rowena Meeks Abdy',
            'it': 'Rowena Meeks Abdy',
            'ko': '로웨나 믹스 압디'
          },
          {
            'order': 1,
            'zh-cn': '黒瀬来华',
            'en': 'Laica Chrose',
            'zh-hant': 'Laica Chrose',
            'ja': 'Laica Chrose',
            'de': 'Laica Chrose',
            'fr': 'Laica Chrose',
            'it': 'Laica Chrose',
            'ko': '라이카 크로즈'
          },
          {
            'order': 1,
            'zh-cn': '岸本齐史',
            'en': 'Masashi Kishimoto',
            'zh-hant': '岸本齊史（Masashi Kishimoto）',
            'ja': '岸本斉史（Masashi Kishimoto）',
            'de': 'Masashi Kishimoto',
            'fr': 'Masashi Kishimoto',
            'it': 'Masashi Kishimoto',
            'ko': '키시모토 마사시'
          },
          {
            'order': 1,
            'zh-cn': '格雷戈里·克鲁德森',
            'en': 'Gregory Crewdson',
            'zh-hant': '格雷戈里·克魯德森（Gregory Crewdson）',
            'ja': 'グレゴリー・クルードソン（Gregory Crewdson）',
            'de': 'Gregory Crewdson',
            'fr': 'Gregory Crewdson',
            'it': 'Gregory Crewdson',
            'ko': '그레고리 크루드슨'
          },
          {
            'order': 1,
            'zh-cn': '彼得·祖姆托尔',
            'en': 'Peter Zumthor',
            'zh-hant': '彼得·卒姆托（Peter Zumthor）',
            'ja': 'ペーター・ズントー（Peter Zumthor）',
            'de': 'Peter Zumthor',
            'fr': 'Peter Zumthor',
            'it': 'Peter Zumthor',
            'ko': '페터 춤토르'
          },
          {
            'order': 1,
            'zh-cn': '隈研吾',
            'en': 'Kengo Kuma',
            'zh-hant': '隈研吾（Kengo Kuma）',
            'ja': '隈研吾（Kengo Kuma）',
            'de': 'Kengo Kuma',
            'fr': 'Kengo Kuma',
            'it': 'Kengo Kuma',
            'ko': '쿠마 켄고'
          },
          {
            'order': 1,
            'zh-cn': '伊东丰雄',
            'en': 'Toyo Ito',
            'zh-hant': '伊東豐雄（Toyo Ito）',
            'ja': '伊東豊雄（Toyo Ito）',
            'de': 'Toyo Ito',
            'fr': 'Toyo Ito',
            'it': 'Toyo Ito',
            'ko': '이토 도요'
          },
          {
            'order': 1,
            'zh-cn': '安藤忠雄',
            'en': 'Tadao Ando',
            'zh-hant': '安藤忠雄（Tadao Ando）',
            'ja': '安藤忠雄（Tadao Ando）',
            'de': 'Tadao Ando',
            'fr': 'Tadao Ando',
            'it': 'Tadao Ando',
            'ko': '안도 타다오'
          },
          {
            'order': 1,
            'zh-cn': '坂茂',
            'en': 'Shigeru Ban',
            'zh-hant': '坂茂（Shigeru Ban）',
            'ja': '坂茂（Shigeru Ban）',
            'de': 'Shigeru Ban',
            'fr': 'Shigeru Ban',
            'it': 'Shigeru Ban',
            'ko': '시게루 반'
          },
          {
            'order': 1,
            'zh-cn': '贝聿铭',
            'en': 'Pei Ieoh Ming',
            'zh-hant': '貝聿銘（Pei Ieoh Ming）',
            'ja': '貝聿銘（Pei Ieoh Ming）',
            'de': 'Pei Ieoh Ming',
            'fr': 'Pei Ieoh Ming',
            'it': 'Pei Ieoh Ming',
            'ko': '페이 밍'
          },
          {
            'order': 1,
            'zh-cn': '高第',
            'en': 'Antonio Gaudi',
            'zh-hant': '安東尼·高迪（Antonio Gaudi）',
            'ja': 'アントニオ・ガウディ（Antonio Gaudi）',
            'de': 'Antonio Gaudi',
            'fr': 'Antonio Gaudi',
            'it': 'Antonio Gaudi',
            'ko': '안토니 가우디'
          },
          {
            'order': 1,
            'zh-cn': '柯比意',
            'en': 'Le Corbusier',
            'zh-hant': '勒·柯布西耶（Le Corbusier）',
            'ja': 'ル・コルビュジエ（Le Corbusier）',
            'de': 'Le Corbusier',
            'fr': 'Le Corbusier',
            'it': 'Le Corbusier',
            'ko': '르 코르뷔지에'
          },
          {
            'order': 1,
            'zh-cn': '约翰乌松',
            'en': 'Jorn Utzon',
            'zh-hant': '約恩·烏松（Jorn Utzon）',
            'ja': 'ヨーン・ウッツォン（Jorn Utzon）',
            'de': 'Jorn Utzon',
            'fr': 'Jorn Utzon',
            'it': 'Jorn Utzon',
            'ko': '요른 웃손'
          },
          {
            'order': 1,
            'zh-cn': '阿尔瓦·阿尔托的住宅',
            'en': 'Alvar Aalto House',
            'zh-hant': '阿爾瓦·阿爾托（Alvar Aalto）',
            'ja': 'アルヴァ・アールト（Alvar Aalto）',
            'de': 'Alvar Aalto',
            'fr': 'Alvar Aalto',
            'it': 'Alvar Aalto',
            'ko': '알바 알토'
          },
          {
            'order': 1,
            'zh-cn': '圣地亚哥·卡拉特拉瓦',
            'en': 'Santiago Calatrava',
            'zh-hant': '聖地亞哥·卡拉特拉瓦（Santiago Calatrava）',
            'ja': 'サンティアゴ・カラトラバ（Santiago Calatrava）',
            'de': 'Santiago Calatrava',
            'fr': 'Santiago Calatrava',
            'it': 'Santiago Calatrava',
            'ko': '산티아고 칼라트라바'
          },
          {
            'order': 1,
            'zh-cn': '扎哈·哈迪德',
            'en': 'Zaha Hadid',
            'zh-hant': '薩哈·哈蒂德（Zaha Hadid）',
            'ja': 'ザハ・ハディッド（Zaha Hadid）',
            'de': 'Zaha Hadid',
            'fr': 'Zaha Hadid',
            'it': 'Zaha Hadid',
            'ko': '자하 하디드'
          },
          {
            'order': 1,
            'zh-cn': '伦佐·皮亚诺',
            'en': 'Renzo Piano',
            'zh-hant': '任佐·皮亞諾（Renzo Piano）',
            'ja': 'レンゾ・ピアノ（Renzo Piano）',
            'de': 'Renzo Piano',
            'fr': 'Renzo Piano',
            'it': 'Renzo Piano',
            'ko': '렌조 피아노'
          },
          {
            'order': 1,
            'zh-cn': '诺曼·福斯特',
            'en': 'Norman Foster',
            'zh-hant': '諾曼·福斯特（Norman Foster）',
            'ja': 'ノーマン・フォスター（Norman Foster）',
            'de': 'Norman Foster',
            'fr': 'Norman Foster',
            'it': 'Norman Foster',
            'ko': '노먼 포스터'
          },
          {
            'order': 1,
            'zh-cn': '文森特·卡莱博',
            'en': 'Vincent Callebaut',
            'zh-hant': '文森特·卡勒博（Vincent Callebaut）',
            'ja': 'ヴァンサン・カレボー（Vincent Callebaut）',
            'de': 'Vincent Callebaut',
            'fr': 'Vincent Callebaut',
            'it': 'Vincent Callebaut',
            'ko': '뱅상 칼르보'
          },
          {
            'order': 1,
            'zh-cn': '穆夏',
            'en': 'Alphonse Maria Mucha',
            'zh-hant': '阿爾豐斯·瑪麗亞·穆夏（Alphonse Maria Mucha）',
            'ja': 'アルフォンス・マリア・ミュシャ（Alphonse Maria Mucha）',
            'de': 'Alphonse Maria Mucha',
            'fr': 'Alphonse Maria Mucha',
            'it': 'Alphonse Maria Mucha',
            'ko': '알폰스 무하'
          },
          {
            'order': 1,
            'zh-cn': '森山大道',
            'en': 'Daido Moriyama',
            'zh-hant': '森山大道（Daido Moriyama）',
            'ja': '森山大道（Daido Moriyama）',
            'de': 'Daido Moriyama',
            'fr': 'Daido Moriyama',
            'it': 'Daido Moriyama',
            'ko': '모리야마 다이도'
          },
          {
            'order': 1,
            'zh-cn': '杉本博司',
            'en': 'Hiroshi Sugimoto',
            'zh-hant': '杉本博司（Hiroshi Sugimoto）',
            'ja': '杉本博司（Hiroshi Sugimoto）',
            'de': 'Hiroshi Sugimoto',
            'fr': 'Hiroshi Sugimoto',
            'it': 'Hiroshi Sugimoto',
            'ko': '스기모토 히로시'
          },
          {
            'order': 1,
            'zh-cn': '荒木经惟',
            'en': 'Nobuyoshi Araki',
            'zh-hant': '荒木經惟（Nobuyoshi Araki）',
            'ja': '荒木経惟（Nobuyoshi Araki）',
            'de': 'Nobuyoshi Araki',
            'fr': 'Nobuyoshi Araki',
            'it': 'Nobuyoshi Araki',
            'ko': '아라키 노부요시'
          },
          {
            'order': 1,
            'zh-cn': '安塞尔·亚当斯',
            'en': 'Ansel Adams',
            'zh-hant': '安塞爾·亞當斯（Ansel Adams）',
            'ja': 'アンセル・アダムス（Ansel Adams）',
            'de': 'Ansel Adams',
            'fr': 'Ansel Adams',
            'it': 'Ansel Adams',
            'ko': '안셀 아담스'
          },
          {
            'order': 1,
            'zh-cn': '享利·卡蒂埃·布列松',
            'en': 'Henri Cartier-Bresson',
            'zh-hant': '亨利·卡蒂埃-布列松（Henri Cartier-Bresson）',
            'ja': 'アンリ・カルティエ＝ブレッソン（Henri Cartier-Bresson）',
            'de': 'Henri Cartier-Bresson',
            'fr': 'Henri Cartier-Bresson',
            'it': 'Henri Cartier-Bresson',
            'ko': '앙리 카르티에 브레송'
          },
          {
            'order': 1,
            'zh-cn': '安妮·莱伯维茨',
            'en': 'Annie Leibovitz',
            'zh-hant': '安妮·萊博維茲（Annie Leibovitz）',
            'ja': 'アニー・リーボヴィッツ（Annie Leibovitz）',
            'de': 'Annie Leibovitz',
            'fr': 'Annie Leibovitz',
            'it': 'Annie Leibovitz',
            'ko': '애니 레이보비츠'
          },
          {
            'order': 1,
            'zh-cn': '理查德·艾维顿',
            'en': 'Richard Avedon',
            'zh-hant': '理查德·阿維登（Richard Avedon）',
            'ja': 'リチャード・アヴェドン（Richard Avedon）',
            'de': 'Richard Avedon',
            'fr': 'Richard Avedon',
            'it': 'Richard Avedon',
            'ko': '리처드 아베돈'
          },
          {
            'order': 1,
            'zh-cn': '多萝西娅·朗黛',
            'en': 'Dorothea Lange',
            'zh-hant': '多蘿西亞·蘭格（Dorothea Lange）',
            'ja': 'ドロシア・ラング（Dorothea Lange）',
            'de': 'Dorothea Lange',
            'fr': 'Dorothea Lange',
            'it': 'Dorothea Lange',
            'ko': '도로시아 랭'
          },
          {
            'order': 1,
            'zh-cn': '安·阿伯斯',
            'en': 'Diane Arbus',
            'zh-hant': '黛安·阿勃絲（Diane Arbus）',
            'ja': 'ダイアン・アーバス（Diane Arbus）',
            'de': 'Diane Arbus',
            'fr': 'Diane Arbus',
            'it': 'Diane Arbus',
            'ko': '다이앤 아버스'
          },
          {
            'order': 1,
            'zh-cn': '罗伯特·卡帕',
            'en': 'Robert Capa',
            'zh-hant': '羅伯特·卡帕（Robert Capa）',
            'ja': 'ロバート・キャパ（Robert Capa）',
            'de': 'Robert Capa',
            'fr': 'Robert Capa',
            'it': 'Robert Capa',
            'ko': '로버트 카파'
          },
          {
            'order': 1,
            'zh-cn': '爱德华·威斯顿',
            'en': 'Edward Weston',
            'zh-hant': '愛德華·威斯頓（Edward Weston）',
            'ja': 'エドワード・ウェストン（Edward Weston）',
            'de': 'Edward Weston',
            'fr': 'Edward Weston',
            'it': 'Edward Weston',
            'ko': '에드워드 웨스턴'
          },
          {
            'order': 1,
            'zh-cn': '沃克·埃文斯',
            'en': 'Walker Evans',
            'zh-hant': '沃克·埃文斯（Walker Evans）',
            'ja': 'ウォーカー・エヴァンズ（Walker Evans）',
            'de': 'Walker Evans',
            'fr': 'Walker Evans',
            'it': 'Walker Evans',
            'ko': '워커 에반스'
          },
          {
            'order': 1,
            'zh-cn': '史蒂夫·麦库里',
            'en': 'Steve Mccurry',
            'zh-hant': '史蒂夫·麥柯里（Steve McCurry）',
            'ja': 'スティーブ・マッカリー（Steve McCurry）',
            'de': 'Steve McCurry',
            'fr': 'Steve McCurry',
            'it': 'Steve McCurry',
            'ko': '스티브 맥커리'
          },
          {
            'order': 1,
            'zh-cn': '塞巴斯蒂昂·萨尔加多',
            'en': 'Sebastiao Salgado',
            'zh-hant': '塞巴斯蒂昂·薩爾加多（Sebastiao Salgado）',
            'ja': 'セバスチャン・サルガド（Sebastiao Salgado）',
            'de': 'Sebastião Salgado',
            'fr': 'Sebastião Salgado',
            'it': 'Sebastião Salgado',
            'ko': '세바스티앙 살가두'
          }
        ]
      }
    ]
  },
  {
    'order': 1,
    'name': { 'zh-cn': '场景 & 布景', en: 'Scene & Set', 'zh-hant': '場景 & 佈景', ja: 'シーン & セット', de: 'Szene & Dekor', fr: 'Scène & Décor', it: 'Scena & Decorazioni', 'ko': '배경 및 세트' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '场景', en: 'Scene', 'zh-hant': '場景', ja: 'シーン', de: 'Szene', fr: 'Scène', it: 'Scena', 'ko': '장면' },
        'list': [
          {
            'order': 1,
            'zh-cn': '街头风格',
            'en': 'street style',
            'zh-hant': '街頭風格',
            'ja': 'ストリートスタイル',
            'de': 'Straßenstil',
            'fr': 'Style de rue',
            'it': 'Stile di strada',
            'ko': '스트리트 스타일'
          },
          {
            'order': 1,
            'zh-cn': '红毯',
            'en': 'red carpet',
            'zh-hant': '紅毯',
            'ja': 'レッドカーペット',
            'de': 'Roter Teppich',
            'fr': 'Tapis rouge',
            'it': 'Tappeto rosso',
            'ko': '레드 카펫'
          },
          {
            'order': 1,
            'zh-cn': '大都会博物馆慈善晚宴',
            'en': 'met gala',
            'zh-hant': '大都會藝術博物館慈善舞會（Met Gala）',
            'ja': 'メットガラ',
            'de': 'Met Gala',
            'fr': 'Met Gala',
            'it': 'Met Gala',
            'ko': '메트 갈라'
          },
          {
            'order': 1,
            'zh-cn': '时尚摄影',
            'en': 'fashion photography',
            'zh-hant': '時尚攝影',
            'ja': 'ファッションフォトグラフィー',
            'de': 'Modefotografie',
            'fr': 'Photographie de mode',
            'it': 'Fotografia di moda',
            'ko': '패션 사진'
          },
          {
            'order': 1,
            'zh-cn': '杂志编辑摄影',
            'en': 'editorial shoots',
            'zh-hant': '編輯拍攝',
            'ja': 'エディトリアルシュート',
            'de': 'Editorial-Shootings',
            'fr': 'Séances éditoriales',
            'it': 'Servizi editoriali',
            'ko': '에디토리얼 촬영'
          },
          {
            'order': 1,
            'zh-cn': '设计师展示厅',
            'en': 'designer showrooms',
            'zh-hant': '設計師展廳',
            'ja': 'デザイナーショールーム',
            'de': 'Designerausstellungsräume',
            'fr': 'Showrooms de créateurs',
            'it': 'Showroom dei designer',
            'ko': '디자이너 쇼룸'
          },
          {
            'order': 1,
            'zh-cn': 't台秀',
            'en': 'runway shows',
            'zh-hant': '時裝秀',
            'ja': 'ランウェイショー',
            'de': 'Laufstegshows',
            'fr': 'Défilés de mode',
            'it': 'Sfilate di moda',
            'ko': '런웨이 쇼'
          },
          {
            'order': 1,
            'zh-cn': '纽约时装周',
            'en': 'new york fashion week',
            'zh-hant': '紐約時裝週',
            'ja': 'ニューヨークファッションウィーク',
            'de': 'New York Fashion Week',
            'fr': 'Semaine de la mode de New York',
            'it': 'Settimana della moda di New York',
            'ko': '뉴욕 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '巴黎时装周',
            'en': 'paris fashion week',
            'zh-hant': '巴黎時裝週',
            'ja': 'パリファッションウィーク',
            'de': 'Paris Fashion Week',
            'fr': 'Semaine de la mode de Paris',
            'it': 'Settimana della moda di Parigi',
            'ko': '파리 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '伦敦时装周',
            'en': 'london fashion week',
            'zh-hant': '倫敦時裝週',
            'ja': 'ロンドンファッションウィーク',
            'de': 'London Fashion Week',
            'fr': 'Semaine de la mode de Londres',
            'it': 'Settimana della moda di Londra',
            'ko': '런던 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '米兰时装周',
            'en': 'milan fashion week',
            'zh-hant': '米蘭時裝週',
            'ja': 'ミラノファッションウィーク',
            'de': 'Mailand Fashion Week',
            'fr': 'Semaine de la mode de Milan',
            'it': 'Settimana della moda di Milano',
            'ko': '밀라노 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '东京时装周',
            'en': 'tokyo fashion week',
            'zh-hant': '東京時裝週',
            'ja': '東京ファッションウィーク',
            'de': 'Tokyo Fashion Week',
            'fr': 'Semaine de la mode de Tokyo',
            'it': 'Settimana della moda di Tokyo',
            'ko': '도쿄 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '首尔时装周',
            'en': 'seoul fashion week',
            'zh-hant': '首爾時裝週',
            'ja': 'ソウルファッションウィーク',
            'de': 'Seoul Fashion Week',
            'fr': 'Semaine de la mode de Séoul',
            'it': 'Settimana della moda di Seoul',
            'ko': '서울 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '上海时装周',
            'en': 'shanghai fashion week',
            'zh-hant': '上海時裝週',
            'ja': '上海ファッションウィーク',
            'de': 'Shanghai Fashion Week',
            'fr': 'Semaine de la mode de Shanghai',
            'it': 'Settimana della moda di Shanghai',
            'ko': '상하이 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '悉尼时装周',
            'en': 'sydney fashion week',
            'zh-hant': '悉尼時裝週',
            'ja': 'シドニーファッションウィーク',
            'de': 'Sydney Fashion Week',
            'fr': 'Semaine de la mode de Sydney',
            'it': 'Settimana della moda di Sydney',
            'ko': '시드니 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '柏林时装周',
            'en': 'berlin fashion week',
            'zh-hant': '柏林時裝週',
            'ja': 'ベルリンファッションウィーク',
            'de': 'Berlin Fashion Week',
            'fr': 'Semaine de la mode de Berlin',
            'it': 'Settimana della moda di Berlino',
            'ko': '베를린 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '哥本哈根时装周',
            'en': 'copenhagen fashion week',
            'zh-hant': '哥本哈根時裝週',
            'ja': 'コペンハーゲンファッションウィーク',
            'de': 'Kopenhagen Fashion Week',
            'fr': 'Semaine de la mode de Copenhague',
            'it': 'Settimana della moda di Copenaghen',
            'ko': '코펜하겐 패션 위크'
          },
          {
            'order': 1,
            'zh-cn': '反乌托邦',
            'en': 'dystopia',
            'zh-hant': '反烏托邦',
            'ja': 'ディストピア',
            'de': 'Dystopie',
            'fr': 'Dystopie',
            'it': 'Distopia',
            'ko': '디스토피아'
          },
          {
            'order': 1,
            'zh-cn': '幻想',
            'en': 'fantasy',
            'zh-hant': '幻想',
            'ja': 'ファンタジー',
            'de': 'Fantasy',
            'fr': 'Fantaisie',
            'it': 'Fantasia',
            'ko': '판타지'
          },
          {
            'order': 1,
            'zh-cn': '教室',
            'en': 'classroom',
            'zh-hant': '教室',
            'ja': '教室',
            'de': 'Klassenzimmer',
            'fr': 'Salle de classe',
            'it': 'Aula',
            'ko': '교실'
          },
          {
            'order': 1,
            'zh-cn': '异想天开',
            'en': 'whimsically',
            'zh-hant': '異想天開',
            'ja': 'ウィムジカルに',
            'de': 'Märchenhaft',
            'fr': 'De manière fantaisiste',
            'it': 'In modo stravagante',
            'ko': '기발하게'
          },
          {
            'order': 1,
            'zh-cn': '卧室',
            'en': 'bedroom',
            'zh-hant': '臥室',
            'ja': 'ベッドルーム',
            'de': 'Schlafzimmer',
            'fr': 'Chambre',
            'it': 'Camera da letto',
            'ko': '침실'
          },
          {
            'order': 1,
            'zh-cn': '森林',
            'en': 'forest',
            'zh-hant': '森林',
            'ja': '森',
            'de': 'Wald',
            'fr': 'Forêt',
            'it': 'Foresta',
            'ko': '숲'
          },
          {
            'order': 1,
            'zh-cn': '废墟',
            'en': 'ruins',
            'zh-hant': '廢墟',
            'ja': '廃墟',
            'de': 'Ruinen',
            'fr': 'Ruines',
            'it': 'Rovine',
            'ko': '폐허'
          },
          {
            'order': 1,
            'zh-cn': '城市',
            'en': 'city',
            'zh-hant': '城市',
            'ja': '都市',
            'de': 'Stadt',
            'fr': 'Ville',
            'it': 'Città',
            'ko': '도시'
          },
          {
            'order': 1,
            'zh-cn': '废弃城市建筑群',
            'en': 'deserted city buildings',
            'zh-hant': '廢棄的城市建築',
            'ja': '廃墟の都市建物',
            'de': 'Verlassene Stadtgebäude',
            'fr': 'Bâtiments de ville désertés',
            'it': 'Edifici della città abbandonati',
            'ko': '버려진 도시 건물'
          },
          {
            'order': 1,
            'zh-cn': '近未来都市',
            'en': 'near future city',
            'zh-hant': '近未來城市',
            'ja': '近未来の都市',
            'de': 'Stadt der nahen Zukunft',
            'fr': 'Ville du futur proche',
            'it': 'Città del prossimo futuro',
            'ko': '근미래 도시'
          },
          {
            'order': 1,
            'zh-cn': '街景',
            'en': 'street scenery',
            'zh-hant': '街景',
            'ja': '街並み',
            'de': 'Straßenszenerie',
            'fr': 'Scène de rue',
            'it': 'Scenografia di strada',
            'ko': '거리 풍경'
          },
          {
            'order': 1,
            'zh-cn': '天空之城',
            'en': 'castle in the sky',
            'zh-hant': '天空之城',
            'ja': '空飛ぶ城',
            'de': 'Schloss im Himmel',
            'fr': 'Château dans le ciel',
            'it': 'Castello nel cielo',
            'ko': '천공의 성'
          },
          {
            'order': 1,
            'zh-cn': '后启示录、末日后',
            'en': 'post apocalyptic',
            'zh-hant': '末日後',
            'ja': 'ポストアポカリプス',
            'de': 'Post-apokalyptisch',
            'fr': 'Post-apocalyptique',
            'it': 'Post-apocalittico',
            'ko': '포스트 아포칼립스'
          },
          {
            'order': 1,
            'zh-cn': '宇宙',
            'en': 'universe i cosmos',
            'zh-hant': '宇宙',
            'ja': '宇宙',
            'de': 'Universum / Kosmos',
            'fr': 'Univers / Cosmos',
            'it': 'Universo / Cosmo',
            'ko': '우주'
          },
          {
            'order': 1,
            'zh-cn': '雨天',
            'en': 'rain',
            'zh-hant': '雨中',
            'ja': '雨',
            'de': 'Regen',
            'fr': 'Pluie',
            'it': 'Pioggia',
            'ko': '비'
          },
          {
            'order': 1,
            'zh-cn': '在晨雾中',
            'en': 'in the morning mist',
            'zh-hant': '晨霧中',
            'ja': '朝霧の中',
            'de': 'Im Morgennebel',
            'fr': 'Dans la brume du matin',
            'it': 'Nella nebbia mattutina',
            'ko': '아침 안개 속에서'
          },
          {
            'order': 1,
            'zh-cn': '充满阳光',
            'en': 'full of sunlight',
            'zh-hant': '充滿陽光',
            'ja': '太陽の光に満ちた',
            'de': 'Sonnenlichtdurchflutet',
            'fr': 'Plein de lumière du soleil',
            'it': 'Pieno di luce solare',
            'ko': '햇살이 가득한'
          },
          {
            'order': 1,
            'zh-cn': '银河',
            'en': 'galaxy',
            'zh-hant': '銀河系',
            'ja': '銀河',
            'de': 'Galaxie',
            'fr': 'Galaxie',
            'it': 'Galassia',
            'ko': '은하수'
          },
          {
            'order': 1,
            'zh-cn': '黑暗地牢',
            'en': 'dungeon',
            'zh-hant': '地下城',
            'ja': 'ダンジョン',
            'de': 'Verlies',
            'fr': 'Donjon',
            'it': 'Dungeon',
            'ko': '던전'
          },
          {
            'order': 1,
            'zh-cn': '星云',
            'en': 'nebula',
            'zh-hant': '星雲',
            'ja': '星雲',
            'de': 'Nebel',
            'fr': 'Nébuleuse',
            'it': 'Nebulosa',
            'ko': '성운'
          },
          {
            'order': 1,
            'zh-cn': '疯狂麦斯沙地风格',
            'en': 'mad max',
            'zh-hant': '瘋狂的麥克斯',
            'ja': 'マッドマックス',
            'de': 'Mad Max',
            'fr': 'Mad Max',
            'it': 'Mad Max',
            'ko': '매드 맥스'
          },
          {
            'order': 1,
            'zh-cn': '巴比伦空中花园',
            'en': 'hanging gardens of babylon',
            'zh-hant': '巴比倫空中花園',
            'ja': 'バビロンの空中庭園',
            'de': 'Hängende Gärten von Babylon',
            'fr': 'Jardins suspendus de Babylone',
            'it': 'Giardini pensili di Babilonia',
            'ko': '바빌론의 공중정원'
          },
          {
            'order': 1,
            'zh-cn': '草原草地',
            'en': 'meadow',
            'zh-hant': '草地',
            'ja': '草地',
            'de': 'Wiese',
            'fr': 'Prairie',
            'it': 'Prato',
            'ko': '초원'
          },
          {
            'order': 1,
            'zh-cn': '杂草丛生的',
            'en': 'overgrown nature',
            'zh-hant': '叢生的自然',
            'ja': '生い茂った自然',
            'de': 'Überwachsene Natur',
            'fr': 'Nature envahie',
            'it': 'Natura invasa',
            'ko': '무성한 자연'
          },
          {
            'order': 1,
            'zh-cn': '玻璃屋顶的现代画廊',
            'en': 'modern art gallery a glass roof',
            'zh-hant': '現代藝術畫廊，玻璃屋頂',
            'ja': '現代美術館、ガラス屋根',
            'de': 'Moderne Kunstgalerie mit Glasdach',
            'fr': 'Galerie d\'art moderne avec toit en verre',
            'it': 'Galleria d\'arte moderna con tetto di vetro',
            'ko': '유리 지붕이 있는 현대 미술관'
          },
          {
            'order': 1,
            'zh-cn': '沙漠中的奇异岩石群',
            'en': 'strange rock formations in the desert',
            'zh-hant': '沙漠中的奇異岩石',
            'ja': '砂漠の奇妙な岩石形成',
            'de': 'Seltsame Felsformationen in der Wüste',
            'fr': 'Formations rocheuses étranges dans le désert',
            'it': 'Formazioni rocciose strane nel deserto',
            'ko': '사막의 기이한 바위 형상'
          },
          {
            'order': 1,
            'zh-cn': '五彩斑斓的市集',
            'en': 'colorful bazaar',
            'zh-hant': '色彩繽紛的集市',
            'ja': 'カラフルなバザール',
            'de': 'Bunter Basar',
            'fr': 'Bazar coloré',
            'it': 'Bazaar colorato',
            'ko': '다채로운 시장'
          },
          {
            'order': 1,
            'zh-cn': '水下世界的珊瑚礁',
            'en': 'coral reef underwater world',
            'zh-hant': '珊瑚礁水下世界',
            'ja': 'サンゴ礁の水中世界',
            'de': 'Korallenriff-Unterwasserwelt',
            'fr': 'Monde sous-marin des récifs coralliens',
            'it': 'Mondo sottomarino della barriera corallina',
            'ko': '산호초 수중 세계'
          },
          {
            'order': 1,
            'zh-cn': '巨大仓库里的工业机器人',
            'en': 'industrial robots in a large warehouse',
            'zh-hant': '大型倉庫中的工業機器人',
            'ja': '大きな倉庫の工業用ロボット',
            'de': 'Industrielle Roboter in einem großen Lagerhaus',
            'fr': 'Robots industriels dans un grand entrepôt',
            'it': 'Robot industriali in un grande magazzino',
            'ko': '대형 창고의 산업용 로봇'
          },
          {
            'order': 1,
            'zh-cn': '雨林中的瀑布和蒸汽',
            'en': 'waterfalls and steam in the rainforest',
            'zh-hant': '熱帶雨林中的瀑布和蒸汽',
            'ja': '熱帯雨林の滝と蒸気',
            'de': 'Wasserfälle und Dampf im Regenwald',
            'fr': 'Cascades et vapeur dans la forêt tropicale',
            'it': 'Cascate e vapore nella foresta pluviale',
            'ko': '열대우림의 폭포와 증기'
          },
          {
            'order': 1,
            'zh-cn': '赛车场上的速度感',
            'en': 'speed and motion at the racetrack',
            'zh-hant': '賽道上的速度與動感',
            'ja': 'レーストラックの速度と動き',
            'de': 'Geschwindigkeit und Bewegung auf der Rennstrecke',
            'fr': 'Vitesse et mouvement sur la piste de course',
            'it': 'Velocità e movimento sulla pista da corsa',
            'ko': '경주장의 속도감과 움직임'
          },
          {
            'order': 1,
            'zh-cn': '繁华都市的霓虹灯光影',
            'en': 'neon lights in the bustling city',
            'zh-hant': '繁華城市中的霓虹燈',
            'ja': '賑やかな街のネオンライト',
            'de': 'Neonlichter in der geschäftigen Stadt',
            'fr': 'Lumières néon dans la ville animée',
            'it': 'Luci al neon nella città vivace',
            'ko': '번화가의 네온사인'
          },
          {
            'order': 1,
            'zh-cn': '海岸边的峭壁和海浪',
            'en': 'cliffs and waves at the coastline',
            'zh-hant': '海岸線上的懸崖與海浪',
            'ja': '海岸線の崖と波',
            'de': 'Klippen und Wellen an der Küste',
            'fr': 'Falaises et vagues sur la côte',
            'it': 'Scogliere e onde sulla costa',
            'ko': '해안가의 절벽과 파도'
          },
          {
            'order': 1,
            'zh-cn': '星空下的太空舱或太空站',
            'en': 'spacecraft or station under the starry sky',
            'zh-hant': '星空下的太空船或太空站',
            'ja': '星空の下の宇宙船またはステーション',
            'de': 'Raumfahrzeug oder Station unter dem Sternenhimmel',
            'fr': 'Vaisseau spatial ou station sous le ciel étoilé',
            'it': 'Navicella spaziale o stazione sotto il cielo stellato',
            'ko': '별이 빛나는 하늘 아래의 우주선이나 우주정거장'
          },
          {
            'order': 1,
            'zh-cn': '高科技实验室中的光影效果',
            'en': 'light and shadow effects in a high-tech laboratory',
            'zh-hant': '高科技實驗室中的光影效果',
            'ja': 'ハイテク研究所の光と影の効果',
            'de': 'Licht- und Schatteneffekte in einem High-Tech-Labor',
            'fr': 'Effets de lumière et d\'ombre dans un laboratoire high-tech',
            'it': 'Effetti di luce e ombra in un laboratorio high-tech',
            'ko': '첨단 실험실의 빛과 그림자 효과'
          },
          {
            'order': 1,
            'zh-cn': '巨大冰山和北极动物',
            'en': 'giant icebergs and arctic animals',
            'zh-hant': '巨大的冰山和北極動物',
            'ja': '巨大な氷山と北極の動物',
            'de': 'Riesige Eisberge und arktische Tiere',
            'fr': 'Icebergs géants et animaux arctiques',
            'it': 'Ghiacciai giganti e animali artici',
            'ko': '거대한 빙산과 북극 동물'
          },
          {
            'order': 1,
            'zh-cn': '古老城堡的蜡烛灯下',
            'en': 'candlelight in an ancient castle',
            'zh-hant': '古老城堡中的燭光',
            'ja': '古い城のろうそくの灯',
            'de': 'Kerzenlicht in einem alten Schloss',
            'fr': 'Lumière de bougie dans un ancien château',
            'it': 'Luce di candela in un antico castello',
            'ko': '고성의 촛불 아래'
          },
          {
            'order': 1,
            'zh-cn': '熔岩喷发时的火山',
            'en': 'volcano eruption with lava',
            'zh-hant': '火山噴發與熔岩',
            'ja': '溶岩を伴う火山噴火',
            'de': 'Vulkanausbruch mit Lava',
            'fr': 'Éruption volcanique avec de la lave',
            'it': 'Eruzione vulcanica con lava',
            'ko': '용암이 흐르는 화산 폭발'
          },
          {
            'order': 1,
            'zh-cn': '森林中迷雾缭绕',
            'en': 'foggy forest',
            'zh-hant': '霧氣繚繞的森林',
            'ja': '霧の森',
            'de': 'Nebelwald',
            'fr': 'Forêt brumeuse',
            'it': 'Foresta nebbiosa',
            'ko': '안개 낀 숲'
          },
          {
            'order': 1,
            'zh-cn': '工业区中的机器人工厂',
            'en': 'robot factory in industrial area',
            'zh-hant': '工業區的機器人工廠',
            'ja': '工業地域のロボット工場',
            'de': 'Roboterfabrik im Industriegebiet',
            'fr': 'Usine de robots dans une zone industrielle',
            'it': 'Fabbrica di robot in zona industriale',
            'ko': '공업단지의 로봇 공장'
          },
          {
            'order': 1,
            'zh-cn': '大瀑布的水雾中',
            'en': 'misty waterfall',
            'zh-hant': '霧氣瀰漫的瀑布',
            'ja': '霧のかかった滝',
            'de': 'Nebeliger Wasserfall',
            'fr': 'Cascade embrumée',
            'it': 'Cascata nebbiosa',
            'ko': '안개 낀 폭포'
          },
          {
            'order': 1,
            'zh-cn': '着火的沙漠和狂风',
            'en': 'burning desert with strong winds',
            'zh-hant': '狂風肆虐的燃燒沙漠',
            'ja': '強風に吹かれる燃える砂漠',
            'de': 'Brennende Wüste mit starken Winden',
            'fr': 'Désert brûlant avec vents violents',
            'it': 'Deserto infuocato con forti venti',
            'ko': '강한 바람이 부는 불타는 사막'
          },
          {
            'order': 1,
            'zh-cn': '大都市的高楼大厦',
            'en': 'skyscrapers in the big city',
            'zh-hant': '大城市中的摩天大樓',
            'ja': '大都市の高層ビル',
            'de': 'Wolkenkratzer in der großen Stadt',
            'fr': 'Gratte-ciel dans la grande ville',
            'it': 'Grattacieli nella grande città',
            'ko': '대도시의 고층 빌딩'
          },
          {
            'order': 1,
            'zh-cn': '刚刚降落的宇宙飞船玤',
            'en': 'just landed spaceship',
            'zh-hant': '剛剛降落的太空船',
            'ja': '着陸したばかりの宇宙船',
            'de': 'Gerade gelandetes Raumschiff',
            'fr': 'Vaisseau spatial tout juste atterri',
            'it': 'Navicella spaziale appena atterrata',
            'ko': '방금 착륙한 우주선'
          },
          {
            'order': 1,
            'zh-cn': '论文堆积的学者书房',
            'en': 'scholar\'s study with piles of papers',
            'zh-hant': '學者書房中的書堆',
            'ja': '山積みの書類がある学者の書斎',
            'de': 'Gelehrtenstudie mit Stapeln von Papieren',
            'fr': 'Bureau d\'érudit avec des piles de papiers',
            'it': 'Studio di uno studioso con pile di carte',
            'ko': '논문이 쌓인 학자의 서재'
          },
          {
            'order': 1,
            'zh-cn': '猛兽出没的密林',
            'en': 'jungle with wild beasts',
            'zh-hant': '叢林中的野獸',
            'ja': '野獣がいるジャングル',
            'de': 'Dschungel mit wilden Bestien',
            'fr': 'Jungle avec des bêtes sauvages',
            'it': 'Giungla con bestie selvagge',
            'ko': '맹수가 출몰하는 밀림'
          },
          {
            'order': 1,
            'zh-cn': '海洋里的海龟和珊瑚礁',
            'en': 'sea turtles and coral reefs in the ocean',
            'zh-hant': '海洋中的海龜和珊瑚礁',
            'ja': '海の中のウミガメとサンゴ礁',
            'de': 'Meeresschildkröten und Korallenriffe im Ozean',
            'fr': 'Tortues de mer et récifs coralliens dans l\'océan',
            'it': 'Tartarughe marine e barriere coralline nell\'oceano',
            'ko': '바다의 거북이와 산호초'
          },
          {
            'order': 1,
            'zh-cn': '河流上的小桥和爱情故事',
            'en': 'love story on a small bridge over river',
            'zh-hant': '小橋流水上的愛情故事',
            'ja': '川の上の小さな橋の上のラブストーリー',
            'de': 'Liebesgeschichte auf einer kleinen Brücke über dem Fluss',
            'fr': 'Histoire d\'amour sur un petit pont au-dessus de la rivière',
            'it': 'Storia d\'amore su un piccolo ponte sopra il fiume',
            'ko': '강 위 작은 다리의 사랑 이야기'
          },
          {
            'order': 1,
            'zh-cn': '未来都市中的飞行汽车',
            'en': 'flying cars in futuristic city',
            'zh-hant': '未來城市中的飛行汽車',
            'ja': '未来都市の空飛ぶ車',
            'de': 'Fliegende Autos in der futuristischen Stadt',
            'fr': 'Voitures volantes dans une ville futuriste',
            'it': 'Auto volanti in una città futuristica',
            'ko': '미래 도시의 비행 자동차'
          },
          {
            'order': 1,
            'zh-cn': '充满神秘符号的远古神庙',
            'en': 'ancient temple with mysterious symbols',
            'zh-hant': '帶有神秘符號的古廟',
            'ja': '神秘的なシンボルがある古代の寺院',
            'de': 'Antiker Tempel mit mysteriösen Symbolen',
            'fr': 'Temple ancien avec des symboles mystérieux',
            'it': 'Tempio antico con simboli misteriosi',
            'ko': '신비한 상징이 가득한 고대 신전'
          },
          {
            'order': 1,
            'zh-cn': '远海中的巨大海怪',
            'en': 'giant sea monster in the far-off sea',
            'zh-hant': '遙遠海域中的巨型海怪',
            'ja': '遠い海の巨大な海の怪物',
            'de': 'Riesiges Seemonster im fernen Meer',
            'fr': 'Monstre marin géant dans la mer lointaine',
            'it': 'Mostro marino gigante nel mare lontano',
            'ko': '먼 바다의 거대한 해양 괴물'
          },
          {
            'order': 1,
            'zh-cn': '沉船和水下宝藏',
            'en': 'shipwreck and treasure under the sea',
            'zh-hant': '海底的沉船與寶藏',
            'ja': '海底の難破船と宝物',
            'de': 'Schiffswrack und Schatz unter dem Meer',
            'fr': 'Épave et trésor sous la mer',
            'it': 'Relitto e tesoro sotto il mare',
            'ko': '해저의 난파선과 보물'
          },
          {
            'order': 1,
            'zh-cn': '雾气缭绕的山洞和地牢',
            'en': 'misty caves and dungeons',
            'zh-hant': '霧氣瀰漫的洞穴和地牢',
            'ja': '霧の洞窟とダンジョン',
            'de': 'Neblige Höhlen und Verliese',
            'fr': 'Grottes et donjons brumeux',
            'it': 'Grotte e sotterranei nebbiosi',
            'ko': '안개 낀 동굴과 지하 감옥'
          },
          {
            'order': 1,
            'zh-cn': '当代艺术展览馆',
            'en': 'contemporary art exhibition hall',
            'zh-hant': '當代藝術展覽廳',
            'ja': '現代美術展示ホール',
            'de': 'Ausstellungshalle für zeitgenössische Kunst',
            'fr': 'Salle d\'exposition d\'art contemporain',
            'it': 'Sala espositiva d\'arte contemporanea',
            'ko': '현대 미술 전시관'
          },
          {
            'order': 1,
            'zh-cn': '火车站的烟雾和蒸汽',
            'en': 'steam and smoke at train station',
            'zh-hant': '火車站的蒸汽和煙霧',
            'ja': '駅での蒸気と煙',
            'de': 'Dampf und Rauch am Bahnhof',
            'fr': 'Vapeur et fumée à la gare',
            'it': 'Vapore e fumo alla stazione dei treni',
            'ko': '기차역의 증기와 연기'
          },
          {
            'order': 1,
            'zh-cn': '落日余晖的田野和农场',
            'en': 'fields and farms at sunset',
            'zh-hant': '日落時的田野和農場',
            'ja': '日没時の田畑',
            'de': 'Felder und Bauernhöfe bei Sonnenuntergang',
            'fr': 'Champs et fermes au coucher du soleil',
            'it': 'Campi e fattorie al tramonto',
            'ko': '일몰의 들판과 농장'
          },
          {
            'order': 1,
            'zh-cn': '世外桃源的花园和池塘',
            'en': 'garden and pond in a hidden paradise',
            'zh-hant': '隱秘樂園中的花園和池塘',
            'ja': '隠れた楽園の庭と池',
            'de': 'Garten und Teich in einem versteckten Paradies',
            'fr': 'Jardin et étang dans un paradis caché',
            'it': 'Giardino e stagno in un paradiso nascosto',
            'ko': '숨겨진 낙원의 정원과 연못'
          },
          {
            'order': 1,
            'zh-cn': '大都市的黑夜和霓虹灯',
            'en': 'neon lights in the dark city',
            'zh-hant': '黑暗城市中的霓虹燈',
            'ja': '暗い街のネオンライト',
            'de': 'Neonlichter in der dunklen Stadt',
            'fr': 'Lumières néon dans la ville sombre',
            'it': 'Luci al neon nella città buia',
            'ko': '어두운 도시의 네온사인'
          },
          {
            'order': 1,
            'zh-cn': '森林里的小屋和湖泊',
            'en': 'cabin and lake in the woods',
            'zh-hant': '森林中的小屋和湖泊',
            'ja': '森の中のキャビンと湖',
            'de': 'Hütte und See im Wald',
            'fr': 'Cabane et lac dans les bois',
            'it': 'Capanna e lago nei boschi',
            'ko': '숲속의 오두막과 호수'
          },
          {
            'order': 1,
            'zh-cn': '太空中的陨石带',
            'en': 'asteroid belt in space',
            'zh-hant': '太空中的小行星帶',
            'ja': '宇宙の小惑星帯',
            'de': 'Asteroidengürtel im Weltraum',
            'fr': 'Ceinture d\'astéroïdes dans l\'espace',
            'it': 'Fascia di asteroidi nello spazio',
            'ko': '우주의 소행성대'
          },
          {
            'order': 1,
            'zh-cn': '沙漠中的沉默与孤寂',
            'en': 'silence and solitude in the desert',
            'zh-hant': '沙漠中的寂靜與孤獨',
            'ja': '砂漠の静けさと孤独',
            'de': 'Stille und Einsamkeit in der Wüste',
            'fr': 'Silence et solitude dans le désert',
            'it': 'Silenzio e solitudine nel deserto',
            'ko': '사막의 고요함과 고독'
          },
          {
            'order': 1,
            'zh-cn': '海上巨浪和暴风雨',
            'en': 'big waves and storms on the sea',
            'zh-hant': '海上的大浪和風暴',
            'ja': '海の大波と嵐',
            'de': 'Große Wellen und Stürme auf dem Meer',
            'fr': 'Grandes vagues et tempêtes en mer',
            'it': 'Grandi onde e tempeste sul mare',
            'ko': '바다의 큰 파도와 폭풍'
          },
          {
            'order': 1,
            'zh-cn': '雪山与滑雪手套',
            'en': 'snowy mountains and ski gloves',
            'zh-hant': '雪山和滑雪手套',
            'ja': '雪山とスキー手袋',
            'de': 'Schneeberge und Skihandschuhe',
            'fr': 'Montagnes enneigées et gants de ski',
            'it': 'Montagne innevate e guanti da sci',
            'ko': '설산과 스키 장갑'
          },
          {
            'order': 1,
            'zh-cn': '未来城市的机器人警察',
            'en': 'robot police in future city',
            'zh-hant': '未來城市中的機器人警察',
            'ja': '未来都市のロボット警察',
            'de': 'Roboterpolizei in der zukünftigen Stadt',
            'fr': 'Police robotique dans la ville future',
            'it': 'Polizia robotica nella città futura',
            'ko': '미래 도시의 로봇 경찰'
          },
          {
            'order': 1,
            'zh-cn': '神话故事中的精灵森林',
            'en': 'elf forest in mythical story',
            'zh-hant': '神話故事中的精靈森林',
            'ja': '神話の物語のエルフの森',
            'de': 'Elfenwald in einer mythischen Geschichte',
            'fr': 'Forêt elfique dans une histoire mythique',
            'it': 'Foresta elfica in una storia mitica',
            'ko': '신화 속의 엘프 숲'
          },
          {
            'order': 1,
            'zh-cn': '雪地中的鹿和松树',
            'en': 'deer and pine trees in snowy landscape',
            'zh-hant': '雪景中的鹿和松樹',
            'ja': '雪景色の鹿と松の木',
            'de': 'Hirsche und Kiefern in einer schneebedeckten Landschaft',
            'fr': 'Cerfs et pins dans un paysage enneigé',
            'it': 'Cervi e pini in un paesaggio innevato',
            'ko': '눈 덮인 풍경 속의 사슴과 소나무'
          },
          {
            'order': 1,
            'zh-cn': '大海上的帆船和海豚',
            'en': 'sailing ship and dolphins on the ocean',
            'zh-hant': '海洋上的帆船和海豚',
            'ja': '海上の帆船とイルカ',
            'de': 'Segelschiff und Delfine auf dem Ozean',
            'fr': 'Voilier et dauphins sur l\'océan',
            'it': 'Veliero e delfini sull\'oceano',
            'ko': '바다의 돛단배와 돌고래'
          },
          {
            'order': 1,
            'zh-cn': '秋季森林中的彩叶和小溪',
            'en': 'fall foliage and brook in forest',
            'zh-hant': '森林中的秋葉和小溪',
            'ja': '森の中の秋の葉と小川',
            'de': 'Herbstlaub und Bach im Wald',
            'fr': 'Feuilles d\'automne et ruisseau dans la forêt',
            'it': 'Foglie autunnali e ruscello nella foresta',
            'ko': '숲속의 단풍과 시냇물'
          },
          {
            'order': 1,
            'zh-cn': '乡村道路风景与老爷车',
            'en': 'vintage cars on country road',
            'zh-hant': '鄉村道路上的復古汽車',
            'ja': '田舎道のビンテージカー',
            'de': 'Vintage-Autos auf der Landstraße',
            'fr': 'Voitures vintage sur la route de campagne',
            'it': 'Auto d\'epoca sulla strada di campagna',
            'ko': '시골길의 클래식 자동차'
          },
          {
            'order': 1,
            'zh-cn': '火山喷发时的闪电',
            'en': 'lightning during volcano eruption',
            'zh-hant': '火山噴發時的閃電',
            'ja': '火山噴火時の稲妻',
            'de': 'Blitz während eines Vulkanausbruchs',
            'fr': 'Éclairs pendant une éruption volcanique',
            'it': 'Fulmini durante un\'eruzione vulcanica',
            'ko': '화산 폭발 중의 번개'
          },
          {
            'order': 1,
            'zh-cn': '漆黑的地下城市',
            'en': 'dark underground city',
            'zh-hant': '黑暗的地下城市',
            'ja': '暗い地下都市',
            'de': 'Dunkle Untergrundstadt',
            'fr': 'Ville souterraine sombre',
            'it': 'Città sotterranea oscura',
            'ko': '어두운 지하 도시'
          },
          {
            'order': 1,
            'zh-cn': '红色沙漠和日落',
            'en': 'red desert and sunset',
            'zh-hant': '紅色沙漠和日落',
            'ja': '夕日の赤い砂漠',
            'de': 'Rote Wüste und Sonnenuntergang',
            'fr': 'Désert rouge et coucher de soleil',
            'it': 'Deserto rosso e tramonto',
            'ko': '붉은 사막과 일몰'
          },
          {
            'order': 1,
            'zh-cn': '魔法森林中的巨型蘑菇',
            'en': 'giant mushrooms in magic forest',
            'zh-hant': '魔法森林中的巨型蘑菇',
            'ja': '魔法の森の巨大キノコ',
            'de': 'Riesige Pilze im Zauberwald',
            'fr': 'Champignons géants dans une forêt magique',
            'it': 'Funghi giganti nella foresta magica',
            'ko': '마법의 숲속 거대 버섯'
          },
          {
            'order': 1,
            'zh-cn': '爆炸火花的金属工厂',
            'en': 'metal factory with sparks and explosions',
            'zh-hant': '金屬工廠中的火花和爆炸',
            'ja': '火花と爆発の金属工場',
            'de': 'Metallfabrik mit Funken und Explosionen',
            'fr': 'Usine de métaux avec étincelles et explosions',
            'it': 'Fabbrica di metalli con scintille ed esplosioni',
            'ko': '불꽃과 폭발이 있는 금속 공장'
          },
          {
            'order': 1,
            'zh-cn': '沙漠中的沙尘暴',
            'en': 'sandstorm in the desert',
            'zh-hant': '沙漠中的沙塵暴',
            'ja': '砂漠の砂嵐',
            'de': 'Sandsturm in der Wüste',
            'fr': 'Tempête de sable dans le désert',
            'it': 'Tempesta di sabbia nel deserto',
            'ko': '사막의 모래폭풍'
          },
          {
            'order': 1,
            'zh-cn': '火焰和烟雾弥漫的城市',
            'en': 'city with flame and smoke',
            'zh-hant': '火焰和煙霧中的城市',
            'ja': '炎と煙の都市',
            'de': 'Stadt mit Flammen und Rauch',
            'fr': 'Ville avec flammes et fumée',
            'it': 'Città con fiamme e fumo',
            'ko': '화염과 연기에 휩싸인 도시'
          },
          {
            'order': 1,
            'zh-cn': '冬季里的极地和北极光',
            'en': 'polar regions and northern lights in winter',
            'zh-hant': '冬季極地與北極光',
            'ja': '冬の極地とオーロラ',
            'de': 'Polarregionen und Nordlichter im Winter',
            'fr': 'Régions polaires et aurores boréales en hiver',
            'it': 'Regioni polari e aurore boreali in inverno',
            'ko': '겨울의 극지방과 오로라'
          },
          {
            'order': 1,
            'zh-cn': '可爱的动物们在森林里玩耍',
            'en': 'cute animals playing in the forest',
            'zh-hant': '森林中玩耍的可愛動物',
            'ja': '森で遊ぶかわいい動物たち',
            'de': 'Niedliche Tiere, die im Wald spielen',
            'fr': 'Animaux mignons jouant dans la forêt',
            'it': 'Animali carini che giocano nella foresta',
            'ko': '숲에서 노는 귀여운 동물들'
          },
          {
            'order': 1,
            'zh-cn': '闪闪发光的宝石洞穴',
            'en': 'glittering gemstone cave',
            'zh-hant': '閃閃發光的寶石洞穴',
            'ja': '輝く宝石の洞窟',
            'de': 'Glitzernde Edelsteinhöhle',
            'fr': 'Grotte aux gemmes scintillantes',
            'it': 'Grotta di gemme scintillanti',
            'ko': '반짝이는 보석 동굴'
          },
          {
            'order': 1,
            'zh-cn': '雨天的城市夜景和反光',
            'en': 'wet city night view with reflections',
            'zh-hant': '雨夜城市的反光景象',
            'ja': '濡れた夜の街の反射風景',
            'de': 'Nasse nächtliche Stadtansicht mit Reflexionen',
            'fr': 'Vue nocturne de la ville mouillée avec des reflets',
            'it': 'Vista notturna della città bagnata con riflessi',
            'ko': '비 내리는 도시의 야경과 반사'
          },
          {
            'order': 1,
            'zh-cn': '水波荡漾的湖泊和小船',
            'en': 'lake with rippling water and small boats',
            'zh-hant': '波光粼粼的小船湖',
            'ja': '小舟が浮かぶ波立つ湖',
            'de': 'See mit Kräuselwasser und kleinen Booten',
            'fr': 'Lac avec eau ondulante et petits bateaux',
            'it': 'Lago con acque increspate e piccole barche',
            'ko': '잔잔한 물결이 있는 호수와 작은 배'
          },
          {
            'order': 1,
            'zh-cn': '未来城市的交通管制中心',
            'en': 'traffic control center in future city',
            'zh-hant': '未來城市的交通控制中心',
            'ja': '未来都市の交通管理センター',
            'de': 'Verkehrskontrollzentrum in der zukünftigen Stadt',
            'fr': 'Centre de contrôle du trafic dans la ville du futur',
            'it': 'Centro di controllo del traffico nella città del futuro',
            'ko': '미래 도시의 교통 관제 센터'
          },
          {
            'order': 1,
            'zh-cn': '巨大飓风和海啸',
            'en': 'hurricane and tsunami',
            'zh-hant': '颶風和海嘯',
            'ja': 'ハリケーンと津波',
            'de': 'Hurrikan und Tsunami',
            'fr': 'Ouragan et tsunami',
            'it': 'Uragano e tsunami',
            'ko': '허리케인과 쓰나미'
          },
          {
            'order': 1,
            'zh-cn': '迷失在迷宫中的探险家',
            'en': 'explorer lost in a maze',
            'zh-hant': '迷宮中迷路的探險者',
            'ja': '迷宮で迷子になった探検家',
            'de': 'Entdecker, der sich in einem Labyrinth verirrt hat',
            'fr': 'Explorateur perdu dans un labyrinthe',
            'it': 'Esploratore perso in un labirinto',
            'ko': '미로에 빠진 탐험가'
          }
        ]
      },
      {
        'order': 1,
        'name': {
          'zh-cn': '场景材质/氛围描述',
          en: 'Scene Material/Atmosphere Description',
          'zh-hant': '場景材質/氛圍描述',
          ja: 'シーンの素材/雰囲気の説明',
          de: 'Beschreibung von Szenenmaterial/Atmosphäre',
          fr: 'Description du matériau/atmosphère de la scène',
          it: 'Descrizione del materiale/atmosfera della scena',
          'ko': '장면 재료/분위기 설명'
        },
        'list': [
          {
            'order': 1,
            'zh-cn': '毛玻璃材质',
            'en': 'frostedglass',
            'zh-hant': '霧面玻璃',
            'ja': 'すりガラス',
            'de': 'Mattglas',
            'fr': 'Verre dépoli',
            'it': 'Vetro smerigliato',
            'ko': '서리유리'
          },
          {
            'order': 1,
            'zh-cn': '半透明磨砂质感',
            'en': 'transparent',
            'zh-hant': '透明',
            'ja': '透明',
            'de': 'Transparent',
            'fr': 'Transparent',
            'it': 'Trasparente',
            'ko': '투명'
          },
          {
            'order': 1,
            'zh-cn': '半透明质感',
            'en': 'translucent',
            'zh-hant': '半透明',
            'ja': '半透明',
            'de': 'Transluzent',
            'fr': 'Translucide',
            'it': 'Traslucido',
            'ko': '반투명'
          },
          {
            'order': 1,
            'zh-cn': '亚克力材质',
            'en': 'acrylic',
            'zh-hant': '丙烯酸纖維',
            'ja': 'アクリル',
            'de': 'Acryl',
            'fr': 'Acrylique',
            'it': 'Acrilico',
            'ko': '아크릴'
          },
          {
            'order': 1,
            'zh-cn': '毛茸茸',
            'en': 'fluffy',
            'zh-hant': '蓬鬆',
            'ja': 'ふわふわ',
            'de': 'Flauschig',
            'fr': 'Moelleux',
            'it': 'Soffice',
            'ko': '푹신푹신'
          },
          {
            'order': 1,
            'zh-cn': '等距棱形材质',
            'en': 'isometric',
            'zh-hant': '等距',
            'ja': 'アイソメトリック',
            'de': 'Isometrisch',
            'fr': 'Isométrique',
            'it': 'Isometrico',
            'ko': '등각'
          },
          {
            'order': 1,
            'zh-cn': '赤铜',
            'en': 'cuprite',
            'zh-hant': '紅銅礦',
            'ja': '銅鉱石',
            'de': 'Cuprit',
            'fr': 'Cuprite',
            'it': 'Cuprite',
            'ko': '적동석'
          },
          {
            'order': 1,
            'zh-cn': '浮雕',
            'en': 'embossing',
            'zh-hant': '浮雕',
            'ja': 'エンボス加工',
            'de': 'Prägung',
            'fr': 'Gaufrage',
            'it': 'Stampa a rilievo',
            'ko': '엠보싱'
          },
          {
            'order': 1,
            'zh-cn': '蚀刻',
            'en': 'etching',
            'zh-hant': '蝕刻',
            'ja': 'エッチング',
            'de': 'Ätzen',
            'fr': 'Gravure à l\'eau-forte',
            'it': 'Incisione',
            'ko': '에칭'
          },
          {
            'order': 1,
            'zh-cn': '雕',
            'en': 'engraving',
            'zh-hant': '雕刻',
            'ja': '彫刻',
            'de': 'Gravieren',
            'fr': 'Gravure',
            'it': 'Incisione',
            'ko': '조각'
          },
          {
            'order': 1,
            'zh-cn': '刻',
            'en': 'deepcarving',
            'zh-hant': '深雕',
            'ja': '深彫り',
            'de': 'Tiefschnitt',
            'fr': 'Sculptage profond',
            'it': 'Incisione profonda',
            'ko': '깊은 조각'
          },
          {
            'order': 1,
            'zh-cn': '象牙',
            'en': 'livory',
            'zh-hant': '象牙',
            'ja': '象牙',
            'de': 'Elfenbein',
            'fr': 'Ivoire',
            'it': 'Avorio',
            'ko': '상아'
          },
          {
            'order': 1,
            'zh-cn': '黑曜石',
            'en': 'obsidian',
            'zh-hant': '黑曜石',
            'ja': '黒曜石',
            'de': 'Obsidian',
            'fr': 'Obsidienne',
            'it': 'Ossidiana',
            'ko': '흑요석'
          },
          {
            'order': 1,
            'zh-cn': '花岗岩',
            'en': 'granite',
            'zh-hant': '花崗岩',
            'ja': '花崗岩',
            'de': 'Granit',
            'fr': 'Granit',
            'it': 'Granito',
            'ko': '화강암'
          },
          {
            'order': 1,
            'zh-cn': '玄武岩',
            'en': 'basalt',
            'zh-hant': '玄武岩',
            'ja': '玄武岩',
            'de': 'Basalt',
            'fr': 'Basalte',
            'it': 'Basalto',
            'ko': '현무암'
          },
          {
            'order': 1,
            'zh-cn': '大理石',
            'en': 'marble',
            'zh-hant': '大理石',
            'ja': '大理石',
            'de': 'Marmor',
            'fr': 'Marbre',
            'it': 'Marmo',
            'ko': '대리석'
          },
          {
            'order': 1,
            'zh-cn': '松木',
            'en': 'pine',
            'zh-hant': '松木',
            'ja': '松',
            'de': 'Kiefer',
            'fr': 'Pin',
            'it': 'Pino',
            'ko': '소나무'
          },
          {
            'order': 1,
            'zh-cn': '珍珠',
            'en': 'pearl',
            'zh-hant': '珍珠',
            'ja': '真珠',
            'de': 'Perle',
            'fr': 'Perle',
            'it': 'Perla',
            'ko': '진주'
          },
          {
            'order': 1,
            'zh-cn': '玉石',
            'en': 'jade',
            'zh-hant': '玉',
            'ja': '翡翠',
            'de': 'Jade',
            'fr': 'Jade',
            'it': 'Giada',
            'ko': '옥'
          },
          {
            'order': 1,
            'zh-cn': '琥珀',
            'en': 'amber',
            'zh-hant': '琥珀',
            'ja': '琥珀',
            'de': 'Bernstein',
            'fr': 'Ambre',
            'it': 'Ambra',
            'ko': '호박'
          },
          {
            'order': 1,
            'zh-cn': '红宝石',
            'en': 'ruby',
            'zh-hant': '紅寶石',
            'ja': 'ルビー',
            'de': 'Rubin',
            'fr': 'Rubis',
            'it': 'Rubino',
            'ko': '루비'
          },
          {
            'order': 1,
            'zh-cn': '紫水晶',
            'en': 'amethyst',
            'zh-hant': '紫水晶',
            'ja': 'アメジスト',
            'de': 'Amethyst',
            'fr': 'Améthyste',
            'it': 'Ametista',
            'ko': '자수정'
          },
          {
            'order': 1,
            'zh-cn': '钻石',
            'en': 'diamond',
            'zh-hant': '鑽石',
            'ja': 'ダイヤモンド',
            'de': 'Diamant',
            'fr': 'Diamant',
            'it': 'Diamante',
            'ko': '다이아몬드'
          },
          {
            'order': 1,
            'zh-cn': '太阳石',
            'en': 'heliodor',
            'zh-hant': '金綠寶石（黃晶）',
            'ja': 'ヘリオドール',
            'de': 'Heliodor',
            'fr': 'Héliodore',
            'it': 'Eliodoro',
            'ko': '헬리오도어'
          },
          {
            'order': 1,
            'zh-cn': '做旧',
            'en': 'antique',
            'zh-hant': '古董',
            'ja': 'アンティーク',
            'de': 'Antik',
            'fr': 'Antique',
            'it': 'Antico',
            'ko': '앤틱'
          },
          {
            'order': 1,
            'zh-cn': '抛光',
            'en': 'highpolished',
            'zh-hant': '高拋光',
            'ja': '高光沢',
            'de': 'Hochglanzpoliert',
            'fr': 'Hautement poli',
            'it': 'Altamente lucido',
            'ko': '고광택'
          },
          {
            'order': 1,
            'zh-cn': '拉丝',
            'en': 'brushed',
            'zh-hant': '拉絲',
            'ja': 'ブラッシュド',
            'de': 'Gebürstet',
            'fr': 'Brossé',
            'it': 'Spazzolato',
            'ko': '브러시드'
          },
          {
            'order': 1,
            'zh-cn': '哑光',
            'en': 'matte',
            'zh-hant': '霧面',
            'ja': 'マット',
            'de': 'Matt',
            'fr': 'Mat',
            'it': 'Opaco',
            'ko': '무광'
          },
          {
            'order': 1,
            'zh-cn': '缎面',
            'en': 'satin',
            'zh-hant': '緞面',
            'ja': 'サテン',
            'de': 'Satin',
            'fr': 'Satin',
            'it': 'Raso',
            'ko': '새틴'
          },
          {
            'order': 1,
            'zh-cn': '捶打',
            'en': 'hammered',
            'zh-hant': '錘打',
            'ja': 'ハンマー仕上げ',
            'de': 'Gehämmert',
            'fr': 'Martelé',
            'it': 'Martellato',
            'ko': '망치질'
          },
          {
            'order': 1,
            'zh-cn': '喷砂',
            'en': 'sandblasted',
            'zh-hant': '噴砂',
            'ja': 'サンドブラスト',
            'de': 'Sandgestrahlt',
            'fr': 'Sablé',
            'it': 'Sabbiato',
            'ko': '샌드블라스트'
          },
          {
            'order': 1,
            'zh-cn': '乌木',
            'en': 'ebony',
            'zh-hant': '烏木',
            'ja': 'エボニー',
            'de': 'Ebenholz',
            'fr': 'Ébène',
            'it': 'Ebano',
            'ko': '흑단'
          },
          {
            'order': 1,
            'zh-cn': '半透明熔融体',
            'en': 'translucent molten body',
            'zh-hant': '半透明熔融體',
            'ja': '半透明の溶融体',
            'de': 'Transparenter geschmolzener Körper',
            'fr': 'Corps fondu translucide',
            'it': 'Corpo fuso traslucido',
            'ko': '반투명 용융체'
          },
          {
            'order': 1,
            'zh-cn': '针织物',
            'en': 'knitted creatures',
            'zh-hant': '編織生物',
            'ja': '編まれた生き物',
            'de': 'Gestrickte Kreaturen',
            'fr': 'Créatures tricotées',
            'it': 'Creature lavorate a maglia',
            'ko': '뜨개질 생물'
          },
          {
            'order': 1,
            'zh-cn': '颗粒感',
            'en': 'grainy',
            'zh-hant': '顆粒感',
            'ja': '粒状感',
            'de': 'Körnig',
            'fr': 'Granuleux',
            'it': 'Granuloso',
            'ko': '입자감'
          },
          {
            'order': 1,
            'zh-cn': '全息图的',
            'en': 'holographic',
            'zh-hant': '全息',
            'ja': 'ホログラフィック',
            'de': 'Holographisch',
            'fr': 'Holographique',
            'it': 'Olografico',
            'ko': '홀로그래픽'
          },
          {
            'order': 1,
            'zh-cn': '羊毛毡',
            'en': 'wool felt',
            'zh-hant': '羊毛氈',
            'ja': 'ウールフェルト',
            'de': 'Wollfilz',
            'fr': 'Feutre de laine',
            'it': 'Feltro di lana',
            'ko': '양모 펠트'
          },
          {
            'order': 1,
            'zh-cn': '磨砂颗粒质感',
            'en': 'sandpaper texture',
            'zh-hant': '砂紙質感',
            'ja': '砂紙の質感',
            'de': 'Sandpapierstruktur',
            'fr': 'Texture de papier de verre',
            'it': 'Struttura della carta vetrata',
            'ko': '사포 질감'
          },
          {
            'order': 1,
            'zh-cn': '像羽毛一样的波浪质感',
            'en': 'feather-like wavy texture',
            'zh-hant': '羽毛狀波紋質感',
            'ja': '羽のような波状の質感',
            'de': 'Federartige wellige Textur',
            'fr': 'Texture ondulée semblable à des plumes',
            'it': 'Struttura ondulata simile a piume',
            'ko': '깃털 같은 물결 질감'
          },
          {
            'order': 1,
            'zh-cn': '刀锋一样利落笔挺的感觉',
            'en': 'sharp and crisp feeling',
            'zh-hant': '銳利和清脆的感覺',
            'ja': '鋭くてクリスプな感じ',
            'de': 'Scharfe und klare Haptik',
            'fr': 'Sensation nette et précise',
            'it': 'Sensazione nitida e tagliente',
            'ko': '날카롭고 선명한 느낌'
          },
          {
            'order': 1,
            'zh-cn': '科技未来感',
            'en': 'futuristic atmosphere',
            'zh-hant': '未來氛圍',
            'ja': '未来的な雰囲気',
            'de': 'Futuristische Atmosphäre',
            'fr': 'Atmosphère futuriste',
            'it': 'Atmosfera futuristica',
            'ko': '미래적인 분위기'
          },
          {
            'order': 1,
            'zh-cn': '油画般的色彩层次',
            'en': 'oil painting-like color layers',
            'zh-hant': '油畫般的色彩層次',
            'ja': '油絵のような色の層',
            'de': 'Ölgemäldeartige Farbschichten',
            'fr': 'Couches de couleur semblables à la peinture à l\'huile',
            'it': 'Strati di colore simili alla pittura a olio',
            'ko': '유화와 같은 색채 층'
          },
          {
            'order': 1,
            'zh-cn': '柔和朦胧的光影效果',
            'en': 'soft and hazy light and shadow effects',
            'zh-hant': '柔和朦朧的光影效果',
            'ja': '柔らかくかすんだ光と影の効果',
            'de': 'Weiche und verschwommene Licht- und Schatteneffekte',
            'fr': 'Effets de lumière et d\'ombre doux et flous',
            'it': 'Effetti di luce e ombra morbidi e sfumati',
            'ko': '부드럽고 흐릿한 명암 효과'
          },
          {
            'order': 1,
            'zh-cn': '金属冷酷质感',
            'en': 'cold metallic texture',
            'zh-hant': '冷金屬質感',
            'ja': '冷たい金属の質感',
            'de': 'Kalte Metalltextur',
            'fr': 'Texture métallique froide',
            'it': 'Struttura metallica fredda',
            'ko': '차가운 금속 질감'
          },
          {
            'order': 1,
            'zh-cn': '震慑力十足的视觉效果',
            'en': 'visually striking effects',
            'zh-hant': '視覺震撼效果',
            'ja': '視覚的に印象的な効果',
            'de': 'Visuell beeindruckende Effekte',
            'fr': 'Effets visuellement frappants',
            'it': 'Effetti visivamente sorprendenti',
            'ko': '시각적으로 강렬한 효과'
          },
          {
            'order': 1,
            'zh-cn': '细腻柔软的绒毛质感',
            'en': 'delicate and soft velvet texture',
            'zh-hant': '精緻柔軟的天鵝絨質感',
            'ja': '繊細で柔らかなベルベットの質感',
            'de': 'Zarte und weiche Samttextur',
            'fr': 'Texture délicate et douce du velours',
            'it': 'Struttura delicata e morbida del velluto',
            'ko': '섬세하고 부드러운 벨벳 질감'
          },
          {
            'order': 1,
            'zh-cn': '温暖舒适的氛围感',
            'en': 'warm and cozy atmosphere',
            'zh-hant': '溫暖舒適的氛圍',
            'ja': '暖かく居心地の良い雰囲気',
            'de': 'Warme und gemütliche Atmosphäre',
            'fr': 'Atmosphère chaude et confortable',
            'it': 'Atmosfera calda e accogliente',
            'ko': '따뜻하고 아늑한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '凄美寂静的氛围感',
            'en': 'melancholic and silent atmosphere',
            'zh-hant': '憂鬱寂靜的氛圍',
            'ja': '憂鬱で静かな雰囲気',
            'de': 'Melancholische und stille Atmosphäre',
            'fr': 'Atmosphère mélancolique et silencieuse',
            'it': 'Atmosfera malinconica e silenziosa',
            'ko': '처연하고 고요한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '逼真写实的质感表现',
            'en': 'realistic texture rendering',
            'zh-hant': '寫實質感渲染',
            'ja': 'リアルな質感レンダリング',
            'de': 'Realistische Texturwiedergabe',
            'fr': 'Rendu de texture réaliste',
            'it': 'Rendering di texture realistico',
            'ko': '사실적인 질감 표현'
          },
          {
            'order': 1,
            'zh-cn': '神秘幽暗的氛围感',
            'en': 'mysterious and dark atmosphere',
            'zh-hant': '神秘而黑暗的氛圍',
            'ja': '神秘的で暗い雰囲気',
            'de': 'Mysteriöse und dunkle Atmosphäre',
            'fr': 'Atmosphère mystérieuse et sombre',
            'it': 'Atmosfera misteriosa e scura',
            'ko': '신비롭고 어두운 분위기'
          },
          {
            'order': 1,
            'zh-cn': '营造出时空错乱感的视觉效果',
            'en': 'visual effects creating a sense of time and space distortion',
            'zh-hant': '創造時空扭曲感的視覺效果',
            'ja': '時空の歪みを感じさせる視覚効果',
            'de': 'Visuelle Effekte, die ein Gefühl der Zeit- und Raumverzerrung erzeugen',
            'fr': 'Effets visuels créant une distorsion du temps et de l\'espace',
            'it': 'Effetti visivi che creano una distorsione del tempo e dello spazio',
            'ko': '시공간 왜곡을 느끼게 하는 시각 효과'
          },
          {
            'order': 1,
            'zh-cn': '酷炫张扬的氛围感',
            'en': 'cool and bold atmosphere',
            'zh-hant': '涼爽大膽的氛圍',
            'ja': 'クールで大胆な雰囲気',
            'de': 'Kühle und mutige Atmosphäre',
            'fr': 'Atmosphère fraîche et audacieuse',
            'it': 'Atmosfera fresca e audace',
            'ko': '멋지고 대담한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '恢弘壮观的场面效果',
            'en': 'grand and spectacular scene effects',
            'zh-hant': '宏大壯觀的場景效果',
            'ja': '壮大でスペクタクルなシーン効果',
            'de': 'Großartige und spektakuläre Szeneneffekte',
            'fr': 'Effets de scène grandioses et spectaculaires',
            'it': 'Effetti scenici grandiosi e spettacolari',
            'ko': '웅장하고 장엄한 장면 효과'
          },
          {
            'order': 1,
            'zh-cn': '光线斑驳的氛围感',
            'en': 'dappled light atmosphere',
            'zh-hant': '斑駁光影氛圍',
            'ja': '斑点のある光の雰囲気',
            'de': 'Gefleckte Lichtatmosphäre',
            'fr': 'Atmosphère de lumière tachetée',
            'it': 'Atmosfera di luce screziata',
            'ko': '얼룩진 빛의 분위기'
          },
          {
            'order': 1,
            'zh-cn': '复古怀旧的质感表现',
            'en': 'vintage and nostalgic texture rendering',
            'zh-hant': '復古懷舊質感渲染',
            'ja': 'ビンテージでノスタルジックな質感レンダリング',
            'de': 'Vintage- und nostalgische Texturwiedergabe',
            'fr': 'Rendu de texture vintage et nostalgique',
            'it': 'Rendering di texture vintage e nostalgico',
            'ko': '빈티지하고 향수를 불러일으키는 질감 표현'
          },
          {
            'order': 1,
            'zh-cn': '热带风情的氛围感',
            'en': 'tropical atmosphere',
            'zh-hant': '熱帶氛圍',
            'ja': 'トロピカルな雰囲気',
            'de': 'Tropische Atmosphäre',
            'fr': 'Atmosphère tropicale',
            'it': 'Atmosfera tropicale',
            'ko': '열대의 분위기'
          },
          {
            'order': 1,
            'zh-cn': '沉浸式的视觉体验',
            'en': 'immersive visual experience',
            'zh-hant': '沉浸式視覺體驗',
            'ja': '没入型の視覚体験',
            'de': 'Immersives visuelles Erlebnis',
            'fr': 'Expérience visuelle immersive',
            'it': 'Esperienza visiva immersiva',
            'ko': '몰입형 시각 경험'
          },
          {
            'order': 1,
            'zh-cn': '火热的红色色调',
            'en': 'fiery red color tone',
            'zh-hant': '火紅色調',
            'ja': '炎のような赤い色調',
            'de': 'Feuriger roter Farbton',
            'fr': 'Ton rouge flamboyant',
            'it': 'Tonalità di colore rosso fuoco',
            'ko': '불타는 듯한 붉은 색조'
          },
          {
            'order': 1,
            'zh-cn': '清新明亮的气息',
            'en': 'fresh and bright atmosphere',
            'zh-hant': '清新明亮的氛圍',
            'ja': '新鮮で明るい雰囲気',
            'de': 'Frische und helle Atmosphäre',
            'fr': 'Atmosphère fraîche et lumineuse',
            'it': 'Atmosfera fresca e luminosa',
            'ko': '상쾌하고 밝은 분위기'
          },
          {
            'order': 1,
            'zh-cn': '茂密浓郁的植物气息',
            'en': 'dense and lush plant atmosphere',
            'zh-hant': '植被茂密的氛圍',
            'ja': '濃密な植物の雰囲気',
            'de': 'Dichte und üppige Pflanzenatmosphäre',
            'fr': 'Atmosphère de plantes denses et luxuriantes',
            'it': 'Atmosfera di piante dense e rigogliose',
            'ko': '울창하고 풍성한 식물의 분위기'
          },
          {
            'order': 1,
            'zh-cn': '幻想般的梦幻效果',
            'en': 'fantasy-like dreamy effect',
            'zh-hant': '幻想般的夢幻效果',
            'ja': 'ファンタジーのような夢の効果',
            'de': 'Fantasiehafte, traumhafte Effekte',
            'fr': 'Effet onirique fantastique',
            'it': 'Effetto onirico simile a un sogno',
            'ko': '환상적인 꿈같은 효과'
          },
          {
            'order': 1,
            'zh-cn': '陈旧呆板的场景感',
            'en': 'old and stiff scene feeling',
            'zh-hant': '老舊僵硬的場景感',
            'ja': '古くて硬いシーンの感覚',
            'de': 'Alte und steife Szenengefühl',
            'fr': 'Sensation de scène ancienne et rigide',
            'it': 'Sensazione di scena vecchia e rigida',
            'ko': '낡고 딱딱한 장면 느낌'
          },
          {
            'order': 1,
            'zh-cn': '压抑沉闷的氛围气息',
            'en': 'oppressive and dull atmosphere',
            'zh-hant': '壓抑沉悶的氛圍',
            'ja': '抑圧的で鈍い雰囲気',
            'de': 'Unterdrückende und stumpfe Atmosphäre',
            'fr': 'Atmosphère oppressante et terne',
            'it': 'Atmosfera opprimente e cupa',
            'ko': '억압적이고 침울한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '细致入微的质感表现',
            'en': 'intricate texture rendering',
            'zh-hant': '複雜的質感渲染',
            'ja': '複雑な質感レンダリング',
            'de': 'Komplexe Texturwiedergabe',
            'fr': 'Rendu de texture complexe',
            'it': 'Rendering di texture intricata',
            'ko': '섬세한 질감 표현'
          },
          {
            'order': 1,
            'zh-cn': '沙漠中黄昏时分的温暖光线',
            'en': 'warm light in the desert at dusk',
            'zh-hant': '黃昏時沙漠中的溫暖光線',
            'ja': '夕暮れ時の砂漠の暖かい光',
            'de': 'Warmes Licht in der Wüste bei Sonnenuntergang',
            'fr': 'Lumière chaude dans le désert au crépuscule',
            'it': 'Luce calda nel deserto al tramonto',
            'ko': '황혼의 사막에서 따뜻한 빛'
          },
          {
            'order': 1,
            'zh-cn': '多层次的视觉效果',
            'en': 'multi-layered visual effects',
            'zh-hant': '多層次視覺效果',
            'ja': '多層的な視覚効果',
            'de': 'Mehrschichtige visuelle Effekte',
            'fr': 'Effets visuels multi-couches',
            'it': 'Effetti visivi multistrato',
            'ko': '다층적인 시각 효과'
          },
          {
            'order': 1,
            'zh-cn': '冰冷尖锐的氛围感',
            'en': 'icy and sharp atmosphere',
            'zh-hant': '冰冷銳利的氛圍',
            'ja': '氷のような鋭い雰囲気',
            'de': 'Eisige und scharfe Atmosphäre',
            'fr': 'Atmosphère glaciale et tranchante',
            'it': 'Atmosfera gelida e tagliente',
            'ko': '차갑고 날카로운 분위기'
          },
          {
            'order': 1,
            'zh-cn': '抽象奇妙的场景效果',
            'en': 'abstract and fantastic scene effects',
            'zh-hant': '抽象奇幻的場景效果',
            'ja': '抽象的で幻想的なシーン効果',
            'de': 'Abstrakte und fantastische Szeneneffekte',
            'fr': 'Effets de scène abstraits et fantastiques',
            'it': 'Effetti scenici astratti e fantastici',
            'ko': '추상적이고 환상적인 장면 효과'
          },
          {
            'order': 1,
            'zh-cn': '沉静安逸的气息',
            'en': 'calm and serene atmosphere',
            'zh-hant': '平靜安詳的氛圍',
            'ja': '穏やかで静かな雰囲気',
            'de': 'Ruhige und gelassene Atmosphäre',
            'fr': 'Atmosphère calme et sereine',
            'it': 'Atmosfera calma e serena',
            'ko': '고요하고 평온한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '纯净清澈的质感表现',
            'en': 'pure and clear texture rendering',
            'zh-hant': '純淨清晰的質感渲染',
            'ja': '純粋で透明な質感レンダリング',
            'de': 'Reine und klare Texturwiedergabe',
            'fr': 'Rendu de texture pure et claire',
            'it': 'Rendering di texture pura e chiara',
            'ko': '순수하고 맑은 질감 표현'
          },
          {
            'order': 1,
            'zh-cn': '乡村风情的气息',
            'en': 'rustic atmosphere',
            'zh-hant': '鄉村氛圍',
            'ja': '田舎の雰囲気',
            'de': 'Rustikale Atmosphäre',
            'fr': 'Atmosphère rustique',
            'it': 'Atmosfera rustica',
            'ko': '전원적인 분위기'
          },
          {
            'order': 1,
            'zh-cn': '热带雨林的湿润质感',
            'en': 'moist and humid texture in tropical rainforest',
            'zh-hant': '熱帶雨林中的潮濕質感',
            'ja': '熱帯雨林の湿った質感',
            'de': 'Feuchte und nasse Textur im tropischen Regenwald',
            'fr': 'Texture humide et moite dans la forêt tropicale',
            'it': 'Texture umida e bagnata nella foresta pluviale tropicale',
            'ko': '열대우림의 습윤한 질감'
          },
          {
            'order': 1,
            'zh-cn': '奇异荒芜的场景感',
            'en': 'strange and desolate scene feeling',
            'zh-hant': '奇異荒涼的場景感',
            'ja': '奇妙で荒涼とした場面感',
            'de': 'Seltsame und trostlose Szenerie',
            'fr': 'Sentiment de scène étrange et désolée',
            'it': 'Sensazione di scena strana e desolata',
            'ko': '기이하고 황량한 장면 느낌'
          },
          {
            'order': 1,
            'zh-cn': '典雅高贵的气息',
            'en': 'elegant and noble atmosphere',
            'zh-hant': '優雅高貴的氛圍',
            'ja': '優雅で高貴な雰囲気',
            'de': 'Elegante und edle Atmosphäre',
            'fr': 'Atmosphère élégante et noble',
            'it': 'Atmosfera elegante e nobile',
            'ko': '우아하고 고귀한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '眩目耀眼的视觉效果',
            'en': 'dazzling visual effects',
            'zh-hant': '令人目眩的視覺效果',
            'ja': '目を見張る視覚効果',
            'de': 'Blendende visuelle Effekte',
            'fr': 'Effets visuels éblouissants',
            'it': 'Effetti visivi abbaglianti',
            'ko': '눈부신 시각 효과'
          },
          {
            'order': 1,
            'zh-cn': '极寒严酷的氛围感',
            'en': 'frigid and severe atmosphere',
            'zh-hant': '寒冷嚴峻的氛圍',
            'ja': '寒冷で厳しい雰囲気',
            'de': 'Frostige und strenge Atmosphäre',
            'fr': 'Atmosphère glaciale et sévère',
            'it': 'Atmosfera gelida e severa',
            'ko': '혹한의 엄격한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '繁华喧嚣的气息',
            'en': 'lively and bustling atmosphere',
            'zh-hant': '熱鬧繁華的氛圍',
            'ja': '活気があり賑やかな雰囲気',
            'de': 'Lebhafte und geschäftige Atmosphäre',
            'fr': 'Atmosphère vivante et animée',
            'it': 'Atmosfera vivace e brulicante',
            'ko': '번화하고 활기찬 분위기'
          },
          {
            'order': 1,
            'zh-cn': '沙漠中白天的明亮光线',
            'en': 'bright light in the desert during daytime',
            'zh-hant': '白天沙漠中的明亮光線',
            'ja': '昼間の砂漠の明るい光',
            'de': 'Helles Licht in der Wüste während des Tages',
            'fr': 'Lumière éclatante dans le désert en journée',
            'it': 'Luce intensa nel deserto durante il giorno',
            'ko': '사막의 밝은 낮 빛'
          },
          {
            'order': 1,
            'zh-cn': '钢铁硬朗的质感表现',
            'en': 'tough and robust texture rendering',
            'zh-hant': '堅韌粗獷的質感渲染',
            'ja': '堅固で頑丈な質感レンダリング',
            'de': 'Zähe und robuste Texturwiedergabe',
            'fr': 'Rendu de texture dur et robuste',
            'it': 'Rendering di texture resistente e robusto',
            'ko': '강철같이 단단한 질감 표현'
          },
          {
            'order': 1,
            'zh-cn': '优雅细腻的气息',
            'en': 'graceful and delicate atmosphere',
            'zh-hant': '優美細膩的氛圍',
            'ja': '優美で繊細な雰囲気',
            'de': 'Anmutige und zarte Atmosphäre',
            'fr': 'Atmosphère gracieuse et délicate',
            'it': 'Atmosfera graziosa e delicata',
            'ko': '우아하고 섬세한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '萎靡不振的场景感',
            'en': 'lackluster scene feeling',
            'zh-hant': '乏味的場景感',
            'ja': 'ぱっとしない場面感',
            'de': 'Langweilige Szenerie',
            'fr': 'Sentiment de scène terne',
            'it': 'Sensazione di scena scialba',
            'ko': '침체된 장면 느낌'
          },
          {
            'order': 1,
            'zh-cn': '激烈狂野的氛围感',
            'en': 'intense and wild atmosphere',
            'zh-hant': '強烈狂野的氛圍',
            'ja': '激しく野性的な雰囲気',
            'de': 'Intensive und wilde Atmosphäre',
            'fr': 'Atmosphère intense et sauvage',
            'it': 'Atmosfera intensa e selvaggia',
            'ko': '격렬하고 야성적인 분위기'
          },
          {
            'order': 1,
            'zh-cn': '纯真可爱的气息',
            'en': 'innocent and lovely atmosphere',
            'zh-hant': '天真可愛的氛圍',
            'ja': '純真でかわいらしい雰囲気',
            'de': 'Unschuldige und liebevolle Atmosphäre',
            'fr': 'Atmosphère innocente et adorable',
            'it': 'Atmosfera innocente e adorabile',
            'ko': '순수하고 사랑스러운 분위기'
          },
          {
            'order': 1,
            'zh-cn': '机械冷酷的质感表现',
            'en': 'mechanic and cold texture rendering',
            'zh-hant': '機械冰冷的質感渲染',
            'ja': '機械的で冷たい質感レンダリング',
            'de': 'Mechanische und kalte Texturwiedergabe',
            'fr': 'Rendu de texture mécanique et froide',
            'it': 'Rendering di texture meccanica e fredda',
            'ko': '기계적이고 차가운 질감 표현'
          },
          {
            'order': 1,
            'zh-cn': '诡异神秘的氛围感',
            'en': 'eerie and mysterious atmosphere',
            'zh-hant': '詭異神秘的氛圍',
            'ja': '不気味で神秘的な雰囲気',
            'de': 'Unheimliche und mysteriöse Atmosphäre',
            'fr': 'Atmosphère étrange et mystérieuse',
            'it': 'Atmosfera inquietante e misteriosa',
            'ko': '기괴하고 신비로운 분위기'
          },
          {
            'order': 1,
            'zh-cn': '迷幻缤纷的彩色效果',
            'en': 'psychedelic and colorful effects',
            'zh-hant': '迷幻多彩的效果',
            'ja': 'サイケデリックでカラフルな効果',
            'de': 'Psychedelische und bunte Effekte',
            'fr': 'Effets psychédéliques et colorés',
            'it': 'Effetti psichedelici e colorati',
            'ko': '환각적이고 다채로운 색채 효과'
          },
          {
            'order': 1,
            'zh-cn': '沉重艰苦的氛围气息',
            'en': 'heavy and arduous atmosphere',
            'zh-hant': '沉重艱難的氛圍',
            'ja': '重苦しく困難な雰囲気',
            'de': 'Schwere und mühsame Atmosphäre',
            'fr': 'Atmosphère lourde et ardue',
            'it': 'Atmosfera pesante e ardua',
            'ko': '무겁고 고된 분위기'
          },
          {
            'order': 1,
            'zh-cn': '温婉从容的气息',
            'en': 'gentle and poised atmosphere',
            'zh-hant': '溫柔沉穩的氛圍',
            'ja': '優しく落ち着いた雰囲気',
            'de': 'Sanfte und gelassene Atmosphäre',
            'fr': 'Atmosphère douce et posée',
            'it': 'Atmosfera gentile e composta',
            'ko': '온화하고 침착한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '质感粗糙的表现效果',
            'en': 'rough texture rendering',
            'zh-hant': '粗糙的質感渲染',
            'ja': '粗い質感レンダリング',
            'de': 'Raue Texturwiedergabe',
            'fr': 'Rendu de texture rugueux',
            'it': 'Rendering di texture ruvida',
            'ko': '거친 질감 표현'
          },
          {
            'order': 1,
            'zh-cn': '惊险紧张的场景感',
            'en': 'thrilling and tense scene feeling',
            'zh-hant': '驚險緊張的場景感',
            'ja': 'スリリングで緊張感のある場面感',
            'de': 'Spannende und angespannte Szene',
            'fr': 'Sentiment de scène palpitante et tendue',
            'it': 'Sensazione di scena emozionante e tesa',
            'ko': '스릴 넘치고 긴장감 있는 장면 느낌'
          },
          {
            'order': 1,
            'zh-cn': '甜美可口的气息',
            'en': 'sweet and delectable atmosphere',
            'zh-hant': '甜美可口的氛圍',
            'ja': '甘くて美味しい雰囲気',
            'de': 'Süße und köstliche Atmosphäre',
            'fr': 'Atmosphère douce et délectable',
            'it': 'Atmosfera dolce e deliziosa',
            'ko': '달콤하고 맛있는 분위기'
          },
          {
            'order': 1,
            'zh-cn': '冰川和雪峰的纯净氛围',
            'en': 'pure atmosphere of glaciers and snow peaks',
            'zh-hant': '冰川和雪峰的純淨氛圍',
            'ja': '氷河と雪山の純粋な雰囲気',
            'de': 'Reine Atmosphäre von Gletschern und Schneegipfeln',
            'fr': 'Atmosphère pure des glaciers et des sommets enneigés',
            'it': 'Atmosfera pura di ghiacciai e cime innevate',
            'ko': '빙하와 설봉의 순수한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '玩味风趣的视觉效果',
            'en': 'whimsical and humorous visual effects',
            'zh-hant': '異想天開的幽默視覺效果',
            'ja': '奇抜でユーモラスな視覚効果',
            'de': 'Skurrile und humorvolle visuelle Effekte',
            'fr': 'Effets visuels fantaisistes et humoristiques',
            'it': 'Effetti visivi stravaganti e umoristici',
            'ko': '재치있고 유머러스한 시각 효과'
          },
          {
            'order': 1,
            'zh-cn': '带着浓重历史气息的场景',
            'en': 'scene with rich historical feeling',
            'zh-hant': '富有歷史感的場景',
            'ja': '豊かな歴史感のある場面',
            'de': 'Szenerie mit reichem historischen Gefühl',
            'fr': 'Scène avec une riche sensation historique',
            'it': 'Scena con un ricco sentimento storico',
            'ko': '짙은 역사적 분위기가 있는 장면'
          },
          {
            'order': 1,
            'zh-cn': '昏暗模糊的氛围气息',
            'en': 'dim and blurred atmosphere',
            'zh-hant': '昏暗模糊的氛圍',
            'ja': '薄暗くぼやけた雰囲気',
            'de': 'Düstere und verschwommene Atmosphäre',
            'fr': 'Atmosphère sombre et floue',
            'it': 'Atmosfera cupa e sfocata',
            'ko': '어둡고 흐릿한 분위기'
          },
          {
            'order': 1,
            'zh-cn': '海浪和海鸥的自由感',
            'en': 'sense of freedom in waves and seagulls',
            'zh-hant': '海浪和海鷗中的自由感',
            'ja': '波とカモメの自由感',
            'de': 'Gefühl der Freiheit in den Wellen und Möwen',
            'fr': 'Sentiment de liberté dans les vagues et les mouettes',
            'it': 'Sensazione di libertà tra le onde e i gabbiani',
            'ko': '파도와 갈매기의 자유로움'
          },
          {
            'order': 1,
            'zh-cn': '清新冷艳的气息',
            'en': 'fresh and cool atmosphere',
            'zh-hant': '清新涼爽的氛圍',
            'ja': '新鮮で涼しい雰囲気',
            'de': 'Frische und kühle Atmosphäre',
            'fr': 'Atmosphère fraîche et agréable',
            'it': 'Atmosfera fresca e piacevole',
            'ko': '상쾌하고 시원한 분위기'
          }
        ]
      }
    ]
  },
  {
    'order': 1,
    'name': { 'zh-cn': '摄影', en: 'Photography', 'zh-hant': '攝影', ja: '撮影', de: 'Fotografie', fr: 'Photographie', it: 'Fotografia', 'ko': '촬영' },
    'list': [
      {
        'order': 1,
        'name': { 'zh-cn': '光线', en: 'Lighting', 'zh-hant': '光線', ja: '照明', de: 'Beleuchtung', fr: 'Éclairage', it: 'Illuminazione', ko: '조명' },
        'list': [
          {
            'order': 1,
            'zh-cn': '体积光',
            'en': 'volumetric lighting',
            'zh-hant': '體積光',
            'ja': '体積光',
            'de': 'Volumenbeleuchtung',
            'fr': 'Éclairage volumétrique',
            'it': 'Illuminazione volumetrica',
            'ko': '볼륨 라이팅'
          },
          {
            'order': 1,
            'zh-cn': '气氛光',
            'en': 'mood lighting',
            'zh-hant': '情調燈光',
            'ja': 'ムード照明',
            'de': 'Stimmungsbeleuchtung',
            'fr': 'Éclairage d\'ambiance',
            'it': 'Illuminazione d\'atmosfera',
            'ko': '분위기 조명'
          },
          {
            'order': 1,
            'zh-cn': '明亮',
            'en': 'bright',
            'zh-hant': '明亮',
            'ja': '明るい',
            'de': 'Hell',
            'fr': 'Lumineux',
            'it': 'Luminoso',
            'ko': '밝은'
          },
          {
            'order': 1,
            'zh-cn': '柔光照明',
            'en': 'soft illumination',
            'zh-hant': '柔和照明',
            'ja': '柔らかな照明',
            'de': 'Sanfte Beleuchtung',
            'fr': 'Illumination douce',
            'it': 'Illuminazione soffusa',
            'ko': '부드러운 조명'
          },
          {
            'order': 1,
            'zh-cn': '瑞光千条',
            'en': 'soft lights',
            'zh-hant': '柔光',
            'ja': '柔らかい光',
            'de': 'Weiche Lichter',
            'fr': 'Lumières douces',
            'it': 'Luci soffuse',
            'ko': '부드러운 빛'
          },
          {
            'order': 1,
            'zh-cn': '超闪轰趴光',
            'en': 'rays of shimmering light',
            'zh-hant': '閃爍的光線',
            'ja': 'きらめく光線',
            'de': 'Schimmernde Lichtstrahlen',
            'fr': 'Rayons de lumière scintillante',
            'it': 'Raggi di luce scintillante',
            'ko': '반짝이는 빛줄기'
          },
          {
            'order': 1,
            'zh-cn': '耶稣光',
            'en': 'crepuscular ray',
            'zh-hant': '曙暮光束',
            'ja': '薄明光線',
            'de': 'Dämmerungsstrahl',
            'fr': 'Rayon crépusculaire',
            'it': 'Raggi crepuscolari',
            'ko': '황혼 광선'
          },
          {
            'order': 1,
            'zh-cn': '生物发光',
            'en': 'bioluminescence',
            'zh-hant': '生物發光',
            'ja': '生物発光',
            'de': 'Biolumineszenz',
            'fr': 'Bioluminescence',
            'it': 'Bioluminescenza',
            'ko': '생물 발광'
          },
          {
            'order': 1,
            'zh-cn': '电影感氛围光',
            'en': 'cinematic lighting',
            'zh-hant': '電影燈光',
            'ja': '映画的な照明',
            'de': 'Kinematische Beleuchtung',
            'fr': 'Éclairage cinématographique',
            'it': 'Illuminazione cinematografica',
            'ko': '영화적 조명'
          },
          {
            'order': 1,
            'zh-cn': '红蓝双色光',
            'en': 'bisexual lighting',
            'zh-hant': '雙性戀燈光（紫藍粉光）',
            'ja': 'バイセクシャル照明',
            'de': 'Bisexuelle Beleuchtung (violett-blau-rosa Licht)',
            'fr': 'Éclairage bisexuel (lumière violet-bleu-rose)',
            'it': 'Illuminazione bisessuale (luce viola-blu-rosa)',
            'ko': '바이섹슈얼 조명 (보라-파랑-분홍 빛)'
          },
          {
            'order': 1,
            'zh-cn': '高对比的侧面光',
            'en': 'split lighting',
            'zh-hant': '分割照明',
            'ja': '分割照明',
            'de': 'Geteiltes Licht',
            'fr': 'Éclairage séparé',
            'it': 'Illuminazione divisa',
            'ko': '분할 조명'
          },
          {
            'order': 1,
            'zh-cn': '正面光顺光',
            'en': 'front lighting',
            'zh-hant': '正面照明',
            'ja': '前方照明',
            'de': 'Frontalbeleuchtung',
            'fr': 'Éclairage frontal',
            'it': 'Illuminazione frontale',
            'ko': '정면 조명'
          },
          {
            'order': 1,
            'zh-cn': '逆光',
            'en': 'back lighting',
            'zh-hant': '背面照明',
            'ja': '背面照明',
            'de': 'Hintergrundbeleuchtung',
            'fr': 'Éclairage arrière',
            'it': 'Retroilluminazione',
            'ko': '역광'
          },
          {
            'order': 1,
            'zh-cn': '斜逆光',
            'en': 'halfrear lighting',
            'zh-hant': '半背光',
            'ja': '半背面照明',
            'de': 'Halb-Hintergrundbeleuchtung',
            'fr': 'Éclairage demi-arrière',
            'it': 'Illuminazione posteriore parziale',
            'ko': '반역광'
          },
          {
            'order': 1,
            'zh-cn': '轮辋照明灯',
            'en': 'rim lights',
            'zh-hant': '邊緣光',
            'ja': '縁取り照明',
            'de': 'Randlichter',
            'fr': 'Lumières de bordure',
            'it': 'Luci di bordo',
            'ko': '림 라이트'
          },
          {
            'order': 1,
            'zh-cn': '林布兰光',
            'en': 'rembrandt lighting',
            'zh-hant': '伦勃朗照明',
            'ja': 'レンブラント照明',
            'de': 'Rembrandt-Beleuchtung',
            'fr': 'Éclairage Rembrandt',
            'it': 'Illuminazione Rembrandt',
            'ko': '렘브란트 조명'
          },
          {
            'order': 1,
            'zh-cn': '雾中散光',
            'en': 'light througn the mist',
            'zh-hant': '霧中的光',
            'ja': '霧の中の光',
            'de': 'Licht durch den Nebel',
            'fr': 'Lumière à travers la brume',
            'it': 'Luce attraverso la nebbia',
            'ko': '안개 속의 빛'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '视角构图', en: 'Perspective Composition', 'zh-hant': '視角構圖', ja: '視点構成', de: 'Perspektivkomposition', fr: 'Composition de la perspective', it: 'Composizione prospettica', ko: '시점 구도' },
        'list': [
          {
            'order': 1,
            'zh-cn': '正视图',
            'en': 'front view',
            'zh-hant': '正面視角',
            'ja': '正面ビュー',
            'de': 'Vorderansicht',
            'fr': 'Vue de face',
            'it': 'Vista frontale',
            'ko': '정면도'
          },
          {
            'order': 1,
            'zh-cn': '后视图',
            'en': 'back view',
            'zh-hant': '背面視角',
            'ja': '背面ビュー',
            'de': 'Rückansicht',
            'fr': 'Vue de dos',
            'it': 'Vista posteriore',
            'ko': '후면도'
          },
          {
            'order': 1,
            'zh-cn': '侧视图',
            'en': 'side view',
            'zh-hant': '側面視角',
            'ja': '側面ビュー',
            'de': 'Seitenansicht',
            'fr': 'Vue latérale',
            'it': 'Vista laterale',
            'ko': '측면도'
          },
          {
            'order': 1,
            'zh-cn': '俯视图',
            'en': 'overhead view',
            'zh-hant': '頭頂視角',
            'ja': '頭上ビュー',
            'de': 'Draufsicht',
            'fr': 'Vue de dessus',
            'it': 'Vista dall\'alto',
            'ko': '조감도'
          },
          {
            'order': 1,
            'zh-cn': '左视图',
            'en': 'left view',
            'zh-hant': '左視角',
            'ja': '左ビュー',
            'de': 'Linke Ansicht',
            'fr': 'Vue de gauche',
            'it': 'Vista sinistra',
            'ko': '좌측면도'
          },
          {
            'order': 1,
            'zh-cn': '右视图',
            'en': 'right view',
            'zh-hant': '右視角',
            'ja': '右ビュー',
            'de': 'Rechte Ansicht',
            'fr': 'Vue de droite',
            'it': 'Vista destra',
            'ko': '우측면도'
          },
          {
            'order': 1,
            'zh-cn': '顶视图',
            'en': 'top view',
            'zh-hant': '上視角',
            'ja': '上部ビュー',
            'de': 'Obenansicht',
            'fr': 'Vue du dessus',
            'it': 'Vista dall\'alto',
            'ko': '평면도'
          },
          {
            'order': 1,
            'zh-cn': '底视图',
            'en': 'bottom view',
            'zh-hant': '底視角',
            'ja': '下部ビュー',
            'de': 'Unteransicht',
            'fr': 'Vue de dessous',
            'it': 'Vista dal basso',
            'ko': '저면도'
          },
          {
            'order': 1,
            'zh-cn': '高角度视图',
            'en': 'highangle view',
            'zh-hant': '高角度視角',
            'ja': '高角度ビュー',
            'de': 'Hochwinkelansicht',
            'fr': 'Vue en plongée',
            'it': 'Vista ad angolo alto',
            'ko': '하이앵글 뷰'
          },
          {
            'order': 1,
            'zh-cn': '鸟瞰图',
            'en': 'aerial view',
            'zh-hant': '航拍視角',
            'ja': '空中ビュー',
            'de': 'Luftaufnahme',
            'fr': 'Vue aérienne',
            'it': 'Vista aerea',
            'ko': '조감도'
          },
          {
            'order': 1,
            'zh-cn': '第三人称视角',
            'en': 'third-person perspective',
            'zh-hant': '第三人稱視角',
            'ja': '第三者視点',
            'de': 'Dritte-Person-Perspektive',
            'fr': 'Perspective à la troisième personne',
            'it': 'Prospettiva in terza persona',
            'ko': '3인칭 시점'
          },
          {
            'order': 1,
            'zh-cn': '产品视图',
            'en': 'product view',
            'zh-hant': '產品視角',
            'ja': 'プロダクトビュー',
            'de': 'Produktansicht',
            'fr': 'Vue produit',
            'it': 'Vista del prodotto',
            'ko': '제품 뷰'
          },
          {
            'order': 1,
            'zh-cn': '卫星视图',
            'en': 'satellite view',
            'zh-hant': '衛星視角',
            'ja': '衛星ビュー',
            'de': 'Satellitenansicht',
            'fr': 'Vue satellite',
            'it': 'Vista satellitare',
            'ko': '위성 뷰'
          },
          {
            'order': 1,
            'zh-cn': '两点透视',
            'en': 'two-point perspective',
            'zh-hant': '兩點透視',
            'ja': '二点透視',
            'de': 'Zweipunktperspektive',
            'fr': 'Perspective à deux points',
            'it': 'Prospettiva a due punti',
            'ko': '2점 투시'
          },
          {
            'order': 1,
            'zh-cn': '三点透视',
            'en': 'three-point perspective',
            'zh-hant': '三點透視',
            'ja': '三点透視',
            'de': 'Dreipunktperspektive',
            'fr': 'Perspective à trois points',
            'it': 'Prospettiva a tre punti',
            'ko': '3점 투시'
          },
          {
            'order': 1,
            'zh-cn': '立面透视',
            'en': 'elevation perspective',
            'zh-hant': '高度透視',
            'ja': '高さ透視',
            'de': 'Höhenperspektive',
            'fr': 'Perspective d\'élévation',
            'it': 'Prospettiva elevata',
            'ko': '입면 투시'
          },
          {
            'order': 1,
            'zh-cn': '居中构图',
            'en': 'center the composition',
            'zh-hant': '中心構圖',
            'ja': '中心構図',
            'de': 'Komposition zentrieren',
            'fr': 'Centrer la composition',
            'it': 'Centrare la composizione',
            'ko': '중앙 구도'
          },
          {
            'order': 1,
            'zh-cn': '对称构图',
            'en': 'symmetrical the composition',
            'zh-hant': '對稱構圖',
            'ja': '対称構図',
            'de': 'Symmetrische Komposition',
            'fr': 'Composition symétrique',
            'it': 'Composizione simmetrica',
            'ko': '대칭 구도'
          },
          {
            'order': 1,
            'zh-cn': '三分法构图',
            'en': 'rule of thirds composition',
            'zh-hant': '三分法構圖',
            'ja': '三分割法構図',
            'de': 'Drittelregel-Komposition',
            'fr': 'Composition règle des tiers',
            'it': 'Composizione della regola dei terzi',
            'ko': '삼분할 구도'
          },
          {
            'order': 1,
            'zh-cn': '牛仔镜头',
            'en': 'cowboy shot',
            'zh-hant': '牛仔鏡頭',
            'ja': 'カウボーイショット',
            'de': 'Cowboy-Schuss',
            'fr': 'Plan américain',
            'it': 'Ripresa cowboy',
            'ko': '카우보이 샷'
          },
          {
            'order': 1,
            'zh-cn': '膝盖以上',
            'en': 'mediumfullshot',
            'zh-hant': '中全身鏡頭',
            'ja': 'ミディアムフルショット',
            'de': 'Mittelganzer Schuss',
            'fr': 'Plan moyen en pied',
            'it': 'Ripresa media totale',
            'ko': '미디엄 풀샷'
          },
          {
            'order': 1,
            'zh-cn': '全身照',
            'en': 'full length shot',
            'zh-hant': '全身鏡頭',
            'ja': '全身ショット',
            'de': 'Ganzkörperaufnahme',
            'fr': 'Plan en pied',
            'it': 'Ripresa a figura intera',
            'ko': '전신 샷'
          },
          {
            'order': 1,
            'zh-cn': '面部拍摄',
            'en': 'face shot',
            'zh-hant': '面部特寫',
            'ja': '顔ショット',
            'de': 'Gesichtsschuss',
            'fr': 'Gros plan',
            'it': 'Ripresa del viso',
            'ko': '얼굴 샷'
          },
          {
            'order': 1,
            'zh-cn': '对称肖像',
            'en': 'symmetrical portrait',
            'zh-hant': '對稱肖像',
            'ja': '対称ポートレート',
            'de': 'Symmetrisches Porträt',
            'fr': 'Portrait symétrique',
            'it': 'Ritratto simmetrico',
            'ko': '대칭 초상화'
          },
          {
            'order': 1,
            'zh-cn': '清晰的面部特征',
            'en': 'clear facial features',
            'zh-hant': '清晰的面部特徵',
            'ja': 'はっきりした顔の特徴',
            'de': 'Klare Gesichtszüge',
            'fr': 'Traits faciaux clairs',
            'it': 'Caratteristiche facciali chiare',
            'ko': '선명한 얼굴 특징'
          },
          {
            'order': 1,
            'zh-cn': '肖像',
            'en': 'portrait',
            'zh-hant': '肖像',
            'ja': '肖像',
            'de': 'Porträt',
            'fr': 'Portrait',
            'it': 'Ritratto',
            'ko': '초상화'
          },
          {
            'order': 1,
            'zh-cn': '半身像',
            'en': 'busts',
            'zh-hant': '半身像',
            'ja': 'バストショット',
            'de': 'Büsten',
            'fr': 'Bustes',
            'it': 'Busti',
            'ko': '반신상'
          },
          {
            'order': 1,
            'zh-cn': '侧面',
            'en': 'profile',
            'zh-hant': '側面像',
            'ja': 'プロフィール（横顔）',
            'de': 'Profil',
            'fr': 'Profil',
            'it': 'Profilo',
            'ko': '측면'
          },
          {
            'order': 1,
            'zh-cn': '对称的身体',
            'en': 'symmetrical body',
            'zh-hant': '對稱的身體',
            'ja': '対称の体',
            'de': 'Symmetrischer Körper',
            'fr': 'Corps symétrique',
            'it': 'Corpo simmetrico',
            'ko': '대칭적인 몸'
          },
          {
            'order': 1,
            'zh-cn': '对称的脸',
            'en': 'symmetrical face',
            'zh-hant': '對稱的面部',
            'ja': '対称の顔',
            'de': 'Symmetrisches Gesicht',
            'fr': 'Visage symétrique',
            'it': 'Viso simmetrico',
            'ko': '대칭적인 얼굴'
          },
          {
            'order': 1,
            'zh-cn': '低视角',
            'en': 'low angle view',
            'zh-hant': '低角度視角',
            'ja': '低角度ビュー',
            'de': 'Untersicht',
            'fr': 'Vue en contre-plongée',
            'it': 'Vista ad angolo basso',
            'ko': '로우 앵글'
          },
          {
            'order': 1,
            'zh-cn': '高视角',
            'en': 'high angle view',
            'zh-hant': '高角度視角',
            'ja': '高角度ビュー',
            'de': 'Aufsicht',
            'fr': 'Vue en plongée',
            'it': 'Vista ad angolo alto',
            'ko': '하이 앵글'
          },
          {
            'order': 1,
            'zh-cn': '自拍',
            'en': 'selfie',
            'zh-hant': '自拍',
            'ja': '自撮り',
            'de': 'Selfie',
            'fr': 'Selfie',
            'it': 'Selfie',
            'ko': '셀카'
          },
          {
            'order': 1,
            'zh-cn': 'gopro自拍',
            'en': 'gopro selfie',
            'zh-hant': 'GoPro 自拍',
            'ja': 'GoPro自撮り',
            'de': 'GoPro-Selfie',
            'fr': 'Selfie GoPro',
            'it': 'Selfie con GoPro',
            'ko': '고프로 셀카'
          },
          {
            'order': 1,
            'zh-cn': '人物摄影',
            'en': 'people photography',
            'zh-hant': '人像攝影',
            'ja': '人物写真',
            'de': 'Personenfotografie',
            'fr': 'Photographie de personnes',
            'it': 'Fotografia di persone',
            'ko': '인물 사진'
          },
          {
            'order': 1,
            'zh-cn': '航拍',
            'en': 'aerial photography',
            'zh-hant': '航拍攝影',
            'ja': '空撮',
            'de': 'Luftaufnahme',
            'fr': 'Photographie aérienne',
            'it': 'Fotografia aerea',
            'ko': '항공 촬영'
          },
          {
            'order': 1,
            'zh-cn': '超特写',
            'en': 'extreme close up',
            'zh-hant': '極近特寫',
            'ja': '超クローズアップ',
            'de': 'Extreme Nahaufnahme',
            'fr': 'Gros plan extrême',
            'it': 'Estremo primo piano',
            'ko': '익스트림 클로즈업'
          },
          {
            'order': 1,
            'zh-cn': '特写',
            'en': 'close-up',
            'zh-hant': '特寫',
            'ja': 'クローズアップ',
            'de': 'Nahaufnahme',
            'fr': 'Gros plan',
            'it': 'Primo piano',
            'ko': '클로즈업'
          },
          {
            'order': 1,
            'zh-cn': '中特写',
            'en': 'medium close-up',
            'zh-hant': '中近景',
            'ja': '中クローズアップ',
            'de': 'Mittelnahe Aufnahme',
            'fr': 'Plan moyen rapproché',
            'it': 'Mezzo primo piano',
            'ko': '미디엄 클로즈업'
          },
          {
            'order': 1,
            'zh-cn': '中景',
            'en': 'medium shot',
            'zh-hant': '中景',
            'ja': '中距離ショット',
            'de': 'Mittelaufnahme',
            'fr': 'Plan moyen',
            'it': 'Mezza figura',
            'ko': '미디엄 샷'
          },
          {
            'order': 1,
            'zh-cn': '中远暴',
            'en': 'medium long shot',
            'zh-hant': '中全景',
            'ja': '中全景ショット',
            'de': 'Halbtotale',
            'fr': 'Plan américain',
            'it': 'Piano americano',
            'ko': '미디엄 롱 샷'
          },
          {
            'order': 1,
            'zh-cn': '远景',
            'en': 'long shot',
            'zh-hant': '全景',
            'ja': 'ロングショット',
            'de': 'Totale',
            'fr': 'Plan large',
            'it': 'Campo lungo',
            'ko': '롱 샷'
          },
          {
            'order': 1,
            'zh-cn': '群景',
            'en': 'groupshot',
            'zh-hant': '群體照',
            'ja': 'グループショット',
            'de': 'Gruppenfoto',
            'fr': 'Photo de groupe',
            'it': 'Foto di gruppo',
            'ko': '단체 사진'
          },
          {
            'order': 1,
            'zh-cn': '风景照',
            'en': 'scenery shot',
            'zh-hant': '風景照',
            'ja': '風景ショット',
            'de': 'Landschaftsaufnahme',
            'fr': 'Photo de paysage',
            'it': 'Scatto paesaggistico',
            'ko': '풍경 사진'
          },
          {
            'order': 1,
            'zh-cn': '双重曝光',
            'en': 'double exposure',
            'zh-hant': '雙重曝光',
            'ja': '二重露光',
            'de': 'Doppelbelichtung',
            'fr': 'Double exposition',
            'it': 'Doppia esposizione',
            'ko': '이중 노출'
          },
          {
            'order': 1,
            'zh-cn': 's 型构图',
            'en': 's-shaped composition',
            'zh-hant': 'S形構圖',
            'ja': 'S字構図',
            'de': 'S-förmige Komposition',
            'fr': 'Composition en forme de S',
            'it': 'Composizione a forma di S',
            'ko': 'S자 구도'
          },
          {
            'order': 1,
            'zh-cn': '水平构图',
            'en': 'horizontal composition',
            'zh-hant': '水平構圖',
            'ja': '水平構図',
            'de': 'Horizontale Komposition',
            'fr': 'Composition horizontale',
            'it': 'Composizione orizzontale',
            'ko': '수평 구도'
          },
          {
            'order': 1,
            'zh-cn': '对角线构图',
            'en': 'diagonal composition',
            'zh-hant': '對角線構圖',
            'ja': '斜め構図',
            'de': 'Diagonale Komposition',
            'fr': 'Composition diagonale',
            'it': 'Composizione diagonale',
            'ko': '대각선 구도'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '画面细节精度', en: 'Image Detail Precision', 'zh-hant': '畫面細節精度', ja: '画像の詳細精度', de: 'Bilddetailschärfe', fr: 'Précision des détails de l\'image', it: 'Precisione dei dettagli dell\'immagine', 'ko': '이미지 세부 정밀도' },
        'list': [
          {
            'order': 1,
            'zh-cn': '1080p',
            'en': '1080p',
            'zh-hant': '1080p',
            'ja': '1080p',
            'de': '1080p',
            'fr': '1080p',
            'it': '1080p',
            'ko': '1080p'
          },
          {
            'order': 1,
            'zh-cn': '2k',
            'en': '2k',
            'zh-hant': '2k',
            'ja': '2k',
            'de': '2k',
            'fr': '2k',
            'it': '2k',
            'ko': '2k'
          },
          {
            'order': 1,
            'zh-cn': '4k',
            'en': '4k',
            'zh-hant': '4k',
            'ja': '4k',
            'de': '4k',
            'fr': '4k',
            'it': '4k',
            'ko': '4k'
          },
          {
            'order': 1,
            'zh-cn': '8k',
            'en': '8k',
            'zh-hant': '8k',
            'ja': '8k',
            'de': '8k',
            'fr': '8k',
            'it': '8k',
            'ko': '8k'
          },
          {
            'order': 1,
            'zh-cn': '高细节',
            'en': 'high detail',
            'zh-hant': '高細節',
            'ja': '高詳細',
            'de': 'Hohe Detailgenauigkeit',
            'fr': 'Haute détail',
            'it': 'Dettagli elevati',
            'ko': '고해상도 디테일'
          },
          {
            'order': 1,
            'zh-cn': '高品质',
            'en': 'hyper quality',
            'zh-hant': '超高質量',
            'ja': 'ハイパークオリティ',
            'de': 'Hyper Qualität',
            'fr': 'Hyper qualité',
            'it': 'Qualità iper',
            'ko': '초고품질'
          },
          {
            'order': 1,
            'zh-cn': '高分辨率',
            'en': 'high resolution',
            'zh-hant': '高解析度',
            'ja': '高解像度',
            'de': 'Hohe Auflösung',
            'fr': 'Haute résolution',
            'it': 'Alta risoluzione',
            'ko': '고해상도'
          },
          {
            'order': 1,
            'zh-cn': '全高清',
            'en': 'fhd',
            'zh-hant': 'FHD（全高清）',
            'ja': 'FHD（フルHD）',
            'de': 'FHD (Full HD)',
            'fr': 'FHD (Full HD)',
            'it': 'FHD (Full HD)',
            'ko': 'FHD (풀 HD)'
          },
          {
            'order': 1,
            'zh-cn': '多细节',
            'en': 'ultra detailed',
            'zh-hant': '超細緻',
            'ja': '超詳細',
            'de': 'Ultra detailliert',
            'fr': 'Ultra détaillé',
            'it': 'Ultra dettagliato',
            'ko': '초정밀 디테일'
          },
          {
            'order': 1,
            'zh-cn': '复杂的',
            'en': 'sophisticated',
            'zh-hant': '精緻',
            'ja': '洗練された',
            'de': 'Anspruchsvoll',
            'fr': 'Sophistiqué',
            'it': 'Sofisticato',
            'ko': '정교한'
          },
          {
            'order': 1,
            'zh-cn': '逼真细节',
            'en': 'realistic details',
            'zh-hant': '寫實細節',
            'ja': 'リアリスティックな詳細',
            'de': 'Realistische Details',
            'fr': 'Détails réalistes',
            'it': 'Dettagli realistici',
            'ko': '사실적인 디테일'
          },
          {
            'order': 1,
            'zh-cn': '精致还原',
            'en': 'exquisite restoration',
            'zh-hant': '精美還原',
            'ja': '精巧な復元',
            'de': 'Exquisite Restaurierung',
            'fr': 'Restauration exquise',
            'it': 'Restauro squisito',
            'ko': '정교한 복원'
          },
          {
            'order': 1,
            'zh-cn': '纹理细节',
            'en': 'texture details',
            'zh-hant': '細節質感',
            'ja': 'テクスチャの詳細',
            'de': 'Texturdetails',
            'fr': 'Détails de texture',
            'it': 'Dettagli di texture',
            'ko': '텍스처 디테일'
          },
          {
            'order': 1,
            'zh-cn': '细节丰富',
            'en': 'rich details',
            'zh-hant': '豐富細節',
            'ja': '豊富な詳細',
            'de': 'Reiche Details',
            'fr': 'Détails riches',
            'it': 'Dettagli ricchi',
            'ko': '풍부한 디테일'
          },
          {
            'order': 1,
            'zh-cn': '精细模型',
            'en': 'fine model',
            'zh-hant': '精細模型',
            'ja': '細かいモデル',
            'de': 'Feines Modell',
            'fr': 'Modèle fin',
            'it': 'Modello fine',
            'ko': '정교한 모델'
          },
          {
            'order': 1,
            'zh-cn': '完美细节',
            'en': 'perfect details',
            'zh-hant': '完美細節',
            'ja': '完璧な詳細',
            'de': 'Perfekte Details',
            'fr': 'Détails parfaits',
            'it': 'Dettagli perfetti',
            'ko': '완벽한 디테일'
          },
          {
            'order': 1,
            'zh-cn': '复杂场景',
            'en': 'complex scenes',
            'zh-hant': '複雜場景',
            'ja': '複雑なシーン',
            'de': 'Komplexe Szenen',
            'fr': 'Scènes complexes',
            'it': 'Scene complesse',
            'ko': '복잡한 장면'
          },
          {
            'order': 1,
            'zh-cn': '细节刻画',
            'en': 'detailed depiction',
            'zh-hant': '細緻描繪',
            'ja': '詳細な描写',
            'de': 'Detaillierte Darstellung',
            'fr': 'Dépiction détaillée',
            'it': 'Descrizione dettagliata',
            'ko': '상세한 묘사'
          },
          {
            'order': 1,
            'zh-cn': '真实还原',
            'en': 'realistic restoration',
            'zh-hant': '寫實還原',
            'ja': 'リアリスティックな復元',
            'de': 'Realistische Restaurierung',
            'fr': 'Restauration réaliste',
            'it': 'Restauro realistico',
            'ko': '사실적인 복원'
          },
          {
            'order': 1,
            'zh-cn': '细节描述',
            'en': 'elaborate depiction',
            'zh-hant': '精緻描述',
            'ja': '精巧な描写',
            'de': 'Ausführliche Darstellung',
            'fr': 'Dépiction élaborée',
            'it': 'Descrizione elaborata',
            'ko': '정교한 묘사'
          },
          {
            'order': 1,
            'zh-cn': '清晰呈现',
            'en': 'clear presentation',
            'zh-hant': '清晰呈現',
            'ja': '明確な提示',
            'de': 'Klare Darstellung',
            'fr': 'Présentation claire',
            'it': 'Presentazione chiara',
            'ko': '선명한 표현'
          },
          {
            'order': 1,
            'zh-cn': '细节纤毫',
            'en': 'minute details',
            'zh-hant': '微小細節',
            'ja': '微細な詳細',
            'de': 'Feine Details',
            'fr': 'Détails minutieux',
            'it': 'Dettagli minuti',
            'ko': '미세한 디테일'
          },
          {
            'order': 1,
            'zh-cn': '精细还原',
            'en': 'precise restoration',
            'zh-hant': '精確還原',
            'ja': '精密な復元',
            'de': 'Präzise Restaurierung',
            'fr': 'Restauration précise',
            'it': 'Restauro preciso',
            'ko': '정밀한 복원'
          },
          {
            'order': 1,
            'zh-cn': '高清还原',
            'en': 'hd details',
            'zh-hant': '高清細節',
            'ja': 'HD詳細',
            'de': 'HD-Details',
            'fr': 'Détails HD',
            'it': 'Dettagli HD',
            'ko': 'HD 디테일'
          },
          {
            'order': 1,
            'zh-cn': '细节呈现',
            'en': 'detailed presentation',
            'zh-hant': '細節展示',
            'ja': '詳細なプレゼンテーション',
            'de': 'Detaillierte Präsentation',
            'fr': 'Présentation détaillée',
            'it': 'Presentazione dettagliata',
            'ko': '상세한 표현'
          },
          {
            'order': 1,
            'zh-cn': '细节严谨',
            'en': 'meticulous details',
            'zh-hant': '一絲不苟的細節',
            'ja': '細かい詳細',
            'de': 'Sorgfältige Details',
            'fr': 'Détails méticuleux',
            'it': 'Dettagli meticolosi',
            'ko': '꼼꼼한 디테일'
          },
          {
            'order': 1,
            'zh-cn': '逼真还原',
            'en': 'realistic restoration',
            'zh-hant': '寫實還原',
            'ja': 'リアリスティックな復元',
            'de': 'Realistische Restaurierung',
            'fr': 'Restauration réaliste',
            'it': 'Restauro realistico',
            'ko': '사실적인 복원'
          },
          {
            'order': 1,
            'zh-cn': '细节表现',
            'en': 'detail expression',
            'zh-hant': '細節表現',
            'ja': '詳細表現',
            'de': 'Detailexpression',
            'fr': 'Expression des détails',
            'it': 'Espressione dei dettagli',
            'ko': '디테일 표현'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '镜头', en: 'Camera', 'zh-hant': '鏡頭', ja: 'レンズ', de: 'Kamera', fr: 'Caméra', it: 'Fotocamera', ko: '카메라' },
        'list': [
          {
            'order': 1,
            'zh-cn': '电影镜头',
            'en': 'cinematic shot',
            'zh-hant': '電影鏡頭',
            'ja': 'シネマティックショット',
            'de': 'Filmaufnahme',
            'fr': 'Prise de vue cinématographique',
            'it': 'Ripresa cinematografica',
            'ko': '시네마틱 샷'
          },
          {
            'order': 1,
            'zh-cn': '对焦',
            'en': 'in focus',
            'zh-hant': '聚焦',
            'ja': 'フォーカス',
            'de': 'Im Fokus',
            'fr': 'Mise au point',
            'it': 'A fuoco',
            'ko': '초점'
          },
          {
            'order': 1,
            'zh-cn': '景深',
            'en': 'depth of field',
            'zh-hant': '景深',
            'ja': '被写界深度',
            'de': 'Schärfentiefe',
            'fr': 'Profondeur de champ',
            'it': 'Profondità di campo',
            'ko': '피사계 심도'
          },
          {
            'order': 1,
            'zh-cn': '鱼眼镜头',
            'en': 'fish-eye lens',
            'zh-hant': '魚眼鏡頭',
            'ja': 'フィッシュアイレンズ',
            'de': 'Fischaugenobjektiv',
            'fr': 'Objectif fisheye',
            'it': 'Obiettivo fish-eye',
            'ko': '어안 렌즈'
          },
          {
            'order': 1,
            'zh-cn': '广角镜头',
            'en': 'wide-angle view',
            'zh-hant': '廣角視角',
            'ja': '広角ビュー',
            'de': 'Weitwinkelansicht',
            'fr': 'Vue grand angle',
            'it': 'Vista grandangolare',
            'ko': '광각 뷰'
          },
          {
            'order': 1,
            'zh-cn': '全拍',
            'en': 'full shot',
            'zh-hant': '全景',
            'ja': 'フルショット',
            'de': 'Vollbildaufnahme',
            'fr': 'Prise de vue complète',
            'it': 'Ripresa completa',
            'ko': '풀샷'
          },
          {
            'order': 1,
            'zh-cn': '过肩画面',
            'en': 'over-shoulder shot',
            'zh-hant': '越肩鏡頭',
            'ja': '肩越しショット',
            'de': 'Über-die-Schulter-Aufnahme',
            'fr': 'Prise de vue par-dessus l\'épaule',
            'it': 'Ripresa sopra la spalla',
            'ko': '오버 숄더 샷'
          },
          {
            'order': 1,
            'zh-cn': '宽松画面',
            'en': 'loose shot',
            'zh-hant': '鬆散鏡頭',
            'ja': 'ルーズショット',
            'de': 'Lockere Aufnahme',
            'fr': 'Prise de vue lâche',
            'it': 'Ripresa larga',
            'ko': '루즈 샷'
          },
          {
            'order': 1,
            'zh-cn': '紧缩画面',
            'en': 'tight shot',
            'zh-hant': '緊湊鏡頭',
            'ja': 'タイトショット',
            'de': 'Enge Aufnahme',
            'fr': 'Prise de vue serrée',
            'it': 'Ripresa stretta',
            'ko': '타이트 샷'
          },
          {
            'order': 1,
            'zh-cn': '群体画面',
            'en': 'group shot',
            'zh-hant': '群體鏡頭',
            'ja': 'グループショット',
            'de': 'Gruppenaufnahme',
            'fr': 'Prise de vue de groupe',
            'it': 'Foto di gruppo',
            'ko': '그룹 샷'
          },
          {
            'order': 1,
            'zh-cn': '超广角镜头',
            'en': 'ultra wide shot',
            'zh-hant': '超廣角鏡頭',
            'ja': '超広角ショット',
            'de': 'Ultra-Weitwinkel-Aufnahme',
            'fr': 'Prise de vue ultra-large',
            'it': 'Ripresa ultra-grandangolare',
            'ko': '울트라 와이드 샷'
          },
          {
            'order': 1,
            'zh-cn': '头部摄影',
            'en': 'headshot',
            'zh-hant': '頭像',
            'ja': 'ヘッドショット',
            'de': 'Kopfaufnahme',
            'fr': 'Tête de prise de vue',
            'it': 'Ritratto',
            'ko': '헤드샷'
          },
          {
            'order': 1,
            'zh-cn': '2人画面',
            'en': 'two shot',
            'zh-hant': '雙人鏡頭',
            'ja': 'ツーショット',
            'de': 'Zwei-Personen-Aufnahme',
            'fr': 'Double prise de vue',
            'it': 'Doppia ripresa',
            'ko': '투샷'
          },
          {
            'order': 1,
            'zh-cn': '3人画面',
            'en': 'three shot',
            'zh-hant': '三人鏡頭',
            'ja': 'スリーショット',
            'de': 'Drei-Personen-Aufnahme',
            'fr': 'Triple prise de vue',
            'it': 'Tripla ripresa',
            'ko': '쓰리샷'
          },
          {
            'order': 1,
            'zh-cn': '背景虚化',
            'en': 'bokeh',
            'zh-hant': '焦外成像（散景）',
            'ja': 'ボケ',
            'de': 'Bokeh',
            'fr': 'Bokeh',
            'it': 'Bokeh',
            'ko': '보케'
          },
          {
            'order': 1,
            'zh-cn': '前景',
            'en': 'foreground',
            'zh-hant': '前景',
            'ja': '前景',
            'de': 'Vordergrund',
            'fr': 'Premier plan',
            'it': 'Primo piano',
            'ko': '전경'
          },
          {
            'order': 1,
            'zh-cn': '背景',
            'en': 'background',
            'zh-hant': '背景',
            'ja': '背景',
            'de': 'Hintergrund',
            'fr': 'Arrière-plan',
            'it': 'Sfondo',
            'ko': '배경'
          },
          {
            'order': 1,
            'zh-cn': '细节镜头',
            'en': 'detailshot',
            'zh-hant': '細節鏡頭',
            'ja': 'ディテールショット',
            'de': 'Detailaufnahme',
            'fr': 'Prise de vue détaillée',
            'it': 'Ripresa di dettaglio',
            'ko': '디테일 샷'
          },
          {
            'order': 1,
            'zh-cn': '面部拍摄',
            'en': 'faceshot',
            'zh-hant': '面部特寫',
            'ja': 'フェイスショット',
            'de': 'Gesichtsaufnahme',
            'fr': 'Prise de vue du visage',
            'it': 'Scatto del viso',
            'ko': '페이스 샷'
          },
          {
            'order': 1,
            'zh-cn': '移轴摄影',
            'en': 'tilt-shift',
            'zh-hant': '傾斜移軸鏡頭',
            'ja': 'ティルトシフト',
            'de': 'Tilt-Shift',
            'fr': 'Tilt-shift',
            'it': 'Tilt-shift',
            'ko': '틸트 시프트'
          },
          {
            'order': 1,
            'zh-cn': '轴侧图/2.5d透视',
            'en': 'isometric 3d',
            'zh-hant': '等距3D',
            'ja': 'アイソメトリック3D',
            'de': 'Isometrische 3D-Ansicht',
            'fr': 'Vue isométrique 3D',
            'it': 'Vista isometrica 3D',
            'ko': '아이소메트릭 3D'
          },
          {
            'order': 1,
            'zh-cn': '微观',
            'en': 'microscopic view',
            'zh-hant': '微觀視角',
            'ja': '顕微鏡ビュー',
            'de': 'Mikroskopische Ansicht',
            'fr': 'Vue microscopique',
            'it': 'Vista microscopica',
            'ko': '현미경 뷰'
          },
          {
            'order': 1,
            'zh-cn': '极端特写视图',
            'en': 'extreme closeup view',
            'zh-hant': '極近特寫',
            'ja': '極端なクローズアップビュー',
            'de': 'Extrem Nahaufnahme',
            'fr': 'Vue en gros plan extrême',
            'it': 'Vista in primissimo piano',
            'ko': '익스트림 클로즈업 뷰'
          },
          {
            'order': 1,
            'zh-cn': '仰视',
            'en': 'lookup',
            'zh-hant': '仰視',
            'ja': '見上げる',
            'de': 'Aufblick',
            'fr': 'Regard vers le haut',
            'it': 'Vista in su',
            'ko': '올려다보기'
          },
          {
            'order': 1,
            'zh-cn': '第一人称视角',
            'en': 'first-person view',
            'zh-hant': '第一人稱視角',
            'ja': '一人称視点',
            'de': 'Erste-Person-Ansicht',
            'fr': 'Vue à la première personne',
            'it': 'Vista in prima persona',
            'ko': '1인칭 시점'
          },
          {
            'order': 1,
            'zh-cn': '等距视图',
            'en': 'isometric view',
            'zh-hant': '等距視角',
            'ja': 'アイソメトリックビュー',
            'de': 'Isometrische Ansicht',
            'fr': 'Vue isométrique',
            'it': 'Vista isometrica',
            'ko': '아이소메트릭 뷰'
          }
        ]
      },
      {
        'order': 1,
        'name': { 'zh-cn': '渲染器', en: 'Renderer', 'zh-hant': '渲染器', ja: 'レンダラー', de: 'Renderer', fr: 'Rendu', it: 'Renderer', ko: '렌더러' },
        'list': [
          {
            'order': 1,
            'zh-cn': '虚幻引擎',
            'en': 'unreal engine',
            'zh-hant': '虛幻引擎',
            'ja': 'Unreal Engine（アンリアルエンジン）',
            'de': 'Unreal Engine',
            'fr': 'Unreal Engine',
            'it': 'Unreal Engine',
            'ko': '언리얼 엔진'
          },
          {
            'order': 1,
            'zh-cn': 'oc渲染',
            'en': 'octane render',
            'zh-hant': 'Octane 渲染',
            'ja': 'Octane Render（オクタンレンダー）',
            'de': 'Octane Render',
            'fr': 'Octane Render',
            'it': 'Octane Render',
            'ko': '옥테인 렌더'
          },
          {
            'order': 1,
            'zh-cn': '渲染',
            'en': 'maxon cinema 4d',
            'zh-hant': 'Maxon Cinema 4D',
            'ja': 'Maxon Cinema 4D（マクソン シネマ 4D）',
            'de': 'Maxon Cinema 4D',
            'fr': 'Maxon Cinema 4D',
            'it': 'Maxon Cinema 4D',
            'ko': '맥슨 시네마 4D'
          },
          {
            'order': 1,
            'zh-cn': '建筑渲染',
            'en': 'architectural visualisation',
            'zh-hant': '建築可視化',
            'ja': '建築ビジュアライゼーション',
            'de': 'Architektonische Visualisierung',
            'fr': 'Visualisation architecturale',
            'it': 'Visualizzazione architettonica',
            'ko': '건축 시각화'
          },
          {
            'order': 1,
            'zh-cn': '室内渲染',
            'en': 'corona render',
            'zh-hant': 'Corona 渲染',
            'ja': 'Corona Render（コロナレンダー）',
            'de': 'Corona Render',
            'fr': 'Corona Render',
            'it': 'Corona Render',
            'ko': '코로나 렌더'
          },
          {
            'order': 1,
            'zh-cn': '真实感',
            'en': 'quixel megascans render',
            'zh-hant': 'Quixel Megascans 渲染',
            'ja': 'Quixel Megascans Render（クイクセル メガスキャン レンダー）',
            'de': 'Quixel Megascans Render',
            'fr': 'Quixel Megascans Render',
            'it': 'Quixel Megascans Render',
            'ko': '퀵셀 메가스캔 렌더'
          },
          {
            'order': 1,
            'zh-cn': 'v射线',
            'en': 'v-ray',
            'zh-hant': 'V-Ray',
            'ja': 'V-Ray（ヴィーレイ）',
            'de': 'V-Ray',
            'fr': 'V-Ray',
            'it': 'V-Ray',
            'ko': 'V-레이'
          }
        ]
      }
    ]
  }
]

/**
 * 自定义模特设置
 */
export const DIYModelSettingBuilder = () => {
  // @ts-ignore
  const t = i18n.global.t
  return {
    /**
     * 身形
     */
    BodyShape: {
      Man: {
        /**
         * 苗条体型
         */
        SlenderBody: {
          label: t(I18nKeys.diyModel.slenderBody),
          value:
            'slender-body'
        }
        ,
        /**
         * 匀称身材
         */
        HourglassBody: {
          label: t(I18nKeys.diyModel.hourglassBody),
          value:
            'hourglass-body'
        }
        ,
        /**
         * 肌肉发达体型
         */
        MuscularBody: {
          label: t(I18nKeys.diyModel.muscularBody),
          value:
            'muscular-body'
        }
        ,
        /**
         * 婴儿肥体型
         */
        BabyFatBody: {
          label: t(I18nKeys.diyModel.babyFatBody),
          value:
            'baby-fat-body'
        }
        ,
        /**
         * 矮胖身材
         */
        ShortAndFatBody: {
          label: t(I18nKeys.diyModel.shortAndFatBody),
          value:
            'short-and-fat-body'
        }
      }
      ,
      Woman: {
        /**
         * 苗条体型
         */
        SlenderBody: {
          label: t(I18nKeys.diyModel.slenderBody),
          value:
            'slender-body'
        }
        ,
        /**
         * 匀称身材
         */
        HourglassBody: {
          label: t(I18nKeys.diyModel.hourglassBody),
          value:
            'hourglass-body'
        }
        ,
        /**
         * 肌肉发达体型
         */
        MuscularBody: {
          label: t(I18nKeys.diyModel.muscularBody),
          value:
            'muscular-body'
        }
        ,
        /**
         * 曲线窈窕体型
         */
        CurvaceousBody: {
          label: t(I18nKeys.diyModel.curvaceousBody),
          value:
            'curvaceous-body'
        }
        ,
        /**
         * 婴儿肥体型
         */
        BabyFatBody: {
          label: t(I18nKeys.diyModel.babyFatBody),
          value:
            'baby-fat-body'
        }
        ,
        /**
         * 矮胖身材
         */
        ShortAndFatBody: {
          label: t(I18nKeys.diyModel.shortAndFatBody),
          value:
            'short-and-fat-body'
        }
      }
    }
    ,
    /**
     * 发型
     */
    Hairstyles: {
      Style: {
        /**
         * 直发
         */
        Straight: {
          label: t(I18nKeys.diyModel.straight),
          value:
            'straight'
        }
        ,
        /**
         * 波浪发
         */
        Wavy: {
          label: t(I18nKeys.diyModel.wavy),
          value:
            'wavy'
        }
        ,
        /**
         * 卷曲发
         */
        Curly: {
          label: t(I18nKeys.diyModel.curly),
          value:
            'curly'
        }
        ,
        /**
         * 编织发
         */
        Braided: {
          label: t(I18nKeys.diyModel.braided),
          value:
            'braided'
        }
        ,
        /**
         * 自然卷
         */
        NaturallyCurly: {
          label: t(I18nKeys.diyModel.naturallyCurly),
          value:
            'naturally-curly'
        }
        ,
        /**
         * 盘发
         */
        Updo: {
          label: t(I18nKeys.diyModel.updo),
          value:
            'updo'
        }
        ,
        /**
         * 空气刘海
         */
        AirBangs: {
          label: t(I18nKeys.diyModel.airBangs),
          value:
            'air-bangs'
        }
        ,
        /**
         * 脏辫
         */
        Dreadlocks: {
          label: t(I18nKeys.diyModel.dreadlocks),
          value:
            'dreadlocks'
        }
        ,
        /**
         * 马尾辫
         */
        Ponytail: {
          label: t(I18nKeys.diyModel.ponytail),
          value:
            'ponytail'
        }
        ,
        /**
         * 光头
         */
        Bald: {
          label: t(I18nKeys.diyModel.bald),
          value:
            'bald'
        }
        ,
        /**
         * 中分发型
         */
        CenterPartedHair: {
          label: t(I18nKeys.diyModel.centerPartedHair),
          value:
            'center-parted'
        }
        ,
        /**
         * 齐刘海
         */
        Bangs: {
          label: t(I18nKeys.diyModel.bangs),
          value:
            'Bangs'
        }
        ,
        /**
         * 前发束
         */
        FrontBangs: {
          label: t(I18nKeys.diyModel.frontBangs),
          value:
            'front-bangs'
        }
      }
      ,
      /**
       * 长度
       */
      Length: {
        /**
         * 短发
         */
        Short: {
          label: t(I18nKeys.diyModel.short),
          value:
            'short'
        }
        ,
        /**
         * 短发
         */
        Long: {
          label: t(I18nKeys.diyModel.long),
          value:
            'long'
        }
        ,
        /**
         * 披肩发
         */
        ShoulderLength: {
          label: t(I18nKeys.diyModel.shoulderLength),
          value:
            'shoulder-length'
        }
        ,
        /**
         * 超长发
         */
        ExtraLongHair: {
          label: t(I18nKeys.diyModel.extraLongHair),
          value:
            'extra-long'
        }
        ,
        /**
         * 耳际短发
         */
        PixieCut: {
          label: t(I18nKeys.diyModel.pixieCut),
          value:
            'pixie-cut'
        }
        ,
        /**
         * 及肩发
         */
        CollarboneLengthHair: {
          label: t(I18nKeys.diyModel.collarboneLengthHair),
          value:
            'collarbone-length'
        }
        ,
        /**
         * 齐肩发
         */
        ShoulderLengthHair: {
          label: t(I18nKeys.diyModel.shoulderLengthHair),
          value:
            'shoulder-length'
        }
        ,
        /**
         * 及腰发
         */
        WaistLengthHair: {
          label: t(I18nKeys.diyModel.waistLengthHair),
          value:
            'waist-length'
        }
      }
    }
    ,
    /**
     * 肤色
     */
    SkinColors: {
      /**
       * 白皙肤色
       */
      FairSkinWhite: {
        label: t(I18nKeys.diyModel.fairSkinWhite),
        value:
          'fair-skin/white'
      }
      ,
      /**
       * 黝黑肤色
       */
      DarkSkin: {
        label: t(I18nKeys.diyModel.darkSkin),
        value:
          'dark-skin'
      }
      ,
      /**
       * 黄皮肤
       */
      YellowSkin: {
        label: t(I18nKeys.diyModel.yellowSkin),
        value:
          'yellow-skin'
      }
    }
    ,
    /**
     * 人种
     */
    Ethnicities: {
      /**
       * 亚洲人
       */
      Asian: {
        label: t(I18nKeys.diyModel.asian),
        value:
          'Asian'
      }
      ,
      /**
       * 欧洲人
       */
      European: {
        label: t(I18nKeys.diyModel.european),
        value:
          'European'
      }
      ,
      /**
       * 非洲人
       */
      African: {
        label: t(I18nKeys.diyModel.african),
        value:
          'African'
      }
      ,
      /**
       * 美洲人
       */
      American: {
        label: t(I18nKeys.diyModel.american),
        value:
          'American'
      }
      ,
      /**
       * 中东人
       */
      MiddleEastern: {
        label: t(I18nKeys.diyModel.middleEastern),
        value:
          'Middle-eastern'
      }
    }
    ,
    /**
     * 年龄
     */
    Age: {
      /**
       * 儿童
       */
      Kid: {
        label: t(I18nKeys.diyModel.kid),
        value:
          'kid'
      }
      ,
      /**
       * 少年
       */
      Juvenile: {
        label: t(I18nKeys.diyModel.juvenile),
        value:
          'juvenile'
      }
      ,
      /**
       * 成人
       */
      Adult: {
        label: t(I18nKeys.diyModel.adult),
        value:
          'adult'
      }
      ,
      /**
       * 青年
       */
      Teenager: {
        label: t(I18nKeys.diyModel.youth),
        value:
          'teenager'
      }
      ,
      /**
       * 中年
       */
      MiddleAged: {
        label: t(I18nKeys.diyModel.middleAged),
        value:
          'middle-aged'
      }
      ,
      /**
       * 老年
       */
      Old: {
        label: t(I18nKeys.diyModel.elderly),
        value:
          'old'
      }
    }
  }
}

export enum Sex {
  MALE = 'male',
  FEMALE = 'female'
}

export enum Age {
  KID = 1,
  JUVENILE = 2,
  ADULT = 3,
  TEENAGER = 4,
  MIDDLE_AGED = 5,
  OLD = 6
}

export const MASK_BACKGROUND =
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAEgASADAREAAhEBAxEB/8QAGwABAQEBAQEBAQAAAAAAAAAABQYBAAIDBAn/xABAEAABAQMKBQEFBAoDAQEAAAAAAQIREgMGFjFEZIKjweEEEyE2kQUUIkFRoTJCYXIVIyQ0UmNxgaKxM1RiQ3P/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A/o6A3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYAlG75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsA2AJOOz49ABALYAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgHANzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2AJRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbANgDzgWThkkbRXqjcKp8KgBGJONGlRpEVlHq/oBZgCziR68Ojn/b0AIl1kFVOSwrLk6vX4gWIA04GYuQyiKrSq276AC8mVeqctXso9fwQCzAEnE5/Dv/8AegA7CSTmlbaVFd7rk+IFmAb6tJSEry+ernI07r/QCfaZZiVhhHqquQCyAFnCy00vDwo90a/6AHSSVZJqViZRyuc/qBZACziT936/x6ACNMqyvVHAWoAs4nfs69OkfT51ADMsq2rUEmrSOf8A0AswBJx2fHoAQywwsm02soiNM1M/MCyAEnHZ8egBCSStSTUqjSOZVzviBZACTjs+PQAZplWVcqKgFoAJOOz49ABVZVlz/ijwPT22UVmJURU8oAzN17pdfyJ/sBoCJAbm5aMGoDYEV1cA96A1JtScoywy5pmGJfnWAuBHSMSNRMtwfCIBj0BlGG+JZRtGkSDqnxrAZAi/k9EX8PmA3N9UVriWkZhRVZcnyrAZAkpThIGGmkbidUiIApN6TaYZlmmkcjUDvqAyBGNMtr76s9FAYm7aMGoDYEWy22wiwtKiNdF/EBqbqKnPen8GoDQEjwXDs8TLQNNOR1YD3pnDM8M1LMstxPh6fKsBACNlZGUknRsokXVAF5uWjBqA2BMSPGSMnzHyaLFUB+6b7UTXEqlT2NQGQI6SZlpRHMdURU6PAYm+jUXExI5VgWr+oDIAizcVa+Nq/wDG4GdZv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAazNxEVFXinp8oNwMe16AiI/wBoSWq+5DD5fWBrM42VaRGuEVE+Kxv0AxZuXzp+TcDO3/5/PwQw+X1gfokPWZSXk25VjhEcxWnM2A+KTbZcr+LV/wAPc3AzrN/4e0c/BDD5fWB6ZnA201D7EqOr9+r6AfdfR1RGoOIhVfjA/UD5Ssu16Iwww1+v5j3fcc7y+sD50kueZsB+r9EpyORzU/NBuB+Tt+8c/BDD5fWB7WccnC9nhlVfkrWwGMzccqL7W938vcD7cRxDPo7LCJJc1ZTp0WGrz8wPik4lVFVODqr/AFmwH1kPRG5F6e2PRev2NwMl5f8AQqM+7zub8Hwud5fWB82ZxoquXg1/Fzb9APUpN9qUV68Yrkqew931A8OX0BFa6cRz1+cDneX1geknCisoqcIr3uX39gMSbqoyrKcZ0Wv9XuBsnJSnoiNKwz7Tzeq/chRny+sDys41RXLweZsB9pH0RqSRUXi4k/JV9QPk2216E0rTS+0LxC/khh8vrAykl0zNgGwBJx2fHoAIBbACTjs+PQAQC2AJ9clWJJZGOTRt6Non4VAAdH/gBagD+vyUpKMyMCIrlaf9ABlWW4dpWFbVFVyq5QLEAf11nmNcOwrTkWNf9AEMykrISraSTUSq9FWsCvAEnGiukF/PoAK9FX+3xAtQBJx2fHoAK5XP+YFqANODosgsTlSNU/r0AD6LVWBagCTjs+PQAdhGWpREabhZWtV+AFmAPOGTbaYkW2amYkX+7gAkd1eqoqVOAtQBpwSjcnyIWlRFjf8AjUAG0qK0qojn/AC1AEnFZ8egA3uK0q/ZR3RK+oGvcyyqMIlaPfWAxNy0YNQGwIkBublowagNgRIDc3KuIwagNgRSgOzfbZak5VlGERWYXqnxAYAjmm22ZNJJWIfiqu6qAvN20Pr9zUBoCKVHI9/V9QDk3mXMSzUaLFD0+VYDIEhLtyMDLEkylb1V3UBSblowagNgRQDU3LRg1AbAimVc09yL/UBubqq6XZX4Kyv+wGgIpEVytQvRKwG5uqrpdH9Eg1AaAinorvgA3N3qvEdHfY1AaAjFWT5aIiLG/qoDE3LRg1AbAFo6vRPbKqv1e4HnrN+8e0YIYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wPaTiYVhWl4ZUaSpIq/oBlHL5/huBjlm+ir+8c/BDD5fWBtI3u/ZMzYD3K+gtSqoq8WiO/l7gfLt+8c/BDD5fWB+iS9ZblpFuWZ4VERitFlNgPgs3FWvjMvcDO36v2jn4IYfL6wNpJc8zYDWZuIjSK1xT0StIK/qBzSp6C0qsM85OIV7nwwoz5fWBlJLnmbAcs232zL3AzrN+8c/BDD5fWBtJLnmbAdRu+Ze4GdZv3jn4IYfL6wNpI/p7HmbAek9AbZYWTTjvdarTl7ge5GRT0VhpEXntSr1/h+ylXxfX9QPcr60xJMNNLIqqp8EX/fyA+CTcVHu4yv8Al7gYyn6AVEaXnpxGGFGfL6wPrKzgk2ESCQjxO0A+aTcRF/enp8lY3A5hlr0NtGGE9oXiVcifYdD5fWB6Z9fbbVpE4Jys1vlNgGAB5wSUcnJSkSJBF0+b3AAgWwAk47Pj0AEAtgBJx2fHoAIBbACTjs6fn0AF6OToBagCziqkKvv6AEMsS3LiZfA0sNfxAsQB/Xm2GGpBW2IkVG0c/wDoAEBagCziR/Ix6ACO+SvAtQCPX2GGpKTaaXqkTgAf7gWoB3qnCJxSySKroYtAJ/iJLkyqyb3uAsQDvWEYWSRGkWppen4dQCuIlGuHYRlERX9Ef+H0UCmAEnHZ/n7+gArlTo7qBagCziVUXh1RXfb6+ABVe9Veq/j8wNhaVXKw6JUd+ADU32YGuJYe9UVlP9gMgRTl6O6v+QDU3EX9oV38GoDYEfINJItpKSslEyvTqAtN9UVriVRHIqsdPIDQESA3N20YNQGwIoBqblowagNgR8hLJJK1Giq/4pX5AY9Bb5jfEtojkWB31AYAikTr0f0+QDU3bRg1AbAilRUrRzwHJvNxMSzCp9mHUBkCJAcm6qu4hPlBqA0BGsLJrJtJKK1En2HVAMTdVXS6P6e4rvIDQEbKMIzKNI96IoC83bRg1AbAi+iIior1WtHAMzcc7iPn7moDYAtHVc72yv8Al7gY+j6O/eOev5IYfL6wPSTiiVzPCKqfOPYD1I+grISnMZ4pF/BZPcDZKRlPSpRWWf168Qr/AOCF3l9YHmV9fakW1Yb4Pqn8zYD6cR6KnENstLLoyjPwRiv6gfKVak/QmnyUnzUl/hFDDD5fWB9eF9cZ4lpWFkUYX4Pbr+gHiS9BSSf+0vf/AONwPEK+gsq29JfnKiO+w53l9YGUkT/p/wCewHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wPTcq16EywwqJLpK9EckDofL6wPNJLnmbAdRy+f4bgara+gMMsOSX5yqv8DneX1gZSR3ReDzNgOo3fMvcDO37xz8EMPl9YG0kueZsBrE3EZaRpeKRXfDl7gY21+gWlaRlJb2hak9yGHy+sD3SFmFGvZWutfvdE+gHNzeZVqKT4mFPlA/UDGWP0Cw03EkvzXdPsKkPl9YHmklzzNgOWbiqr14zL3A5EX0BHu9o569V+xDD5fWB6anHJp9nhml6fxOA8pNtyv8AbP8ADcDUd6E2kbXOTiF6qiQww+X1gc1ONEVUThH49gGgBvX3xcOqMROj6eABEVWXoqVgWgBHrku3INSDTFfv6ACSko3KvbaZf1r+QFkAP69JNSvJRl3RG16r/QAJHv6Pf+AFqAPOBltUkW2fuxv+gAVfVQLUAWcSKvs6Ij/t6ACsNQNI05Fcr3KBaACTiR/s+PQAdhGWW05rKw/ECzAEnFXw6fn0AFctQFqAJOJHrw6fn0AHlZJZJtWFaRp3V6VAWYA/r8nHyPeRHI2vX+wAbLS9UVeio5QLQAWcX/we776/6AE6q9QLUAScdnx6ACvXwBagCziVIZBHdXtOXwAO3JozJsNo2yqtVolaAeUe0rnK0qo5AGpvIqLxD2VR8Ff9wGgIyTk25VtGWGXqvUBmb6Ky1xKKidFYq/uA0BFso96IiqvyRAGZuWjBqA2BFxtdetavUB70LiG5ZiUYa+5C7+7wFgJT21tmRWQcgCE3bRg1AbAilRWVcqOAam5aMGoDYEXG29ViV619QHPQJJqTSWaaVHNowqOX+oDAESA3Ny0YNQGwJDnttto9qBF6PQBf0JlllviUZbjT3OvkBgCLWUbVmCJYUV6I8BmblowagNgRjErKST0k21RGk6uAZm8qtLxDSq9Vgf8AUBoCLaReiu6Kj0QBqbr09oZX4QagNADyU30kmka9pRp3/jcD1LSqeiojUPOWV6dVhVIfL6wPlSS55mwHqTm+3JNRMccqL8+XuB5VWvQVeq+0LxC/khh8vrA/V+lWkZZaa4dPeqc2/QD8zM3YVenGf4bgYiL6Ark/aPaMEMPl9YHuS9fblmlZY4LqiP8A+TYDxRt1XGZe4He96Cv/AGOfghRny+sD6M+uyjcm1Ks8C9liteZsB86N3zL3AzrN+8c/BDD5fWB7YnEy0rm+GhT5xv0A9S/oCS0pGnEox+EG4Hy7fvHPwQw+X1gelnGy/wB3hFVPxb2A1ubrCug4lWXV+69/1A8dv3jn4IYfL6wNpIn/AE/89gOo3fMvcDO37xz8EMPl9YH0pAzyuZ7Oj3uh5nX/AEB5Wbiq5/G1dP8Aj3A89v3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4GowvoDDTaKnEJKqj/uOd5fWByzjZcjuFVV+KR1fQDkm6qVcaqfD7G4GyUmz6Eqxt81JZHvdDDD5fWB5pJc8zYBsAWcSKvI/CPQAWFVZVvoiJ9QLQAScXVeHT8+gBbacRwzkVpWYkRawK8An1+TRuTk21XqzE4AGFpGY6urgLQAScVnT8+gAyNtoyrKNKiLWnzAtABJx2fHoAQsj7jLaSjKxK5z6gLIAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABUZVXqiKrqwLUAWcVUgr/AOPQAQD6yCyCRc99XR3zAVm7aPl7moDYEY2yslKNM9Fd0AZm6y5JdXp1Rhei/wBQGgI6XkUkWkRJRGno/oAvN5pppJdFV7oHfUBoCJAbm5aMGoDYAXDSySbmkT3VZqX5Afq9KVheI4lWFRUWBen9wEwIxuUlG0hbaVXfBQGJuWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAjJJJJVXmtKiO6O+YDE3LRg1AbAEo3fMvcD7Jy/RJHr+sVvDV5A+NJLnmbAdRu+Ze4HOX0BFad7QkuvX7kMPl9YHUk6J+yZmwHUcvn+G4Gdv8A8/n4IYfL6wNpJc8zYDaOK53tnT/89wPPb945+CGHy+sD2xOJG20ZXhUZernrKVfQDFm80rUXtqv/ACbgees37x7Rghh8vrA2klzzNgNam6rbStLxnVev/HuB57fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wM7fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wM7fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wM7fvHPwQw+X1gbSS55mwDYA04W3MSLP8UWgAaMtKiqjKqiVgWoBvq/DrxCSbMTkRGl/0BOtswNKz0X8QLQAWcTKqkg0nwjf9ABEdU5QLUAScdnx6ACAWwBPrSN8zh2pOF7KNr739gAGlVVVVrVQLUAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABALYAScdnx6AEtSrDUgzJJJIjTKvVr5gY1LSjcmkk017rNSANTf5XLlYHx+7F9XAMASfGwRIqqsfx+TgEpuvdLvq9x31AaAjZFtGJRFaqf1QCk9O4iSl4+Wn2UZeB+4CJAbm5aMGoDYEZKsMybULLaNo570AYm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwBKN3zL3Azt+8c/BDD5fWB6pGjkVOEevxSOr6Ac1N1ptXtcaqrV1Y3A1qUa9BYYk1dxCSqq77kLvL6wOpA3BzPYVhqfHsB5o3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA9MziiaRlODr/mbAZRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWB6ZnGyrTm+FVlPmjb9AGgBJx2fHoAKiqj3KqP6KBagCTjs+PQAfnSnL5MXuPe4CzAEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEA4BublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwBKN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYBsAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABAOAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsASjd8y9wM7fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wM7fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wM7fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wM7fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wM7fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2A6jd8y9wM7fvHPwQw+X1gbSS55mwHUbvmXuBnb945+CGHy+sDaSXPM2AbAEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQDgG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAEo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgOo3fMvcDO37xz8EMPl9YG0kueZsB1G75l7gZ2/eOfghh8vrA2klzzNgGwBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEA4BublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwIkBublowagNgRIDc3LRg1AbAiQG5uWjBqA2BEgNzctGDUBsCJAbm5aMGoDYESA3Ny0YNQGwBKN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYDqN3zL3Azt+8c/BDD5fWBtJLnmbAdRu+Ze4Gdv3jn4IYfL6wNpJc8zYBsAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABALYAScdnx6ACAWwAk47Pj0AEAtgBJx2fHoAIBbACTjs+PQAQC2AEnHZ8egAgFsAJOOz49ABAP/9k='

export const GuideImage = [
  new URL('@/assets/images/guide/guide1.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide2.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide3.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide4.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide5.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide6.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide7.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide8.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide9.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide10.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide11.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide12.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide13.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide14.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide15.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide16.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide17.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide18.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide19.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide20.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide21.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide22.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide23.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide24.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide25.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide26.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide27.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide28.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide29.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide30.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide31.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide32.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide33.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide34.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide35.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide36.png', import.meta.url).href,
  new URL('@/assets/images/guide/guide37.png', import.meta.url).href
]
